// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export const he = {
    'accountsLookup.ContextMenuItem': 'עחיפוש חשבונות',
    'accountDetailsWidget.DropdownButton': 'חשבון',
    'accountDetailsWidget.DropdownButton.Tooltip': 'תפריט חשבון',
    'additional.verification': 'נדרש אימות סיסמה נוסף.',
    'AdditionalProperty.Message': 'הודעה',
    'AdditionalProperty.Position closed because the loss limit was reached': 'הפוזיציה {0} תיסגר בגלל שהיא הגיעה למגבלת ההפסד.',
    'AdditionalProperty.enum_StopOutType_AutoClose': 'סגירה אוטומטית',
    'AdditionalProperty.enum_StopOutType_CloseAllByInstruments': 'סגור הכל לפי מכשירים',
    'AdditionalProperty.enum_StopOutType_CloseAllPositions': 'סגור את כל הפוזיציות',
    'AdditionalProperty.enum_StopOutType_CloseLagestLoss': 'סגור פוזיציות כשאין מספיק בטוחות (מההפסד הגדול לקטן)',
    'AdditionalProperty.enum_StopOutType_ClosePositionsByMarginExcess': 'סגור פוזיציות לפי חריגת בטוחות',
    'AdditionalProperty.enum_StopOutType_DoNotClosePositions': 'אל תסגור פוזיציות',
    'AdditionalProperty.enum_StopOutType_ExternalLossLimit': 'הגבלת הפסד יומי',
    'AdditionalProperty.enum_StopOutType_FIFO': 'סגור פוזיציות כשאין מספיק בטוחות (לפי סדר פתיחת הפוזיציות = ראשון נכנס ראשון יוצא)',
    'AdditionalProperty.enum_StopOutType_LargestFirst': 'סגור פוזיציות כאשר אין מספיק בטוחות (מהגדול לקטן)',
    'AdditionalProperty.enum_StopOutType_LIFO': 'סגור פוזיציות כשאין מספיק בטוחות (לפי סדר נפתח אחרון יוצא ראשון - LIFO)',
    'AdditionalProperty.User': 'משתמש',
    'AdditionalProperty.Account': 'חשבון',
    'AdditionalProperty.Projected balance': 'יתרה חזויה',
    'AdditionalProperty.Margin used': 'בטוחות נוצלו',
    'AdditionalProperty.Time': 'תאריך/שעה',
    'AdditionalProperty.MarginCallMessage.Message': 'אנא הפקד לחשבונך',
    'AdditionalProperty.MarginCallReachedMessage.Message': '#hidden#',
    'AdditionalProperty.StopOutType': 'סוג סטופ-אאוט',
    'AdditionalProperty.MarginCallMessage.header.MarginWarning': 'אזהרת בטוחות',
    'AdditionalProperty.MarginCallMessage.header.MarginCallReached': 'קריאת בטוחות הגיעה',
    'AdditionalProperty.LackOfMargin': 'חוסר בבטוחות',
    'AdditionalProperty.ErrorPriceOutOfTradingLimits': 'המחיר מחוץ למגבלות המסחר',
    'AdditionalProperty.Reverse': 'הפוך',
    Alligator: 'אינדיקטור - אליגטור',
    'Average Directional Index': 'מדד כיווני ממוצע (ADX)',
    'Average True Range': 'טווח ממוצע אמיתי',
    'Bollinger Band': 'רצועת בולינגר',
    'Bollinger Bands': 'רצועות בולינגר',
    'bonds.couponCycle.1m': 'חודש אחד',
    'bonds.couponCycle.1y': 'שנה אחת',
    'bonds.couponCycle.3m': 'שלושה חודשים',
    'bonds.couponCycle.6m': 'שישה חודשים',
    'BrokerMessage.Cancel': 'בטל מנוי',
    'BrokerMessage.OK': 'אוקיי',
    'BrokerMessage.Text': 'הודעת ברוקר',
    'BusinessRejectMessage.28': 'סיסמה נוכחית שגויה',
    'BusinessRejectMessage.31': 'סיסמה חדשה שגויה: אינך יכול להשתמש באותה סיסמה',
    'BusinessRejectMessage.201': 'הסיסמה החדשה מכילה תווים אסורים',
    'BusinessRejectMessage.202': 'הסיסמה לא יכולה להיות זהה לשם המשתמש',
    'BusinessRejectMessage.203': 'אנא הזן סיסמה חדשה',
    'BusinessRejectMessage.221': 'לא ניתן לשנות את הסיסמה: הסיסמה החדשה צריכה לכלול לפחות אות גדולה אחת, אות קטנה אחת וספרה אחת. אפשר לנסות שוב.',
    'BusinessRejectMessage.222': 'לא ניתן לשנות את הסיסמה: הסיסמה החדשה צריכה לכלול לפחות אות גדולה אחת, אות קטנה אחת וספרה אחת, ולכלול לפחות 8 תווים. אפשר לנסות שוב.',
    'BusinessRejectMessage.223': 'לא ניתן לשנות את הסיסמה: הסיסמה החדשה צריכה לכלול לפחות אות גדולה אחת, אות קטנה אחת, ספרה אחת ותו מיוחד אחד (כמו @#$%), ולכלול לפחות 8 תווים. אפשר לנסות שוב.',
    'BusinessRejectMessage.338': 'סיסמת שחרור נעילת מסחר אינה מותרת על ידי לוגיקת שחרור נעילת מסחר.',
    'BusinessRejectMessage.339': 'סיסמת המסחר הנוכחית שגויה',
    'BusinessRejectMessage.419': 'לא ניתן ליצור התראה. ניתן ליצור התראות רק עבור החשבונות של המשתמש המחובר.',
    'BusinessRejectMessage.432': 'לא ניתן לעבד את בקשת המוצר.',
    'BusinessRejectMessage.433': 'הגעת למגבלת סך ההתראות.',
    'BusinessRejectMessage.434': 'לא ניתן ליצור את ההתראה בגלל צומת שגוי.',
    'BusinessRejectMessage.435': 'מחירי קנייה/מכירה אינם זמינים עבור המכשיר.',
    'BusinessRejectMessage.436': 'ההרשמה למוצר {0} נכשלה: לא ניתן להירשם כי אין חשבונות פעילים לחיוב על המוצר.',
    'BusinessRejectMessage.437': 'ההרשמה למוצר {0} נכשלה: אין מספיק יתרה לתשלום העמלה.',
    'BusinessRejectMessage.446': 'המוצר לא רלוונטי יותר לשימוש',
    'BusinessRejectMessage.452': 'הוראת מרקט אסורה בגלל שבמהלך היום הנוכחי לא מתרחשות עסקאות.',
    'BusinessRejectMessage.453': 'לא ניתן ליצור את ההוראה בגלל מחיר שלילי.',
    'BusinessRejectMessage.461': 'סיבת הדחייה: אין מה לשנות.',
    'BusinessRejectMessage.466': 'מחיר לימיט קרוב מדי למחיר ה-Ask',
    'BusinessRejectMessage.467': 'מחיר LIMIT קרוב מידי למחיר ה-BID',
    'BusinessRejectMessage.468': 'מחיר מימוש רווח קרוב מדי למחיר ההוראה',
    'BusinessRejectMessage.469': 'מחיר ה-סטופ קרוב מידי למחיר ה-ASK',
    'BusinessRejectMessage.470': 'מחיר הסטופ קרוב מידי למחיר ה-BID',
    'BusinessRejectMessage.471': 'מחיר סטופ-לוס קרוב מדי למחיר ההוראה',
    'BusinessRejectMessage.472': 'מחיר הלימיט קרוב מידי למחיר הסטופ',
    'BusinessRejectMessage.475': 'רק אופציות בתוך הכסף יכולות להיות מופעלות',
    'BusinessRejectMessage.483': 'לא ניתן לשנות הוראה עם סטטוס ביטול בהמתנה',
    'BusinessRejectMessage.484': 'לא ניתן לבטל הוראה עם סטטוס ביטול בהמתנה',
    'reports.Reason for rejection: Nothing to change.': 'סיבת הדחייה: אין מה לשנות.',
    'Chande Momentum Oscillator': "מתנד מומנטום צ'אנדה",
    'chart.agregationType.Button': 'סוגי צבירה',
    'chart.goTo.Button': 'עבור אל',
    'chart.agregationType.Button.ToolTip': 'הגדר זמן לנר המסחר',
    'chart.AllowedPeriods.15M': '15 דקות',
    'chart.AllowedPeriods.1D': 'יום',
    'chart.AllowedPeriods.1H': 'שעה',
    'chart.AllowedPeriods.1M': 'דקה',
    'chart.AllowedPeriods.1S': '1S',
    'chart.AllowedPeriods.1T': 'טיק',
    'chart.AllowedPeriods.1W': 'שבוע',
    'chart.AllowedPeriods.1Y': 'שנה',
    'chart.AllowedPeriods.30M': '30 דקות',
    'chart.AllowedPeriods.4H': '4H',
    'chart.AllowedPeriods.5M': '5 דקות',
    'chart.AllowedPeriods.Month': 'חודש',
    'chart.AllowedPeriods.Range': 'טווח',
    'chart.AllowedPeriods.Ticks': 'טיקים',
    'chart.ChartPanel.accountLookup.ToolTip': 'בחר חשבון',
    'chart.ChartPanel.symbolLookup.ToolTip': 'בחר סמל',
    'chart.chartScroll.toBegin': 'לציטוט האחרון',
    'chart.chartScroll.zoomInButton': 'הגדל',
    'chart.chartScroll.zoomOutButton': 'הקטן',
    'chart.ChartSymbolSelector.addIndicator.ButtonToolTip': 'הוסף אינדיקטור',
    'chart.ChartSymbolSelector.drawingButton': 'סרגל כלי ציור',
    'chart.ChartSymbolSelector.drawingButton.ToolTip': 'הצג/הסתר סרגל כלי ציור',
    'chart.ChartSymbolSelector.mouseTradeButton': 'מסחר עכבר',
    'chart.ChartSymbolSelector.mouseTradeButton.ToolTip': 'מסחר עכבר',
    'chart.ChartSymbolSelector.oeButton': 'הזנת הוראה בגרף',
    'chart.ChartSymbolSelector.oeButton.ToolTip': 'הזנת הוראה בגרף',
    'chart.ChartSymbolSelector.OverlayTooltip': 'הוסף שכבה',
    'chart.ChartSymbolSelector.ObjectManagerTooltip': 'מנהל אובייקטים',
    'Chart.chartWindow.auto': 'אוטומטי',
    'Chart.chartWindow.collapsed': 'מכווץ',
    'Chart.chartWindow.manual': 'ידני',
    'chart.chartWindowManager.SetAuto': 'עבור לסולם מחירים אוטומטי',
    'chart.chartWindowManager.SetManual': 'עבור לסולם מחירים ידני',
    'chart.head.addOverlay': 'הוסף שכבה...',
    'chart.head.charttype': 'סגנון',
    'chart.head.line': 'כלי ציור',
    'chart.head.overlayRemoveAll': 'הסר הכל',
    'chart.head.overlays': 'שכבות',
    'chart.indicator': 'אינדיקטור',
    'chart.indicatorAdd': 'הוסף אינדיקטור',
    'chart.indicatorRemoveAll': 'הסר הכל',
    'chart.indicators': 'אינדיקטורים',
    'chart.Infoline.days': 'ימים',
    'chart.Infoline.hours': 'שעות',
    'chart.Infoline.min': 'דקות',
    'chart.Infoline.price': 'מחיר',
    'chart.Infoline.sec': 'שניות',
    'chart.Infoline.time': 'זמן',
    'chart.infoWindow.Items.Ask': 'היצע:',
    'chart.infoWindow.Items.Bars': '#עמודות:',
    'chart.infoWindow.Items.Bid': 'מחיר ביקוש:',
    'chart.infoWindow.Items.Change': 'שינוי יומי,%',
    'chart.infoWindow.Items.DailyChange': 'שינוי יומי, %',
    'chart.infoWindow.Items.DailyChangeShort': 'שי',
    'chart.infoWindow.Items.Close': 'סגירה',
    'chart.infoWindow.Items.Date': 'תאריך:',
    'chart.infoWindow.Items.High': 'גבוה:',
    'chart.infoWindow.Items.Low': 'נמוך:',
    'chart.infoWindow.Items.Open': 'פתיחה',
    'chart.infoWindow.Items.Ticks': 'טיקים:',
    'chart.infoWindow.Items.Time': 'זמן:',
    'chart.infoWindow.Items.Volume': 'נפח:',
    'chart.infoWindow.Items.PortfolioGrowth': 'יתרת תיק השקעות:',
    'chart.instrumentsLookup': 'חיפוש סימולים',
    'chart.layerManager': 'הגדרות...',
    'chart.loading': 'טוען...',
    'chart.loadingData': 'טוען נתונים עבור',
    'chart.mainlayer.gridPrice': 'מחיר גריד',
    'chart.mainlayer.gridTime': 'זמן גריד',
    'chart.mainlayer.volume': 'עמודות נפח מסחר',
    'chart.menu.cancelByAccount': 'בטל הכל לפי חשבון',
    'chart.menu.cancelByInstrument': 'בטל הכל לפי סמל',
    'chart.menu.cancelOrder': 'בטל הוראה',
    'chart.menu.close': 'סגור פוזיציה',
    'chart.menu.closeall': 'סגור את כל הפוזיציות...',
    'chart.menu.InfoWindowDock': 'עגן',
    'chart.menu.InfoWindowHide': 'הסתר',
    'chart.menu.InfoWindowHidden': 'מוסתר',
    'chart.menu.InfoWindowSeparateWindow': 'חלון נפרד',
    'chart.menu.InfoWindowAttachedToCursor': 'מצורף לסמן',
    'chart.menu.InfoWindowSettings': 'הגדרות',
    'chart.menu.InfoWindowShortMode': 'מצב קצר',
    'chart.menu.modify': 'ערוך',
    'chart.menu.PlateIndicatorDublicate': 'שכפל אינדיקטור',
    'chart.menu.PlateIndicatorRemove': 'סגירה',
    'chart.menu.PlateIndicatorSettings': 'הגדרות',
    'chart.menu.PlateIndicatorVisible': 'גלוי',
    'chart.menu.PlateOverlay.Overlay': 'שכבה',
    'chart.menu.PlateOverlayRemove': 'סגירה',
    'chart.menu.PlateOverlaySettings': 'הגדרות',
    'chart.menu.PlateOverlayVisible': 'גלוי',
    'chart.menu.rollback': 'גלגל אחורה את הפוזיציה',
    'chart.noAvailableData': 'אין נתונים זמינים עבור',
    'chart.NoData': 'אין נתונים',
    'chart.priceScaleContextMenu.AutoScale': 'אוטומטי',
    'chart.priceScaleContextMenu.FitAlerts': 'התאם התראות',
    'chart.priceScaleContextMenu.FitDay': 'התאם גבוה/נמוך יומי',
    'chart.priceScaleContextMenu.FitDrawings': 'התאם ציורים',
    'chart.priceScaleContextMenu.FitIndicators': 'התאם אינדיקטורים',
    'chart.priceScaleContextMenu.FitOrdersPositions': 'התאם הוראות/פוזיציות',
    'chart.priceScaleContextMenu.ManualScale': 'ידני',
    'chart.refresh': 'רענן',
    'chart.Remove': 'הסר',
    'chart.shortPeriodName.m': 'm',
    'chart.shortPeriodName.ticks': 'טיקים',
    'chart.ShowHighLow.Close': 'סגירה',
    'chart.ShowHighLow.High': 'גבוה יומי',
    'chart.ShowHighLow.Low': 'נמוך יומי',
    'chart.StyleButton.ToolTip': 'סגנון',
    'chart.templates.tooltip': 'תבניות',
    'chart.templates.visibility': '#not hidden#',
    'chart.tic.short.15min.name': '15 דקות',
    'chart.tic.short.1day.name': 'יום',
    'chart.tic.short.1hour.name': 'שעה',
    'chart.tic.short.1min.name': 'דקה',
    'chart.tic.short.1tic.name': 'טיק',
    'chart.tic.short.30min.name': '30 דקות',
    'chart.tic.short.4hour.name': '4 שעות',
    'chart.tic.short.5min.name': '5 דקות',
    'chart.tic.short.month.name': 'חודש',
    'chart.tic.short.range.name': 'טווח',
    'chart.tic.short.second.name': 'שנ',
    'chart.tic.short.week.name': 'שבוע',
    'chart.tic.short.year.name': 'שנה',
    'chart.info.high': 'גבוה יומי',
    'chart.info.low': 'נמוך יומי',
    'chart.info.volume': 'נפח',
    'chart.info.ticks': 'טיקים',
    'chart.info.open': 'פתח',
    'chart.info.change': 'שינוי',
    'chart.info.prevClose': 'סגירה קודמת',
    'chart.timeframeselector.rangeButton': 'תקופת נתונים',
    'chart.timeframeselector.rangeButton.ToolTip': 'בחר תקופת הצגת נתונים',
    'chart.timeframeselector.time': 'זמן',
    'chart.timeScaleContextMenu.ShowAllSessions': 'הצג סשנים מורחבים',
    'chart.timeScaleContextMenu.ShowDaySeparator': 'הצג מפריד ימים',
    'chart.timeScaleContextMenu.ShowEmptyBars': 'הצג חורים בהיסטוריה',
    'chart.timeScaleContextMenu.ShowMonthSeparator': 'הצג מפריד חודשים',
    'chart.timeScaleContextMenu.ShowTimePeriodsSeparator': 'הצג מפרידי תקופות זמן',
    'chart.timeScaleContextMenu.ShowWeeksSeparator': 'הצג מפריד שבועות',
    'chart.timeScaleContextMenu.ShowYearSeparator': 'הצג מפריד שנים',
    'chart.tool.bar': 'עמודות',
    'chart.tool.candle': 'נרות יפניים',
    'chart.tool.clone': 'שכפל',
    'chart.tool.Dash': 'מקף',
    'chart.tool.delete': 'הסר',
    'chart.tool.deleteAll': 'הסר הכל',
    'chart.tool.dot': 'נקודות',
    'chart.tool.dotline': 'קו ונקודות',
    'chart.tool.DottedLine': 'קו מעוצב',
    'chart.tool.forest': 'היסטוגרמה',
    'chart.tool.IsoDot': 'נקודת בהנחה',
    'chart.tool.line': 'קו',
    'chart.tool.properties': 'הגדרות',
    'chart.tool.ShapedLine': 'קו מעוצב',
    'chart.tool.solid': 'אזור',
    'chart.tools.ABCPatern': 'תבנית ABC',
    'chart.tools.AndrewPitchfork': 'Andrew Pitchfork',
    'chart.tools.backcolor': 'צבע הרקע',
    'chart.tools.ButterflyGartley': 'פרפר גרטלי',
    'chart.tools.Circle': 'מעגל',
    'chart.tools.default': 'מצביע',
    'chart.tools.ElliottImpulse': 'גלי אליוט - אימפולס (12345)',
    'chart.tools.ElliottCorrection': 'גלי אליוט - תיקון (ABC)',
    'chart.tools.ElliottTriangle': 'גלי אליוט - משולש (ABCDE)',
    'chart.tools.ElliottTripleCombo': 'גלי אליוט - קומבו משולש (WXYXZ)',
    'chart.tools.ElliottDoubleCombo': 'גלי אליוט - קומבו כפול (WXY)',
    'chart.tools.Ellipse': 'אליפסה',
    'chart.tools.eraser': 'מחק',
    'chart.tools.FibArc': "קשת פיבונאצ'י",
    'chart.tools.FibEllipses': "אליפסות פיבונאצ'י",
    'chart.tools.FibExp': "התרחבות פיבונאצ'י",
    'chart.tools.FibFan': "מניפות פיבונאצ'י",
    'chart.tools.FibPhiChannel': "ערוץ פי פיבונאצ'י",
    'chart.tools.Fibretr': "נסיגת פיבונאצ'י",
    'chart.tools.FibSpiral': "ספירלת פיבונאצ'י",
    'chart.tools.FibTga': "ניתוח יעד זמן פיבונאצ'י",
    'chart.tools.FibTz': "אזור זמן פיבונאצ'י",
    'chart.tools.GannFan': 'מניפת גאן (כלי ניתוח)',
    'chart.tools.GannGrid': 'גרפים גאן',
    'chart.tools.GannLine': 'קו גאן',
    'chart.tools.horizontal': 'קו אופקי',
    'chart.tools.infoline': 'סרגל',
    'chart.tools.arrowLabel': 'חץ',
    'chart.tools.commentsLabel': 'הערות',
    'chart.tools.priceLabel': 'תווית מחיר',
    'chart.tools.Line': 'קו',
    'chart.tools.mirrored': 'הפעל תצוגת מראה',
    'chart.tools.points': 'ספירת נקודות',
    'chart.tools.Polygon': 'מצולע',
    'chart.tools.PPZ': 'PPZ (אזור פיבוט מחיר)',
    'chart.tools.PriceChannel': 'ערוץ מחיר',
    'chart.tools.Rectangle': 'מלבן',
    'chart.tools.RegressionChannel': 'ערוץ רגרסיה',
    'chart.tools.ScalingByRect': 'קנה מידה לפי מלבן',
    'chart.tools.selection': 'בחירה',
    'chart.tools.snapToCandle': 'הצמד לנר',
    'chart.tools.StayDrawingMode': 'הישאר במצב ציור',
    'chart.tools.symbol': 'סמן',
    'chart.tools.text': 'הערות',
    'chart.tools.TopBottomPattern': 'תבנית עליון תחתון',
    'chart.tools.Triangle': 'משולש',
    'chart.tools.vertical': 'קו אנכי',
    'chart.tools.ABCPatern.deleteByType': 'כל תבניות ABC',
    'chart.tools.AndrewPitchfork.deleteByType': 'כל Andrew Pitchfork',
    'chart.tools.ButterflyGartley.deleteByType': 'כל פרפרי גרטלי',
    'chart.tools.Circle.deleteByType': 'כל העיגולים',
    'chart.tools.Ellipse.deleteByType': 'כל האליפסות',
    'chart.tools.ElliottImpulse.deleteByType': 'כל גלי אליוט - אימפולס (12345)',
    'chart.tools.ElliottCorrection.deleteByType': 'כל גלי אליוט - תיקון (ABC)',
    'chart.tools.ElliottTriangle.deleteByType': 'כל גלי אליוט - משולש (ABCDE)',
    'chart.tools.ElliottTripleCombo.deleteByType': 'כל גלי אליוט - קומבו משולש (WXYXZ)',
    'chart.tools.ElliottDoubleCombo.deleteByType': 'כל גלי אליוט - קומבו כפול (WXY)',
    'chart.tools.FibArc.deleteByType': "כל קשתות פיבונאצ'י",
    'chart.tools.FibEllipses.deleteByType': "כל אליפסות פיבונאצ'י",
    'chart.tools.FibExp.deleteByType': "כל התרחבות פיבונאצ'י",
    'chart.tools.FibFan.deleteByType': "כל מניפות פיבונאצ'י",
    'chart.tools.FibPhiChannel.deleteByType': "כל ערוצי פי פיבונאצ'י",
    'chart.tools.Fibretr.deleteByType': "כל נסיגות פיבונאצ'י",
    'chart.tools.FibSpiral.deleteByType': "כל ספירלות פיבונאצ'י",
    'chart.tools.FibTga.deleteByType': "כל ניתוחי יעד זמן פיבונאצ'י",
    'chart.tools.FibTz.deleteByType': "כל אזורי זמן פיבונאצ'י",
    'chart.tools.GannFan.deleteByType': 'כל מניפות גאן',
    'chart.tools.GannGrid.deleteByType': 'כל רשתות גאן',
    'chart.tools.GannLine.deleteByType': 'כל קווי גאן',
    'chart.tools.horizontal.deleteByType': 'כל הקווים האופקיים',
    'chart.tools.infoline.deleteByType': 'כל הסרגלים',
    'chart.tools.arrowLabel.deleteByType': 'כל החצים',
    'chart.tools.commentsLabel.deleteByType': 'כל ההערות',
    'chart.tools.priceLabel.deleteByType': 'כל תוויות המחיר',
    'chart.tools.Line.deleteByType': 'כל הקווים',
    'chart.tools.Polygon.deleteByType': 'כל המצולעים',
    'chart.tools.PPZ.deleteByType': 'כל PPZ',
    'chart.tools.PriceChannel.deleteByType': 'כל ערוצי המחיר',
    'chart.tools.Rectangle.deleteByType': 'כל המלבנים',
    'chart.tools.RegressionChanel.deleteByType': 'כל ערוצי הרגרסיה',
    'chart.tools.symbol.deleteByType': 'כל הסימולים',
    'chart.tools.text.deleteByType': 'כל ההערות',
    'chart.tools.TopBottomPattern.deleteByType': 'כל תבניות עליון תחתון',
    'chart.tools.Triangle.deleteByType': 'כל המשולשים',
    'chart.tools.vertical.deleteByType': 'כֹּל הקווים האנכיים',
    'chart.tools.VolumeProfile.deleteByType': 'כל פרופילי הנפח בהתאמה אישית',
    'chart.tools.FibonacciTools': "פיבונאצ'י",
    'chart.tools.GannTools': 'גאן (כלי ניתוח)',
    'chart.tools.GeometryTools': 'גיאומטריה',
    'chart.tools.ElliottTools': 'גל אליוט',
    'chart.tools.TrendTools': 'מגמה',
    'chart.tools.SecondaryTools': 'כלים משניים',
    'chart.view': 'הצג',
    'chart.view.analyseGroupMenu': 'כלי ניתוח',
    'chart.view.analysetoolbar': 'כלי ניתוח',
    'chart.view.barsToRight': 'עמודות מימין...',
    'chart.view.colors': 'הגדרות',
    'chart.view.dataInfo': 'חלון מידע',
    'chart.view.Day_HighLow': 'גבוה/נמוך יומי',
    'chart.view.drawingtoolbar': 'סרגל כלי ציור',
    'chart.view.font': 'גופן הצירים',
    'chart.view.landscapequestion': 'להשתמש בסידור נייר לרוחב?',
    'chart.view.merge': 'קווים רציפים',
    'chart.view.orderEntry': 'הזנת הוראה בגרף',
    'chart.view.periods': 'מרווחים...',
    'chart.view.previousCloseLine': 'סגירה קודמת',
    'chart.view.PrevSettlementPriceLine': 'מחיר סליקה קודם',
    'chart.view.scroller': 'פס גלילה',
    'chart.view.setOrder': 'הצבת הוראה',
    'chart.view.SettlementPriceLine': 'מחיר סליקה',
    'chart.view.show_cross': 'סמן מעקב',
    'chart.view.show_history': 'הצג את היסטוריית העסקה',
    'chart.view.show_set_zero': 'הצג עמודות ריקות',
    'chart.view.showEvents': 'הצג עסקאות',
    'chart.view.showNews': 'הצג חדשות',
    'chart.view.showOrders': 'הצג הוראות',
    'chart.view.showPositions': 'הצג פוזיציות',
    'chart.view.source': 'סוג נתונים',
    'chart.view.source0': 'ברירת מחדל לפי סימול',
    'chart.view.source1': 'ביקוש',
    'chart.view.source1000': 'היצע',
    'chart.view.source1001': 'ממוצע ביקוש/היצע',
    'chart.view.source1002': 'מינימום (ביקוש) ומקסימום (היצע)',
    'chart.view.source4': 'סגירה קודמת',
    'chart.view.sourceBID/ASK': 'לפי הצע/בקש',
    'chart.view.sourceTick1': 'לפי הצע/בקש',
    'chart.view.TimeToNextBar': 'זמן לנר הבא',
    'chart.view.toolbar': 'סרגל כלים',
    'chart.view.volume': 'הצג נפח',
    'chart.visualTrading.Invalid price': 'מחיר לא תקין',
    'chart.volumeColoringMode.ByBar': 'לפי בר',
    'chart.volumeColoringMode.ByDifference': 'לפי הפרש',
    'chart.volumeColoringMode.Fixed': 'קבוע',
    'chart.volumeColoringMode.ByMovingAverage': 'מעל/מתחת לממוצע הנע',
    'chart.quickTrading.Buy limit': 'קנייה בלימיט',
    'chart.quickTrading.Buy stop': 'קנייה בסטופ',
    'chart.quickTrading.Buy stop limit': 'קנייה בסטופ-לימיט',
    'chart.quickTrading.Invalid price': 'מחיר לא תקין',
    'chart.quickTrading.Sell limit': 'מכירה בלימיט',
    'chart.quickTrading.Sell stop': 'מכירה בסטופ',
    'chart.quickTrading.Sell stop limit': 'מכירה בסטופ-לימיט',
    'Commodity Channel Index': 'מדד ערוץ סחורות',
    'connect.connection.connect.error': 'פרמטרי חיבורים שגויים',
    'connect.connection.tradestream.error': 'לא נמצאו זרמי מסחר!',
    'connect.connection.unknown.error': 'שגיאה לא ידועה!',
    'contextMenu.Totals.visibility': '#not hidden#',
    Custom: 'מותאם אישית',
    'dataSourceWidget.btnText': 'מקור נתונים',
    'dataSourceWidget.openedBtn.tt': 'הסתר מקור נתונים',
    'dataSourceWidget.closedBtn.tt': 'הצג מקור נתונים',
    'dataSourceWidget.delayed.tt': 'נתונים מעוכבים',
    'dataSourceWidget.disabled.tt': 'מקור הנתונים אסור במכשיר בזה.',
    'dataSourceWidget.disabledWhenOnlyTradeRoute.tt': 'מקור הנתונים אסור בניתוב העסקה הזה.',
    'dataSourceWidget.noData.text': 'אין נתונים להצגה',
    'dataSourceWidget.price': 'מחיר',
    'dataSourceWidget.size': 'גודל',
    'dataSourceWidget.venue': 'מקום',
    'dataSourceWidget.last': 'סגירה קודמת',
    'dataSourceWidget.bid': 'ביקוש',
    'dataSourceWidget.ask': 'היצע',
    'dayTimeLabel.days': 'ימים',
    'dayTimeLabel.hours': 'שעות',
    'dayTimeLabel.minutes': 'דקות',
    'dayTimeLabel.seconds': 'שניות',
    'dayTimeLabel.day': 'יום',
    'dayTimeLabel.hour': 'שעה',
    'dayTimeLabel.minute': 'דקה',
    'dayTimeLabel.second': 'שניה',
    'dayTimeLabel.lifeTime': 'אורך חיים',
    'dayTimeLabel.lifeTimeExpired': 'אורך החיים פקע',
    Day: 'יום',
    'DaysPerType.Actual': 'בפועל',
    'dealticket.RiskRuleWarning.Header': 'אזהרת כלל סיכון',
    'dealticket.RiskRuleWarning.AccountName': 'חשבון',
    'dealticket.RiskRuleWarning.UserName': 'משתמש',
    Deutsch: '#hidden#',
    'enum.AccountType.ClosedFund': 'קרן סגורה',
    'enum.AccountType.MultiAsset': 'רב נכסי',
    'enum.AccountType.OpenedFund': 'קרן פתוחה',
    'enum.AccountType.SingleCCY': 'מטבע יחיד',
    'enum.AssetType.COMMODITIES': 'סחורות',
    'enum.AssetType.CRYPTO_CCY': 'מטבע קריפטו',
    'enum.AssetType.CURRENCY': 'מטבע',
    'enum.AssetType.SHARES': 'מניות',
    'editableComboBox.CreateNew': 'צור חדש',
    'editableComboBox.CreateNewTemplate': 'צור תבנית',
    'editableComboBox.CreateNew.tooltip': 'לחץ ליצירת רשימת מכשירים חדשה',
    'editableComboBox.CreateNewTemplate.tooltip': 'לחץ ליצירת תבנית חדשה',
    'editableComboBox.defaultList': 'רשימת ברירת מחדל',
    'editableComboBox.tooltip': 'רשימות שמורות',
    EstQuantity: 'כמות מוערכת:',
    'ExchangeId.All': 'כל הבורסות',
    'Exponential Moving Average': 'ממוצע נע אקספוננציאלי',
    FOK: 'FILL OR KILL‏ (FOK)',
    'FullLogs.Cluster': 'שרת',
    'FullLogs.DateTime': 'זמן',
    'FullLogs.Fields': 'שדות',
    'FullLogs.Message name': 'שם הודעה',
    'FullLogs.Session': 'סשן',
    'FullLogs.FieldsNew': 'שדות חדשים',
    'FullLogs.Mode': 'מצב',
    'general.addToWatchlist': 'הוסף לרשימת מעקב',
    'general.connection.status.Connected': 'מחובר',
    'general.connection.status.Disconnected': 'מנותק',
    'general.connection.status.Reconnecting': 'מתחבר מחדש...',
    'general.connection.CancelConnectRequested': 'בקשת ניתוק בוטלה',
    'general.connection.fullInfo': 'מידע מלא',
    'general.connection.is not valid. Attempt': 'לא תקין. לנסות',
    'general.connection.lastMessage': 'ההודעה האחרונה הייתה',
    'general.connection.Login/password combination is not valid. Attempt': 'שילוב שם משתמש/סיסמה אינו תקף. נסה {0}.',
    'general.connection.Login/password combination is not valid.': 'שילוב שם משתמש/סיסמה אינו תקף.',
    'general.connection.status': 'סטטוס',
    'general.connection.This client type is not allowed for user': 'סוג הלקוח הזה אסור עבור המשתמש',
    'general.connection.User/password combination for user': 'שילוב שם משתמש/סיסמה.',
    'general.connection.User/password combination is not valid. Atemp': 'השילוב של שם המשתמש/סיסמה אינו תקף. לנסות',
    'general.connection.User/password combination is not valid.': 'שילוב שם משתמש/סיסמה אינו תקף.',
    'general.connection.Verification password not valid.': 'סיסמת האימות אינה תקינה',
    'User is locked after brute force!': 'המשתמש ננעל לאחר מתקפה גסה!',
    'screen.LoginScreen.responceErrors.bruteforceBlockedMinutes': 'המשתמש {1} חסום, אנא נסה שוב בעוד כ-{2} דקות או צור קשר עם צוות התמיכה שלך.',
    'User is blocked. Please contact support.': 'המשתמש חסום. אנא צור קשר עם התמיכה.',
    'general.Instrument': 'מכשיר',
    'general.Calculating': 'מחשב...',
    'general.connection.restErrorMsg': 'יש כרגע בעיה בשמירת הגדרות וסביבות עבודה. אנא צור קשר עם מחלקת התמיכה.',
    'general.CUSTOM': 'מותאם אישית',
    'general.Friday': 'שישי',
    'general.messageBox.cancel': 'בטל מנוי',
    'general.messageBox.logout': 'התנתק',
    'general.messageBox.no': 'לא',
    'general.messageBox.ok': 'אוקיי',
    'general.messageBox.showNextTime': 'הצג בפעם הבאה',
    'general.messageBox.yes': 'כן',
    'general.Monday': 'שני',
    'general.day1.Mo': 'ב׳',
    'general.day2.Tu': 'ג׳',
    'general.day3.We': 'ד׳',
    'general.day4.Th': 'ה׳',
    'general.day5.Fr': 'ו׳',
    'general.day6.Sa': 'ש׳',
    'general.day7.Su': 'א׳',
    'general.month.1': "ינו'",
    'general.month.10': "אוק'",
    'general.month.11': "נוב'",
    'general.month.12': "דצמ'",
    'general.month.2': "פבר'",
    'general.month.3': 'מרץ',
    'general.month.4': "אפר'",
    'general.month.5': 'מאי',
    'general.month.6': 'יוני',
    'general.month.7': 'יולי',
    'general.month.8': "אוג'",
    'general.month.9': "ספט'",
    'general.monthFullName.1': 'ינואר',
    'general.monthFullName.10': 'אוקטובר',
    'general.monthFullName.11': 'נובמבר',
    'general.monthFullName.12': 'דצמבר',
    'general.monthFullName.2': 'פברואר',
    'general.monthFullName.3': 'מרץ',
    'general.monthFullName.4': 'אפריל',
    'general.monthFullName.5': 'מאי',
    'general.monthFullName.6': 'יוני',
    'general.monthFullName.7': 'יולי',
    'general.monthFullName.8': 'אוגוסט',
    'general.monthFullName.9': 'ספטמבר',
    'general.N_A': 'לא זמין',
    'general.NoData...': 'אין נתונים...',
    'general.NoDataMatchingYourCriteria': 'אין נתונים התואמים את הקריטריונים שלך',
    'general.OvernightMarginNotificationMessage': 'הצג הודעת התראה על בטוחות למשך הלילה',
    'general.Settings': 'הגדרות',
    'general.Saturday': 'שבת',
    'general.Sunday': 'ראשון',
    'general.Thursday': 'חמישי',
    'general.trading.at': 'ב-',
    'general.trading.Buy': 'קנייה',
    'general.trading.confirmation': 'אישור',
    'general.trading.confirmation.prefix': '',
    'general.trading.confirmationString': '{1} {2} {3} {4} {5} {6} {7} {8} {9} {10} {14} {13} {14} {15} {11} {12} {16}',
    'general.trading.for': 'עבור',
    'general.trading.limitBuyLessAsk': 'שער הוראת קנייה בלימיט שווה או גבוה ממחיר ההיצע בשוק, יתכן שההוראה תתממש באופן מיידי.',
    'general.trading.limitSellMoreBid': 'שער הוראת מכירה בלימיט של ההוראה שווה או נמוך ממחיר הביקוש בשוק, יתכן שההוראה תתממש באופן מיידי.',
    'general.trading.limitBuyLessAllowableFromLast': 'מחיר לימיט של ההוראה נמוך מהמחיר האחרון {1} ביותר מהאחוז המותר. בטוח שברצונך לשלוח את ההוראה?',
    'general.trading.limitBuyLessAllowableFromBase': 'מחיר לימיט של ההוראה נמוך ממחיר הבסיס {1} ביותר מהאחוז המותר. בטוח שברצונך לשלוח את ההוראה?',
    'general.trading.limitSellMoreAllowableFromLast': 'מחיר לימיט של ההוראה גבוה מהמחיר האחרון {1} ביותר מהאחוז המותר. בטוח שברצונך לשלוח את ההוראה?',
    'general.trading.limitSellMoreAllowableFromBase': 'מחיר לימיט של ההוראה גבוה ממחיר הבסיס {1} ביותר מהאחוז המותר. בטוח שברצונך לשלוח את ההוראה?',
    'general.trading.marketCloseFor': 'סגירה במחיר מרקט עבור',
    'general.trading.pips': 'טיקים',
    'general.trading.points': 'נקודות',
    'general.trading.percent': '%',
    'general.trading.position': 'פוזיציה',
    'general.trading.PositionExerciseReject': 'ביצוע הפוזיציה נדחתה',
    'general.trading.position.Buy': 'לונג',
    'general.trading.position.Sell': 'שורט',
    'general.trading.priceNotAvailable': 'לא זמין',
    'general.trading.refused': 'סורב',
    'general.trading.Sell': 'מכירה',
    'general.trading.orderStatus.PlacingOrder': 'מציב את הההוראה...',
    'general.trading.orderStatus.CancelledByUser': 'בוטל על ידי המשתמש...',
    'general.trading.orderStatus.IllegalParameters': 'פרמטריי ההוראה לא חוקיים',
    'general.trading.orderStatus.Opened': 'נפתח בהצלחה',
    'general.trading.stopBuyMoreAsk': 'מחיר הוראת קנייה בסטופ שווה או נמוך ממחיר ההיצע בשוק, יתכן שההוראה תתממש באופן מיידי.',
    'general.trading.stopSellLessBid': 'מחיר הוראת מכירה בסטופ שווה או גבוה ממחיר הביקוש בשוק, יתכן שההוראה תתממש באופן מיידי.',
    'general.trading.with offset': 'עם תוספת הפרש',
    'general.Tuesday': 'שלישי',
    'property.general.WarnIfWrongOrderParam': 'הצג התראה אם ההוראה שגויה',
    'property.general.WarnIfWrongOrderParam.tooltip': 'הצגת אזהרה אם הפרמטרים של ההוראה שגויים',
    'general.WarnIfOrderRepeat': 'לא מוסתר',
    'property.general.WarnIfIdenticalOrderTime': '',
    'property.general.WarnIfIdenticalOrder': 'הצגת אזהרה אם הוצבה הוראה עוקבת זהה (שנייה)',
    'property.general.WarnIfOrderQtyExceed': 'אזהרה אם כמות ההוראה גבוהה מ-',
    'property.general.WarnIfOrderQtyExceed.tooltip': 'אזהרה זו מופעלת אם כמות ההוראה חורגת מהמגבלה המותרת.',
    'property.general.WarnIfOrderCapitalExceed': 'אזהר אם ההון של ההוראה גבוה מ-',
    'property.general.WarnIfOrderCapitalExceed.tooltip': 'אזהרה זו מופעלת אם הון ההוראה חורג מהסכום המותר.',
    'property.general.WarnIfTodayGrossLess': 'הזהר אם הברוטו היום קטן מ-',
    'property.general.WarnIfTodayGrossLess.tooltip': 'אזהרה זו מופעלת אם ההכנסה ברוטו היום נמוכה מהסף שצוין.',
    'property.general.WarnIfAvailibleFundsLess': 'אזהר אם הכסף הזמין נמוך מ-',
    'property.general.WarnIfAvailibleFundsLess.tooltip': 'אזהרה זו מופעלת אם הכספים הזמינים יורדים מתחת למינימום שצוין.',
    'property.general.WarnIfTodayVolumeExeed': 'הזהר אם הנפח היום גדול מ-',
    'property.general.WarnIfTodayVolumeExeed.tooltip': 'אזהרה זו מופעלת אם נפח המסחר היום חורג מהמגבלה המותרת.',
    'property.general.ShowInstrumentHalt': 'הצג אזהרות השהיית סמל',
    'property.general.ShowInstrumentHalt.tooltip': 'אזהרה זו מוצגת אם יש השהייה בסמל המסחר.',
    'property.general.WarnIfQtyToCloseMoreThanMaxLot': 'אזהרה אם הכמות לסגירה > לוט מקסימלי',
    'property.general.WarnWhenEnteringIntoLeverage': 'אזהרה בעת כניסה למינוף',
    'general.WarnIfIdenticalOrdertText': 'אתה מנסה להציב הוראה עם פרמטרים זהים להוראה הקודמת ב-{0} השניות האחרונות.',
    'general.warnings.quantityExceedText': 'הכמות של ההוראה [{0}] עולה על רמת האזהרה [{1}].',
    'general.warnings.orderCapitalExceedText': 'סכום ההון של ההוראה [{0}] עולה על רמת האזהרה [{1}].',
    'general.warnings.todayGrossLessText': 'ברוטו היום [{0}] נמוך ממגבלת אזהרה [{1}]',
    'general.warnings.availibleFundsLessText': 'כספים זמינים [{0}] נמוך ממגבלת אזהרה [{1}]',
    'general.warnings.todayVolumeExeedText': 'נפח כולל היום [{0}] עולה על מגבלת האזהרה [{1}]',
    'general.warnings.instrumentHaltHeader': 'השהיית מסחר {0}',
    'general.warnings.instrumentHaltText': "אזהרה. המכשיר '{0}' הגיע למגבלות המסחר. המסחר הופסק זמנית. הפעולות הזמינות: ביטול הוראות לאחר ההשהייה גבולות המסחר יורחבו.",
    'general.Wednesday': 'רביעי',
    'general.InstrumentIsNotAvailableNow': 'המכשיר אינו זמין יותר',
    GTC: 'GTC',
    'helpPage.link': 'https://guide.traderevolution.com/project/',
    'homePage.link': 'http://traderevolution.com/',
    Ichimoku: "איצ'ימוקו",
    'Instrument.Futures.contract': 'חוזה',
    'Instrument.Level1.ExtendedFields.NormalMarketSize': 'גודל שוק רגיל',
    'Instrument.Spreadbet.bet': 'הימורים',
    'Instrument.Corporate.Securities': 'ניירות ערך',
    'Instrument.ExerciseStyle.EUROPEAN': 'אירופאי',
    'Instrument.ExerciseStyle.AMERICAN': 'אמריקאי',
    'InstrumentDetailsPanel.(Indicative symbol)': '(סמל אינדיקטיבי)',
    'InstrumentDetailsPanel.1.GeneralInfo': 'מידע כללי',
    'InstrumentDetailsPanel.2.TradingInfo': 'מידע מסחר',
    'InstrumentDetailsPanel.3.MarginReg': 'דרישת בטוחות',
    'InstrumentDetailsPanel.4.Fees': 'עמלות',
    'InstrumentDetailsPanel.4.Fees.InfoIconTooltip': 'עמלות עבור {0}. כדי לראות עמלות עבור חשבון אחר יש לפתוח חלונית עם חיפוש חשבון או להשתמש בקישור לחשבון.',
    'InstrumentDetailsPanel.5.Rebates': 'החזרים',
    'InstrumentDetailsPanel.6.SessionInfo': 'לוח זמנים אינדיקטיבי לשוק',
    'InstrumentDetailsPanel.7.Plans': 'תוכניות',
    'InstrumentDetailsPanel.AccruedInterest': 'ריבית צבורה',
    'InstrumentDetailsPanel.AddLiqudityRebateOrderPerLot': 'הוסף החזר נזילות להוראה לפי לוט',
    'InstrumentDetailsPanel.AddLiqudityRebatePerLot': 'הוסף החזר נזילות לפי לוט',
    'InstrumentDetailsPanel.AddLiqudityRebatePerVolume': 'הוסף החזר נזילות לפי נפח',
    'InstrumentDetailsPanel.AFTER_MARKET': 'אפטר מרקט',
    'InstrumentDetailsPanel.Allow short positions': 'כן',
    'InstrumentDetailsPanel.AllowedOperations': 'פעולות מותרות',
    'InstrumentDetailsPanel.AllowedOrderTypes': 'סוגי הוראות מותרות',
    'InstrumentDetailsPanel.AllowShortPositions': 'אפשר פוזיציות שורט',
    'InstrumentDetailsPanel.AllowOvernightTrading': 'אפשר מסחר ללילה',
    'InstrumentDetailsPanel.Amount': 'כמות.',
    'InstrumentDetailsPanel.AssetClass': 'סוג הסימול',
    'InstrumentDetailsPanel.BEFORE_MARKET': 'מסחר טרום שוק (פרה-מרקט)',
    'InstrumentDetailsPanel.Cash': 'מזומן',
    'InstrumentDetailsPanel.Close': 'סגירה',
    'InstrumentDetailsPanel.Closed': 'סגור',
    'InstrumentDetailsPanel.CloseOutDeadline': 'מועד סגירה',
    'InstrumentDetailsPanel.Commisions': 'עמלות',
    'InstrumentDetailsPanel.ContactMonth': 'חודש חוזה',
    'InstrumentDetailsPanel.ContractMultiplier': '#hidden#',
    'InstrumentDetailsPanel.ContractSize': 'כמות החוזה',
    'InstrumentDetailsPanel.CouponCycle': 'מחזור קופון',
    'InstrumentDetailsPanel.CouponRate': 'שיעור קופון, %',
    'InstrumentDetailsPanel.CurrentSession': 'מושב המסחר הנוכחי',
    'InstrumentDetailsPanel.DeliveryMethod': 'שיטת משלוח',
    'InstrumentDetailsPanel.DeliveryStatus': 'סטטוס משלוח',
    'InstrumentDetailsPanel.Depend from account': 'תלוי בחשבון',
    'InstrumentDetailsPanel.Description': 'תיאור',
    'InstrumentDetailsPanel.Exchange': 'בורסה',
    'InstrumentDetailsPanel.ExchangeTradeSession': 'סשן בורסה',
    'InstrumentDetailsPanel.Exp1': 'נכס',
    'InstrumentDetailsPanel.FaceValue': 'ערך נקוב',
    'InstrumentDetailsPanel.FirstTradeDate': 'תאריך מסחר ראשון',
    'InstrumentDetailsPanel.Futures': 'חוזים עתידיים',
    'InstrumentDetailsPanel.FuturesClass': 'סוג חוזים עתידיים',
    'InstrumentDetailsPanel.HiLimit': 'גבול עליון',
    'InstrumentDetailsPanel.HiLimitFromPriceLimitsMsg': 'גבול עליון',
    'InstrumentDetailsPanel.Holiday': 'חג',
    'InstrumentDetailsPanel.HolidayDate': 'תאריך',
    'InstrumentDetailsPanel.HolidayName': 'שם חג',
    'InstrumentDetailsPanel.Holidays list': 'רשימת חגים',
    'InstrumentDetailsPanel.HolidayType': 'לוח זמנים',
    'InstrumentDetailsPanel.immediate': 'מיידי',
    'InstrumentDetailsPanel.KEYNextHoliday': 'החג הבא',
    'InstrumentDetailsPanel.LastTradeDate': 'תאריך מסחר אחרון',
    'InstrumentDetailsPanel.LiquidationOnly': 'מימוש בלבד',
    'InstrumentDetailsPanel.LotSize': 'כמות חוזה(לוט)',
    'InstrumentDetailsPanel.LotStep': 'צעד לוט',
    'InstrumentDetailsPanel.LowLimit': 'גבול תחתון',
    'InstrumentDetailsPanel.LowLimitFromPriceLimitsMsg': 'גבול תחתון',
    'InstrumentDetailsPanel.MAIN': 'ראשי',
    'InstrumentDetailsPanel.Margin': 'דרישת בטוחות',
    'InstrumentDetailsPanel.Margin_ByAccount': 'בטוחות לפי חשבון',
    'InstrumentDetailsPanel.MarginBuy': 'קנייה',
    'InstrumentDetailsPanel.MarginDay': 'יום',
    'InstrumentDetailsPanel.MarginDayBuy': 'קנייה יום',
    'InstrumentDetailsPanel.MarginDaySell': 'מכירה יום',
    'InstrumentDetailsPanel.MarginBuy.Intraday': 'קנייה תוך-יומית',
    'InstrumentDetailsPanel.MarginSell.Intraday': 'תוך-יומי - מכירה',
    'InstrumentDetailsPanel.MarginBuy.Delivery': 'משלוח קנייה',
    'InstrumentDetailsPanel.MarginSell.Delivery': 'מעל יום - מכירה',
    'InstrumentDetailsPanel.MarginInAccountCurrency': '#hidden#',
    'InstrumentDetailsPanel.MarginOvernight': 'החזקה למשך לילה',
    'InstrumentDetailsPanel.MarginOvernightBuy': 'קנייה למשך הלילה',
    'InstrumentDetailsPanel.MarginOvernightSell': 'החזקה למשך לילה - מכירה',
    'InstrumentDetailsPanel.MarginSell': 'מכירה',
    'InstrumentDetailsPanel.MaturityDate': 'תאריך פירעון',
    'InstrumentDetailsPanel.MaximumLot': 'לוט מקסימלי',
    'InstrumentDetailsPanel.MaxPositionQtyPerSymbol': 'כמות מקסימלית לפוזיציה',
    'InstrumentDetailsPanel.MaxPositionQtyPerSymbol.Intraday': 'כמות מקסימלית לפוזיציה תוך יומית',
    'InstrumentDetailsPanel.MaxPositionQtyPerSymbol.Delivery': 'כמות מקסימלית לפוזיציה למשלוח',
    'InstrumentDetailsPanel.MinimalLot': 'לוט מינימלי',
    'InstrumentDetailsPanel.NextPaymentDate': 'תשלום התשואה הבאה',
    'InstrumentDetailsPanel.No': 'לא',
    'InstrumentDetailsPanel.non trading day': 'סגירה',
    'InstrumentDetailsPanel.None': 'ללא',
    'InstrumentDetailsPanel.NormalMarketSize': '#hidden#',
    'InstrumentDetailsPanel.Not allow short positions': 'לא',
    'InstrumentDetailsPanel.NoticeDate': 'תאריך הודעה',
    'InstrumentDetailsPanel.onlyCloseOrders': 'רק הוראות סגירה',
    'InstrumentDetailsPanel.Open': 'פתוח',
    'InstrumentDetailsPanel.OptionExercise': 'עמלת מימוש אופציה',
    'InstrumentDetailsPanel.OptionExercise1': 'עמלת מימוש אופציה (לונג)',
    'InstrumentDetailsPanel.OptionExercise3': 'עמלת מימוש אופציה (שורט)',
    'InstrumentDetailsPanel.PerOrderVolume1': 'נפח ההוראה',
    'InstrumentDetailsPanel.PerOrderVolume2': 'נפח ההוראה',
    'InstrumentDetailsPanel.PerOrderVolume3': 'נפח ההוראה',
    'InstrumentDetailsPanel.PerOrder': 'לכל הוראה',
    'InstrumentDetailsPanel.PerOrderVolume': 'נפח הוראה, %',
    'InstrumentDetailsPanel.PerPhoneTransaction': 'לטרנזקציה טלפונית',
    'InstrumentDetailsPanel.PerTransaction': 'לטרנזקציה',
    'InstrumentDetailsPanel.PerVolume': 'נפח מילוי, %',
    'InstrumentDetailsPanel.Physically': 'פיזית',
    'InstrumentDetailsPanel.POSTCLOSE': 'מסחר אפטר',
    'InstrumentDetailsPanel.PREOPEN': 'טרום שוק',
    'InstrumentDetailsPanel.PreviousPaymentDate': 'תשלום תשואה קודם',
    'InstrumentDetailsPanel.Price': 'מחיר',
    'InstrumentDetailsPanel.ProductType': 'סוג מוצר',
    'InstrumentDetailsPanel.QuotiongCurrency': 'מטבע ציטוט',
    'InstrumentDetailsPanel.RemoveLiqudityRebateOrderPerLot': 'הסר החזר נזילות להוראה לפי לוט',
    'InstrumentDetailsPanel.RemoveLiqudityRebatePerLot': 'הסר החזר נזילות לפי לוט',
    'InstrumentDetailsPanel.RemoveLiqudityRebatePerVolume': 'הסר החזר נזילות לפי נפח',
    'InstrumentDetailsPanel.SessionStatus': '#hidden#',
    'InstrumentDetailsPanel.SettlementDate': 'תאריך סליקה',
    'InstrumentDetailsPanel.shortened': 'יום מקוצר',
    'InstrumentDetailsPanel.ShortCommissionInfo': 'פרטי עמלות',
    'InstrumentDetailsPanel.ShortPostionInterest': 'ריבית פוזיצית שורט',
    'InstrumentDetailsPanel.StrikePrice': 'מחיר סטרייק',
    'InstrumentDetailsPanel.SwapDetails': 'הפרטים של ה-Swap',
    'InstrumentDetailsPanel.SwapBuy': 'SWAP לונג',
    'InstrumentDetailsPanel.SwapSell': 'SWAP שורט',
    'InstrumentDetailsPanel.Latest historical long swap': 'החלפה ארוכה היסטורית אחרונה',
    'InstrumentDetailsPanel.Latest historical short swap': 'החלפה קצרה היסטורית אחרונה',
    'InstrumentDetailsPanel.Historical swap last updated on': 'החלפה היסטורית עודכנה לאחרונה ב-',
    'InstrumentDetailsPanel.Symbol': 'סמל',
    'InstrumentDetailsPanel.T+0': 'T + 0 (היום)',
    'InstrumentDetailsPanel.TickCoast': 'עלות טיק',
    'InstrumentDetailsPanel.TickSize': 'כמות טיק',
    'InstrumentDetailsPanel.Tier': 'שכבה',
    'InstrumentDetailsPanel.TradindBlockedOnSession': 'המסחר חסום בסשן',
    'InstrumentDetailsPanel.TradingBalance': 'מערכת סליקה',
    'InstrumentDetailsPanel.TradingHalt': 'השהיית מסחר',
    'InstrumentDetailsPanel.TradingStatus': 'סטטוס סמל',
    'InstrumentDetailsPanel.Underlier': 'תחתון',
    'InstrumentDetailsPanel.VAT': 'מע"מ',
    'InstrumentDetailsPanel.Volume': 'נפח מסחר',
    'InstrumentDetailsPanel.VolumeWithMinPD': 'נפח מילוי, %, עם מינימום ליום',
    'InstrumentDetailsPanel.VolumeWithMinPDOPEN': 'נפח מילוי, %, עם מינימום ליום (פתיחה)',
    'InstrumentDetailsPanel.VolumeWithMinPDCLOSE': 'נפח מילוי, %, עם מינימום ליום (סגירה)',
    'InstrumentDetailsPanel.PerVolume1': 'נפח מילוי (קנייה), %',
    'InstrumentDetailsPanel.PerVolume2': 'נפח הפקודה',
    'InstrumentDetailsPanel.PerVolume3': 'נפח מילוי (מכירה), %',
    'InstrumentDetailsPanel.working': 'פתח',
    'InstrumentDetailsPanel.Yes': 'כן',
    'InstrumentDetailsPanel.Yield': 'תשואה',
    'InstrumentDetailsPanel.YTM': 'תשואה לפדיון, %',
    'InstrumentDetailsPanel.YTM.RefreshLink': 'רענן',
    'InstrumentDetailsPanel.HistoricalSwap.points': 'נקודות',
    'InstrumentDetailsPanel.HighLimitWarning': 'אזהרת גבול עליון',
    'InstrumentDetailsPanel.HighLimitWarning.descr': 'הגבול העליון של טווח המחיר האחרון המותר עם שינוי אחרון % שמעליו הוראות הגבלה מקבלות אזהרה',
    'InstrumentDetailsPanel.LowLimitWarning': 'אזהרת גבול תחתון',
    'InstrumentDetailsPanel.LowLimitWarning.descr': 'הגבול התחתון של טווח המחיר האחרון המותר עם שינוי אחרון % שמתחתיו הוראות הגבלה מקבלות אזהרה',
    'InstrumentDetailsPanel.ExtField.TradingUnit': '#hidden#',
    'InstrumentDetailsPanel.ExtField.PriceQuoteUnit': '#hidden#',
    'InstrumentDetailsPanel.ExtField.DeliveryUnit': '#hidden#',
    'InstrumentDetailsPanel.ExtField.LotSize': '#hidden#',
    'InstrumentDetailsPanel.ExtField.TenderPeriodStartDate': '#hidden#',
    'InstrumentDetailsPanel.ExtField.TenderPeriodEndDate': '#hidden#',
    'InstrumentDetailsPanel.ExtField.SMFlag.Short term ASM Flag': 'דגל ASM לטווח קצר',
    'InstrumentDetailsPanel.ExtField.SMFlag.Long term ASM Flag': 'דגל ASM לטווח ארוך',
    'InstrumentDetailsPanel.ExtField.SMFlag.GSM Flag': 'דגל GSM',
    'InstrumentDetailsPanel.ExtField.SMFlag.ESM Flag': 'דגל ESM',
    'InstrumentDetailsPanel.CareOrder': 'הוראה לטיפול',
    IOC: 'IOC',
    'IsAllowedResponceReason.CloseViaOENotAllowed': '"סגור דרך OE" אינו זמין לפוזיציה זו.',
    'IsAllowedResponceReason.ExecuteAtMarketNotAllowedForBindOrders': 'לא ניתן לבצע כשוק להוראות מוגבלות',
    'IsAllowedResponceReason.ExecuteAtMarketNotAllowedForSlTp': 'ביצוע בשוק אינו מותר עבור SL/TP',
    'IsAllowedResponceReason.ExecuteAtMarketNotAllowedOrderType': 'שינוי סוג ההוראה או סוג הוראת השוק אינו מותר',
    'IsAllowedResponceReason.InstrumentForAccountDelivery': 'מכשיר למשלוח חשבון',
    'IsAllowedResponceReason.InstrumentTradingMode': 'המסחר במכשיר אינו מותר',
    'IsAllowedResponceReason.LockTrading': 'המסחר נעול בפלטפורמה',
    'IsAllowedResponceReason.LockTradingByPassword': 'אנא הזן את סיסמת המסחר בתחתית הטרמינל',
    'IsAllowedResponceReason.MarketCloseNotAllowed': 'סגירה בשוק אינה זמינה לכלי/לסשן זה. השתמש ב־"סגור דרך OE".',
    'IsAllowedResponceReason.NoLastQuote': 'אין ציטוט אחרון',
    'IsAllowedResponceReason.NotAllowedByOrderStaus': 'הפעולות אינן מותרות על פי מצב ההוראה',
    'IsAllowedResponceReason.NotAllowedMaxLotHasBeenReached': 'הושגה כמות מקסימלית',
    'IsAllowedResponceReason.NotAllowedByExploreMode': 'התחבר כדי להתחיל לסחור.',
    'IsAllowedResponceReason.NotAllowedPositionCloseOnly': 'מותר רק לסגור פוזיציות',
    'IsAllowedResponceReason.NotAllowedRouteOrderType': 'לא ניתן ליצור את ההוראה, מכיוון שאין תמיכה בתוקף ההוראה ובסוג ההוראה שנבחרו.',
    'IsAllowedResponceReason.NotClosablePosition': 'לא ניתנת לסגירה פוזיציה',
    'IsAllowedResponceReason.NotLoadCache': 'המטמון לא נטען',
    'IsAllowedResponceReason.NotVisibleInstrumentRoute': 'מכשיר או נתיב שאינם גלויים',
    'IsAllowedResponceReason.NotAllowedForTrades': 'לא מותר לעסקאות',
    'IsAllowedResponceReason.NotSupportedTIF': 'TIF לא נתמך',
    'IsAllowedResponceReason.OperationNotAllowedByOrderType': 'הפעולה אינה מותרת על פי סוג ההוראה',
    'IsAllowedResponceReason.OperationNotAllowedBySession': 'הפעולה אינה מותרת על ידי הסשן',
    'IsAllowedResponceReason.OptionPendingExerciseStatus': 'פוזיציה לחוזה ממתינה למימוש. ניתן לבטל את הביצוע במהלך סשן המסחר.',
    'IsAllowedResponceReason.OptionPendingExerciseDealticket': 'המסחר אסור מכיוון שפוזיציה לחוזה {0} ממתינה למימוש.',
    'IsAllowedResponceReason.OrderTypeNotAllowedBySession': 'סוג ההוראה אינו מותר על ידי הסשן',
    'IsAllowedResponceReason.RouteNotRunning': 'המסחר במכשיר אינו מותר.',
    'IsAllowedResponceReason.RuleAdministration': 'ניהול כלל',
    'IsAllowedResponceReason.RuleClosePositionDisable': 'סגירת הפוזיציה אינה מותרת על פי הכלל',
    'IsAllowedResponceReason.RuleFunctionSelfTrading': 'פונקציית מסחר עצמי של הכלל',
    'IsAllowedResponceReason.RuleTrading': 'המסחר אינו מותר על פי הכלל',
    'IsAllowedResponceReason.RuleFunctionTrading': 'המסחר הושבת על ידי כללי הסיכון.',
    'IsAllowedResponceReason.RuleOCO': 'כלל OCO',
    'IsAllowedResponceReason.RuleSlTpNotAllowed': 'סטופ-לוס/מימוש רווח אסור לפי כלל',
    'IsAllowedResponceReason.RuleTrStop': 'כלל סטופ נגרר',
    'IsAllowedResponceReason.Unknown': 'סיבה לא ידועה',
    'IsAllowedResponceReason.NotAllowedCorporateActionPositions': 'מושבת עבור פוזיציות של פעולה תאגידית',
    'IsAllowedResponceReason.WrongTraidingPositionType': 'סוג פוזיציית מסחר שגויה',
    'Keltner Channel': 'ערוץ קלטנר',
    Limit: 'לימיט',
    'Linear Weighted Moving Average': 'ממוצע נע משוקלל ליניארי',
    LOC: 'LOC (LIMIT בסגירה)',
    LOO: 'LOO',
    Manual: 'ידני',
    Market: 'מרקט',
    'MarketDepthPanel.ColoringMethod.ByPriceLVL': 'לפי רמת מחיר',
    'MarketDepthPanel.ColoringMethod.RelativeToVolume': 'יחסית לנפח',
    'MarketDepthPanel.ColoringMethod.SizeHistogram': 'היסטוגרמת גודל',
    'McGinley Dynamic': 'McGinley Dynamic',
    'MDLotsMode.General': 'ברירות מחדל כלליות ({1})',
    'MDLotsMode.Lots': 'לוטים',
    'MDLotsMode.RealSize': 'כמות אמיתי',
    'MessageBox.ThemeChanged.Title': 'אזהרה',
    MOC: 'MOC',
    'Modified Moving Average': 'ממוצע נע מעודכן',
    Momentum: 'מומנטיום',
    MOO: 'MOO',
    'Moving Average Envelope': 'מעטפת ממוצע נע',
    'Moving Average/Convergence Divergence': 'ממוצע נע/קונברגנציה דיברגנציה',
    'NetTrader.SaveWorkspace.Save': 'שמור מרחב עבודה',
    'NumericComboCtrl.Edit': 'הגדר ברירות מחדל',
    OCO: 'OCO',
    'OEProductTypeSelector.tooltip': 'הגדר סוג מוצר',
    'OELeverageSelector.tooltip': 'הגדר מינוף',
    'On Balance Volume': 'מאזן נפח',
    OnClose: 'בסגירה',
    OnOpen: 'בפתיחה',
    'Order.ExecutionType.ACCEPTED': 'התקבל',
    'Order.ExecutionType.ACTIVATED': 'מופעל',
    'Order.ExecutionType.CANCELED': 'בוטל',
    'Order.ExecutionType.FILLED': 'מומש',
    'Order.ExecutionType.NEW': 'נוצר',
    'Order.ExecutionType.PART_FILLED': 'הוזן חלקית',
    'Order.ExecutionType.REFUSED': 'נדחה',
    'Order.ExecutionType.REPLACED': 'נערך',
    'Order.ExecutionType.RESTATED': 'הוצג מחדש',
    'Order.ExecutionType.UNKNOWN': 'לא ידוע',
    'OrderEntry.InfoBlock.1.Risks': 'סיכונים',
    'OrderEntry.InfoBlock.2.Fees': 'עמלות',
    'OrderEntry.InfoBlock.After trade funds': 'כספים לאחר מסחר',
    'OrderEntry.InfoBlock.Availible funds': 'כספים זמינים',
    'OrderEntry.InfoBlock.Balance': 'יתרה',
    'OrderEntry.InfoBlock.Blocked for Stocks': 'חסום למניות',
    'OrderEntry.InfoBlock.Fee': 'עמלה',
    'OrderEntry.InfoBlock.Gross': 'ברוטו',
    'OrderEntry.InfoBlock.Impact on portfolio': 'השפעה על תיק ההשקעות',
    'OrderEntry.InfoBlock.Init. margin': 'בטוחות התחלתייות',
    'OrderEntry.InfoBlock.Maint. margin': 'בטוחות מתעדכנות',
    'OrderEntry.InfoBlock.Warn. margin': 'אזהרת בטוחות',
    'OrderEntry.InfoBlock.Margin availible': 'בטוחות זמינות',
    'OrderEntry.InfoBlock.Net': 'נטו',
    'OrderEntry.InfoBlock.Spread in loss': 'הפסד התחלתי מפער',
    'OrderEntry.InfoBlock.P/L per Tick': 'רווח/הפסד לטיק',
    'OrderEntry.InfoBlock.Allow short positions': 'אפשר פוזיציות שורט',
    'OrderEntry.InfoBlock.After trade cash': 'מזומן לאחר המסחר',
    'OrderEntry.InfoBlock.Free commission': 'ללא עמלה',
    'OrderEntry.InfoBlock.FillPerLot': 'מילוי חוזה(לוט)',
    'OrderEntry.InfoBlock.OrderPerLot': 'הוראה ללוט (חוזה)',
    'OrderEntry.InfoBlock.FillVolume': 'נפח מסחר',
    'OrderEntry.InfoBlock.FillVolumeWithMinPD': 'נפח מילוי, %, עם מינימום ליום',
    'OrderEntry.InfoBlock.PerFill': 'לכל מילוי',
    'OrderEntry.InfoBlock.PerTransaction': 'לטרנזקציה',
    'OrderEntry.InfoBlock.PerPhoneTransaction': 'לטרנזקציה טלפונית',
    'OrderEntry.InfoBlock.VAT': 'מע"מ',
    'OrderEntry.InfoBlock.OrderVolume': 'נפח הוראה',
    'OrderEntry.InfoBlock.SwapDetails': 'פרטי הסוואפ',
    'OrderEntry.InfoBlock.LongSwap': 'ריבית סוואפ על קנייה',
    'OrderEntry.InfoBlock.refreshBtnTooltip': 'לחץ כדי לרענן את נתוני הבטוחות, או המתן 30 שניות.',
    'OrderEntry.InfoBlock.ShortSwap': 'ריבית סוואפ על מכירה',
    'OrderEntry.InfoBlock.TotalFee': 'סה"כ עמלה',
    'OrderEntry.InfoBlock.Visibility': '#not hidden#',
    'OrderEntry.InfoBlock.Incoming funds': 'כספים נכנסים',
    'OrderEntry.InfoBlock.CareOrder': 'הוראה לטיפול',
    'OverlayScreen.barsBodyLabel': 'גוף',
    'OverlayScreen.barsBorderLabel': 'גבולות',
    'OverlayScreen.barsHiLowLabel': 'קו',
    'OverlayScreen.cancelButton': 'ביטול',
    'OverlayScreen.dataLabel': 'סוג נתונים',
    'OverlayScreen.dojiLabel': "דוג'י",
    'OverlayScreen.histogramLineLabel': 'קו היסטוגרמה',
    'OverlayScreen.instrumentLabel': 'סימול',
    'OverlayScreen.Main scale': 'סולם ראשי',
    'OverlayScreen.name': 'שכבה',
    'OverlayScreen.numberOverlaysError': 'אינך יכול להוסיף יותר מ-5 חפיפות.',
    'OverlayScreen.okButton': 'אוקיי',
    'OverlayScreen.Overlays': 'שכבות',
    'OverlayScreen.priceLabel': 'מידרוג מחירים',
    'OverlayScreen.priceMarkerCheckbox': 'הצג סמן מחיר',
    'OverlayScreen.Separate scale': 'סולם נפרד',
    'OverlayScreen.solidPriceLabel': 'אזור',
    'OverlayScreen.styleLabel': 'סגנון',
    'OverlayScreen.wickLabel': 'פתיל',
    'panel.accountDetails.Groups.1.General': 'כללי',
    'panel.accountDetails.Groups.2.Margin': 'בטוחות',
    'panel.accountDetails.Groups.3.AccountActivity': 'פעילות חשבון',
    'panel.accountDetails.Groups.4.TodayResults': 'תוצאות היום',
    'panel.accountDetails.Groups.5.RiskManagement': 'ניהול סיכונים',
    'panel.accountDetails.Groups.55.Plans': 'תוכניות',
    'panel.accountDetails.Groups.6.Info': 'מידע',
    'panel.AccountDetailsPanel': 'פרטי חשבון',
    'panel.AccountDetailsPanel.InfoTooltip': 'שנה את השדות ביישומון, על ידי גרירה ושחרור מהטבלה',
    'panel.MarketConsensusPanel': 'קונצנזוס שוק',
    'panel.MarketConsensusPanel.topLong': 'לונגים מובילים',
    'panel.MarketConsensusPanel.topShort': 'שורט מובילים',
    'panel.accountDetails.Groups.Rico risks': 'פרטי חשבון',
    'panel.accountDetails.Groups.Kyrrex risks': 'פרטי חשבון',
    'panel.accountDetails.Groups.AccountActivity': '2. פעילות חשבון',
    'panel.accountDetails.Groups.General': '1. כללי',
    'panel.accountDetails.Groups.Info': '5. מידע',
    'panel.accountDetails.Groups.RiskManagement': '4. ניהול סיכונים',
    'panel.accountDetails.Groups.TodayResults': '3. תוצאות היום',
    'panel.accountDetails.Groups.Portfolio': 'תיק השקעות',
    'panel.accountDetails.Groups.Stocks': 'מניות',
    'panel.accountDetails.Groups.Credit': 'אשראי',
    'panel.accountDetails.Groups.Cash and Buying Power': 'מזומן וכוח קנייה',
    'panel.accountDetails.Kyrrex risks.AvailableBalance': 'יתרת מאזן זמינה',
    'panel.accountDetails.Kyrrex risks.BlockedBalance': 'יתרה חסומה',
    'panel.accountDetails.Rico risks.AVLM': 'בטוחות זמינות',
    'panel.accountDetails.Rico risks.BCKA': 'סכום חסום',
    'panel.accountDetails.Rico risks.BKBL': 'יתרה חסומה',
    'panel.accountDetails.Rico risks.BLNC': 'יתרה',
    'panel.accountDetails.Rico risks.BMBM': 'BMF - בטוחות חסומות',
    'panel.accountDetails.Rico risks.BMFL': 'מגבלת BMF',
    'panel.accountDetails.Rico risks.BOPT': 'מאזן אופציות',
    'panel.accountDetails.Rico risks.BUOP': 'מאזן פעולה לא מכוסה',
    'panel.accountDetails.Rico risks.CED0': 'יום קבלת אשראי 0',
    'panel.accountDetails.Rico risks.CED1': 'יום קבלת אשראי 1',
    'panel.accountDetails.Rico risks.CED2': 'יום קבלת אשראי 2',
    'panel.accountDetails.Rico risks.CED3': 'יום קבלת אשראי 3',
    'panel.accountDetails.Rico risks.CRLM': 'מגבלת אשראי',
    'panel.accountDetails.Rico risks.CRLO': 'מגבלת אשראי OPT',
    'panel.accountDetails.Rico risks.CULM': 'מגבלה נוכחית',
    'panel.accountDetails.Rico risks.D1PB': 'יתרה מוערכת D1',
    'panel.accountDetails.Rico risks.D2PB': 'יתרה מוערכת D2',
    'panel.accountDetails.Rico risks.D3PB': 'יתרה חזויה D3',
    'panel.accountDetails.Rico risks.D1PD': 'תאריך מוערך D1',
    'panel.accountDetails.Rico risks.D2PD': 'תאריך מוערך D2',
    'panel.accountDetails.Rico risks.D3PD': 'תאריך מוערך D3',
    'panel.accountDetails.Rico risks.DED0': 'יום חיוב 0',
    'panel.accountDetails.Rico risks.DED1': 'יום חיוב 1',
    'panel.accountDetails.Rico risks.DED2': 'יום חיוב 2',
    'panel.accountDetails.Rico risks.DED3': 'יום חיוב 3',
    'panel.accountDetails.Rico risks.DLBL': 'יתרת סילוק יומית',
    'panel.accountDetails.Rico risks.DLMT': 'מגבלה יומית',
    'panel.accountDetails.Rico risks.EBVL': 'ערך קנייה שבוצע',
    'panel.accountDetails.Rico risks.ESVL': 'ערך מכירה שבוצע',
    'panel.accountDetails.Rico risks.FBBL': 'יתרת BMF סופית',
    'panel.accountDetails.Rico risks.FNBL': 'יתרה סופית',
    'panel.accountDetails.Rico risks.FNLE': 'מינוף פיננסי',
    'panel.accountDetails.Rico risks.INBA': 'יתרה התחלתית',
    'panel.accountDetails.Rico risks.INBL': 'יתרה התחלתית',
    'panel.accountDetails.Rico risks.LEVE': 'מינוף',
    'panel.accountDetails.Rico risks.LILO': 'מגבלת מינוף אופציות',
    'panel.accountDetails.Rico risks.LVLM': 'מגבלת מינוף',
    'panel.accountDetails.Rico risks.NTEQ': 'הון עצמי נטו',
    'panel.accountDetails.Rico risks.OPBL': 'יתרת אופציות',
    'panel.accountDetails.Rico risks.OVLT': 'מגבלת משיכת יתר',
    'panel.accountDetails.Rico risks.PBVL': 'ערך קנייה בהמתנה',
    'panel.accountDetails.Rico risks.POVA': 'סכום משיכת יתר פוטנציאלי',
    'panel.accountDetails.Rico risks.PRBA': 'יתרה מוערכת',
    'panel.accountDetails.Rico risks.PSVL': 'ערך מכירה בהמתנה',
    'panel.accountDetails.Rico risks.SKBL': 'יתרת מניות',
    'panel.accountDetails.Rico risks.WDBL': 'יתרת משיכה',
    'panel.accountDetails.Portfolio.TR_OAL': 'שווי תיק נטו',
    'panel.accountDetails.Portfolio.TR_T1B': 'שווי תיק נטו T1',
    'panel.accountDetails.Portfolio.TR_T2B': 'שווי תיק נטו T2',
    'panel.accountDetails.Portfolio.TR_ASN': 'יתרת קנייה מכירה נטו',
    'panel.accountDetails.Stocks.TR_CHS': 'יתרת מניות',
    'panel.accountDetails.Stocks.TR_CHST1': 'יתרת מניות T1',
    'panel.accountDetails.Stocks.TR_CHST2': 'יתרת מניות T2',
    'panel.accountDetails.Stocks.TR_CBK': 'מזומן',
    'panel.accountDetails.Stocks.TR_CBKT1': 'מזומן T1',
    'panel.accountDetails.Stocks.TR_CBKT2': 'מזומן T2',
    'panel.accountDetails.Credit.TR_KRD': 'יתרת זיכוי',
    'panel.accountDetails.Credit.TR_KRDT1': 'יתרת זיכוי T1',
    'panel.accountDetails.Credit.TR_KRDT2': 'יתרת זיכוי T2',
    'panel.accountDetails.Credit.TR_OZK': 'יחס חוב להון',
    'panel.accountDetails.Credit.TR_OZ1': 'יחס חוב להון T1',
    'panel.accountDetails.Credit.TR_OZ2': 'יחס חוב להון T2',
    'panel.accountDetails.Cash and Buying Power.TR_NAK': 'מגבלת מזומן',
    'panel.accountDetails.Cash and Buying Power.TR_ISL': 'כוח קנייה תוך-יומי',
    'panel.accountDetails.Cash and Buying Power.TR_LMT': 'יתרת זיכוי',
    'panel.accountDetails.Cash and Buying Power.TR_KIL': 'יתרת זיכוי זמינה',
    'panel.accountDetails.Cash and Buying Power.TR_ASL': 'מגבלת מכירות בחסר זמינה',
    'panel.accountDetails.Cash and Buying Power.TR_GKZ': 'שינוי כולל',
    'panel.accountDetails.Cash and Buying Power.TR_TPLM': 'שווי הון עצמי כולל',
    'panel.accountDetails.Cash and Buying Power.TR_TPLMT1': 'שווי הון עצמי כולל T1',
    'panel.accountDetails.Cash and Buying Power.TR_TPLMT2': 'שווי הון עצמי כולל T2',
    'panel.AccountLink.SymbolLink.ToolTip': 'קישור סימול',
    'panel.AccountLink.ToolTip': 'קישור חשבון',
    'panel.AccountLink.CanFilterToolTip': 'הנתונים בפאנל מסוננים לפי חשבון',
    'panel.AccountLinkButton.ToolTip': 'פונקציה זו מסננת את הפוזיציות וההוראות לפי חשבון. החשבון מתחלף באופן סינכרוני בכל החלוניות',
    'panel.accounts.AccountLink.ToolTip': 'קישור חשבונות מופעל',
    'panel.accounts': 'חשבונות',
    'panel.accounts.AccountDescription': '#hidden#',
    'panel.accounts.accountDetails.RiskManagement.MaxOrderCapital.Unlimited': 'ללא הגבלה',
    'panel.accounts.accountDetails.RiskManagement.Trading.Daily loss limit reached': 'הגעת למגבלת ההפסד היומי',
    'panel.accounts.accountDetails.RiskManagement.Trading.Max day volume  reached': 'הגעת לנפח היומי המקסימלי',
    'panel.accounts.accountDetails.RiskManagement.Trading.Order Flow Limit(per day)': 'מגבלת זרם הוראות (ליום)',
    'panel.accounts.accountDetails.RiskManagement.Trading.State.Disabled': 'מושבת',
    'panel.accounts.accountDetails.RiskManagement.Trading.State.Enabled': 'מופעל',
    'panel.accounts.accountDetails.RiskManagement.TradingStatus.Active': 'פעיל',
    'panel.accounts.accountDetails.RiskManagement.TradingStatus.Auto closed': 'נסגר באופן אוטומטי',
    'panel.accounts.accountDetails.RiskManagement.TradingStatus.Closed': 'סגור',
    'panel.accounts.accountDetails.RiskManagement.TradingStatus.Disabled by risk rules': 'מסחר הושבת על ידי כללי סיכון',
    'panel.accounts.accountDetails.RiskManagement.TradingStatus.Disabled by risk rules.maxOrdersPerDay': 'המסחר הושבת על ידי כללי הסיכון. הגעת למספר ההוראות המרבי ליום.',
    'panel.accounts.accountDetails.RiskManagement.TradingStatus.FinraDayTraderStatus': 'דפוס סוחר יום FINRA',
    'panel.accounts.accountDetails.RiskManagement.TradingStatus.LiquidationOnlyStatus': 'מימוש בלבד',
    'panel.accounts.accountDetails.RiskManagement.TradingStatus.MarginWarning': 'אזהרה לגבי סטופ-אאוט פוטנציאלי',
    'panel.accounts.accountDetails.RiskManagement.TradingStatus.Max trailing drawdown was reached': 'הגעת לירידה הנגררת המקסימלית',
    'panel.accounts.accountDetails.RiskManagement.TradingStatus.Suspend': 'השהה',
    'panel.accounts.accountDetails.RiskManagement.TradingStatus.Unrealized loss limit reached': 'הושגה מגבלת הפסד לא ממומש',
    'panel.accounts.accountDetails.RiskManagement.TradingStatus.Weekly lost limit reached': 'הושגה מגבלת הפסד שבועית',
    'panel.accounts.AccountMode': 'מצב חשבון',
    'panel.accounts.AccountType': 'סוג חשבון',
    'panel.accounts.AccountValue': 'ערך חשבון',
    'panel.accounts.AllowOvernightTrading': '#hidden#',
    'panel.accounts.AllowTradingPrePost': 'מסחר בשווקים טרום/לאחר',
    'panel.accounts.Asset': 'נכס',
    'panel.accounts.AssetDescription': 'תיאור נכס',
    'panel.accounts.AssetType': 'סוג נכס',
    'panel.accounts.AvailableMargin': 'בטחונות זמינים',
    'panel.accounts.Balance': 'יתרה',
    'panel.accounts.BalancePlusAllRisks': 'יתרה וכל הסיכונים',
    'panel.accounts.BeginBalance': 'נטו של היום',
    'panel.accounts.BlockedByOrders': 'בטוחות ששימשו להוראות',
    'panel.accounts.BlockedByPamm': 'הון קרן מושקע',
    'panel.accounts.BlockedForStocks': '#hidden#',
    'panel.accounts.BlockedForStocksNew': 'חסום למניות',
    'panel.accounts.CashBalance': 'יתרת מזומנים',
    'panel.accounts.ClientType': 'סוג הטרמינל',
    'panel.accounts.Commissions': 'עמלות',
    'panel.accounts.CreditValue': 'ערך אשראי',
    'panel.accounts.CurBalance': 'יתרה חזויה',
    'panel.accounts.CurMargin': 'דרישת בטוחות התחלתית, %',
    'panel.accounts.CurrentDailyLoss': 'הפסד יומי',
    'panel.accounts.CurrentFundCapital': 'הון קרן נוכחי',
    'panel.accounts.CurrentStatus': 'סטטוס מסחר',
    'panel.accounts.CurrentStatus.descr': 'סטטוס מסחר',
    'panel.accounts.CurrentWeeklyLoss': 'הפסד שבועי',
    'panel.accounts.Email': 'דוא"ל',
    'panel.accounts.EODTrailingDrawdownLevel': 'רמת ירידה נגררת בסוף היום',
    'panel.accounts.RelativeDailyLossLimit': 'הגבלת הפסד יומי יחסי מקסימלי',
    'panel.accounts.Estimate value': 'ערך משוער',
    'panel.accounts.FundCapitalGain': 'רווח הון קרן',
    'panel.accounts.FundsUsed': 'כספים בשימוש',
    'panel.accounts.FundsUsedPercent': 'כספים בשימוש, %',
    'panel.accounts.DayTraderPatternProtection': 'הגנת דפוס סוחר יומי',
    'panel.accounts.AvailableDayTrades': 'עסקאות יום זמינות',
    'panel.accounts.GrossPNL': 'ברוטו יומי',
    'panel.accounts.InsertOnBalance': 'הכנס ביתרה',
    'panel.accounts.InterestRate': 'ריבית, %',
    'panel.accounts.IntradayRiskManagement': 'סטטוס ניהול סיכונים',
    'panel.accounts.InitialMarginWithoutWaived': '#hidden#',
    'panel.accounts.InitialMarginWithoutWaived.descr': 'דרישת בטוחות התחלתית ללא ויתור',
    'panel.accounts.Leverage': 'מינוף',
    'panel.accounts.LockedBalance': 'יתרה חסומה',
    'panel.accounts.LockedBy': 'נעול',
    'panel.accounts.Login': 'חשבון',
    'panel.accounts.MaintMargin': 'דרישת בטוחות מתעדכנות, %',
    'panel.accounts.MarginAndRisks': 'בטוחות וסיכונים',
    'panel.accounts.MarginAvailableReal': 'בטוחות זמינות',
    'panel.accounts.MarginDeficiency': 'חוסר בבטוחות',
    'panel.accounts.MarginForOthers': '#hidden#',
    'panel.accounts.MarginRequirement': 'דרישת בטוחות מתעדכנות לפוזיציה',
    'panel.accounts.MarginStopOut': 'דרישת בטוחות מתעדכנות',
    'panel.accounts.MarginStopTrade': 'הפסק מסחר',
    'panel.accounts.MarginSurplus': 'עודף בטוחות',
    'panel.accounts.MarginUsedNew': 'דרישת בטוחות התחלתית',
    'panel.accounts.MarginWarning': 'אזהרת בטוחות',
    'panel.accounts.marginWarnPercent': 'רמת אזהרת בטוחות',
    'panel.accounts.MarketDataCharging': 'חיוב נתוני שוק',
    'panel.accounts.MaxDailyLossLimit': 'הגבלת הפסד יומי',
    'panel.accounts.MaxDailyProfit': 'יעד רווח יומי',
    'panel.accounts.MaxDayVolume': '#hidden#',
    'panel.accounts.MaximumLot': 'לוט מקסימלי',
    'panel.accounts.MaxOrderAmount': 'סכום מרבי בהוראה',
    'panel.accounts.MaxOrderCapital': 'הון מירבי בהוראה',
    'panel.accounts.MaxOrdersPerDay': 'מספר מקסימלי של הוראות ביום',
    'panel.accounts.MaxPendingOrders': 'מספר מרבי של הוראות בהמתנה',
    'panel.accounts.MaxDrawdownLevel': 'רמת ירידה מקסימלית',
    'panel.accounts.MaxPendingOrdersValue': 'שווי מרבי של הוראות בהמתנה',
    'panel.accounts.MaxPositionQtyPerSymbol': 'כמות מרבית בסימול',
    'panel.accounts.MaxPositions': 'מספר מרבי של פוזיציות',
    'panel.accounts.MaxWeekLostLimit': 'הגבלת הפסד שבועית',
    'panel.accounts.MinMargin': 'בטוחות בשימוש לפוזיציות',
    'panel.accounts.Murkups': 'מארק-אפ',
    'panel.accounts.N/A_TelephoneNumber': 'לא זמין',
    'panel.accounts.OptionPremiumReq': 'דרישת פרמיית אופציות',
    'panel.accounts.OptionValue': 'ערך אופציה',
    'panel.accounts.Orders': '# הוראות',
    'panel.accounts.Owner': 'בעלים',
    'panel.accounts.Positions': '# פוזיציות',
    'panel.accounts.PowerOfAttorney': 'ייפוי כוח',
    'panel.accounts.Profit': 'רווח/הפסד ברוטו פתוח',
    'panel.accounts.ProfitNet': 'רווח/הפסד פתוח נטו',
    'panel.accounts.Role': 'סוג קרן',
    'panel.accounts.Spreads': 'מרווחים',
    'panel.accounts.Status': 'סטטוס',
    'panel.accounts.Collateral': '#hidden#',
    'panel.accounts.BuyingPower': 'כוח קנייה',
    'panel.accounts.GivenLeverage': 'מינוף מורשה',
    'panel.accounts.OpenBalance': 'יתרה פתוחה',
    'panel.accounts.StopOut': 'שווי סטופ-אאוט',
    'panel.accounts.StopOut.descr': 'שווי סטופ-אאוט',
    'panel.accounts.StocksLiquidity': 'נזילות מניות',
    'panel.accounts.StocksOrdersReq': 'דרישת הוראות למניות',
    'panel.accounts.StocksValue': 'שווי מניות',
    'panel.accounts.stopOutPercent': 'רמת סטופ-אאוט',
    'panel.accounts.stopTradingPercent': 'רמת הפסקת מסחר',
    'panel.accounts.Swap': 'סוואפ',
    'panel.accounts.TelephoneNumber': 'מספר טלפון',
    'panel.accounts.TodaysPnLPercent': '% רווח או הפסד היום',
    'panel.accounts.TodayFees': 'עמלות של היום',
    'panel.accounts.TodayRebates': 'ההנחות של היום',
    'panel.accounts.TodaySwaps': '#hidden#',
    'panel.accounts.TodayTrades': 'עסקאות שנעשו היום',
    'panel.accounts.TodayTurnover': 'המחזור היום',
    'panel.accounts.TodayVolume': 'נפח מסחר יומי',
    'panel.accounts.TotalMaxPositionsQty': 'כמות מקסימלית כוללת של עמדות',
    'panel.accounts.TrailingDrawdownLevel': 'רמת ירידה נגררת',
    'panel.accounts.UnrealizedLoss': 'הפסד לא ממומש',
    'panel.accounts.UnrealizedLossLimit': 'מגבלת הפסד לא ממומש',
    'panel.accounts.UnsettledCash': 'מזומן לא מסולק',
    'panel.accounts.UserGroup': 'קבוצת משתמשים',
    'panel.accounts.UserID': 'מזהה משתמש',
    'panel.accounts.UserLogin': 'שם משתמש',
    'panel.accounts.VolumeLimitForALL': 'מגבלת נפח כוללת',
    'panel.accounts.VolumeLimitForFOREX': 'מגבלת נפח מט"ח',
    'panel.accounts.VolumeLimitForEQUITIES': 'מגבלת נפח מניות',
    'panel.accounts.VolumeLimitForFUTURES': 'מגבלת נפח חוזים עתידיים',
    'panel.accounts.VolumeLimitForOPTIONS': 'מגבלת נפח אופציות',
    'panel.accounts.VolumeLimitForEQUITIES_CFD': 'מגבלת נפח CFD על מניות',
    'panel.accounts.VolumeLimitForFORWARD': 'מגבלת נפח חוזי פורוורד',
    'panel.accounts.VolumeLimitForCFD_FUTURES': 'מגבלת נפח CFD על חוזים עתידיים',
    'panel.accounts.VolumeLimitForINDICIES': 'מגבלת נפח של מדדים',
    'panel.accounts.VolumeLimitForCRYPTO': 'מגבלת נפח מטבעות קריפטו',
    'panel.accounts.VolumeLimitForSPREADBET': 'מגבלת נפח ספרדבט',
    'panel.accounts.VolumeLimitForBOND': 'מגבלת נפח אג"ח',
    'panel.accounts.VolumeLimitForETF': 'מגבלת נפח ETF',
    'panel.accounts.VolumeLimitForTBILL': 'מגבלת נפח T-Bills',
    'panel.accounts.VolumeLimitForSPOT': 'מגבלת נפח ספוט',
    'panel.accounts.VolumeLimitForCORPORATE': 'מגבלת נפח אג"ח קונצרני',
    'panel.accounts.WithdrawalAvailable': 'משיכה זמינה',
    'panel.accounts.WaivedMargin': 'בטוחות שוויתרו עליהן',
    'panel.accounts.WaivedMargin.descr': 'ויתור על בטוחות עבור חשבון',
    'panel.accounts.WarningMarginReq': 'אזהרת דרישת בטוחות',
    'panel.accounts.WarningMarginReq.descr': 'אזהרה על דרישת בטוחות עבור פוזיציות והוראות.',
    'panel.accounts.WarningMarginReqPercent': 'אזהרת דרישת בטוחות, %',
    'panel.accounts.WarningMarginReqPercent.descr': 'אזהרה על דרישת בטוחות ביחס ליתרה + כל הסיכונים',
    'panel.accounts.MarginBeforeWarning': 'בטוחות לפני אזהרה',
    'panel.accounts.MarginBeforeWarning.descr': 'סכום הבטוחות הזמין לפני הפעלת אזהרה',
    'panel.accounts.IncomingFunds': 'כספים נכנסים',
    'panel.accounts.IncomingFunds.descr': 'אתה יכול להשתמש בסכום הזה לפני שהוא יכנס ליתרה. אבל אתה לא יכול למשוך אותו.',
    'panel.assetBalances': 'חשבונות',
    'panel.backoffice': 'בק אופיס',
    'panel.backoffice.You need to add connection!': 'עליך להוסיף חיבור!',
    'panel.caption.NotAllowedMode': 'הפאנל הנוכחי אינו מורשה בקבוצת הכללים',
    'panel.caption.showHideToolbar': 'הצג סרגל כלים',
    'panel.chart': 'גרף',
    'panel.close': 'סגירה',
    'panel.closePosition.Gross_P/L_ToClose': 'רווח/הפסד ברוטו נוכחי',
    'panel.closePosition.QunatityToClose': 'כמות לסגירה',
    'panel.closePosition.productTypeText': 'סוג מוצר',
    'panel.copypanel': 'שכפל חלונית',
    'panel.CopyTrading': 'העתק את המסחר',
    'panel.CopyTrading.ShowConfirmationLabel': 'הצג הודעת מידע לגבי התחלה/הפסקה של העתקת מסחר',
    'panel.CopyTrading.Confirmation.Start.Caption': 'אשר התחלה של העתקת מסחר',
    'panel.CopyTrading.Confirmation.Start.Message': 'כאשר חשבון המאסטר פותח פוזיציה או סוגר אותה חלקית, אותה פעולה תתבצע עבור החשבונות העוקבים שנבחרו.\n\nלידיעתך, הוראות מימוש רווח או סטופ-לוס לא ייווצרו אוטומטית עבור החשבונות העוקבים.\n\nהאם אתה בטוח שברצונך להתחיל את העתקת המסחר בחשבונות שנבחרו?',
    'panel.CopyTrading.Confirmation.Stop.Caption': 'אשר הפסקה של העתקת מסחר',
    'panel.CopyTrading.Confirmation.Stop.Message': 'פעולה זו תגרום להפסקת ההעתקה של העסקאות בחשבון המאסטר לחשבונות העוקבים.\n\nהאם אתה בטוח שברצונך להפסיק את המעקב?',
    'panel.CopyTrading.Error.Start.Message': 'אינך יכול לעקוב אחר חשבון זה מכיוון שהוא כבר עוקב אחר אחד מהחשבונות שבחרת.',
    'panel.CopyTrading.Error.Stop.Message': 'הפסקת ההעתקה של המסחר נכשלה, נסה שוב מאוחר יותר.',
    'panel.CopyTrading.Error.Reject.AlreadyFollowingMaster': 'החשבון {0} כבר עוקב אחרי חשבון מאסטר אחר. חשבון יכול לעקוב רק אחר חשבון מאסטר אחד.',
    'panel.CopyTrading.Error.Reject.MasterCannotFollow': 'החשבון {0} לא יכול לעקוב אחר חשבון אחר מכיוון שכבר יש לו עוקבים. חשבון מאסטר לא יכול להיות עוקב.',
    'panel.CopyTrading.item.fromAccount': 'מחשבון',
    'panel.CopyTrading.item.toAccount': 'אל חשבונות',
    'panel.CopyTrading.RowControl.ButtonStart.Text': 'התחל',
    'panel.CopyTrading.RowControl.ButtonStart.Tooltip': 'התחל מעקב',
    'panel.CopyTrading.RowControl.ButtonStart.Disabled.Tooltip': 'בחר חשבון עוקב כדי להתחיל את ההעתקה.',
    'panel.CopyTrading.RowControl.ButtonStop.Text': 'עצור',
    'panel.CopyTrading.RowControl.ButtonStop.Tooltip': 'הפסק את ההעתקה',
    'panel.detail': 'ציטוט מפורט',
    'panel.detail.AuctionEndTime': '#hidden#',
    'panel.detail.CBAuctionStart': '#hidden#',
    'panel.detail.change': 'שינוי',
    'panel.detail.changePr': 'שינוי יומי %',
    'panel.detail.CurrentSession': '#hidden#',
    'panel.detail.high': 'גבוה יומי',
    'panel.detail.bid': 'ביקוש',
    'panel.detail.ask': 'היצע',
    'panel.detail.last': 'סגירה קודמת',
    'panel.detail.Limit.High': '#hidden#',
    'panel.detail.Limit.Low': '#hidden#',
    'panel.detail.low': 'נמוך יומי',
    'panel.detail.NormalMarketSize': '#hidden#',
    'panel.detail.OffExchangeValue': '#hidden#',
    'panel.detail.OffExchangeVolume': '#hidden#',
    'panel.detail.open': 'פתח',
    'panel.detail.prevClose': 'סגירה קודמת',
    'panel.detail.RemainingQty': '#hidden#',
    'panel.detail.RemainingQtySide': '#hidden#',
    'panel.detail.TradedValue': '#hidden#',
    'panel.detail.TradingStatus': '#hidden#',
    'panel.detail.TotalBuyQty': '#hidden#',
    'panel.detail.TotalSellQty': '#hidden#',
    'panel.detail.LastTradedTime': '#hidden#',
    'panel.detail.LastTime': 'זמן אחרון',
    'panel.detail.LastUpdateTime': '#hidden#',
    'panel.detail.AvgTradedPrice': '#hidden#',
    'panel.detail.NSEValue': '#hidden#',
    'panel.detail.DPR': '#hidden#',
    'panel.detail.FiftyTwoWeekHighPrice': '#hidden#',
    'panel.detail.FiftyTwoWeekLowPrice': '#hidden#',
    'panel.detail.volume': 'נפח',
    'panel.detail.BidSource': '#hidden#',
    'panel.detail.AskSource': '#hidden#',
    'panel.detail.LastSource': '#hidden#',
    'panel.detail.OpenInterest': '#hidden#',
    'panel.detail.IndicativeAuctionPrice': '#hidden#',
    'panel.detail.SettlementPrice': '#hidden#',
    'panel.detail.PrevSettlementPrice': '#hidden#',
    'panel.detail.VWAP': '#hidden#',
    'panel.detail.ReferencePrice': '#hidden#',
    'panel.detail.Spread': '#hidden#',
    'panel.detail.ETB': '#hidden#',
    'panel.detail.BidSize': '#hidden#',
    'panel.detail.AskSize': '#hidden#',
    'panel.detail.LastSize': '#hidden#',
    'panel.watchlist.BidSource': 'מקור ביקוש',
    'panel.watchlist.AskSource': 'מקור היצע',
    'panel.watchlist.LastSource': 'מקור אחרון',
    'panel.EventLog.Action': 'אירוע',
    'panel.EventLog.Date': 'תאריך',
    'panel.EventLog.eventType.alerts': 'התראות',
    'panel.EventLog.eventType.comment': 'הערה',
    'panel.EventLog.eventType.disconnect': 'נתק',
    'panel.EventLog.eventType.exception': 'יוצא מן הכלל',
    'panel.EventLog.eventType.info': 'מידע',
    'panel.EventLog.eventType.none': 'ללא',
    'panel.EventLog.eventType.system': 'מערכת',
    'panel.EventLog.eventType.trading': 'מסחר',
    'panel.EventLog.eventType.updater': 'מעדכן',
    'panel.EventLog.menu.Clear': 'נקה',
    'panel.EventLog.Message': 'פרטים',
    'panel.EventLog.NamePanel': 'יומן אירועים',
    'panel.EventLog.Roundtrip': 'זמן סבב, מ"ש',
    'panel.EventLog.Type': 'סוג',
    'panel.external.Attach': 'צרף',
    'panel.external.Dettach': 'נתק',
    'panel.GridPanel.listButton.ToolTip': 'בחר סמל עבור החלונית',
    'panel.GridPanel.recreateButton.ToolTip': 'ציין את מספר החלוניות',
    'panel.GridPanel.refreshAllCharts.ToolTip': 'רענן את כל התרשימים',
    'panel.GridPanel.resetMI.Text': 'אפס גודל פאנלים',
    'panel.informer': 'רשימת מעקב',
    'panel.Ideas': 'רעיונות',
    'panel.Ideas.riskDisclosure': 'גילוי סיכונים',
    'panel.Ideas.riskDisclosure.agreeBtnTxt': 'אני מסכים',
    'panel.Ideas.riskDisclosure.noDataText': 'אין רעיונות למסחר',
    'panel.Ideas.productTypeChangeToIntraday': 'הרעיון הוצע עם סוג המוצר - מסירה. שינית את סוג המוצר לתוך-יומי. האם אתה בטוח?',
    'panel.Ideas.productTypeChangeToDelivery': 'הרעיון הוצע עם סוג המוצר - תוך-יומי. שינית את סוג המוצר למסירה. האם אתה בטוח?',
    'panel.Ideas.AttachmentFile': 'קובץ מצורף',
    'panel.Ideas.AttachmentScreen': 'מסך',
    'panel.Ideas.orderButtonTextBuy': 'הזן הוראת קנייה',
    'panel.Ideas.orderButtonTextSell': 'הזן הוראת מכירה',
    'panel.Ideas.orderButtonVisibility': 'לא מוסתר',
    'panel.Ideas.quantityVisiblility': 'לא מוסתר',
    'panel.Ideas.DealTicketHeader': 'רעיונות למסחר',
    'panel.Ideas.DealTicketText': 'קיבלת רעיון מסחר חדש מ-',
    'panel.Ideas.SubscribeDealTicketText': 'נרשמת כמנוי אל',
    'panel.Ideas.UnsubscribeDealTicketText': 'ביטלת מנוי אל',
    'panel.Ideas.FilteringByInstrumentTypes': '#hidden#',
    'panel.Ideas.FilteringAllTypes': 'All',
    'panel.Notifications': 'התראות',
    'panel.Notifications.tt': 'לחץ כדי לפתוח את לוח ההתראות',
    'panel.Notifications.noSelCardTxt': 'בחר הודעה כדי לראות את הטקסט המלא',
    'panel.Notifications.noNotificationsText': 'אין לך התראות',
    'panel.VideoWidget': 'סרטון',
    'panel.VideoWidget.noDataText': 'ספריית הווידאו שלך ריקה',
    'panel.VideoWidget.isLoadingText': 'ספריית הווידאו שלך נטענת',
    'panel.VideoWidget.TimeDateLabelTextForLIVE': 'עכשיו',
    'screen.Alerts.Settings.Screen': 'הגדרות התראה',
    'screen.Alerts.Settings.ContextMenu': 'הגדרות...',
    'screen.Alerts.Action.PlaceOrder': 'הזנת הוראה + הודעה',
    'screen.Alerts.Action.Notify': 'הודעה',
    'screen.Alerts.Action.Edit': 'ערוך',
    'screen.Alerts.Condition.Greater': 'גדול',
    'screen.Alerts.Condition.Less': 'פחות',
    'screen.Alerts.Condition.Greater or equal': 'גדול או שווה',
    'screen.Alerts.Ask': 'היצע',
    'screen.Alerts.Bid': 'ביקוש',
    'screen.Alerts.Last': 'סגירה קודמת',
    'screen.Alerts.ChangePr': 'שינוי יומי %',
    'screen.Alerts.Volume': 'נפח',
    'screen.Alerts.Condition.Less or equal': 'פחות או שווה',
    'screen.Alerts.Notify.Popup': 'הצג חלון קופץ',
    'screen.Alerts.Notify.Sound': 'צליל',
    'screen.Alerts.Notify.Push': 'דחיפה',
    'screen.Alerts.Notify.Email': 'דוא"ל',
    'screen.Alerts.Action.Start': 'התחל',
    'screen.Alerts.AddAlert': 'צור חדש',
    'screen.Alerts.AddAlert.Tooltip': 'לחץ כדי ליצור התראה חדשה',
    'screen.Alerts.AddAlert.Disabled.Tooltip': 'חרגת ממספר ההתראות המרבי',
    'screen.Alerts.noDataText': 'אין התראות',
    'screen.Alerts.AfterExecute.Remove': 'הסר',
    'screen.Alerts.AfterExecute.Stop': 'עצור',
    'screen.Alerts.Alert': 'התראה',
    'screen.Alerts.Button.Apply.Tooltip': 'לחץ כדי להחיל שינויים',
    'screen.Alerts.Button.Create': 'צור',
    'screen.Alerts.Button.Create.Tooltip': 'השדה אינו יכול להיות ריק',
    'screen.Alerts.Header.Create': 'צור התראה',
    'screen.Alerts.Header.Edit': 'עריכה',
    'screen.Alerts.Importance.High': 'גבוה יומי',
    'screen.Alerts.Importance.Low': 'נמוך יומי',
    'screen.Alerts.Importance.Medium': 'בינוני',
    'screen.Alerts.Label.Action': 'פעולה',
    'screen.Alerts.Label.Notify': 'הודעה',
    'screen.Alerts.Label.Notify.InfoTooltip': '',
    'screen.Alerts.Label.OrderParameters': 'פרמטרים של ההוראה',
    'screen.Alerts.Label.OrderParameters.Tooltip': 'לחץ כדי לבחור את הפרמטרים של ההוראה',
    'screen.Alerts.Label.AfterExecute.Tooltip': 'הפקודה נדחתה עקב מחיר שלילי.',
    'screen.Alerts.Label.AfterExecute': 'לאחר ביצוע',
    'screen.Alerts.Label.AlertType.Tooltip': 'הגדרת סוג התראה',
    'screen.Alerts.Label.AlertType': 'סוג התראה',
    'screen.Alerts.Label.Condition.Tooltip': 'הגדרת תנאי להתראה',
    'screen.Alerts.Label.Condition': 'תנאי',
    'screen.Alerts.Label.Importance': 'חשיבות',
    'screen.Alerts.Label.Symbol': 'סמל',
    'screen.Alerts.Label.Account': 'חשבון',
    'screen.Alerts.Label.Value': 'ערך',
    'screen.Alerts.Label.Expiration': 'פקיעה',
    'screen.Alerts.Label.Expiration.Tooltip': 'תאריך ושעת פקיעה של ההתראה',
    'screen.Alerts.Label.Expiration.InfoTooltip': 'ההתראה תוסר לאחר הפקיעה',
    'screen.Alerts.Message': 'הודעת התראה',
    'screen.Alerts.Notify.All': 'כל ההתראות',
    'screen.Alerts.Notify.Few': 'התראות',
    'screen.Alerts.RemoveAlertMessage': 'ההתראה תוסר. האם אתה בטוח?',
    'screen.Alerts.TableItem.Condition': 'תנאי',
    'screen.Alerts': 'התראות',
    'screen.Alerts.visibility': '#not hidden#',
    'screen.Alerts.WarningHeader': 'אזהרה',
    'screen.Alerts.SendOeAlert': 'ההוראה {0} נשלחה.',
    'screen.Alerts.item.stopped': 'הופעל סטופ',
    'screen.Alerts.item.active': 'פעיל',
    'panel.instrumentInfo.AvgPrice': 'מחיר ממוצע:',
    'panel.instrumentInfo.Price': 'מחיר:',
    'panel.instrumentInfo.P/L': 'רווח/הפסד:',
    'panel.instrumentInfo.Qty': 'כמות:',
    'panel.instrumentInfo.BEven': 'נקודת איזון:',
    'panel.instruments': 'סמלים',
    'panel.instrumentsInfo': 'פרטי סמל',
    'panel.knowledgebase': 'מאגר הידע',
    'panel.assets': 'נכסים',
    'panel.Assets.Asset type': 'סוג נכס',
    'panel.Assets.Description': 'תיאור',
    'panel.Assets.Interest rate, %': 'ריבית, %',
    'panel.Assets.Menu.SellAsset': 'מכור נכס',
    'panel.Assets.Minimal change': 'שינוי מינימלי',
    'panel.Assets.Name': 'שם',
    'panel.Assets.NoAssetsAvailable': 'אין נכסים זמינים',
    'panel.Assets.QuickTable.Column.Account': 'חשבון',
    'panel.Assets.QuickTable.Column.AssetName': 'שם נכס',
    'panel.Assets.QuickTable.Column.AvailableQtySell': 'כמות זמינה למכירה',
    'panel.Assets.QuickTable.Column.CurrentPrice': 'מחיר נוכחי',
    'panel.Assets.QuickTable.Column.CurrentQty': '#hidden#',
    'panel.Assets.QuickTable.Column.CurrentValue': '#hidden#',
    'panel.Assets.QuickTable.Column.CurrentValueSell': 'ערך נוכחי למכירה',
    'panel.Assets.QuickTable.Column.DefaultSymbol': 'סמל ברירת מחדל',
    'panel.Assets.QuickTable.Column.ExchangeTrading': 'בורסת מסחר',
    'panel.Assets.QuickTable.Column.LiquidityRate': 'שיעור נזילות, %',
    'panel.Assets.QuickTable.Column.SellAsset.cellsTooltip': 'הפעל רישום הוראה כדי למכור נכס',
    'panel.Assets.QuickTable.Column.SellAsset': 'מכור נכס',
    'panel.Assets.QuickTable.Column.StartDayQty': 'כמות יום פתיחה',
    'panel.Assets.QuickTable.Column.StartDayQtyMargin': 'כמות בתחילת היום עבור הבטוחות הזמינות',
    'panel.Assets.QuickTable.Column.TodayTradedQty.descr': 'כמות נטו של הנכס הנסחר היום',
    'panel.Assets.QuickTable.Column.TodayTradedQty': 'כמות מסחר היום',
    'panel.Assets.QuickTable.Column.SellExchange': 'בורסת מכירה',
    'panel.Assets.Menu.SellAssetOn': 'מכור נכס ב-',
    'panel.Assets.Menu.ShowToolbar': 'הצג סרגל כלים',
    'IsAllowedResponceReason.NoAssetsSelected': 'לא נבחרו נכסים',
    'IsAllowedResponceReason.MoreThanOneAssetIsSelected': 'נבחר יותר מנכס אחד',
    'panel.level2': 'עומק שוק',
    'panel.Level2.Age': '#hidden#',
    'panel.level2.Auction': ' AUC',
    'panel.Level2.AvgPrice': 'מחיר ממוצע',
    'panel.Level2.Contr. CCY Total value': 'חוזה שווי מטבע כולל',
    'panel.Level2.Contr. CCY value': 'ערך מטבע חוזה',
    'panel.Level2.DayTradeVolume': 'נפח',
    'panel.Level2.menu.View': 'הצג',
    'panel.Level2.menu.View.InstrInfo': 'עמודת פוזיציה',
    'panel.Level2.menu.View.Level1': 'סרגל רמה 1',
    'panel.Level2.menu.View.Order Entry': 'הכנסת ההוראה',
    'panel.Level2.MPID': 'MPID',
    'panel.Level2.Number': 'הוראה',
    'panel.Level2.oe.BuyButton': 'קנייה',
    'panel.Level2.oe.SellButton': 'מכירה',
    'panel.Level2.Price': 'מחיר',
    'panel.Level2.Size': 'כמות',
    'panel.Level2.Source': 'מקור',
    'panel.Level2.Time': 'זמן',
    'panel.Level2.TotalVol': 'כמות כולל',
    'panel.Level2.NumberOfOrders': '#hidden#',
    'panel.log': 'יומן אירועים',
    'panel.menu.GroupBy': 'קבץ לפי',
    'panel.menu.new': 'חדש',
    'panel.menu.Remove': 'הסר',
    'panel.menu.AddToWL': 'הוסף',
    'panel.menu.RemoveFromWL': 'הסר',
    'panel.menu.resetToDefault': 'אפס לברירת מחדל',
    'panel.menu.renameList': 'לחץ לשינוי השם של רשימת המכשירים',
    'panel.menu.removeList': 'לחץ להסרת רשימת המכשירים',
    'panel.menu.renameTemplate': 'לחץ לשינוי שם התבנית',
    'panel.menu.removeTemplate': 'לחץ להסרת תבנית',
    'panel.menu.saveList': 'לחץ לשמירה מחדש של התבנית',
    'panel.menu.symbolWasNotFound': 'הסימול לא נמצא.',
    'panel.neworder': 'הכנסת ההוראה',
    'panel.newOrderEntry.accountLabel': 'חשבון',
    'panel.newOrderEntry.AddOrder': 'הוסף הוראה',
    'panel.newOrderEntry.AddAskButton': 'מכירה לפי מחיר היצע',
    'panel.newOrderEntry.AddBitButton': 'קנייה לפי מחיר ביקוש',
    'panel.newOrderEntry.AddSavedOrder': 'הוספה להוראות השמורות',
    'panel.newOrderEntry.AddPaperPosition': 'הוספת הוראה על הנייר',
    'panel.newOrderEntry.amountLabel': 'כמות',
    'panel.newOrderEntry.cashLabel': 'מזומן',
    'panel.newOrderEntry.BuyAskButton': 'קנייה במחיר היצע',
    'panel.newOrderEntry.BuyMarketButton': 'קניה במרקט',
    'panel.newOrderEntry.buySideCheckBox': 'קנייה',
    'panel.newOrderEntry.delayedText': 'נתונים מעוכבים',
    'panel.newOrderEntry.disclosedLabel': '#hidden#',
    'panel.newOrderEntry.disclosedLabel.tt': 'קבע כמות גלויה',
    'panel.newOrderEntry.instrumentLabel': 'סמל',
    'panel.newOrderEntry.Leverage': 'מינוף',
    'panel.newOrderEntry.limitPricePanel': 'מחיר לימיט',
    'panel.newOrderEntry.placeOrderButton': 'הצבת הוראה',
    'panel.newOrderEntry.ProductType': 'סוג מוצר',
    'panel.newOrderEntry.RefreshMarginReq': 'לחץ כדי לרענן את נתוני הבטוחות, או המתן 30 שניות.',
    'panel.newOrderEntry.riskDetailsLabel': 'בטוחות',
    'panel.newOrderEntry.SaveParams': 'שמירת הפרמטרים',
    'panel.newOrderEntry.SellBidButton': 'מכירה במחיר ביקוש',
    'panel.newOrderEntry.SellMarketButton': 'מכירה במרקט',
    'panel.newOrderEntry.sellSideCheckBox': 'מכירה',
    'panel.newOrderEntry.Side': 'צד',
    'panel.newOrderEntry.singleOrderRadio': 'יחיד',
    'panel.newOrderEntry.slPriceRisk': 'מחיר סטופ-לוס',
    'panel.newOrderEntry.slPriceRiskOffset': 'כמות הסטופ לוס בתיקים',
    'panel.newOrderEntry.snapshotText': 'קבל תמונת מצב',
    'panel.newOrderEntry.snapshotBtn.enabled.tt': 'קבל צילום מצב נתונים בזמן אמת',
    'panel.newOrderEntry.snapshotBtn.disabled.tt': 'הגעת למגבלת הבקשות לתמונת מצב',
    'panel.newOrderEntry.stopLossCheckBox': 'מחיר סטופ-לוס',
    'panel.newOrderEntry.stopLossCheckBox.offset': 'כמות הסטופ לוס בתיקים',
    'panel.newOrderEntry.stopPricePanel': 'מחיר סטופ',
    'panel.newOrderEntry.stopLimitLimitPrice': 'מחיר סטופ-לוס לימיט',
    'panel.newOrderEntry.stopLimitLimitPrice.tt': 'קבע מחיר לימיט לסטופ-לוס',
    'panel.newOrderEntry.stopLimitLimitOffset': 'הפרש סטופ-לוס לימיט',
    'panel.newOrderEntry.stopLimitLimitOffset.tt': 'קביעת הפרש לימיט בהוראת סטופ-לוס',
    'panel.newOrderEntry.stopInfoBtn.tt': 'מחיר לימיט נוסף זמין מכיוון שהפעלת "השתמש בסטופ-לימיט במקום בסטופ"',
    'panel.newOrderEntry.takeProfitCheckBox': 'מחיר מימוש רווח',
    'panel.newOrderEntry.takeProfitCheckBox.offset': 'הפרש מימוש רווח',
    'panel.newOrderEntry.tifPanel': 'תוקף',
    'panel.newOrderEntry.tpPriceRisk': 'מחיר מימוש רווח',
    'panel.newOrderEntry.tpPriceRiskOffset': 'הפרש מימוש רווח',
    'panel.newOrderEntry.trstopOffset': 'הפרש של הוראת סטופ נגרר',
    'panel.newOrderEntry.typePanel': 'סוג הוראה',
    'panel.newOrderEntry.stopLossNumeric.ToolTip.offset': "קביעת סטופ-לוס בערכי הפרש. כדי לעבור למחיר יש לעבור אל 'הגדרות כלליות' ->'ברירות מחדל למסחר'",
    'panel.newOrderEntry.stopLossNumeric.ToolTip': "קבע סטופ-לוס בערכי מחיר. כדי לעבור להפרש יש לעבור אל 'הגדרות כלליות' ->'ברירות מחדל למסחר'",
    'panel.newOrderEntry.takeProfitNumeric.ToolTip.offset': "קביעת מימוש רווח בערכי הפרש. כדי לעבור למחיר יש לעבור אל 'הגדרות כלליות' ->'ברירות מחדל למסחר'",
    'panel.newOrderEntry.takeProfitNumeric.ToolTip': "קבע מימוש רווח בערכי מחיר. כדי לעבור להפרש יש לעבור אל 'הגדרות כלליות' ->'ברירות מחדל למסחר'",
    'panel.newOrderEntry.Comment': 'הערה',
    'panel.newOrderEntry.Comment.ToolTip': 'ציין את ההערה עבור הוראה זו',
    'panel.NewTrades.Account': 'חשבון',
    'panel.NewTrades.Amount': 'כמות',
    'panel.NewTrades.Bought': 'סוג הנכס או שווי במימוש העסקה',
    'panel.NewTrades.Commission': 'עמלת ביצוע',
    'panel.NewTrades.Commission.InInstrumentQuotingCurrency': '#hidden#',
    'panel.NewTrades.Date': 'תאריך/שעה',
    'panel.NewTrades.Exchange': '#hidden#',
    'panel.NewTrades.ExchangeTrading': 'בורסת מסחר',
    'panel.NewTrades.ExecutionVenue': 'מקום ביצוע',
    'panel.NewTrades.ExpirationDate': 'תאריך פקיעה',
    'panel.NewTrades.ExternalOrderId': '#hidden#',
    'panel.NewTrades.ExternalPrice': 'מחיר חיצוני',
    'panel.NewTrades.ExternalTradeId': '#hidden#',
    'panel.NewTrades.instrType': 'סוג הסימול',
    'panel.NewTrades.Instrument': 'סמל',
    'panel.NewTrades.Leverage': 'מינוף',
    'panel.NewTrades.Login': 'התחברות',
    'panel.NewTrades.Net_PL': 'רווח/הפסד נטו',
    'panel.NewTrades.Net_PL.InInstrumentQuotingCurrency': '#hidden#',
    'panel.NewTrades.Operation': 'צד',
    'panel.NewTrades.OrderId': 'מזהה הוראה',
    'panel.NewTrades.OrderType': 'סוג הוראה',
    'panel.NewTrades.Price': 'מחיר',
    'panel.NewTrades.ProductType': 'סוג מוצר',
    'panel.NewTrades.PurchasePrice': 'חשיפה',
    'panel.NewTrades.RealizedProfitLoss': 'רווח/הפסד ברוטו',
    'panel.NewTrades.RealizedProfitLoss.InInstrumentQuotingCurrency': '#hidden#',
    'panel.NewTrades.Rebates': 'החזרים',
    'panel.NewTrades.Route': 'נתיב',
    'panel.NewTrades.Sold': 'נמכר',
    'panel.NewTrades.StrikePrice': 'מחיר סטרייק',
    'panel.NewTrades.Time': 'זמן',
    'panel.NewTrades.TradeID': 'מזהה עסקה',
    'panel.NewTrades.TradeIDLabel': '#hidden#',
    'panel.NewTrades.Description': 'תיאור',
    'panel.news': 'חדשות',
    'panel.news.feed': 'פיד',
    'panel.news.feedComboBox.tt': 'בחר פיד חדשות',
    'panel.news.all': 'All',
    'panel.news.received': 'התקבל',
    'panel.news.source': 'מקור',
    'panel.news.subject': 'נושא',
    'panel.news.context': 'תוכן',
    'panel.news.category': 'קטגוריה',
    'panel.news.symbol': 'סמל',
    'panel.news.priority': 'עדיפות',
    'panel.news.Priority_1': 'גבוה יומי',
    'panel.news.Priority_10': 'נמוך יומי',
    'panel.news.Priority_5': 'אמצע',
    'panel.news.Priority_All': 'All',
    'panel.news.menu.clearAll': 'נקה טבלה',
    'panel.news.menu.removeOneRow': 'הסר',
    'panel.news.menu.ShowToolbar': 'הצג סרגל כלים',
    'panel.news.noData': 'אין נתונים להצגה',
    'panel.optionChain': 'שרשרת אופציות',
    'panel.optionChain.call': 'Call',
    'panel.optionChain.put': 'Put',
    'panel.optionChain.lastPrice': 'סגירה קודמת',
    'panel.optionChain.iv': 'IV',
    'panel.optionChain.paperPosition': 'פוזיציית נייר',
    'panel.optionChain.gamma': 'גאמא',
    'panel.optionChain.ask': 'היצע',
    'panel.optionChain.bid': 'ביקוש',
    'panel.optionChain.askSize': 'כמות ההיצע',
    'panel.optionChain.bidSize': 'כמות הביקוש',
    'panel.optionChain.delta': 'דלתא',
    'panel.optionChain.theta': 'תטא',
    'panel.optionChain.vega': 'וגא',
    'panel.optionChain.volume': 'נפח',
    'panel.optionChain.monetaryValue': 'ערך כספי',
    'panel.optionChain.monetaryValue.tt': 'ערך מחיר במזומן',
    'panel.optionChain.rho': 'Rho',
    'panel.optionChain.change': 'שינוי',
    'panel.optionChain.changePercent': 'שינוי יומי %',
    'panel.optionChain.open': 'פתח',
    'panel.optionChain.high': 'גבוה יומי',
    'panel.optionChain.low': 'נמוך יומי',
    'panel.optionChain.prevClose': 'סגירה קודמת',
    'panel.optionChain.lastTime': 'זמן אחרון',
    'panel.optionChain.openInterest': 'ריבית פתיחה',
    'panel.optionChain.strike': 'מימוש',
    'panel.optionAnalyzer': 'מנתח',
    'panel.optionAnalyzer.chart.NoData': 'הוסף פוזיציית נייר כדי לראות את הפרופיל',
    'panel.optionAnalyzer.chartTypeLabel': 'סוג גרף',
    'panel.optionAnalyzer.linesLabel': 'קווים',
    'panel.optionAnalyzer.tPlusLabel': 'T+',
    'panel.optionAnalyzer.tPlusDaysLabel': 'T+, ימים',
    'panel.optionAnalyzer.volatityLabel': 'תנודתיות, %',
    'panel.optionAnalyzer.volatityChangeLabel': 'שינוי בתנודתיות, %',
    'panel.optionAnalyzer.daysLabel': 'ימים',
    'panel.optionAnalyzer.modeLabel': 'מצב',
    'panel.optionAnalyzer.infoWindow.intrinsicPL': 'רווח/הפסד אינטרינזי',
    'panel.optionAnalyzer.infoWindow.PL': 'רווח/הפסד',
    'panel.optionAnalyzer.infoWindow.delta': 'דלתא',
    'panel.optionAnalyzer.infoWindow.gamma': 'גאמא',
    'panel.optionAnalyzer.infoWindow.vega': 'וגא',
    'panel.optionAnalyzer.infoWindow.theta': 'תטא',
    'panel.optionAnalyzer.infoWindow.rho': 'Rho',
    'panel.optionAnalyzer.infoWindow.whatif': 'מה אם',
    'panel.optionMaster': 'מאסטר אופציות',
    'panel.optionMaster.settingsHeader': 'מאסטר אופציות - הגדרות',
    'panel.optionMaster.optionTraderInfoControl.currentPortfolio': 'תיק השקעות נוכחי',
    'panel.optionMaster.optionTraderInfoControl.paperPositions': 'תיק השקעות + פוזיציות נייר מנותחות',
    'panel.optionOrders': 'הוראות פעילות',
    'panel.optionPositions': 'פוזיציות',
    'panel.optionPaperPositions': 'בדוק על נייר',
    'panel.optionPaperPositions.addUnderlier': 'הוסף בסיס',
    'panel.optionPaperPositions.cancelAll': 'בטל הכל',
    'panel.optionPaperPositions.placeSelected': 'בצע נבחרות',
    'panel.optionPaperPositions.shortPositionsAreForbidden': 'פוזיציות שורט אסורות',
    'panel.optionPaperPositions.Side': 'צד',
    'panel.optionPaperPositions.Symbol': 'סמל',
    'panel.optionPaperPositions.Strike': 'מחיר סטרייק',
    'panel.optionPaperPositions.Cash': 'מזומן',
    'panel.optionPaperPositions.Quantity': 'כמות',
    'panel.optionPaperPositions.OrderType': 'סוג הוראה',
    'panel.optionPaperPositions.ProductType': 'סוג מוצר',
    'panel.optionPaperPositions.Offset': 'תוספת הפרש',
    'panel.optionPaperPositions.Price': 'מחיר',
    'panel.optionPaperPositions.Link': 'קישור',
    'panel.optionPaperPositions.StopPrice': 'מחיר סטופ (הפרש)',
    'panel.optionPaperPositions.CurrentPrice': 'מחיר נוכחי',
    'panel.optionPaperPositions.TIF': 'תוקף',
    'panel.optionPaperPositions.SL_Offset': 'כמות הסטופ לוס בתיקים',
    'panel.optionPaperPositions.SL_Price': 'מחיר סטופ-לוס',
    'panel.optionPaperPositions.TP_Offset': 'הפרש מימוש רווח',
    'panel.optionPaperPositions.TP_Price': 'מחיר מימוש רווח',
    'panel.optionPaperPositions.Delta': 'דלתא',
    'panel.optionPaperPositions.TrailingStop': 'סטופ נגרר',
    'panel.optionPaperPositions.Gamma': 'גאמא',
    'panel.optionPaperPositions.Vega': 'וגא',
    'panel.optionPaperPositions.Theta': 'תטא',
    'panel.optionPaperPositions.IV': 'IV',
    'panel.optionPaperPositions.Fee': 'עמלה',
    'panel.optionPaperPositions.UnderlierDate': 'תאריך פקיעת בסיס',
    'panel.optionPaperPositions.Type': 'סוג',
    'panel.optionPaperPositions.DaysToExpire': 'ימים לפקיעה',
    'panel.optionPaperPositions.Date': 'תאריך פקיעה',
    'panel.optionPaperPositions.Rho': 'Rho',
    'panel.optionPaperPositions.SLL_Offset': 'הפרש סטופ-לוס לימיט',
    'panel.optionPaperPositions.SLL_Price': 'מחיר סטופ-לוס לימיט',
    'panel.optionPaperPositions.Leverage': 'מינוף',
    'panel.optionPaperPositions.Analyse': 'ניתוח',
    'panel.optionPaperPositions.Send': 'שלח',
    'panel.optionPaperPositions.Remove': 'הסר',
    'panel.optionPaperPositions.Position': 'פוזיציה',
    'panel.optionPaperPositions.PaperPosition': 'נייר',
    'panel.optionPaperPositions.menu.ShowTotals': 'הצג סה"כ',
    'panel.optionVolatilityLab': 'מעבדת תנודתיות',
    'panel.optionVolatilityLab.ChartNoData': 'בחר סדרות נדרשות כדי לראות חיוך תנודתיות',
    'panel.OrderBook.Account': 'חשבון',
    'panel.OrderBook.Action': 'כיוון הפוזיציה',
    'panel.OrderBook.Bought': 'שווי הפוזיציה',
    'panel.OrderBook.Date': 'תאריך/שעה',
    'panel.OrderBook.DislocedQty': '#hidden#',
    'panel.OrderBook.Event': 'אירוע',
    'panel.OrderBook.ExpirationDate': 'תאריך פקיעה',
    'panel.OrderBook.ExternalOrderID': '#hidden#',
    'panel.OrderBook.FilledQuantity': '#hidden#',
    'panel.OrderBook.instrType': 'סוג הסימול',
    'panel.OrderBook.Instrument': 'סמל',
    'panel.OrderBook.Login': 'התחברות',
    'panel.OrderBook.Message': 'הודעה',
    'panel.OrderBook.OrderNumber': 'מזהה הוראה',
    'panel.OrderBook.Price': 'מחיר',
    'panel.OrderBook.ProductType': 'סוג מוצר',
    'panel.OrderBook.Quantity': 'כמות',
    'panel.OrderBook.ReminingQuantity': '#hidden#',
    'panel.OrderBook.RemoteID': 'מזהה מרוחק',
    'panel.OrderBook.Route': 'נתיב',
    'panel.OrderBook.Sold': 'נמכר',
    'panel.OrderBook.StopPrice': 'מחיר סטופ',
    'panel.OrderBook.StrikePrice': 'מחיר סטרייק',
    'panel.OrderBook.TIF': 'תוקף',
    'panel.OrderBook.Time': 'זמן',
    'panel.OrderBook.TraderID': 'נערך על ידי המשתמש',
    'panel.OrderBook.Type': 'סוג',
    'panel.OrderBook.ExchangeTrading': 'בורסת מסחר',
    'panel.OrderBook.Description': 'תיאור',
    'panel.OrderBook.Leverage': 'מינוף',
    'panel.orderEntry': 'הכנסת ההוראה',
    'panel.orderHistory': 'היסטוריית הוראות',
    'panel.orderHistory.print': '#hidden#',
    'panel.orders': 'הוראות פעילות',
    'panel.orders.Account': 'חשבון',
    'panel.orders.action': 'כיוון הפוזיציה',
    'panel.orders.AvgFilledPrice': '#hidden#',
    'panel.orders.BindTo': 'מקושר ל',
    'panel.orders.Cancel': 'בטל פקודה ממתינה',
    'panel.orders.Comment': '#hidden#',
    'panel.orders.Comments': 'הערות',
    'panel.orders.Ct_Ahead': 'Ct. קדימה',
    'panel.orders.CurrentPrice': 'מחיר נוכחי',
    'panel.orders.date': 'תאריך',
    'panel.orders.date_time': 'תאריך/שעה',
    'panel.orders.disclosedQty': '#hidden#',
    'panel.orders.Event': 'אירוע',
    'panel.orders.Exchange': 'בורסה',
    'panel.orders.ExchangeTrading': 'בורסת מסחר',
    'panel.orders.ExpirationDate': 'תאריך פקיעה',
    'panel.orders.ExternalOrderId': '#hidden#',
    'panel.orders.ExternalOrderStatus': '#hidden#',
    'panel.orders.ExternalOrderStatus_0': 'חדש',
    'panel.orders.ExternalOrderStatus_1': 'הוחל',
    'panel.orders.ExternalOrderStatus_2': 'הוזן חלקית',
    'panel.orders.ExternalOrderStatus_3': 'מומש',
    'panel.orders.ExternalOrderStatus_4': 'נדחה',
    'panel.orders.ExternalOrderStatus_5': 'בוטל',
    'panel.orders.ExternalOrderStatus_6': 'מבטל עבור השינוי',
    'panel.orders.ExternalOrderStatus_7': 'שינוי בהמתנה',
    'panel.orders.ExternalOrderStatus_8': 'ביטול בהמתנה',
    'panel.orders.ExternalOrderStatus_9': 'הקפא',
    'panel.orders.ExternalOrderStatus_10': 'בהתמנה לשוק',
    'panel.orders.ExternalOrderStatus_11': 'לא הוצב',
    'panel.orders.ExternalOrderStatus_12': 'הושהה',
    'panel.orders.GroupId': 'מזהה קבוצת MAM',
    'panel.orders.InitReq': 'דרישה התחלתית',
    'panel.orders.Instr_Type': 'סוג הסימול',
    'panel.orders.Login': 'התחברות',
    'panel.orders.Leverage': 'מינוף',
    'panel.orders.Market': 'מרקט',
    'panel.orders.menu.CancelAllByInstrument': 'בטל הכל לפי הסמל שנבחר',
    'panel.orders.menu.CancelAllForAccount': 'בטל הכל עבור החשבון הנבחר',
    'panel.orders.menu.CancelAllOrders': 'בטל את כל ההוראות',
    'panel.orders.menu.CancelOrder': 'בטל הוראה',
    'panel.orders.menu.ExecuteAsMarket': "שנה ל'מרקט'",
    'panel.orders.menu.ExecuteAsMarket.question': 'בטוח שברצונך לבצע הוראה בשער מרקט?',
    'panel.orders.menu.ModifyOrder': 'שנה הוראה...',
    'panel.orders.menu.MoreOneSymbolInfoDisabled.tt': 'נבחרה יותר מהוראה אחת',
    'panel.orders.menu.NoSymbolInfoDisabled.tt': 'לא נבחרו הוראות',
    'panel.orders.menu.Remove': 'בטל הוראה',
    'panel.orders.menu.ShowToolbar': 'הצג סרגל כלים',
    'panel.orders.OCOGrouID': 'מזהה קבוצת OCO',
    'panel.orders.price': 'מחיר',
    'panel.orders.ProductType': 'סוג מוצר',
    'panel.orders.quantity': 'כמות',
    'panel.orders.QuantityFilled': 'הכמות שהתממשה',
    'panel.orders.QuantityRemaining': 'הכמות שנותרה',
    'panel.orders.Reference': 'מזהה הוראה',
    'panel.orders.RemoteID': 'מזהה מרוחק',
    'panel.orders.Route': 'נתיב',
    'panel.orders.SL': 'סטופ-לוס',
    'panel.orders.SL_Offset': 'כמות הסטופ לוס בתיקים',
    'panel.orders.SL_Price': 'מחיר סטופ-לוס',
    'panel.orders.SLL_Price': 'מחיר סטופ-לוס לימיט',
    'panel.orders.SLL_Offset': 'הפרש סטופ-לוס לימיט',
    'panel.orders.Status': 'סטטוס',
    'panel.orders.StopPrice': 'מחיר סטופ',
    'panel.orders.StrikePrice': 'מחיר סטרייק',
    'panel.orders.symbol': 'סמל',
    'panel.orders.symbolDescription': 'תיאור סמל',
    'panel.orders.TIF': 'תוקף',
    'panel.orders.time': 'זמן',
    'panel.orders.Token': 'מזהה הוראה',
    'panel.orders.TP': 'מימוש רווח',
    'panel.orders.TP_Offset': 'הפרש מימוש רווח',
    'panel.orders.TP_Price': 'מחיר מימוש רווח',
    'panel.orders.TraderID': 'מזהה סוחר',
    'panel.orders.type': 'סוג',
    'panel.orders.UserGroup': 'קבוצת משתמשים',
    'panel.orders.showChartMI': '#hidden#',
    'panel.orders.showMDMI': '#hidden#',
    'panel.orders.showTSMI': '#hidden#',
    'panel.orders.showOEMI': '#hidden#',
    'property.Columns': 'עמודות',
    'property.ColorBy': 'צבע לפי',
    'property.Coloring mode.None': 'ללא',
    'property.Coloring mode.By difference': 'לפי הפרש',
    'property.Coloring mode.By sign': 'לפי סימן',
    'property.ColoringMethod': 'שיטת צביעה',
    'property.ColoringMethod.Classic': 'קלאסי',
    'property.ColoringMethod.HistoricalVolatility': 'תנודתיות היסטורית',
    'property.Calculation': 'חישוב',
    'property.Calculation method.Net Qty': 'כמות נטו',
    'property.Calculation method.Average': 'ממוצע',
    'property.Calculation method.Count': 'ספירה',
    'property.Calculation method.Absolute sum': 'סכום מוחלט',
    'property.Calculator': 'מחשבון',
    'property.SummaryGrid.None': 'ללא',
    'property.SummaryGrid.Vertical': 'אנכי',
    'property.SummaryGrid.Horizontal': 'אופקי',
    'property.SummaryGrid.HorVer': 'אנכי ואופקי',
    'property.SummaryColorsForColumn0': 'צבעים',
    'property.SummaryColorsForColumn1': 'צבעים',
    'property.SummaryColorsForColumn2': 'צבעים',
    'property.SummaryColorsForColumn3': 'צבעים',
    'property.SummaryColorsForColumn4': 'צבעים',
    'property.SummaryColorsForColumn5': 'צבעים',
    'property.SummaryColorsForColumn6': 'צבעים',
    'property.SummaryColorsForColumn7': 'צבעים',
    'property.SummaryColorsForColumn8': 'צבעים',
    'property.SummaryColorsForColumn9': 'צבעים',
    'property.SummaryColorsForColumn10': 'צבעים',
    'property.SummaryColorsForColumn11': 'צבעים',
    'property.SummaryColorsForColumn12': 'צבעים',
    'property.SummaryColorsForColumn13': 'צבעים',
    'property.SummaryColorsForColumn14': 'צבעים',
    'property.SummaryColorsForColumn15': 'צבעים',
    'property.SummaryShowTotalForColumn5': 'הצג סה"כ',
    'property.SummaryShowTotalForColumn6': 'הצג סה"כ',
    'property.SummaryShowTotalForColumn7': 'הצג סה"כ',
    'property.SummaryShowTotalForColumn8': 'הצג סה"כ',
    'property.SummaryShowTotalForColumn9': 'הצג סה"כ',
    'property.SummaryShowTotalForColumn10': 'הצג סה"כ',
    'property.SummaryShowTotalForColumn11': 'הצג סה"כ',
    'property.SummaryShowTotalForColumn12': 'הצג סה"כ',
    'property.SummaryShowTotalForColumn14': 'הצג סה"כ',
    'property.SummaryShowTotalForColumn15': 'הצג סה"כ',
    'property.Coloring mode4': 'מצב צביעה',
    'property.Coloring mode5': 'מצב צביעה',
    'property.Coloring mode6': 'מצב צביעה',
    'property.Coloring mode7': 'מצב צביעה',
    'property.Coloring mode8': 'מצב צביעה',
    'property.Coloring mode9': 'מצב צביעה',
    'property.Coloring mode10': 'מצב צביעה',
    'property.Coloring mode11': 'מצב צביעה',
    'property.Coloring mode12': 'מצב צביעה',
    'property.Coloring mode14': 'מצב צביעה',
    'property.Coloring mode15': 'מצב צביעה',
    'property.Increase color4': 'צבע הגדלה',
    'property.Increase color5': 'צבע הגדלה',
    'property.Increase color6': 'צבע הגדלה',
    'property.Increase color7': 'צבע הגדלה',
    'property.Increase color8': 'צבע הגדלה',
    'property.Increase color9': 'צבע הגדלה',
    'property.Increase color10': 'צבע הגדלה',
    'property.Increase color11': 'צבע הגדלה',
    'property.Increase color12': 'צבע הגדלה',
    'property.Increase color14': 'צבע הגדלה',
    'property.Increase color15': 'צבע הגדלה',
    'property.Decrease color4': 'צבע הקטנה',
    'property.Decrease color5': 'צבע הקטנה',
    'property.Decrease color6': 'צבע הקטנה',
    'property.Decrease color7': 'צבע הקטנה',
    'property.Decrease color8': 'צבע הקטנה',
    'property.Decrease color9': 'צבע הקטנה',
    'property.Decrease color10': 'צבע הקטנה',
    'property.Decrease color11': 'צבע הקטנה',
    'property.Decrease color12': 'צבע הקטנה',
    'property.Decrease color14': 'צבע הקטנה',
    'property.Decrease color15': 'צבע הקטנה',
    'property.subscriptions.confirmSubscribeAndUnsubscribe': 'הצג הודעת מידע לגבי הרשמה/ביטול הרשמה',
    'panel.summary.Symbol': 'סמל',
    'panel.summary.SymbolDescription': 'תיאור סמל',
    'panel.summary.SymbolType': 'סוג הסימול',
    'panel.summary.TradingExchange': 'בורסת המסחר',
    'panel.summary.OpenPrice': 'מחיר פתיחה',
    'panel.summary.CurrentPrice': 'מחיר נוכחי',
    'panel.summary.Quantity': 'כמות',
    'panel.summary.PosExposure': 'חשיפה של פוזיציה',
    'panel.summary.PosValue': 'שווי פוזיציה',
    'panel.summary.GrossPL': 'רווח/הפסד ברוטו',
    'panel.summary.NetPL': 'רווח/הפסד נטו',
    'panel.summary.Fee': 'עמלה',
    'panel.summary.ReturnPercent': 'תשואה, %',
    'panel.summary.Sparkline': 'Sparkline',
    'panel.summary.PortfolioWeight': 'משקל בתיק ההשקעות',
    'panel.summary.ModelAllocation': 'מודל הקצאה',
    'panel.positions': 'פוזיציות',
    'panel.positions.Account': 'חשבון',
    'panel.positions.AccruedInterest': 'ריבית צבורה',
    'panel.positions.AccruedInterest.tt': 'ריבית שנצברה על הפוזיציה',
    'panel.positions.AssetName': '#hidden#',
    'panel.positions.AvailableForSell': '#hidden#',
    'panel.positions.Basis': 'מחיר פתיחה',
    'panel.positions.Close': 'סגור בשוק',
    'panel.positions.CloseViaOE': 'סגור דרך OE',
    'panel.positions.comments': 'הערות',
    'panel.positions.commissions': 'עמלה',
    'panel.positions.commissions.InstrumentCurrency': '#hidden#',
    'panel.positions.confirmation.Reverse': 'הפוך',
    'panel.positions.confirmation.ReverseAllPositions': 'האם אתה בטוח שברצונך להפוך את כל הפוזיציות?',
    'panel.positions.confirmation.ReverseByInstrument': 'האם אתה בטוח שברצונך להפוך את כל הפוזיציות לפי הסמל והחשבון שנבחרו?',
    'panel.positions.confirmation.ReverseSelectedPositions': 'האם אתה בטוח שברצונך להפוך את הפוזיציות שנבחרו?',
    'panel.positions.confirmation.ModifyProductType': 'שנה סוג מוצר מ-{0} ל-{1} עבור {2}, {3}, {4}?',
    'panel.positions.cur_price': 'מחיר נוכחי',
    'panel.positions.date_time': 'תאריך/שעה',
    'panel.positions.Delta': 'דלתא',
    'panel.positions.ExpDate': 'תאריך פקיעה',
    'panel.positions.exposition_usd': 'חשיפה של פוזיציה',
    'panel.positions.Gamma': 'גאמא',
    'panel.positions.GroupId': 'מזהה קבוצת MAM',
    'panel.positions.InitReq': 'דרישה התחלתית',
    'panel.positions.IV': 'IV',
    'panel.positions.Login': 'התחברות',
    'panel.positions.Leverage': 'מינוף',
    'panel.positions.MaintReq': 'דרישת בטוחות מתעדכנות',
    'panel.positions.MarginSuplus': 'עודף/גרעון בטוחות',
    'panel.positions.menu.MutualClose': 'סגירה הדדית...',
    'panel.positions.menu.ExercisePosition': 'מימוש פוזיציה',
    'panel.positions.menu.ExerciseCancel': 'בטל מימוש',
    'panel.positions.menu.ExercisePositionDisabled.tt': 'נבחרה יותר מפוזיציה אחת',
    'panel.positions.menu.CancelExerciseDisabledCuzTrSession.tt': 'הפעולה אינה מותרת על ידי הסשן',
    'panel.positions.menu.ModifyProductType': 'שנה סוג מוצר',
    'panel.positions.menu.Modify': 'שנה פוזיציה',
    'panel.positions.menu.MoreOneSymbolInfoDisabled.tt': 'נבחרה יותר מפוזיציה אחת',
    'panel.positions.menu.NoSymbolInfoDisabled.tt': 'לא נבחרו פוזיציות',
    'panel.positions.menu.ShowToolbar': 'הצג סרגל כלים',
    'panel.positions.menu.ShowTotals': 'הצג סה"כ',
    'panel.positions.menu.DisplayTrades': 'הצג עסקאות',
    'panel.positions.menu.ShowGroupQtyAs': '#hidden#',
    'panel.positions.menu.ShowGroupQtyAs.locKey': 'הצג כמות קבוצה כ-',
    'panel.positions.menu.ShowGroupQtyAs.Total': 'סה"כ כמות',
    'panel.positions.menu.ShowGroupQtyAs.Net': 'כמות נטו',
    'panel.positions.menu.View': 'הצג',
    'panel.positions.Net_PL': 'רווח/הפסד נטו',
    'panel.positions.Net_PL.InstrumentCurrency': '#hidden#',
    'panel.positions.PnLPrecentPositionExposure': '#hidden#',
    'panel.positions.PnLPrecentPositionExposure.Tooltip': 'רווח/הפסד נטו באחוזים מהחשיפה לפוזיציה',
    'panel.positions.Operation': 'צד',
    'panel.positions.PL_ticks': 'הפרש ממחיר הקניה או מכירה בתיקים',
    'panel.positions.pos_number': 'מזהה פוזיציה',
    'panel.positions.PositionValue': 'שווי פוזיציה',
    'panel.positions.ProductType': 'סוג מוצר',
    'panel.positions.profit_usd': 'רווח/הפסד ברוטו',
    'panel.positions.profit_usd.InstrumentCurrency': '#hidden#',
    'panel.positions.Qunatity': 'כמות',
    'panel.positions.RealizedPnL': '#hidden#',
    'panel.positions.RealizedPnL.InstrumentCurrency': '#hidden#',
    'panel.positions.Rho': 'Rho',
    'panel.positions.route': 'נתיב',
    'panel.positions.SL': 'מחיר סטופ-לוס',
    'panel.positions.SL_Value': 'הפסד/רווח צפוי בסטופ-לוס נוכחי',
    'panel.positions.SLL': 'מחיר',
    'panel.positions.strike': 'מחיר סטרייק',
    'panel.positions.swaps': 'Swaps',
    'panel.positions.Symbol': 'סמל',
    'panel.positions.SymbolDescription': 'תיאור סמל',
    'panel.positions.Theta': 'תטא',
    'panel.positions.TP': 'מחיר מימוש רווח',
    'panel.positions.type': 'סוג הסימול',
    'panel.positions.UsedMargin': 'בטוחות בשימוש',
    'panel.positions.UserGroup': 'קבוצת משתמשים',
    'panel.positions.Vega': 'וגא',
    'panel.positions.ExchangeTrading': 'בורסת מסחר',
    'panel.positions.showChartMI': '#hidden#',
    'panel.positions.showMDMI': '#hidden#',
    'panel.positions.showTSMI': '#hidden#',
    'panel.positions.showOEMI': '#hidden#',
    'panel.positions.OrderType': 'סוג הוראה',
    'panel.positionsBalance': 'ריכוז פוזיציות פתוחות',
    'panel.positionsBalance.Symbol': 'סמל',
    'panel.positionsBalance.NetPositionQty': 'כמות פוזיציות נטו',
    'panel.positionsBalance.BreakEvenPoint': 'מחיר קניה',
    'panel.positionsBalance.BreakEven': 'נקודת איזון',
    'panel.positionsBalance.CurrentPrice': 'מחיר נוכחי',
    'panel.positionsBalance.GrossPL': 'רווח/הפסד ברוטו',
    'panel.positionsBalance.LongQty': 'כמות פוזיציית לונג',
    'panel.positionsBalance.AverageLong': 'לונג ממוצע',
    'panel.positionsBalance.ShortQty': 'כמות פוזיציית שורט',
    'panel.positionsBalance.AverageShort': 'מחיר פוזיציית שורט ממוצע',
    'panel.positionsBalance.GrossExposure': 'חשיפה ברוטו',
    'panel.positionsBalance.NetExposure': 'חשיפה נטו',
    'panel.positionsBalance.StrikePrice': 'מחיר סטרייק',
    'panel.positionsBalance.ExpDate': 'תאריך פקיעה',
    'panel.positionsBalance.PositionValue': 'שווי פוזיציה',
    'panel.positionsBalance.SymbType': 'סוג הסימול',
    'panel.positionsBalance.ProductType': 'סוג מוצר',
    'panel.positionsBalance.Symbol.tt': 'שם הסימול',
    'panel.positionsBalance.NetPositionQty.tt': 'כמות הפוזיציה',
    'panel.positionsBalance.BreakEvenPoint.tt': 'מחיר קניה',
    'panel.positionsBalance.CurrentPrice.tt': 'מחיר שוק נוכחי',
    'panel.positionsBalance.GrossPL.tt': 'רווח/הפסד במטבע החשבון',
    'panel.positionsBalance.LongQty.tt': 'כמות פוזיציית לונג',
    'panel.positionsBalance.AverageLong.tt': 'מחיר ממוצע של פוזיציות לונג',
    'panel.positionsBalance.ShortQty.tt': 'כמות פוזיציית שורט',
    'panel.positionsBalance.AverageShort.tt': 'מחיר פוזיציית שורט ממוצע',
    'panel.positionsBalance.GrossExposure.tt': 'חשיפה ברוטו של פוזיציות פתוחות',
    'panel.positionsBalance.NetExposure.tt': 'חשיפה נטו של פוזיציות פתוחות',
    'panel.positionsBalance.StrikePrice.tt': 'מחיר סטרייק',
    'panel.positionsBalance.ExpDate.tt': 'תאריך פקיעה',
    'panel.positionsBalance.PositionValue.tt': 'שווי פוזיציה',
    'panel.positionsBalance.SymbType.tt': 'סוג הסימול (שוק/קטגוריה)',
    'panel.positionsBalance.menu.MoreOneSymbolInfoDisabled.tt': 'נבחר יותר מסימול אחד',
    'panel.positionsBalance.menu.NoSymbolInfoDisabled.tt': 'לא נבחרו סמלים',
    'panel.positionsBalance.menu.ShowToolbar': 'הצג סרגל כלים',
    'Web.mobile.active.PositionsBalance.EmptyPlaceholder': 'כרגע אין עדיין פוזיציות',
    'panel.positions.StartOfDayQty.tt': 'כמות שהועלתה בתחילת היום',
    'panel.positions.StartOfDayQty': '#hidden#',
    'panel.savedOrders': 'הוראות שמורות',
    'panel.savedOrders.placeButtonText': 'הזנה פעילה',
    'panel.savedOrders.account': 'חשבון',
    'panel.savedOrders.account.descr': 'שם חשבון',
    'panel.savedOrders.active': 'פעיל',
    'panel.savedOrders.active.descr': 'הפוך את ההוראה לפעילה',
    'panel.savedOrders.ask': 'היצע',
    'panel.savedOrders.ask.descr': 'מחיר ההיצע הטוב ביותר האחרון',
    'panel.savedOrders.bid': 'ביקוש',
    'panel.savedOrders.bid.descr': 'מחיר הביקוש הטוב ביותר האחרון',
    'panel.savedOrders.cash': 'מזומן',
    'panel.savedOrders.cash.descr': 'כמות הוראה במזומן',
    'panel.savedOrders.ChartCoef': 'מקדם גרף',
    'panel.savedOrders.ChartCoef.descr': 'מקדם שער המשמש לבניית גרף',
    'panel.savedOrders.disclosedQty': '#hidden#',
    'panel.savedOrders.ExchangeTrading': 'בורסת מסחר',
    'panel.savedOrders.ExchangeTrading.descr': 'בורסת מסחר',
    'panel.savedOrders.ExpiryDate': 'תאריך פקיעה',
    'panel.savedOrders.ExpiryDate.descr': 'תאריך פקיעה',
    'panel.savedOrders.instrument': 'סמל',
    'panel.savedOrders.instrument.descr': 'שם הסימול',
    'panel.savedOrders.last': 'סגירה קודמת',
    'panel.savedOrders.last.descr': 'מחיר מסחר אחרון',
    'panel.savedOrders.Leverage': 'מינוף',
    'panel.savedOrders.Link': 'קישור',
    'panel.savedOrders.Link.descr': 'קישור',
    'panel.savedOrders.LinkedPriceOffset': 'תוספת הפרש',
    'panel.savedOrders.LinkedPriceOffset.descr': 'תוספת הפרש',
    'panel.savedOrders.menu.AddOrder': 'הוסף הוראה...',
    'panel.savedOrders.menu.EditOrder': 'ערוך הוראה',
    'panel.savedOrders.menu.RemoveOrder': 'הסר הוראה',
    'panel.savedOrders.menu.RemoveAll': 'הסר הכל',
    'panel.savedOrders.menu.SavedOrdersLists': 'רשימות שמורות',
    'panel.savedOrders.menu.ShowToolbar': 'הצג סרגל כלים',
    'panel.savedOrders.menu.ShowTotals': 'הצג סה"כ',
    'panel.savedOrders.operation': 'צד',
    'panel.savedOrders.operation.descr': 'קנייה או מכירה',
    'panel.savedOrders.OptionsType': 'סוג אופציות',
    'panel.savedOrders.OptionsType.descr': 'סוג אופציות',
    'panel.savedOrders.OrderType': 'סוג הוראה',
    'panel.savedOrders.OrderType.descr': 'לימיט, מרקט, סטופ או שילוב שלהם',
    'panel.savedOrders.price': 'מחיר',
    'panel.savedOrders.price.descr': 'מחיר לימיט או מרקט',
    'panel.savedOrders.ProductType': 'סוג מוצר',
    'panel.savedOrders.quantity': 'כמות',
    'panel.savedOrders.quantity.descr': 'קבע כמות',
    'panel.savedOrders.RemoveOrder': 'הסר',
    'panel.savedOrders.route': 'נתיב',
    'panel.savedOrders.SL_Offset': 'כמות הסטופ לוס בתיקים',
    'panel.savedOrders.SLL_Offset': 'הפרש סטופ-לוס לימיט',
    'panel.savedOrders.SLL_Offset.descr': 'הפרש לימיט עבור סטופ-לוס',
    'panel.savedOrders.SL_Price': 'מחיר סטופ-לוס',
    'panel.savedOrders.SLL_Price': 'מחיר סטופ-לוס לימיט',
    'panel.savedOrders.SLL_Price.descr': 'מחיר לימיט עבור הוראת סטופ-לוס',
    'panel.savedOrders.status': 'סטטוס',
    'panel.savedOrders.status.descr': 'סטטוס ההוראה (פעילה, בהמתנה)',
    'panel.savedOrders.stopPrice': 'מחיר סטופ',
    'panel.savedOrders.stopPrice.descr': 'מחיר סטופ',
    'panel.savedOrders.StrikePrice': 'מחיר סטרייק',
    'panel.savedOrders.StrikePrice.descr': 'מחיר סטרייק',
    'panel.savedOrders.SubmitOrder': 'הזן פקודה',
    'panel.savedOrders.SubmitOrder.descr': 'הזן הוראה במערכת',
    'panel.savedOrders.SymbolType': 'סוג הסימול',
    'panel.savedOrders.SymbolType.descr': 'סוג סמל (שוק/קטגוריה)',
    'panel.savedOrders.tif': 'תוקף',
    'panel.savedOrders.tif.descr': 'תוקף ההוראה',
    'panel.savedOrders.TP_Offset': 'הפרש מימוש רווח',
    'panel.savedOrders.TP_Price': 'מחיר מימוש רווח',
    'panel.savedOrders.Trailing': 'נגרר',
    'panel.savedOrders.TrailingStop': 'סטופ נגרר',
    'panel.savedOrders.TrailingStop.descr': 'סטופ נגרר',
    'panel.savedOrders.Error.AccountIsUnknown': 'חשבון לא ידוע',
    'panel.savedOrders.Error.SymbolIsUnknown': 'הסימול לא ידוע',
    'panel.savedOrders.Error.QuantityLessMin': 'הכמות של ההוראה צריכה להיות יותר מהלוט המינימלי',
    'panel.savedOrders.Error.QuantityMoreMax': 'הכמות של ההוראה צריכה להיות פחות מהלוט המקסימלי',
    'panel.savedOrders.Error.QuantityNotMultiple': 'הכמות אינה מרובה לשינוי המינימלי',
    'panel.savedOrders.Error.CashNotMultiple': 'המזומן אינו כפולה של השינוי המינימלי',
    'panel.savedOrders.Error.CashNotAvailable': 'מסחר במזומן אסור',
    'panel.savedOrders.Error.CashWrongOrderType': 'סוג ההוראה אסור למזומן',
    'panel.savedOrders.AdditionalParams': 'פרמטרים נוספים',
    'panel.settings.Information': 'מידע',
    'panel.settings.saveDefault': 'נשמר בהצלחה!',
    'panel.statement': 'הצהרה',
    'panel.statement.print': 'לא מוסתר',
    'panel.statement.Account': 'חשבון',
    'panel.statement.Instrument': 'סמל',
    'panel.statement.Date': 'תאריך',
    'panel.statement.Operation_type': 'סוג פעולה',
    'panel.statement.Operation_ID': 'מזהה פעולה',
    'panel.statement.Amount': 'כמות',
    'panel.statement.Open_price': 'מחיר פתיחה',
    'panel.statement.Close_price': 'מחיר סגירה',
    'panel.statement.Quantity': 'כמות',
    'panel.statement.Currency': 'מטבע',
    'panel.statement.Trade_opening_date': 'תאריך פתיחת עסקה',
    'panel.statement.FX_rate': '#hidden#',
    'panel.statement.positionID': 'מזהה פוזיציה',
    'panel.statement.tradeID': 'מזהה עסקה',
    'panel.statement.Portfolio_overnight_fee': 'עמלת החזקה למשך לילה של תיק ההשקעות',
    'panel.statement.searchBtn.tt': 'לחץ לחיפוש, להצגת מידע בחלונית דוח',
    'panel.statement.noData': 'אין היסטוריית חשבון עבור מסגרת הזמן והמסננים שנבחרו.',
    'StatementItem.PositionID.GroupKey.Format': 'פוזיציה#{0}',
    'StatementItem.PositionID.GroupKey.EmptyValue': 'אחר',
    'panel.terceraChart': 'גרף',
    'panel.tradingViewChart': 'גרף TradingView',
    'panel.tradingViewChart.header': 'גרף TradingView',
    'panel.TerceraSymbolLookupDropDownForm.Add': 'הוסף',
    'panel.TerceraSymbolLookupDropDownForm.All': 'All',
    'panel.TerceraSymbolLookupDropDownForm.Bonds': 'אגרות חוב',
    'panel.TerceraSymbolLookupDropDownForm.Cancel': 'בטל מנוי',
    'panel.TerceraSymbolLookupDropDownForm.CFDs': 'חוזי הפרשים (CFDS)',
    'panel.TerceraSymbolLookupDropDownForm.collapceAllButton': 'כווץ הכל',
    'panel.TerceraSymbolLookupDropDownForm.crypto': 'מטבע קריפטו',
    'panel.TerceraSymbolLookupDropDownForm.Equities': 'מניות',
    'panel.TerceraSymbolLookupDropDownForm.ETFs': 'קרנות סל',
    'panel.TerceraSymbolLookupDropDownForm.exchangeComboBox.All exchanges': 'כל הבורסות',
    'panel.TerceraSymbolLookupDropDownForm.exchangeComboBox.exchanges': 'בורסות',
    'panel.TerceraSymbolLookupDropDownForm.exchangeComboBox.No exchanges': 'אין בורסות',
    'panel.TerceraSymbolLookupDropDownForm.expandExchangesButton': 'הרחב בורסות',
    'panel.TerceraSymbolLookupDropDownForm.expandTypesButton': 'הרחב סוגים',
    'panel.TerceraSymbolLookupDropDownForm.expandGroupsButton': 'הרחב קבוצות',
    'panel.TerceraSymbolLookupDropDownForm.Other': 'אחר',
    'panel.TerceraSymbolLookupDropDownForm.Forex': 'מט"ח',
    'panel.TerceraSymbolLookupDropDownForm.Forward': 'פורווד',
    'panel.TerceraSymbolLookupDropDownForm.Futures': 'חוזים עתידיים',
    'panel.TerceraSymbolLookupDropDownForm.indices': 'מדדים',
    'panel.TerceraSymbolLookupDropDownForm.Options': 'אופציות',
    'panel.TerceraSymbolLookupDropDownForm.Options.Put': 'אופציות Put',
    'panel.TerceraSymbolLookupDropDownForm.Options.Call': 'אופציות Call',
    'panel.TerceraSymbolLookupDropDownForm.Portfolio': 'סינתטי',
    'panel.TerceraSymbolLookupDropDownForm.Select': 'בחר הכל',
    'panel.TerceraSymbolLookupDropDownForm.Select all': 'בחר הכל',
    'panel.TerceraSymbolLookupDropDownForm.Show additionl info': 'הצג מידע נוסף',
    'panel.TerceraSymbolLookupDropDownForm.Spot': 'ספוט',
    'panel.TerceraSymbolLookupDropDownForm.Spreadbet': 'ספרדבט',
    'panel.TerceraSymbolLookupDropDownForm.TBill': 'מק"מ',
    'panel.TerceraSymbolLookupDropDownForm.Corporate': 'תאגידי',
    'panel.TerceraSymbolLookupDropDownForm.typeComboBox.All types': 'כל הסוגים',
    'panel.TerceraSymbolLookupDropDownForm.typeComboBox.No types': 'אין סוגים',
    'panel.TerceraSymbolLookupDropDownForm.typeComboBox.types': 'סוגים',
    'panel.timeSales': 'זמן ומכירות',
    'panel.timeSales.Agressor flag': 'צד',
    'panel.timeSales.AgressorFlag.Auction': 'מכרז',
    'panel.timeSales.AgressorFlag.Buy': 'קנייה',
    'panel.timeSales.AgressorFlag.CrossTrade': 'מסחר צולב',
    'panel.timeSales.AgressorFlag.None': 'ללא',
    'panel.timeSales.AgressorFlag.Sell': 'מכירה',
    'panel.timeSales.AgressorFlag.RLP': 'RLP',
    'panel.timeSales.ask': 'היצע',
    'panel.timeSales.AskBidSize': 'כמות ביקוש והיצע',
    'panel.timeSales.AskSource': 'MPID היצע',
    'panel.timeSales.bid': 'ביקוש',
    'panel.timeSales.BidSource': 'MPID ביקוש',
    'panel.timeSales.BuyerSource': 'קונה',
    'panel.timeSales.Exchange': 'מקור',
    'panel.timeSales.Instrument': 'סמל',
    'panel.timeSales.MenuName': 'זמן & מכירות',
    'panel.timeSales.Price': 'מחיר',
    'panel.timeSales.SellerSource': 'מוכר',
    'panel.timeSales.Size': 'כמות',
    'panel.timeSales.Time': 'זמן',
    'panel.timeSales.Type': 'סוג הסימול',
    'panel.tooltiper.System': 'מערכת',
    'panel.trades': 'הוראות שמולאו',
    'panel.trades.print': '#hidden#',
    'panel.tradingCentral': 'Trading central',
    'panel.tradingCentral.screenBtn.text': 'מסך',
    'panel.tradingCentral.chartBtn.text': 'גרף',
    'panel.tradingCentral.ScreenButton': 'לא מוסתר',
    'panel.tradingCentral.settings': 'הגדרות...',
    'panel.tradingCentral.settings.technicalAnalysis.term': 'טווח',
    'panel.tradingCentral.settings.technicalAnalysis.days': 'ימים',
    'panel.tradingCentral.settings.technicalAnalysis.lastOnly': 'רק אחרון',
    'panel.tradingCentral.settings.alerts.lastOnly': 'רק אחרון',
    'panel.tradingCentral.settings.alerts.days': 'ימים',
    'panel.tradingCentral.settings.candlestick.lastOnly': 'רק אחרון',
    'panel.tradingCentral.settings.candlestick.days': 'ימים',
    'panel.tradingCentral.term.All': 'All',
    'panel.tradingCentral.term.Intraday': 'תוך יומי',
    'panel.tradingCentral.term.Short term': 'טווח קצר',
    'panel.tradingCentral.term.Middle term': 'טווח בינוני',
    'panel.tradingCentral.chart.resistance': 'התנגדות',
    'panel.tradingCentral.chart.support': 'תמיכה',
    'panel.tradingCentral.chart.pivot': 'ציר',
    'panel.watchlist': 'רשימת מעקב',
    'panel.watchlist.Ask': 'היצע',
    'panel.watchlist.AskSize': 'כמות ההיצע',
    'panel.watchlist.AuctionEndTime': '#hidden#',
    'panel.watchlist.Bid': 'ביקוש',
    'panel.watchlist.BidSize': 'כמות הביקוש',
    'panel.watchlist.Buy': 'קנייה',
    'panel.watchlist.CBAuctionStart': '#hidden#',
    'panel.watchlist.cell.cancel': 'בטל מנוי',
    'panel.watchlist.cell.modify': 'שינוי',
    'panel.watchlist.cell.Not allow': 'אל תאפשר',
    'panel.watchlist.cell.sending': 'חדש',
    'panel.watchlist.cell.ticks': 'טיקים',
    'panel.watchlist.Change': 'שינוי',
    'panel.watchlist.ChangeFromOpen': 'שינוי מפתיחה',
    'panel.watchlist.ChangeFromOpen%': 'שינוי מפתיחה, %',
    'panel.watchlist.ChangePr': 'שינוי יומי %',
    'panel.watchlist.Close': 'סגירה',
    'panel.watchlist.ClosePostMarket': 'סגירה במסחר מאוחר',
    'panel.watchlist.Comment': 'הערה',
    'panel.watchlist.Company': 'חברה',
    'panel.watchlist.ContractSize': 'כמות חוזה(לוט)',
    'panel.watchlist.CurrentSession': 'מושב המסחר הנוכחי',
    'panel.watchlist.Date': 'תאריך אחרון',
    'panel.watchlist.Descr': 'תיאור',
    'panel.watchlist.Exchange': 'בורסה',
    'panel.watchlist.ExpDate': 'תאריך פקיעה',
    'panel.watchlist.High': 'גבוה יומי',
    'panel.watchlist.High13': '#hidden#',
    'panel.watchlist.High26': '#hidden#',
    'panel.watchlist.High52': '#hidden#',
    'panel.watchlist.IndicativeAuctionPrice': 'מחיר מכרז אינד.',
    'panel.watchlist.Instrument': 'סימול',
    'panel.watchlist.Last': 'סגירה קודמת',
    'panel.watchlist.LastSize': 'כמות אחרון',
    'panel.watchlist.Limit.High': '#hidden#',
    'panel.watchlist.Limit.Low': '#hidden#',
    'panel.watchlist.Low': 'נמוך יומי',
    'panel.watchlist.Low13': '#hidden#',
    'panel.watchlist.Low26': '#hidden#',
    'panel.watchlist.Low52': '#hidden#',
    'panel.watchlist.Main Volume': 'נפח ראשי',
    'panel.watchlist.Market': 'מרקט',
    'panel.watchlist.MarketCap': 'שווי שוק',
    'panel.watchlist.Match Volume': 'נפח התאמה',
    'panel.watchlist.menu.AddSymbol': 'הוסף סימולים...',
    'panel.watchlist.menu.clearAll': 'נקה הכל',
    'panel.watchlist.menu.SymbolLists': 'רשימות סמלים',
    'panel.watchlist.menu.RemoveInstrument': 'הסר סמלים נבחרים',
    'panel.watchlist.menu.SymbolInfo': 'פרטי סמל',
    'panel.watchlist.menu.Chart': '#hidden#',
    'panel.watchlist.menu.MarketDepth': '#hidden#',
    'panel.watchlist.menu.TimeSales': '#hidden#',
    'panel.watchlist.menu.OrderEntry': '#hidden#',
    'panel.watchlist.menu.NoSymbolSelected.tt': 'לרשימת המעקב אין סמל נבחר',
    'panel.watchlist.menu.MoreThanOneSymbolSelected.tt': 'נבחר יותר מסימול אחד',
    'panel.watchlist.NA': 'לא זמין',
    'panel.watchlist.noQuotes': 'עדכון אחרון',
    'panel.watchlist.NormalMarketSize': '#hidden#',
    'panel.watchlist.OffExchangeValue': '#hidden#',
    'panel.watchlist.OffExchangeVolume': '#hidden#',
    'panel.watchlist.Open': 'פתח',
    'panel.watchlist.OpenInterest': '#hidden#',
    'panel.watchlist.OpenPreMarket': 'פתיחה לפני השוק',
    'panel.watchlist.Order': '#hidden#',
    'panel.watchlist.Order.tt': 'הצבת הוראת לימיט',
    'panel.watchlist.Trade': '#hidden#',
    'panel.watchlist.Trade.tt': 'הצבת הוראת מרקט',
    'panel.watchlist.ITChartAdvanced': 'גרף מתקדם',
    'panel.watchlist.ITChartAdvanced.tt': 'גרף מתקדם של IT-Finance',
    'panel.watchlist.PreMarketChange': 'שינוי טרום שוק',
    'panel.watchlist.PreMarketChange%': 'שינוי טרום שוק, %',
    'panel.watchlist.PrevClose': 'סגירה קודמת',
    'panel.watchlist.PrevSettlementPrice': 'מחיר סילוק קודם',
    'panel.watchlist.ReferencePrice': 'מחיר ייחוס',
    'panel.watchlist.RemainingQty': '#hidden#',
    'panel.watchlist.RemainingQtySide': '#hidden#',
    'panel.watchlist.Sell': 'מכירה',
    'panel.watchlist.SettlementPrice': 'מחיר סליקה',
    'panel.watchlist.Spread': 'מרווח',
    'panel.watchlist.SpreadPr': 'מרווח, %',
    'panel.watchlist.Ticks': 'טיקים',
    'panel.watchlist.TicksPostMarket': 'טיקים לאחר השוק',
    'panel.watchlist.TicksPreMarket': 'טיקים טרום שוק',
    'panel.watchlist.Time': 'זמן אחרון',
    'panel.watchlist.TradedValue': '#hidden#',
    'panel.watchlist.Type': 'סוג הסימול',
    'panel.watchlist.Volume': 'נפח',
    'panel.watchlist.VolumePostMarket': 'נפח אפטר מרקט',
    'panel.watchlist.VolumePreMarket': 'נפח לפני השוק',
    'panel.watchlist.AvgTradedPrice': '#hidden#',
    'panel.watchlist.TotalBuyQuantity': '#hidden#',
    'panel.watchlist.TotalSellQuantity': '#hidden#',
    'panel.watchlist.HighOpenInterest': '#hidden#',
    'panel.watchlist.LowOpenInterest': '#hidden#',
    'panel.watchlist.InitiatorPrice': '#hidden#',
    'panel.watchlist.InitiatorQuantity': '#hidden#',
    'panel.watchlist.InitiatorType': '#hidden#',
    'panel.watchlist.LastTradedTime': '#hidden#',
    'panel.watchlist.AuctionNumber': '#hidden#',
    'panel.watchlist.AuctionStatus': '#hidden#',
    'panel.watchlist.FiftyTwoWeekHighPrice': '#hidden#',
    'panel.watchlist.FiftyTwoWeekLowPrice': '#hidden#',
    'panel.watchlist.NSEValue': '#hidden#',
    'panel.watchlist.LPP': '#hidden#',
    'panel.watchlist.DPR': '#hidden#',
    'panel.watchlist.Code': '#hidden#',
    'panel.watchlist.InstrumentType': '#hidden#',
    'panel.watchlist.MarketType': '#hidden#',
    'panel.watchlist.Symbol': '#hidden#',
    'panel.watchlist.Series': '#hidden#',
    'panel.watchlist.ExchangeMarketData': 'בורסת נתוני שוק',
    'panel.watchlist.ExchangeTrading': 'בורסת מסחר',
    'Panels.MarketDepth.CancelAll': 'בטל הכל',
    'panels.orders.buttons.AsMarket': "שנה ל'מרקט'",
    'panels.orders.buttons.CancelAllButton': 'בטל הכל',
    'panels.orders.buttons.CancelBuyButton': 'בטל קנייה',
    'panels.orders.buttons.CancelByInstrumentButton': 'ביטול',
    'panels.orders.buttons.CancelDayButton': 'ביטול פקודות יומיות',
    'panels.orders.buttons.CancelGTCButton': 'ביטול GTC',
    'panels.orders.buttons.CancelLimitsButton': 'ביטול לימיט',
    'panels.orders.buttons.CancelSelectedButton': 'ביטול הפקודות שנבחרו',
    'panels.orders.buttons.CancelSellButton': 'בטל מכירה',
    'panels.orders.buttons.CancelStopsButton': 'ביטול סטופ',
    'panels.orders.buttons.ModifyOrder': 'עריכת הוראה',
    'panels.positions.buttons.closeAll': 'סגור הכל',
    'panels.positions.buttons.closeForInstrument': 'סגירה',
    'panels.positions.buttons.closeLong': 'סגור לונג',
    'panels.positions.buttons.closeNegative': 'סגור שורט',
    'panels.positions.buttons.closePositive': 'סגור לונג',
    'panels.positions.buttons.closeSelected': 'סגור נבחרים',
    'panels.positions.buttons.closeShort': 'סגירת שורט',
    'panels.positions.buttons.clxAll': 'סגור ובטל הכל',
    'panels.positions.buttons.clxForInstrument': 'סגור ובטל',
    'panels.positions.buttons.reverse': 'הפוך',
    'panels.positions.buttons.reverseSelected': 'הפוך נבחרים',
    'panels.positions.ButtonsPanel.helpLabel': 'לחיצה ימנית מציגה/מסתירה לחצנים',
    'panel.rangeSelect.daily': 'יומי',
    'panel.rangeSelect.24h': '#hidden#',
    'panel.rangeSelect.7d': '#hidden#',
    'panel.rangeSelect.30d': '#hidden#',
    'panel.rangeSelect.90d': '#hidden#',
    'panel.rangeSelect.range': 'טווח',
    'panel.rangeSelect.tooltip': 'בחר תקופה להצגה',
    'panel.rangeSelect.logs.tooltip': 'בחר תקופה להצגת יומנים',
    'panel.rangeSelect.range.all': 'All',
    'panel.filterSelect.logs.tooltip': 'בחר סוגי יומן להצגה',
    'panel.riskCalculator': 'מחשבון סיכון',
    'PanelSettingsScreen.Text': '- הגדרות',
    'PanelSettingsScreen.TextSmall': '- הגדרות',
    'Parabolic Time/Price System': 'מערכת פרבולית זמן/מחיר',
    'period.Day': 'יום',
    'period.Days': 'ימים',
    'period.Hour': 'שעה',
    'period.Hours': 'שעות',
    'period.Min': 'דקות',
    'period.Mins': 'דקות',
    'period.Month': 'חודש',
    'period.Months': 'חודשים',
    'period.Week': 'שבוע',
    'period.Weeks': 'שבועות',
    'period.Year': 'שנה',
    'period.Years': 'שנים',
    'Pivot Point Moving Average': 'נקודת פיבוט של ממוצע נע',
    PivotPoint: 'נקודת פיבוט',
    'PopupMultiCkeckBox.All': 'All',
    'portfolio.performance.allocation.title': 'הקצאה',
    'portfolio.performance.growth.title': 'צמיחת תיק השקעות',
    'portfolio.performance.portfolioAllocationLabel': 'הקצאת תיק ההשקעות',
    'portfolio.performance.modelAllocationLabel': 'מודל הקצאה',
    'portfolio.performance.contextMenu.AllocationType': 'סוג הקצאה',
    'portfolio.performance.contextMenu.AllocationType.Portfolio': 'תיק השקעות',
    'portfolio.performance.contextMenu.AllocationType.Model': 'מודל',
    'portfolio.performance.contextMenu.View.Total': 'תשואה כוללת',
    'portfolio.performance.contextMenu.View.PortfolioBalance': 'יתרת תיק השקעות',
    'portfolio.DiagramSettings.header': 'גרף הקצאה - הגדרות',
    'property.PNL': 'רווח/הפסד',
    'property.PortfolioPerformanceDiagramBackColor': 'צבע רקע',
    'property.PortfolioPerformanceTotalReturnVisible': 'גלוי',
    'property.PortfolioPerformancePortfolioBalanceVisible': 'גלוי',
    'property.PortfolioPerformanceTotalReturnColors': 'צבעים',
    'property.PortfolioPerformancePortfolioBalanceColor': 'צבע',
    'portfolio.performance.cash': 'מזומן',
    'portfolio.performance.allocationCB.Symbol': 'סמל',
    'portfolio.performance.allocationCB.Symbol type': 'סוג הסימול',
    'portfolio.performance.allocationCB.Country': 'ארץ',
    'portfolio.performance.allocationCB.Sector': 'מגזר',
    'portfolio.performance.allocationCB.Industry': 'תעשייה',
    'portfolio.performance.allocationCB.Currency': 'מטבע',
    'portfolio.performance.growth.contextMenu.GridTime': 'זמן גריד',
    'portfolio.performance.growth.contextMenu.GridBalance': 'יתרת גריד',
    'portfolio.performance.growth.contextMenu.Crosshair': 'כוונת',
    'portfolio.performance.growth.contextMenu.Refresh': 'רענן',
    'portfolio.performance.growth.contextMenu.Settings': 'הגדרות',
    'portfolio.performance.growth.contextMenu.InfoWindow': 'חלון מידע',
    'portfolio.performance.growth.contextMenu.InfoWindow.Separate': 'חלון נפרד',
    'portfolio.performance.growth.contextMenu.InfoWindow.Attached': 'מצורף לסמן',
    'portfolio.performance.growth.contextMenu.InfoWindow.Hidden': 'מוסתר',
    'property.Portfolio balance scale': 'סולם יתרת תיק ההשקעות',
    'property.SeparatorGroup.HighlightPortfolioBalance': 'הדגש את יתרת תיק ההשקעות',
    'portfolio.performance.growth.contextMenu.Style': 'סגנון',
    'property.IsPortfolioGrowthVisible': 'יתרה',
    'portfolio.returns.title': 'תשואות',
    'portfolio.returns.tableHeader.date': 'תקופה',
    'portfolio.returns.tableHeader.return': 'תשואת תיק השקעות, %',
    'portfolio.returns.tableHeader.balance': 'יתרת תיק השקעות',
    'portfolio.returns.tableHeader.monthPercent': 'תיק השקעות:',
    'portfolio.returns.infoWindow.dateHeader': 'תאריך:',
    'portfolio.returns.contextMenu.View': 'הצג',
    'portfolio.returns.contextMenu.Refresh': 'רענן',
    'portfolio.returns.contextMenu.Settings': 'הגדרות',
    'portfolio.returns.contextMenu.GridTime': 'זמן גריד',
    'portfolio.returns.contextMenu.GridPercent': 'אחוז גריד',
    'portfolio.returns.contextMenu.Scrollbar': 'פס גלילה',
    'portfolioReturns.InfoWindowMode.SeparateWindow': 'חלון נפרד',
    'portfolioReturns.InfoWindowMode.None': 'ללא',
    'portfolio.returns.StatisticSwitcher.Portfolio': 'סטטיסטיקת תשואות תיק השקעות',
    'portfolio.returns.StatisticSwitcher.Asset': 'סטטיסטיקת תשואות נכסים',
    'portfolio.returns.StatisticSwitcher.Asset.ConfirmText': 'התקרבות שגויה. האם אתה רוצה להתקרב?',
    'portfolio.returns.StatisticSwitcher.Asset.Zoom': 'הגדל',
    'portfolioReturns.AssetReturnText': 'חזור',
    Português: 'פורטוגזית (ברזיל)',
    'positionSizeCalculator.header': 'מחשבון גודל פוזיציה',
    'positionSizeCalculator.infoText': 'המחשבון עוזר לקבוע את כמות הפוזיציות המומלצת על סמך הסיכון שאתה מוכן לקחת.',
    'positionSizeCalculator.infoText.linkPart': 'עוד ב{0}מאמר על גודל פוזיציה{0}.',
    'positionSizeCalculator.helpLink': 'https://guide.traderevolution.com/project/desktop-application-for-windows/windows/trading-panels/order-entry/position-sizing',
    'positionSizeCalculator.accountRisk': 'סיכון חשבון',
    'positionSizeCalculator.accountRisk.tt': 'אם ברצונך לסכן אחוז מסוים מהכספים הזמינים שלך, הקלד את האחוז הזה. לחלופין, החלף את יחידת הסיכון לקבוע והזן את סכום המזומן שברצונך לסכן',
    'positionSizeCalculator.cashRiskLabel': 'סיכון מזומן',
    'positionSizeCalculator.percentRiskLabel': 'סיכון באחוזים',
    'positionSizeCalculator.PercentMenuItem': 'אחוז',
    'positionSizeCalculator.FixedMenuItem': 'קבוע',
    'positionSizeCalculator.UnableToCalc': 'לא ניתן לחשב ערך',
    'positionSizeCalculator.button.tt': 'מאפשר שדות נוספים לחישוב אוטומטי של הכמות',
    'positionSizeCalculator.buttonDisabled.tt': 'לא ניתן להשתמש במחשבון גודל פוזיציה מכיוון ש-SL אסור',
    'positionSizeCalculator.OEButtonDisabled.less': 'הכמות קטנה מהמינימום המותר ({0})',
    'positionSizeCalculator.OEButtonDisabled.more': 'הכמות גדולה מהמקסימום המותר ({0})',
    'Price Channel': 'ערוץ מחיר',
    'Price Oscillator': 'מתנד מחיר',
    'ProductType.CarryForward': 'המשך קדימה',
    'ProductType.Delivery': 'מסירה',
    'ProductType.General': 'כללי',
    'ProductType.Intraday': 'תוך יומי',
    'ProductType.CorporateAction': 'פעולה תאגידית',
    'property.%': '%',
    'property.Additional': 'נוסף',
    'property.AllPrice': 'סטטיסטיקת מחיר',
    'property.appearance': 'מראה',
    'property.Ask': 'היצע',
    'property.AskColor': 'צבע היצע',
    'property.AskBid/2': '(היצע+ביקוש)/2',
    'property.Author': 'מחבר',
    'property.autosize': 'התאמת גודל אוטומטית של עמודות',
    'property.autoYScale.Auto': 'קנה מידה אוטומטית',
    'property.autoYScale.Manual': 'קנה מידה ידנית',
    'property.Average': 'ממוצע',
    'property.Backgr': 'צבע רקע',
    'property.Backgr. top': 'צבע רקע עליון',
    'property.BarPattern': 'תבנית בר',
    'property.barsHiLowColor': 'קו',
    'property.BarStatistics': 'סטטיסטיקת עמודות',
    'property.Basis': 'בסיס',
    'property.Beta': 'בטא',
    'property.Bid': 'ביקוש',
    'property.BidColor': 'צבע ביקוש',
    'property.BidAskAverage': '(ביקוש+היצע)/2',
    'property.bodyColor': 'גוף',
    'property.borderColor': 'גבולות',
    'property.backgroundColor': 'חזרה',
    'property.BottomCenter': 'מרכז למטה',
    'property.BottomLeft': 'שמאל למטה',
    'property.BottomRight': 'ימין למטה',
    'property.Alerts': 'התראות',
    'property.Action': 'פעולה',
    'property.NoPriceForCurrentAlertType': 'אין שער לסוג ההתראה הנוכחי.',
    'property.Notification': 'הודעה',
    'property.AlertType': 'סוג התראה',
    'property.Condition': 'תנאי',
    'property.Importance': 'חשיבות',
    'property.AfterExecute': 'לאחר ביצוע',
    'property.Browser': 'דפדפן',
    'property.Buy': 'קנייה',
    'property.BuyColor': 'קנייה',
    'property.cAsk': 'כמות ההיצע',
    'property.cASK': 'ב-היצע',
    'property.cASKHI': 'מעל ההיצע',
    'property.cBid': 'כמות הביקוש',
    'property.cBID': 'במחיר הביקוש',
    'property.cBIDLO': 'מתחת למחיר הביקוש',
    'property.cellscin.useSellBuy': 'הפוך את סדר הלחצנים',
    'property.Change': 'שינוי',
    'property.ChangePercent': 'שינוי יומי %',
    'property.Chart': 'גרף',
    'property.Chart OE': 'הזנת הוראה בגרף',
    'property.chart.isBackground': 'העבר לרקע',
    'property.chart.line': 'קו',
    'property.chart.ray': 'RAY',
    'property.chart.rayStyle': 'סגנון RAY',
    'property.chart.showAngle': 'הצג זוית',
    'property.chart.showingOE': 'גלוי',
    'property.chart.stickTo': 'הצמד ל',
    'property.chart.tools.back': 'מילוי ציור',
    'property.chart.tools.fibretr.font': 'גופן תווית',
    'property.chart.tools.fibretr.fontcolor': 'צבע גופן',
    'property.ChartAnalyseToolsToolBar': 'סרגל כלי ניתוח',
    'property.ChartDrawingToolsToolBar': 'סרגל כלי ציור',
    'property.chart.regression.RegressionLine': 'קו רגרסיה',
    'property.chart.regression.UpLine': 'קו עליון',
    'property.chart.regression.DownLine': 'קו תחתון',
    'property.chart.regression.Area.Top': 'אזור עליון',
    'property.chart.regression.Area.Bottom': 'אזור תחתון',
    'property.chart.regression.UpperDeviation': 'סטייה עליונה',
    'property.chart.regression.LowerDeviation': 'סטייה תחתונה',
    'property.chart.regression.PriceType': 'סוג מחיר',
    'property.cLimit': 'צבע הוראת לימיט',
    'property.Close': 'סגירה',
    'property.Cluster.ClusterUpDownColors': 'אשכול',
    'property.Cluster.ColorScheme': 'סכמת צבעים',
    'property.Cluster.ColorScheme.ByDelta': 'לפי דלתא',
    'property.Cluster.ColorScheme.ByDelta.Colors': 'צבע',
    'property.Cluster.ColorScheme.ByDelta.Colors.BuyColor': 'קנייה',
    'property.Cluster.ColorScheme.ByDelta.Colors.SellColor': 'מכירה',
    'property.Cluster.ColorScheme.ByTrades': 'לפי עסקאות',
    'property.Cluster.ColorScheme.ByVolume': 'לפי נפח',
    'property.Cluster.ColorScheme.Color': 'צבע',
    'property.Cluster.ColorScheme.None': 'ללא',
    'property.Cluster.CustomStep': 'צעד מותאם אישית',
    'property.Cluster.Down': 'יורד',
    'property.Cluster.FilterValue': 'ערך מסנן',
    'property.Cluster.Font': 'גופן',
    'property.Cluster.FontColor': 'צבע גופן',
    'property.Cluster.HighlightMax': 'הדגש מקסימום',
    'property.Cluster.HighlightMax.Colors': 'צבעים',
    'property.Cluster.Operator': 'אופרטור',
    'property.Cluster.PriceStep': 'צעד מחיר',
    'property.Cluster.PriceStep.Custom': 'מותאם אישית',
    'property.Cluster.PriceStep.MinTick': 'טיק מינימלי',
    'property.Cluster.ShowOnlySimilarDelta': 'הצג רק דלתא דומה',
    'property.Cluster.ShowValueFilter': 'מסנן ערך',
    'property.Cluster.Up': 'עולה',
    'property.cMIDLO': 'בין המרווח',
    'property.Color': 'צבע',
    'property.ColoringMode': 'מצב צביעה',
    'property.Colors': 'צבעים',
    'property.colors_param': 'צבעים',
    'property.colorScheme': 'סגנון',
    'property.ColorsSeparatorGroup': 'צבעים',
    'property.ColouringMode': 'מצב צביעה',
    'property.Comments': 'הערות',
    'property.Company': 'חברה',
    'property.Confirmations': 'אישורים',
    'property.connection': 'חיבור',
    'property.Connection': 'חיבור',
    'property.ContentAlignment': 'יישור',
    'property.Copyrights': 'זכויות יוצרים',
    'property.cQUOTE': 'ציטוטים',
    'property.CreateColor': 'צור',
    'property.crossHairFontColor': 'צבע גופן',
    'property.cStop': 'הוראת סטופ',
    'property.currency': 'מטבע',
    'property.CurrentHV': 'HV נוכחי, %',
    'property.CurrentLastPrice': 'מחיר אחרון נוכחי',
    'property.CustomUnderlierPrice': 'מחיר בסיס מותאם אישית',
    'property.CustomYMarkingValue': 'מדרגת רשת מינימלית',
    'property.Data Box': 'חלון מידע',
    'property.Data Style': 'סגנון נתונים',
    'property.Day': 'יום',
    'property.GTS': 'GTS',
    'property.DaySeparators': 'מפרידי ימים',
    'property.DefaultProductType': 'סוג מוצר ברירת מחדל',
    'property.Defaults': 'ברירות מחדל של מסחר',
    'property.deviation': 'סטייה',
    'property.DisableStartEndSounds': '#hidden#',
    'property.dK': 'dK',
    'property.Doji': "דוג'י",
    'property.Downband deviation in %': 'סטיית פס תחתון ב-%',
    'property.ElliotWaves.Font': 'צבע גופן',
    'property.email': 'כתובות דוא"ל\n(השתמש בפסיק או נקודה-פסיק)',
    'property.Emulator': 'אמולטור',
    'property.enable': 'אפשר',
    'property.Enable Sounds': 'אפשר סאונד',
    'property.Error': 'שגיאה',
    'property.Example': 'דוגמה',
    'property.Exponential': 'אקספוננציאלי',
    'property.fib.Arc': 'פיב. קשת',
    'property.Fibonacci': "פיבונאצ'י",
    'property.FirstValue': 'ערך ראשון',
    'property.Filters': 'מסננים',
    'property.Filtered': 'לאחר סינון',
    'property.FitDrawings': 'התאם ציורים',
    'property.FitAlerts': 'התאם התראות',
    'property.FitHighLow': 'התאם גבוה/נמוך יומי',
    'property.FitIndicator': 'התאם אינדיקטורים',
    'property.FitOrders': 'להתאים להוראות/פוזיציות',
    'property.FOK': 'FILL OR KILL‏ (FOK)',
    'property.Font': 'גופן',
    'property.FontColor': 'צבע גופן',
    'property.LabelColor': 'צכע תווית',
    'property.Forex': 'מט"ח',
    'property.Forward': 'פורווד',
    'property.Forwards': 'חוזי פורוורד',
    'property.Futures': 'חוזים עתידיים',
    'property.FX Cell': 'תא מט"ח',
    'property.G': 'ג',
    'property.General': 'כללי',
    'property.General.ToolTip': 'הגדרות כלליות',
    'property.general.defaultSymbol': 'סמל',
    'property.general.OvernightMarginNotificationMessage': '#hidden#',
    'property.general.showLotsFX': 'הצג כמות בלוטים',
    'property.gr_type': 'סגנון',
    'property.Gradient': 'גרדיאנט',
    'property.GraphicType.Absolute': 'מוחלט',
    'property.GraphicType.Log': 'לוגריתמי',
    'property.GraphicType.Relative': 'יחסי',
    'property.GridPrice': 'מחיר (אופקי)',
    'property.GridPriceHighLight': 'צבע רשת מודגש',
    'property.GridTime': 'זמן (אנכי)',
    'property.GTC': 'GTC',
    'property.GTD': 'GTD',
    'property.HeaderFont': 'גופן',
    'property.HeaderText': 'טקסט כותרת',
    'property.HideAdditionalPanels': 'הסתר חלוניות נוספות',
    'property.High': 'גבוה יומי',
    'property.HighlightMarkingsStep': 'הדגשת מדרגה ברשת',
    'property.highlightExtendedSessionsColor': 'הדגשת מושבי מסחר מורחבים',
    'property.HistogramLineColor': 'קו היסטוגרמה',
    'property.HistoryType': 'סוג נתונים',
    'property.HorizontalLine.LeftRay': 'הארך שמאלה',
    'property.hostName': 'שם המארח',
    'property.hotkeyManager.ShowVolume': 'הצג נפח',
    'property.infowindow_font': 'גופן',
    'property.infoWindow_fore_back_color': 'צבע',
    'property.infoWindow_value_neutral_color': 'צבע ניטרלי',
    'property.infoWindow_value_increase_color': 'צבע הגדלה',
    'property.infoWindow_value_decrease_color': 'צבע הקטנה',
    'property.infowindow_visible': 'הצג חלון מידע',
    'property.infowindow_displayMode': 'מצב חלון מידע',
    'property.InputParameters': 'פרמטרי קלט',
    'property.Instrument Types': 'ברירות מחדל של הוראה לפי סוג',
    'property.InTheMoneyColor': 'צבע "בתוך הכסף"',
    'property.OutTheMoneyColor': 'צבע "מחוץ לכסף"',
    'property.OHLAverage': 'OHL/3',
    'property.OHLCAverage': 'OHLC/4',
    'property.InterestRate': 'ריבית, %',
    'property.Intrinsic': 'אינטרינזי',
    'property.IOC': 'IOC',
    'property.IsBackground': 'רקע',
    'property.OnTop': 'בחלק העליון',
    'property.IsBarsVisible': '#עמודות',
    'property.IsChangeVisible': 'שינוי, %',
    'property.IsDailyChangeVisible': 'שינוי יומי, %',
    'property.IsCloseVisible': 'סגירה',
    'property.IsDateVisible': 'תאריך',
    'property.IsHighVisible': 'גבוה יומי',
    'property.IsLowVisible': 'נמוך יומי',
    'property.IsHighLowVisible': 'גבוה - נמוך',
    'property.IsOpenVisible': 'פתח',
    'property.IsRoundedAvgPrice': 'לעגל מחיר פתיחה ממוצע',
    'property.isShowToolTips': 'הסברים',
    'property.isShowToolTipsGrop': 'הסברים',
    'property.ConfirmationSubgroup.Other': 'אחר',
    'property.dealTickets.openOnWorkspace': 'פתח כרטיסי עסקה במרחב העבודה',
    'property.dealTickets.showDealTickets': 'הצג כרטיסי עסקה במגש היישומים',
    'property.dealTickets.showDealTickets.ToolTip': 'קובע אם כרטיסי עסקה יוצגו במגש היישומים או לא',
    'property.dealTickets.openMarginOnWorkspace.Default': '#hidden#',
    'property.dealTickets.showMarginDealTicketsOnWorkspace': 'הצג כרטיס עסקה בבטוחות במרחב העבודה',
    'property.dealTickets.showMarginDealTicketsOnWorkspace.ToolTip': 'אם מופעל, כרטיסי עסקאות עם אזהרת בטוחות וקריאת בטוחות יופיעו במרחב העבודה',
    'property.IsSyncActive': 'סנכרן עם תרשימים',
    'property.IsTicksVisible': 'טיקים',
    'property.IsTimeVisible': 'זמן',
    'property.IsVolumeVisible': 'נפח',
    'property.IVCalculationPrice': 'מחיר חישוב סטיות התקן הגלומות',
    'property.LabelColors': 'תווית',
    'property.Language': 'שפה',
    'property.Last': 'סגירה קודמת',
    'property.LastPrice': 'מחיר אחרון',
    'property.lastPrice_AskIndicatorColor': 'היצע',
    'property.lastPrice_BidIndicatorColor': 'ביקוש',
    'property.lastPrice_LastIndicatorColor': 'סגירה קודמת',
    'property.lastPrice_SpreadIndicatorColor': 'צבע אזור מרווח',
    'property.Left ray': 'הארך שמאלה',
    'property.Level': 'רמה',
    'property.Care': 'לטיפול',
    'property.Limit': 'לימיט',
    'property.limitOffsetTicks': 'לימיט הפרש, טיקים',
    'property.Line': 'קו',
    'property.line.lineName': 'שם קו',
    'property.line.plateVisible': 'הצג סמן {0} של קו',
    'property.line.timeShift': 'הזזת זמן',
    'property.line.value': 'ערך',
    'property.line.Visible': 'גלוי',
    'property.line.yFactor': 'מקדם Y',
    'property.Linear Weighted': 'שיקלול ליניארי',
    'property.lineProperties': 'מאפיינים',
    'property.Logo': 'לוגו',
    'property.LOC': 'LOC (LIMIT בסגירה)',
    'property.logBase': 'בסיס לוגריתמי',
    'property.LOO': 'LOO',
    'property.LotsMode': 'הצגת הגודל ב-',
    'property.Low': 'נמוך יומי',
    'property.Mail Server': 'שרת דואר',
    'property.Manual': 'ידני',
    'property.Market': 'מרקט',
    'property.MarketCap': 'שווי שוק',
    'property.MarketDepth.ColoringMethod': 'שיטת צביעה',
    'property.MarketProfile.ColorScheme': 'סכמת צבעים',
    'property.MarketProfile.ColorScheme.Color': 'צבע',
    'property.MarketProfile.ColorScheme.GradientColor': 'אזור',
    'property.MarketProfile.ColorScheme.PairColor.Color': 'צבע',
    'property.MarketProfile.ColorScheme.VolumeColor': 'צבע',
    'property.MarketProfile.Font': 'גופן',
    'property.MarketProfile.PointOfControl': 'נקודת בקרה',
    'property.MarketProfile.PointOfControlStyle': 'סגנון נקודת בקרה',
    'property.MarketProfile.ShowSingles': 'הצג יחידים',
    'property.MarketProfile.SinglesStyle': 'סגנון יחידים',
    'property.MarketProfile.ValueArea': 'אזור הערך',
    'property.MarketProfile.ValueAreaStyleHorisontal': 'סגנון קו אופקי',
    'property.MarketProfile.ValueAreaStyleVertical': 'סגנון קו אנכי',
    'property.MarketProfile.ValuePercents': 'ערך, %',
    'property.Medium': 'בינוני',
    'property.message': 'הודעה',
    'property.method': 'שיטה',
    'property.MirrorShow': 'תצוגת מראה',
    'property.MOC': 'MOC',
    'property.Mode': 'מצב',
    'property.Mode.Trades': 'עסקאות',
    'property.Modified': 'נערך',
    'property.MonthSeparators': 'מפרידי חודש',
    'property.MOO': 'MOO',
    'property.name': 'שם',
    'property.Name': 'שם',
    'property.News': 'חדשות',
    'property.None': 'ללא',
    'property.Note': 'הערה',
    'property.Notifications': 'התראות',
    'property.NotificationType': 'הודעה',
    'property.NotSet': 'לא הוגדר',
    'property.Number': 'ספירה',
    'property.OCO': 'OCO',
    'property.OE_AddBidAddAsk': 'קנייה במחיר ביקוש/מכירה במחיר היצע',
    'property.OE_ShowBuyMarketSellMarket': 'קנייה בשער מרקט/מכירה בשער מרקט',
    'property.OE_ShowSellBidBuyASk': 'מכירה בשער ביקוש/קנייה בשער היצע',
    'property.OE_ShowSLTP': 'סגור הוראות (סטופ-לוס/מימוש רווח)',
    'property.OE_Small': 'שורת הוראה צרה',
    'property.OE_Small.ToolTip': 'אם מסומן, שורת ההוראה תהיה בתצוגה צרה',
    'property.oe.confirmClosePosition': 'אשר סגירת פוזיציה',
    'property.oe.confirmOrderCancel': 'אשר ביטול הוראה',
    'property.oe.confirmOrderChange': 'אשר שינוי הוראות/פוזיציות',
    'property.oe.confirmOrderCreate': 'אשר מיקום הוראה',
    'property.oe.confirmOrderCreateAlert': 'אשר מיקום הוראה',
    'property.oe.confirmAlertRemove': 'אשר הסרת התראה',
    'property.oe.confirmReversePosition': 'אשר היפוך פוזיציה',
    'property.OrderCreateAlertGroup': 'התראות',
    'property.OffsetMode': 'הצג הפרש ב',
    'property.OffsetMode.Points': 'נקודות',
    'property.OffsetMode.Ticks': 'טיקים',
    'property.OffsetMode.TicksFractionalForForex': 'טיקים (טיקים שבריים עבור מט"ח)',
    'property.OffsetMode.Percent': 'אחוז',
    'property.OnClose': 'בסגירה',
    'property.OnOpen': 'בפתיחה',
    'property.Open': 'פתח',
    'property.OptionChain': 'שרשרת אופציות',
    'property.Order Entry': 'הכנסת ההוראה',
    'property.OrderBuyStyleWidth': 'קנייה',
    'property.OrderSellStyleWidth': 'מכירה',
    'property.OutputParameters': 'פרמטרי פלט',
    'property.OverlayVisible': 'חפיפה נראית',
    'property.Panel name': 'שם החלונית',
    'property.panel.accountDetails.Groups.1.General': 'כללי',
    'property.panel.accountDetails.Groups.2.Margin': 'בטוחות',
    'property.panel.accountDetails.Groups.3.AccountActivity': 'פעילות חשבון',
    'property.panel.accountDetails.Groups.4.TodayResults': 'תוצאות היום',
    'property.panel.accountDetails.Groups.5.RiskManagement': 'ניהול סיכונים',
    'property.panel.accountDetails.Groups.6.Info': 'מידע',
    'property.Panels': 'פאנלים',
    'property.Parameters': 'פרמטרים',
    'property.password': 'סיסמה',
    'property.period': 'תקופה',
    'property.Period of indicator': 'תקופת אינדיקטור',
    'property.Period of indicator:': 'תקופת אינדיקטור',
    'property.Period of Linear Regression': 'תקופת רגרסיה לינארית',
    'property.Period of MA for envelopes': 'תקופת ממוצע נע למעטפות',
    'property.Period of MA1': 'תקופת ממוצע נע 1',
    'property.Period of MA2': 'תקופת ממוצע נע 2',
    'property.Period of momentum:': 'תקופת מומנטום',
    'property.Period of Moving Average': 'תקופת ממוצע נע',
    'property.Period of price channel': 'תקופת ערוץ מחיר',
    'property.Period of Simple Moving Average': 'תקופת ממוצע נע פשוט',
    'property.Period of Smoothed Moving Average': 'תקופת ממוצע נע מחולק',
    'property.Periods': 'תקופות',
    'property.Calсulation cycle, bars': 'מחזור חישוב, עמודות',
    'property.Calculation price': 'מחיר חישוב',
    'property.pin': 'PIN',
    'property.pips': 'פיפס',
    'property.POCTypes.Line': 'קו',
    'property.POCTypes.Marker': 'סמן',
    'property.POCTypes.None': 'ללא',
    'property.points': 'נקודות',
    'property.Points': 'נקודות',
    'property.PositionBuyStyleWidth': 'לונג',
    'property.PositionSellStyleWidth': 'שורט',
    'property.Portfolio return': 'תשואת תיק השקעות',
    'property.Analyzer': 'מנתח',
    'property.AnalyzerInfo': 'חלון מידע',
    'property.ATMStrikeColor': 'צבע סטרייק בכסף',
    'property.Asset return': 'תשואת נכסים',
    'property.Percent scale': 'סולם אחוזים',
    'property.AssetReturnVisibility': 'גלוי',
    'property.Previous': 'קודם',
    'property.Price': 'מחיר',
    'property.price': 'מחיר',
    'property.Price Scale': 'סולם מחיר',
    'property.PriceIndicatorDrawingType': 'אינדיקטור מחיר',
    'property.PriceIndicatorDrawingType.None': 'ללא',
    'property.PriceIndicatorDrawingType.ScaleMarker': 'סמן הסולם',
    'property.PriceIndicatorDrawingType.ScaleMarkerWithLine': 'סמן סולם עם קו',
    'property.PriceScaleAxisColor': 'צירים',
    'property.PriceScaleBackColor': 'רקע הצירים',
    'property.PriceScaleFont': 'גופן',
    'property.PriceScaleTextColor': 'צבע טקסט',
    'property.PriceType': 'סוג מחיר',
    'property.PricingModel': 'מודל תמחור',
    'property.PricingModel.BlackScholes': 'מודל בלאק&שולס',
    'property.Probability': 'הסתברות',
    'property.ProbabilityCalculation': 'חישוב הסתברות',
    'property.ProbabilityCalculation.None': 'ללא',
    'property.ProbabilityCalculation.Single': 'יחיד',
    'property.ProbabilityCalculation.OR': 'או',
    'property.ProbabilityCalculation.AND': 'וגם',
    'property.ProbabilitySimulations': 'סימולציות הסתברות',
    'property.ProbabilityScenario': 'תרחיש הסתברות',
    'property.ProbabilityScenario.OneTouch': 'נגיעה אחת',
    'property.ProbabilityScenario.OutOfRange': 'מחוץ לטווח',
    'property.ProfileColoringTypes.DeltaBars': 'עמודות דלתא',
    'property.ProfileColoringTypes.DeltaPrice': 'מחיר דלתא',
    'property.ProfileColoringTypes.DeltaProfile': 'פרופיל דלתא',
    'property.ProfileColoringTypes.Single': 'צבע יחיד',
    'property.ProfileColoringTypes.UpdownBars': 'ברים מעלה/מטה',
    'property.ProfileColoringTypes.UpdownProfile': 'פרופיל מעלה/מטה',
    'property.ProfileColoringTypes.VolumeBars': 'עמודות נפח מסחר',
    'property.ProfileColoringTypes.VolumePrice': 'מחיר נפח',
    'property.protrader.showOrders': 'הוראות',
    'property.Range': 'טווח',
    'property.Ray style': 'סגנון RAY',
    'property.Relative': 'יחסי',
    'property.relativeCalcType': 'מחיר פתיחה',
    'property.RelativeCalculationType.BeginOfTheData': 'תחילת הנתונים',
    'property.RelativeCalculationType.BeginOfTheDay': 'תחילת היום',
    'property.RelativeCalculationType.BeginOfTheScreen': 'תחילת המסך',
    'property.relativeScaleType': 'סוג סולם',
    'property.Reserve': 'שמירת הזמנה',
    'property.Reverse': 'הפוך',
    'property.Right ray': 'הארך ימינה',
    'property.routing.account': 'חשבון',
    'property.routing.orderType': 'סוג הוראה',
    'property.RSI Method:': 'שיטת RSI',
    'property.RSI Period:': 'תקופת RSI',
    'property.ScaleColors': 'צבעי סולם',
    'property.SCRIPTS_SUBGROUP': 'סקריפטים',
    'property.ScrollBar': 'פס גלילה',
    'property.SecondStandardDeviationColor': 'צבע 2 סטיות תקן',
    'property.SecondValue': 'ערך שני',
    'property.secure': 'מאובטח',
    'property.Secure': 'מאובטח',
    'property.Selection': 'בחירה',
    'property.Sell': 'מכירה',
    'property.SellColor': 'מכירה',
    'property.SeparatorGroup.ActiveOrders': 'הוראות פעילות',
    'property.SeparatorGroup.additional': 'נוסף',
    'property.SeparatorGroup.Additional': 'נוסף',
    'property.SeparatorGroup.Appearance': 'מראה',
    'property.SeparatorGroup.CrossHair': 'כוונת',
    'property.SeparatorGroup.Watermark': 'סימן מים',
    'property.SeparatorGroup.ExecutedOrders': 'הוראות שמולאו (מתחילת הסשן)',
    'property.SeparatorGroup.Grid': 'חלון גרפים',
    'property.SeparatorGroup.HighlightDate': 'הדגש תאריך',
    'property.SeparatorGroup.HighlightPercent': 'הדגש אחוז',
    'property.SeparatorGroup.HighlightPrices': 'הדגש מחירים',
    'property.SeparatorGroup.OpenPositions': 'פוזיציות פתוחות',
    'property.SeparatorGroup.ScaleMarkings': 'סימוני הסקאלה',
    'property.SeparatorGroup.ScaleType': 'סוג סולם',
    'property.SeparatorGroup.SeparatorOEWidth': 'הצג',
    'property.SeparatorGroup.Show': 'תצוגה',
    'property.SeparatorGroup.TimeToNextBar': 'זמן לנר הבא',
    'property.SeparatorGroup.WindowColors': 'צבעי רקע',
    'property.SeparatorGroup.Zoom': 'הגדל',
    'property.SeparatorViewButtons': 'מסחר מהיר',
    'property.Sesonality': 'עונתיות',
    'property.shift': 'הזזה',
    'property.ShowAdditionalPanels': 'הצג חלוניות נוספות',
    'property.ShowAlerts': 'הצגת התראות',
    'property.showAllSessions': 'הצג מסחר מוקדם/מאוחר',
    'property.ShowEmptyBars': 'חורים בהיסטוריה',
    'property.showEvents': 'גלוי',
    'property.ShowFullArc': 'הצג את הקשת המלאה',
    'property.ShowHighLow': 'גבוה/נמוך יומי',
    'property.showOrders': 'גלוי',
    'property.showPositions': 'גלוי',
    'property.ShowPrevCloseLine': 'סגירה קודמת',
    'property.ShowTimeToNextBar': 'גלוי',
    'property.ShowTotal': 'הצג סה"כ',
    'property.ShowToolbar': 'הצג סרגל כלים',
    'property.ShowVisualTradingOnLeftSide': 'קשור פוזיציות/הוראות פעילות לצד שמאל',
    'property.showVolume': 'גלוי',
    'property.showVolumeMarker': 'הצגת סמן ערך על הסקאלה',
    'property.Side': 'צד',
    'property.Simple': 'פשוט',
    'property.SimulationModel': 'מודל סימולציה',
    'property.SimulationModel.ByAbsolutePrices': 'לפי מחירים מוחלטים',
    'property.SimulationModel.ByRelativePrices': 'לפי מחירים יחסיים',
    'property.SimulationModel.ByLogarithmicPrices': 'לפי מחירים לוגריתמיים',
    'property.SimulationExamples': 'דוגמאות לסימולציה',
    'property.SizeBy': 'כמות לפי',
    'property.sltpOffsetMode': 'הגדרת ערכי סטופ-לוס/מימוש רווח כהפרש',
    'property.Smoothing': 'החלקה',
    'property.solidPriceColor': 'אזור',
    'property.sounds_param': 'צלילים',
    'property.Sources prices for MA': 'מקורות מחירים עבור ממוצע נע',
    'property.Specific': 'ספציפי',
    'property.SpreadType': 'סוג מרווח',
    'property.SpreadType.Area': 'אזור',
    'property.SpreadType.Line': 'קו',
    'property.SpreadType.LineWithLabel': 'קו עם מחיר',
    'property.SpreadType.None': 'ללא',
    'property.StandardDeviationColor': 'צבע סטיית תקן',
    'property.Step of parabolic SAR system': 'צעד של מערכת פרבולית SAR',
    'property.Stick to': 'הצמד ל',
    'property.stickTo': 'הצמד ל:',
    'property.Stocks': 'מניות',
    'property.Stop': 'עצור',
    'property.Stop Limit': 'סטופ-לימיט',
    'property.Stop-loss': 'סטופ-לוס',
    'property.Stop-loss-SLL': 'סטופ-לוס/ סטופ-לוס לימיט',
    'property.style': 'סגנון:',
    'property.StrikePrice': 'מחיר סטרייק',
    'property.StrikePrices': 'מחירי סטרייק',
    'property.StrikesAggregationStyle': 'סגנון צבירת מחירי סטרייק',
    'property.StrikesAggregationStyle.FromATMStrike': 'מחיר סטרייק בתוך הכסף',
    'property.StrikesAggregationStyle.CustomUnderlierPrice': 'מחיר בסיס מותאם אישית',
    'property.Sum': 'סכום',
    'property.Symbol': 'סמל',
    'property.Symbols': 'סמלים',
    'property.T': 'זמן',
    'property.Take-profit': 'מימוש רווח',
    'property.text': 'טקסט',
    'property.TIF': 'תוקף מרקט',
    'property.TIF_Limit_And_Stop_Limit': 'תוקף לימיט (תוקף סטופ-לימיט)',
    'property.TIF_Stop': 'תוקף סטופ',
    'property.TimeChange': 'שינוי זמן',
    'property.Time Scale': 'ציר הזמן',
    'property.TimeLine': 'קו זמן',
    'property.TimelinePreview': 'פס גלילה בתצוגה מקדימה של גרף',
    'property.TimeScaleAxisColor': 'צירים',
    'property.TimeScaleBackColor': 'רקע הצירים',
    'property.TimeScaleFont': 'גופן',
    'property.TimeScaleImportentFont': 'גופן תאריכים חשובים',
    'property.TimeScaleTextColor': 'צבע גופן',
    'property.TimeToNextBarColor': 'צבע',
    'property.TimeToNextBarFont': 'גופן',
    'property.Title': 'כותרת',
    'property.TopCenter': 'למעלה מרכז',
    'property.TopLeft': 'למעלה שמאל',
    'property.TopRight': 'למעלה ימין',
    'property.Tr. stop': 'סטופ נגרר',
    'property.Tr. stop loss': 'סטופ-לוס נגרר',
    'property.trackShowCrossHair': 'גלוי',
    'property.Trading': 'מסחר',
    'property.Trading Defaults': 'מסחר',
    'property.Type of moving average': 'סוג ממוצע נע',
    'property.Type of Moving Average': 'סוג ממוצע נע',
    'property.Typical': 'אופייני',
    'property.Upband deviation in %': 'סטיית פס עליון ב-%',
    'property.Update': 'עדכן',
    'property.UseCustomYMarkings': 'גרפים מותאמת אישית',
    'property.useStopLimitInsteadStop': 'השתמש בסטופ-לימיט במקום בסטופ',
    'property.user': 'התחברות',
    'property.useSSL': 'מאובטח',
    'property.UnderlierPrice': 'מחיר נכס הבסיס',
    'property.UnderlyingPrice': 'מחיר בסיס',
    'property.Value of confidence interval': 'ערך רווח בר סמך',
    'property.ValueColors': 'צבעי ערך',
    'property.VATypes.Horizontal': 'אופקי',
    'property.VATypes.None': 'ללא',
    'property.VATypes.ToNextProfile': 'לפרופיל הבא',
    'property.VATypes.Vertical': 'אנכי',
    'property.VannaVolgaModel': 'מודל ונה-וולגה',
    'property.vendorName': 'ספק',
    'property.View': 'תצוגה',
    'property.ViewSeparatorGroup': 'הצג',
    'property.VisibleSeries': 'סדרה גלויה',
    'property.Visibility': 'נראות',
    'property.VisibilitySeparatorGroup': 'נראות',
    'property.Visible': 'גלוי',
    'property.Visual Trading': 'מסחר ויזואלי',
    'property.VolatilityChange': 'שינוי בתנודתיות',
    'property.Volatility Lab': 'מעבדת תנודתיות',
    'property.Volume': 'עמודות נפח מסחר',
    'property.Volume.Font': 'גופן',
    'property.Volume.FontColor': 'צבע גופן',
    'property.Volume.UseTicksData': 'השתמש בנפח טיק אמיתי',
    'property.VolumeBars.MovingAverage.Active': 'הצג ממוצע נע',
    'property.VolumeBars.MovingAverage.Line': 'צבע קו',
    'property.VolumeBars.MovingAverage.Period': 'תקופת ממוצע נע',
    'property.VolumeColoringMode': 'סכמת צביעת גודל',
    'property.VolumeDownColor': 'שלילי',
    'property.VolumeFixedColor': 'שווה',
    'property.VolumeHeightPercent': 'גובה, %',
    'property.VolumeMode.BuyVolume': 'נפח קנייה',
    'property.VolumeMode.Delta': 'דלתא',
    'property.VolumeMode.MaxTickVolume': 'נפח טיק מקסימלי',
    'property.VolumeMode.SellVolume': 'נפח מכירה,%',
    'property.VolumeMode.TotalVolume': 'נפח כולל',
    'property.VolumeMode.Trades': 'עסקאות',
    'property.VolumeOpacityPercent': 'שקיפות',
    'property.VolumeProfile': 'פרופיל נפח',
    'property.VolumeUpColor': 'חיובי',
    'property.VolumeBars.Visible.Tooltip': "הגדר 'False' כדי להסתיר את עמודות הנפח בגרף.",
    'property.VolumeBars.PercentageHeight.Tooltip': 'התאם את האחוז כדי לשנות את גובה עמודות הנפח בגרף.',
    'property.VolumeBars.SizeColoringScheme.Tooltip': 'בחר סכמת צבע עבור עמודות הנפח.',
    'property.VolumeBars.Fixed.Tooltip': 'השתמש בסכמת צבע שווה עבור עמודות הנפח.',
    'property.VolumeBars.ByBar.Tooltip': 'צבע עמודות הנפח מבוסס על מחירי פתיחה וסגירה.',
    'property.VolumeBars.ByDifference.Tooltip': 'צבע עמודות הנפח מבוסס על השוואה לעמודה הבאה.',
    'property.VolumeBars.AboveBelowMovingAverage.Tooltip': 'צבע עמודות הנפח מבוסס על המיקום ביחס לממוצע הנע.',
    'property.VolumeBars.EqualColor.Tooltip': 'בחר סכמת צבע עבור עמודות הנפח על סמך הקריטריונים שצוינו.',
    'property.VolumeBars.PositiveColor.Tooltip': 'בחר סכמת צבע עבור עמודות הנפח על סמך הקריטריונים שצוינו.',
    'property.VolumeBars.NegativeColor.Tooltip': 'בחר סכמת צבע עבור עמודות הנפח על סמך הקריטריונים שצוינו.',
    'property.VolumeBars.FontColor.Tooltip': 'בחר את צבע הגופן להצגת ערך הנפח של העמודה.',
    'property.VolumeBars.ShowMovingAverage.Tooltip': 'סמן תיבה זו כדי להגדיר את קו הממוצע הנע.',
    'property.VolumeBars.MAPeriod.Tooltip': 'התאם את התקופה לחישוב הממוצע הנע של עמודות הנפח.',
    'property.VolumeBars.ShowValueMarketOnScale.Tooltip': 'סמן תיבה זו כדי להציג סמן ערך על סולם הגרף.',
    'property.VWAP': 'VWAP',
    'property.Warnings': 'אזהרות',
    'property.WatermarkColor': 'צבע סימן מים',
    'property.WatermarkMode': 'מצב סימן מים',
    'watermarkMode.None': 'ללא',
    'watermarkMode.Symbol': 'סימול',
    'watermarkMode.Description': 'תיאור',
    'watermarkMode.SymbolAndDescription': 'סמל + תיאור',
    'watermarkMode.Logo': 'לוגו מכשיר',
    'property.WeekSeparators': 'מפרידי שבוע',
    'property.Weighted': 'משוקלל',
    'property.wickColor': 'זנב',
    'property.width': 'רוחב:',
    'property.Win num': 'סימון מספר זכיות בגרף כאינדקטור',
    'property.Win num.addWin': 'חלון משנה',
    'property.Win num.main': 'ראשי',
    'property.Y factor': 'מקדם Y',
    'property.YearSeparators': 'מפרידי שנה',
    'property.ZeroLine': 'קו אפס',
    'property.ZoomValue': 'שלב הסולם',
    'property.DisableInactivityPeriod': '#hidden#',
    'property.BuyTPTrigger': 'שער טריגר קנייה במימוש רווח',
    'property.BuySLTrigger': 'שער טריגר קנייה בסטופ-לוס',
    'property.SellTPTrigger': 'שער טריגר מכירה במימוש רווח',
    'property.SellSLTrigger': 'שער טריגר מכירה בסטופ-לוס',
    'property.SLTPTriggerInOE': 'בחירת שער הטריגר של סטופ-לוס/\מימוש רווח בהזנת הפקודה',
    'property.BuyTPTrigger.tt': 'מאפשר לבחור סוג שער עבור טריגר בהוראת קנייה במימוש רווח',
    'property.BuySLTrigger.tt': 'מאפשר לבחור סוג מחיר עבור טריגר בהוראת קנייה בסטופ-לוס',
    'property.SellTPTrigger.tt': 'מאפשר לבחור סוג שער עבור טריגר בהוראת מכירה במימוש רווח',
    'property.SellSLTrigger.tt': 'מאפשר לבחור סוג מחיר עבור טריגר בהוראת מכירה בסטופ-לוס',
    'property.SLTPTriggerInOE.tt': 'אם פעיל, למשתמש תהיה אפשרות לבחור שער טריגר של סטופ-לוס/\מימוש רווח בחלונית הזנת הוראה',
    'property.OETPTrigger': 'טריגר מימוש רווח',
    'property.OESLTrigger': 'טריגר סטופ-לוס',
    'dynProperty.inactive.tooltip': 'לא ניתן לשנות הגדרה במצב מנותק!',
    'property.general.DisableInactivityPeriod.confirmation.caption': 'גילוי סיכונים',
    'property.general.DisableInactivityPeriod.confirmation.message': 'השבתת תקופת חוסר פעילות.\nאני יודע, מבין ומקבל את הסיכונים הכרוכים בהשבתת תקופת חוסר פעילות.',
    'propery.MainPriceRenderer.Down': 'יורד',
    'propery.MainPriceRenderer.Negative': 'שלילי',
    'propery.MainPriceRenderer.Positive': 'חיובי',
    'propery.MainPriceRenderer.Up': 'עולה',
    'Relative Strength Index': 'מדד עוצמה יחסית',
    'reports.#subgroup.Revenue plan.0': 'עמלות',
    'reports.#subgroup.Revenue plan.1': 'מרווחים',
    'reports.#subgroup.Revenue plan.2': 'Swaps',
    'reports.#subgroup.Revenue plan.3': 'החזרים',
    'reports.#subgroup.Revenue plan.4': 'חלקי הסימול',
    'reports.$broker': 'ברוקר',
    'reports.$broker_create_order': 'הוראה שנוצרה על ידי ברוקר',
    'reports.$broker_refuse_with_answer': 'הברוקר סירב עם תשובה',
    'reports.$client': 'לקוח',
    'reports.$client_request': 'בקשת לקוח',
    'reports.$close_position': 'סגור פוזיציה',
    'reports.$confirm_order_removed': 'אישור הוראה הוסר',
    'reports.$enter_system': 'היכנס למערכת',
    'reports.$executed': 'בוצע',
    'reports.$leave_system': 'צא מהמערכת',
    'reports.$open_position': 'פוזיציה פתוחה',
    'reports.$order': 'הוראה',
    'reports.$request_order_removed': 'בקשה הוראה הוסרה',
    'reports.4CastNews': '4CastNews',
    'reports.Accepted': 'התקבל',
    'reports.accname': 'שם חשבון',
    'reports.accoperreqstatus': 'סטטוס',
    'reports.account': 'חשבון',
    'reports.Account': 'חשבון',
    'reports.Initial product type': 'סוג מוצר התחלתי',
    'reports.Target product type': 'סוג מוצר מטרה',
    'reports.Position ID': 'מזהה פוזיציה',
    'reports.Product type modification request': 'בקשה לשינוי סוג מוצר',
    'reports.Account Name': 'שם חשבון',
    'reports.Account operation confirmation.': 'אישור פעולה בחשבון',
    'reports.Account Operation Report': 'דוח פעולות בחשבון',
    'reports.Account operation report (settled)': 'דוח פעולות בחשבון (סולקו)',
    'reports.Account Operation Report Summary': 'דוח סיכום פעולות בחשבון',
    'reports.Account operations report': 'דוח פעולות בחשבון',
    'reports.Account Operations Report': 'דוח פעולות בחשבון',
    'reports.Account Performance Report': 'דוח ביצועי חשבון',
    'reports.Account Statement': 'דוח חשבון',
    'reports.Account statement in defined currency report': 'דוח חשבון במטבע מוגדר',
    'reports.Account Statement on chosen moment report': 'דוח חשבון בתקופה מוגדרת',
    'reports.Account Statement Report': 'דוח חשבון',
    'reports.account_ID': 'מזהה חשבון',
    'reports.account.balance': 'יתרה',
    'reports.account.crossinstrument': 'סמל צלב',
    'reports.account.currency': 'מטבע',
    'reports.account.ismaster': 'הוא מאסטר',
    'reports.account.mirroraccounts': 'חשבונות מראה',
    'reports.account.name': 'שם חשבון',
    'reports.account.status': 'סטטוס',
    'reports.account.type': 'סוג',
    'reports.account.userid': 'מזהה משתמש',
    'reports.account.visibility.editforsuper': 'ערוך עבור קבוצת העל',
    'reports.account.visibility.editforthis': 'ערוך עבור קבוצה זו',
    'reports.account.visibility.tradeforsuper': 'סחור עבור קבוצת העל',
    'reports.account.visibility.tradeforthis': 'סחור עבור קבוצה זו',
    'reports.account.visibility.viewforsuper': 'הצג עבור קבוצת העל',
    'reports.account.visibility.viewforthis': 'הצג עבור קבוצה זו',
    'reports.accountcurrency': 'מטבע',
    'reports.AccountId': 'חשבון',
    'reports.accountname': 'חשבון',
    'reports.AccountOperationAmount': 'כמות',
    'reports.accountoperationid': 'מזהה פעולה בחשבון',
    'reports.accountPassword': 'סיסמת החשבון',
    'reports.accounts': 'חשבונות',
    'reports.accountUsername': 'שם המשתמש בחשבון',
    'reports.AccruedInterest': 'ריבית צבורה',
    'reports.ACM Feed': 'פיד ACM',
    'reports.action': 'צד',
    'reports.actionname': 'שם פעולה',
    'reports.Activated': 'מופעל',
    'reports.Active Orders Report': 'דוח הוראות פעילות',
    'reports.actualprice': 'מחיר בפועל',
    'reports.actualtime': 'זמן בפועל',
    'reports.addliquidityrebate': 'הוסף החזר נזילות',
    'reports.address': 'כתובת',
    'reports.Adjusment': 'התאמה',
    'reports.Adjustment': 'התאמה',
    'reports.ADMINISTRATION_RULES': 'כללים אדמיניסטרטיביים',
    'reports.AK Equity Algo': 'AK Equity Algo',
    'reports.AK Genex Equity': 'AK Genex Equity',
    'reports.AK Genex Turdex': 'AK Genex Turdex',
    'reports.alertNotify': 'התראת הודעה',
    'reports.All brokers': 'כל הברוקרים',
    'reports.All data received.': 'כל הנתונים התקבלו.',
    'reports.ALLOW_AUTO_APPROVE_TRANSFER_REQUEST': 'לאפשר אישור אוטומטי של בקשת העברה',
    'reports.ALLOW_AUTO_ORDER_TYPE': 'הגדרה אוטומטית של סוג ההוראה (לימיט/סטופ/מרקט)',
    'reports.ALLOW_AUTO_RESET_PWD': 'לאפשר איפוס אוטומטי של סיסמה',
    'reports.ALLOW_CLOSE_POSITIONS_ON_STOP_OUT': 'סגור פוזיציות בסטופ-אאוט',
    'reports.ALLOW_DEMO_AUTO_REGISTRATION': 'לאפשר רישום אוטומטי של משתמש דמו',
    'reports.ALLOW_GENERATE_L3': 'לאפשר יצירת L3',
    'reports.ALLOW_GENERATE_PRICE_FROM_SPOT': 'לאפשר הפקת מחיר מספוט',
    'reports.ALLOW_HEDGE_BY_SPOT': 'גידור לפי ספוט',
    'reports.ALLOW_HEDGE_MARGIN': 'לאפשר גידור בבטוחות',
    'reports.ALLOW_JOIN_POSITIONS': 'הצטרף לפוזיציות צד אחד לגידור',
    'reports.ALLOW_LAZY_LOAD_QUOTES': 'לאפשר טעינת ציטוטים עצלים',
    'reports.ALLOW_LIVE_AUTO_REGISTRATION': 'לאפשר רישום אוטומטי חי',
    'reports.ALLOW_ONE_BROKER_FOR_ALL_OPERATION': 'לאפשר ברוקר אחד לכל הפעולות',
    'reports.ALLOW_ORDER_AUTOEXECUTION_IS_MARKET_PRICE': 'בצע הוראות במחיר מרקט (אם false - במחיר ההוראה)',
    'reports.ALLOW_PRICE_EXECUTION_MAPPING': 'מיפוי ביצוע מחיר',
    'reports.ALLOW_PWD_VERIFICATION': 'אמת את הסיסמה באמצעות SMS',
    'reports.ALLOW_REFUSE_IF_BROKER_OFFLINE': 'לאפשר לסרב אם הברוקר נמצא במצב לא מקוון',
    'reports.ALLOW_REMOVE_ORDERS_ON_STOP_OUT': 'הסר הוראות בסטופ-אאוט',
    'reports.ALLOW_SAVE_HISTORY': 'שמור היסטוריית ציטוטים לסימול',
    'reports.ALLOW_SAVE_QUOTE_LOGS': 'לאפשר שמירת יומני ציטוטים',
    'reports.ALLOW_SAVE_QUOTE_TICKS': 'לאפשר שמירת ציטוטי טיקים',
    'reports.ALLOW_SAVE_QUOTES': 'לאפשר שמירת ציטוטים',
    'reports.ALLOW_SAVE_TRADE_LOGS': 'לאפשר שמירת יומני מסחר',
    'reports.ALLOW_SHORT_POSITIONS': 'אפשר פוזיציות שורט',
    'reports.ALLOW_SKIP_REVERSED_PRICE': "דלג על כל הציטוטים ה'הפוכים'",
    'reports.ALLOW_SPIKE_FILTER': 'לאפשר מסנן ספייק',
    'reports.ALLOW_STOP_AVARE_MARGIN': 'השתמש בסטופ מודע לבטוחות',
    'reports.ALLOW_STORE_USERS_FILES': 'אפשר אחסון קבצי משתמש',
    'reports.ALLOW_USE_CERT': 'אפשר שימוש בבקשת התחברות',
    'reports.ALLOW_USER_LEVERIGE': 'לאפשר מינוף משתמש',
    'reports.ALLOW_USERS_EMAIL_DUPLICATE': 'לאפשר שכפול הודעות דוא"ל עבור חשבונות דמו',
    'reports.ALLOW_VISIBLITY': 'לאפשר נראות',
    'reports.allowLimitOrders': 'לאפשר הוראות לימיט',
    'reports.allowStopOrders': 'לאפשר הוראות סטופ',
    'reports.already in processing': 'כבר נמצא בעיבוד',
    'reports.amount': 'כמות',
    'reports.Amount': 'כמות',
    'reports.Amount filled': 'כמות שהוזנה',
    'reports.amountperside': 'סכום לצד',
    'reports.An error occurred during sending mail using user settings. Will use default settings.': 'אירעה שגיאה במהלך שליחת דואר באמצעות הגדרות המשתמש. יעשה שימוש בהגדרות ברירת המחדל.',
    'reports.Aphelion': 'Aphelion',
    'reports.APPLICATION.NAME': 'שם האפליקציה',
    'reports.Approved': 'אושר',
    'reports.asset': 'נכס',
    'reports.AuditReport': 'דוח שינויי בק-אופיס',
    'reports.Authorization Error: Operation is nor allowed': 'שגיאת הרשאה: הפעולה אסורה',
    'reports.autotrade': 'מסחר אוטומטי',
    'reports.Average filled price': 'מחיר',
    'reports.Back Office Changes Report': 'דוח שינויים בק-אופיס',
    'reports.balance': 'יתרה',
    'reports.Balance': 'יתרה',
    'reports.Balance by Instrument Report': 'דוח יתרה לפי סוג סמל',
    'reports.Balance By Instrument Report': 'דוח יתרה לפי סוג סמל',
    'reports.Balance Operations Report': 'דוח פעולות יתרה',
    'reports.Balance Report': 'דוח יתרות',
    'reports.Balance Report(copy)': 'דוח יתרה (עותק)',
    'reports.Balance Summary report': 'דוח סיכום יתרה',
    'reports.Balance Summary Report': 'דוח סיכום יתרה',
    'reports.balance_after': 'יתרה לאחר',
    'reports.balance_before': 'יתרה לפני',
    'reports.balance.amount': 'כמות',
    'reports.balance.buy': 'קנייה',
    'reports.balance.everbuy': 'קנייה ממוצעת',
    'reports.balance.eversell': 'מכירה ממוצעת',
    'reports.balance.exposure': 'חשיפה',
    'reports.balance.exposurenet': 'חשיפה נטו',
    'reports.balance.grossexposure': 'חשיפה ברוטו',
    'reports.balance.grosspl': 'רווח/הפסד ברוטו',
    'reports.balance.grossvalue': 'שווי פוזיציה ברוטו',
    'reports.balance.net': 'נטו',
    'reports.balance.netexposure': 'חשיפה נטו',
    'reports.balance.netvalue': 'שווי פוזיציה נטו',
    'reports.balance.profit': 'רווח',
    'reports.balance.sell': 'מכירה',
    'reports.Barclays': 'Barclays',
    'reports.basis': 'הערה',
    'reports.Basis': 'הערה',
    'reports.because Not enoght margin to create Order': 'מכיוון שאין מספיק בטוחות כדי ליצור הוראה',
    'reports.because Price for Stop limit order is incorrect.': 'מאחר שהמחיר להוראת סטופ-לימיט שגוי.',
    'reports.BeginString': 'התחלת מחרוזת',
    'reports.blocked_funds': 'כספים חסומים (בטוחות)',
    'reports.blockedbalance': 'יתרה חסומה',
    'reports.Blocking': 'חוסם',
    'reports.bmr_brokermessageid': 'מזהה הודעה',
    'reports.bmr_brokermessagename': 'שם הודעה',
    'reports.bmr_confirmtime': 'זמן יעד',
    'reports.bmr_targetuserid': 'מזהה משתמש',
    'reports.bmr_targetuserlogin': 'משתמש',
    'reports.Bound To': 'מקושר ל',
    'reports.Bound to order': 'מקושר להוראה',
    'reports.boundtoorderid': 'מזהה הוראה מקושר',
    'reports.BRANDING_ADMIN_HELP': 'כתובת URL לעזרה אדמיניסטרטיבית',
    'reports.BRANDING_ANONYM_GROUP': 'הצב משתמשים רשומים אנונימיים אוטומטיים בתוך',
    'reports.BRANDING_ANONYM_GROUP_SUPPORT': 'קבוצת תמיכה למשתמשים אנונימיים',
    'reports.BRANDING_CLIENT_MINIMAL_VERSION': 'גרסת לקוח מינימלית (לעדכון מאולץ)',
    'reports.BRANDING_COMMON_RULES': 'משותף',
    'reports.BRANDING_COMPANY_DESC': 'תאור חברת מיתוג',
    'reports.BRANDING_COMPANY_INFO_RULES': 'מידע על החברה',
    'reports.BRANDING_COMPANY_NAME': 'שם החברה',
    'reports.BRANDING_COMPANY_URL': 'כתובת URL של החברה',
    'reports.BRANDING_DEMO_GROUP': 'הצב משתמשי דמו שנרשמו אוטומטית בתוך',
    'reports.BRANDING_DEMOREGISTRATION_URL': 'רישום דמו (ריק-השרת הזה; 0-מושבת; url-דף אתר)',
    'reports.BRANDING_DEPOSIT_URL': 'כתובת URL להפקדה (ריק-מושבת, כתובת URL לדף)',
    'reports.BRANDING_DISCLAMER': 'טקסט גילוי נאות (מוצג בסקין התחברות 0)',
    'reports.BRANDING_DOWJONES_ENCRYPTED_TOKEN': "אסימון מוצפן של דאו ג'ונס",
    'reports.BRANDING_EMAIL': 'דוא"ל החברה',
    'reports.BRANDING_EXT_LINK_RULES': 'קישורים חיצוניים',
    'reports.BRANDING_FORGOTPWD_URL': "כתובת URL ל'שכחתי סיסמה'",
    'reports.BRANDING_HTML_FOOTER': 'תמונת כותרת תחתונה',
    'reports.BRANDING_HTML_LOGINSCREEN_LOGO': 'תמונת מסך כניסה',
    'reports.BRANDING_HTML_LOGO': 'תמונת לוגו',
    'reports.BRANDING_HTML_NAME': 'שם האפליקציה',
    'reports.BRANDING_HTML_STATION_RULES': 'בק-אופיס',
    'reports.BRANDING_INFO_MESSAGE': 'הודעה קופצת (נפתחת בעמדה לאחר ההתחברות)',
    'reports.BRANDING_KEY': 'מפתח מיתוג (משמש לקשר אליו את המתקינים)',
    'reports.BRANDING_KNOWLEDGE_BASE_URL': 'כתובת האתר של מאגר הידע (1- כדי להשבית)',
    'reports.BRANDING_LANG_SET': 'משאבי שפה',
    'reports.BRANDING_LIVE_GROUP': 'הצב משתמשי חשבון חי שנרשמו אוטומטית בתוך',
    'reports.BRANDING_LOGIN_MESSAGE': "הודעת 'שים לב' במסך ההתחברות",
    'reports.BRANDING_MAIL_CONFIGURATION': 'תצורת דואר',
    'reports.BRANDING_MAIL_PATTERN': 'תבנית',
    'reports.BRANDING_NET_BACKGROUND': 'תמונת רקע (אופציונלי/קובץ bmp בכל גודל)',
    'reports.BRANDING_NET_BANNER': 'תמונת באנר (קובץ bmp 500x36)',
    'reports.BRANDING_NET_BROKERIMAGE': 'תמונת דוח (קובץ bmp בכל גודל)',
    'reports.BRANDING_NET_CONFIGURAION': 'תצורת ברירת מחדל (קובץ program.ini)',
    'reports.BRANDING_NET_DEFWORKSPACE': 'מרחב עבודה ברירת מחדל (קובץ ‎*.wrk)',
    'reports.BRANDING_NET_FX_STYLE': 'סקין של תאי מט"ח (הזן קוד)',
    'reports.BRANDING_NET_HELP': 'כתובת URL לעזרה',
    'reports.BRANDING_NET_ICON': 'תמונת אייקון (קובץ ico 16x16+32x32)',
    'reports.BRANDING_NET_INSTALLER_BANNER_IMAGE': 'תמונת באנר של מתקין (500*59)',
    'reports.BRANDING_NET_INSTALLER_DIALOG_IMAGE': 'תמונת דו-שיח של מתקין (500*316)',
    'reports.BRANDING_NET_LINK': 'קישור לאפליקציה',
    'reports.BRANDING_NET_LOADING_IMAGE': 'טוען תמונת ‎*.gif',
    'reports.BRANDING_NET_LOGIN_STYLE': 'סקין מסך התחברות (הזן קוד)',
    'reports.BRANDING_NET_LOGO': 'תמונת לוגו (קובץbmp 500x35)',
    'reports.BRANDING_NET_NAME': 'שם האפליקציה (עבור נתוני אפליקציה, קיצורי דרך)',
    'reports.BRANDING_NET_OE_STYLE': 'סקין הזנת הוראה (הזן קוד)',
    'reports.BRANDING_NET_RIBBONICON': 'תמונת אייקון סרט (קובץ ico 32x32)',
    'reports.BRANDING_NET_STATION_RULES': '‎.Net station',
    'reports.BRANDING_NET_USE_FINGERPRINT': 'השתמש בטביעת אצבע',
    'reports.BRANDING_PHONE': 'טלפון החברה',
    'reports.BRANDING_POWERED_BY': 'מופעל על ידי (שם החברה או האדם)',
    'reports.BRANDING_PROPERTIES_RULES': 'מאפייני המיתוג',
    'reports.BRANDING_RULES': 'נראות המיתוג',
    'reports.BRANDING_SCRIPT_URL': 'כתובת ה-URL של הסקריפט',
    'reports.BRANDING_SERVER_URL': 'כתובת URL של השרת הממותג (כתובת URL או ip עם קישור לדף הראשון, לפני ההתחברות)',
    'reports.BRANDING_STATUS_MESSAGE': 'הודעת שורת המצב (מוצגת בשורת המצב של העמדה)',
    'reports.BRANDING_THEME': 'מראה ותחושה',
    'reports.BRANDING_TOOLS_RULES': 'קישורי אינטרנט חיצוניים בתפריט כלים',
    'reports.BRANDING_TTP_FILE': 'תבניות חלונית',
    'reports.BRANDING_USERS_RULES': 'כללי משתמש',
    'reports.BRANDING_WITHDRAW_URL': 'כתובת URL למשיכה (ריק-מושבת, כתובת URL לדף)',
    'reports.branding.name': 'שם',
    'reports.Broker Message Report': 'דוח הודעות ברוקר',
    'reports.Brokerage': "ברוקרג'",
    'reports.brokerCancel': 'ברוקר - ביטול',
    'reports.brokerlogin': 'ברוקר - התחברות',
    'reports.Buy': 'קנייה',
    'reports.buy trade amount': 'קנייה סכום עסקאות',
    'reports.buy trades': 'קנייה עסקאות',
    'reports.buyselltype': 'סוג קניה/מכירה',
    "reports.Can't allocate route for trade using hadget": "לא ניתן להקצות ניתוב למסחר באמצעות האדג'ט",
    "reports.Can't close entry": 'אי אפשר לסגור את הכניסה',
    'reports.Cancel order:': 'ביטול הוראה:',
    'reports.Cancel request accepted by broker': 'בקשת ביטול התקבלה אצל הברוקר',
    'reports.Cancel request received by STP': 'בקשת הביטול התקבלה על ידי STP',
    'reports.Canceled': 'בוטל',
    'reports.Canceling': 'בוטל',
    'reports.Cancelled': 'בוטל',
    'reports.Cancelling': 'בוטל',
    'reports.CantorFX': 'CantorFX',
    'reports.Cash Deposit And Withdrawal Report': 'דוח הפקדות ומשיכות מזומנים',
    'reports.cash_posted': 'מזומן נשלח',
    'reports.Cash': 'מזומן',
    'reports.Champ stats report': 'דוח סטטיסטיקות Champ',
    'reports.change': 'שינוי',
    'reports.Change password error, new password must differ from old one': 'שגיאת שינוי סיסמה, הסיסמה החדשה חייבת להיות שונה מהישנה',
    'reports.CHART_OE': 'Desktop:Chart OE',
    'reports.DESKTOP_ALERT': 'Desktop:Alert',
    'reports.REST': 'SERVER:REST',
    'reports.MAC_ALERT': 'MAC:Alert',
    'reports.ANDROID_ALERT': 'MOB:Alert “Android”',
    'reports.IOS_ALERT': 'MOB:Alert “IOS”',
    'reports.CHART_VISUAL': 'Desktop:Chart Visual',
    'reports.Chat History Report': "דוח היסטוריית צ'אט",
    'reports.CheckCompID': 'בדוק מזהה רכיב',
    'reports.CheckLatency': 'בדיקת מהירות חיבור',
    'reports.ChoiceFX': 'ChoiceFX',
    'reports.CIBC': 'CIBC',
    'reports.Citi': 'Citi',
    'reports.ClearingVmTransfer': 'מחיקת העברת VM',
    'reports.clfr_close_date': 'תאריך סגירה',
    'reports.clfr_fund_name': 'שם הקרן',
    'reports.clientid': 'מזהה לקוח',
    'reports.clienttype': 'סוג לקוח',
    'reports.Close Limit order created': 'הוראת לימיט לסגירה נוצרה',
    'reports.Close Limit order created is off market': 'הוראת לימיט לסגירה מחוץ לשוק',
    'reports.Close Limit order created is unplaced': 'הוראת לימיט לסגירה לא הוצבה בבורסה',
    'reports.Close Limit order received by broker': 'הוראת לימיט לסגירה התקבלה אצל הברוקר',
    'reports.Close Market order created': 'הוראת מרקט לסגירה נוצרה',
    'reports.Close Market Order Created': 'הוראת מרקט לסגירה נוצרה',
    'reports.Close Market order created is off market': 'הוראה לסגירה במרקט נמצאת מחוץ לשוק',
    'reports.Close Market order created is unplaced': 'הוראת מרקט לסגירה לא הוצבה בבורסה',
    'reports.Close Market order received by broker': 'הוראת מרקט לסגירה התקבלה אצל הברוקר',
    'reports.Close OCO order created': 'הוראת סגירת OCO נוצרה',
    'reports.Close OCO order created is off market': 'הוראת סגירת OCO נמצאת מחוץ לשוק',
    'reports.Close OCO order created is unplaced': 'הוראת סגירת OCO לא הונחה בבורסה',
    'reports.Close OCO order received by broker': 'הוראת סגירת OCO התקבלה על ידי הברוקר',
    'reports.Close order type': 'סוג הוראת סגירה',
    'reports.Close position:': 'סגירת פוזיציה:',
    'reports.Close Sell': 'סגירת מכירה',
    'reports.Close SL order created': 'הוראת סטופ-לוס לסגירה נוצרה',
    'reports.Close SL order created is off market': 'הוראת סטופ-לוס לסגירה רחוקה מדי ממחיר השוק',
    'reports.Close SL order created is unplaced': 'הוראת סטופ-לוס לסגירה לא הוצבה בבורסה',
    'reports.Close SL order received by broker': 'הוראת סטופ-לוס לסגירה התקבלה אצל הברוקר',
    'reports.Close SL tr. stop order created': 'הוראת סגירה בסטופ נגרר נוצרה',
    'reports.Close SL tr. stop order created is off market': 'הוראת סגירה בסטופ נגרר רחוקה מדי ממחיר השוק',
    'reports.Close SL tr. stop order created is unplaced': 'הוראת סגירה בסטופ נגרר לא הוצבה בבורסה',
    'reports.Close SL tr. stop order received by broker': 'הוראת סגירה בסטופ נגרר התקבלה אצל הברוקר',
    'reports.Close Stop Limit order created': 'הוראת סגירה סטופ-לימיט נוצרה',
    'reports.Close Stop Limit order created is off market': 'הוראת סטופ-לימיט לסגירה נמצאת מחוץ לשוק',
    'reports.Close Stop Limit order created is unplaced': 'הוראת סגירה סטופ-לימיט לא הוצבה בבורסה',
    'reports.Close Stop Limit order received by broker': 'הוראת סגירה סטופ-לימיט התקבלה על ידי הברוקר',
    'reports.Close Stop order created': 'הוראת סטופ לסגירה נוצרה',
    'reports.Close Stop order created is off market': 'הוראת סגירה סטופ מחוץ לשוק',
    'reports.Close Stop order created is unplaced': 'הוראת סטופ לסגירה לא הוצבה בבורסה',
    'reports.Close Stop order received by broker': 'הוראת סטופ לסגירה התקבלה אצל הברוקר',
    'reports.Close TP order created': 'הוראת מימוש רווח לסגירה נוצרה',
    'reports.Close TP order created is off market': 'הוראת מימוש רווח מחוץ לשוק',
    'reports.Close TP order created is unplaced': 'הוראת מימוש רווח לסגירה לא הוצבה בבורסה',
    'reports.Close TP order received by broker': 'הוראת מימוש רווח לסגירה התקבלה אצל הברוקר',
    'reports.Close Tr. stop order created': 'הוראת סגירה בסטופ נגרר נוצרה',
    'reports.Close Tr. stop order created is off market': 'הוראת סגירה בסטופ נגרר מחוץ לשוק',
    'reports.Close Tr. stop order created is unplaced': 'הוראת סגירה בסטופ נגרר לא הוצבה בבורסה',
    'reports.Close Tr. stop order received by broker': 'הוראת סגירה בסטופ נגרר התקבלה אצל הברוקר',
    'reports.CLOSE_ALL': 'סגור הכל',
    'reports.CLOSE_ALL_ORDERS': 'שרת: ביטול כל ההוראות',
    'reports.CLOSE_ALL_POSITIONS': 'שרת:סגירת כל הפוזיציות',
    'reports.CLOSE_FIFO': 'סגור פוזיציות כשאין מספיק בטוחות (לפי סדר פתיחת הפוזיציות = ראשון נכנס ראשון יוצא)',
    'reports.CLOSE_LAGES': 'סגור פוזיציות כאשר אין מספיק בטוחות (מהגדול לקטן)',
    'reports.CLOSE_LIFO': 'סגור פוזיציות כשאין מספיק בטוחות (לפי סדר נפתח אחרון יוצא ראשון - LIFO)',
    'reports.closebytradeid': 'סגור לפי מזהה עסקה',
    'reports.Closed funds report': 'דוח כספים סגורים',
    'reports.Closed Positions': 'דוח פוזיציות סגורות',
    'reports.closedat': 'סגירה',
    'reports.closedbyorderid': 'סגור לפי מזהה הוראה',
    'reports.ClosedResendInterval': 'מרווח שליחה חוזרת נסגר',
    'reports.CloseOptionPremium': 'סגירת הפרמיה של אופציה',
    'reports.Closeposition': 'סגור פוזיציה',
    'reports.closeprice': 'מחיר סגירה',
    'reports.closetime': 'זמן סגירה',
    'reports.comission': 'עמלה',
    'reports.Comment': 'הערה',
    'reports.comments': 'הערות',
    'reports.comments.CancelOperation': 'בטל פעולה מספר',
    'reports.COMMISIONSPLAN_RULES': 'נראות תוכניות הכנסה',
    'reports.commission': 'עמלה',
    'reports.commission_out': 'עמלה ביציאה',
    'reports.commissionpertrade': 'עמלה לעסקה',
    'reports.commissions': 'עמלות',
    'reports.Commissions': 'עמלה',
    'reports.Commissions report': 'דוח עמלות',
    'reports.Commissions Report': 'דוח עמלות',
    'reports.Commissions Report(copy)': 'דוח עמלות (עותק)',
    'reports.commissiontotal': 'סה"כ עמלה',
    'reports.COMMON_RULES': 'כללים משותפים',
    'reports.Community': 'קהילה',
    'reports.ConfigFilePath': 'הגדר נתיב קובץ',
    'reports.Connected': 'מחובר',
    'reports.Connection established': 'חיבור נוצר',
    'reports.Connections Report': 'דוח חיבורים',
    'reports.ConnectionType': 'סוג חיבור',
    'reports.connrp_conntime': 'זמן ניסיון חיבור',
    'reports.connrp_fullname': 'שם פרטי ומשפחה',
    'reports.connrp_ip': 'IP',
    'reports.connrp_lastpwdchange': 'שינוי אחרון של הסיסמה',
    'reports.connrp_login': 'התחברות',
    'reports.connrp_success': 'הצלחת החיבור',
    'reports.ContinueInitializationOnError': 'המשך אתחול בשגיאה',
    'reports.Contract Specification Report': 'דוח מפרט חוזה',
    'reports.Counter Account Name': 'שם חשבון נגדי',
    'reports.Counter Operation Id': 'מזהה פעולה נגדית',
    'reports.COUNTERACCOUNTS_RULES': 'חשבונות נגדיים',
    'reports.Created': 'נוצר',
    'reports.Created by': 'נוצר על ידי',
    'reports.createdat': 'נוצר ב-',
    'reports.Creating': 'נוצר',
    'reports.creator': 'יוצר',
    'reports.credit': 'אשראי',
    'reports.Credit': 'אשראי',
    'reports.crossprice': 'מחיר הצלבה',
    'reports.crosstype': 'סוג הצלבה',
    'reports.currency': 'מטבע',
    'reports.Currency Exposure Report': 'דוח חשיפת מט"ח',
    'reports.Currency summary exposure': 'סיכום חשיפת מט"ח',
    'reports.currency.balance_interest': 'ריבית על היתרה (%)',
    'reports.currency.interest_buy_rate': 'ריבית על חיובי (%)',
    'reports.currency.interest_sell_rate': 'ריבית על שלילי (%)',
    'reports.currency.leverage_negative': 'מינוף חשיפה שלילי',
    'reports.currency.leverage_positive': 'מינוף חשיפה חיובי',
    'reports.currency.min_change': 'שינוי מינימלי',
    'reports.currency.name': 'שם',
    'reports.Currenex': 'Currenex',
    'reports.CurrenexFIX': 'CurrenexFIX',
    'reports.Current Balance': 'יתרה נוכחית',
    'reports.currentprice': 'מחיר נוכחי',
    'reports.CUSTOM_COLUMN_BTN_SCRIPT': 'Desktop:Custom column',
    'reports.customReport': 'דוחות מותאמים אישית',
    'reports.DataDictionary': 'מילון נתונים',
    'reports.DateTime': 'תאריך/שעה',
    'reports.days': 'ימים',
    'reports.daystillexpiration': 'ימים עד פקיעה',
    'reports.DBFX': 'DBFX',
    'reports.dealercommission': 'עמלת דילר',
    'reports.debit': 'חיוב',
    'reports.Default settings failed': 'הגדרות ברירת המחדל נכשלו',
    'reports.Delayed Limit Order Created': 'הוראת לימיט ממתינה נוצרה',
    'reports.Delayed Limit Order Modified': 'הוראת לימיט ממתינה שונתה',
    'reports.Delayed Limit Order Removed': 'הוראת לימיט בהמתנה הוסרה',
    'reports.Delayed OCO Order Created': 'הוראת OCO ממתינה נוצרה',
    'reports.Delayed Stop Limit Order Created': 'הוראת סטופ-לימיט נוצרה',
    'reports.Delayed Stop Limit Order Modified': 'הוראת סטופ-לימיט הוחלפה',
    'reports.Delayed Stop Limit Order Removed': 'הוראת סטופ-לימיט הוסרה',
    'reports.Delayed Stop Order Created': 'הוראת סטופ ממתינה נוצרה',
    'reports.Delayed Stop Order Modified': 'הוראת סטופ ממתינה שונתה',
    'reports.Delayed Stop Order Removed': 'הוראת סטופ בהמתנה הוסרה',
    'reports.Delayed Trailing Stop Order Created': 'הוראת סטופ נגרר נוצרה',
    'reports.Delayed Trailing Stop Order Modified': 'הוראת סטופ נגרר שונתה',
    'reports.Delayed Trailing Stop Order Removed': 'הוראת סטופ נגרר הוסרה',
    'reports.DelayedCharging': 'חיוב מושהה',
    'reports.DelayedDataCharging': 'חיוב נתונים מושהים',
    'reports.delivered': 'נשלח',
    'reports.DeliveredForward': 'נמסר קדימה',
    'reports.Delivery': 'מסירה',
    'reports.demoMode': 'מצב דמו',
    'reports.deposit': 'הפקדה',
    'reports.Deposit': 'הפקדה',
    'reports.Detail': 'פרטים',
    'reports.Deutsche Bank': 'Deutsche Bank',
    'reports.DeutscheBankFIXFeed': 'DeutscheBankFIXFeed',
    'reports.DGCX': 'DGCX',
    'reports.Dictionary': 'מילון',
    'reports.discount': 'הנחה',
    'reports.dividends': 'דיבידנדים',
    'reports.DO_NOT_CLOSE': 'אל תסגור פוזיציות',
    'reports.DukasCopy': 'DukasCopy',
    'reports.DWT': 'DWT',
    'reports.email': 'דוא"ל',
    'reports.EMAIL_NOTIFICATION': 'נראות תבנית הודעות דוא"ל',
    'reports.EMAIL_RULES': 'נראות תבנית הודעות דוא"ל',
    'reports.EndDay': 'תאריך סיום',
    'reports.EndTime': 'זמן סיום',
    'reports.entityId': 'מזהה ישות',
    'reports.enum_StopOutType_AutoClose': 'סגירה אוטומטית',
    'reports.enum_StopOutType_CloseAllByInstruments': 'סגור הכל לפי מכשירים',
    'reports.enum_StopOutType_CloseAllPositions': 'סגור את כל הפוזיציות',
    'reports.enum_StopOutType_CloseLagestLoss': 'סגור פוזיציות כשאין מספיק בטוחות (מההפסד הגדול לקטן)',
    'reports.enum_StopOutType_ClosePositionsByMarginExcess': 'סגור פוזיציות לפי חריגת בטוחות',
    'reports.enum_StopOutType_DoNotClosePositions': 'אל תסגור פוזיציות',
    'reports.enum_StopOutType_FIFO': 'סגור פוזיציות כשאין מספיק בטוחות (לפי סדר פתיחת הפוזיציות = ראשון נכנס ראשון יוצא)',
    'reports.enum_StopOutType_LargestFirst': 'סגור פוזיציות כאשר אין מספיק בטוחות (מהגדול לקטן)',
    'reports.enum_StopOutType_LIFO': 'סגור פוזיציות כשאין מספיק בטוחות (לפי סדר נפתח אחרון יוצא ראשון - LIFO)',
    'reports.Error occured during downloading update:': 'אירעה שגיאה במהלך הורדת העדכון:',
    'reports.Error sending email': 'שגיאה בשליחת דוא"ל',
    'reports.Error: Not enough Margin to open position': 'שגיאה: אין מספיק בטוחות לפתיחת פוזיציה',
    'reports.error.certificate_corrupted': 'אישור המשתמש פגום.',
    'reports.error.certificate_not_found': 'אישור המשתמש לא נמצא.',
    'reports.error.error_during_saving_route': 'אירעה שגיאה במהלך שמירת הניתוב. צור קשר עם האדמינסטור.',
    'reports.error.fill_mandatory': 'יש למלא את כל שדות החובה.',
    'reports.error.name_is_in_use': 'השם הזה כבר קיים!',
    'reports.error.not_valid_email': 'דוא"ל לא תקין.',
    'reports.error.not_valid_firstname': 'שם פרטי לא תקין.',
    'reports.error.not_valid_instrumentname_capital': 'שם לא תקין. נדרש אותיות גדולות בלבד.',
    'reports.error.not_valid_instrumentname_exist': 'שם לא תקין. השם הזה כבר קיים.',
    'reports.error.not_valid_instrumentname_length': 'שם לא תקין. השם לא יכול להיות ארוך מ-32 תווים.',
    'reports.error.not_valid_instrumenttypename': 'סוג מכשיר לא תקין. יש לציין את סוג המכשיר הנכון.',
    'reports.error.not_valid_lastname': 'שם משפחה לא תקין.',
    'reports.error.not_valid_login': 'שם משתמש לא תקין.',
    'reports.error.not_valid_name': 'שם לא תקין.',
    'reports.error.not_valid_name_exist': 'שם לא תקין. השם הזה כבר קיים.',
    'reports.error.not_valid_phone_number': 'מספר טלפון לא תקין. יש להזין נתוני ספרות בלבד.',
    'reports.error.photo_not_found': 'התמונה לא נמצאה.',
    'reports.error.too_short_phone_password': 'סיסמת הטלפון קצרה מדי',
    'reports.error.wrong_percenage': 'אחוז שגוי',
    'reports.ESignal': 'ESignal',
    'reports.event': 'אירוע',
    'reports.Event History Report': 'דוח היסטוריית אירועים',
    'reports.Event History Report with IP': 'דוח היסטוריית אירועים עם IP',
    'reports.Exception': 'יוצא מן הכלל',
    'reports.exchange': 'בורסה',
    'reports.Exchange': 'בורסה',
    'reports.Executed': 'מומש',
    'reports.Executed Orders Report': 'דוח הוראות שבוצעו',
    'reports.executedat': 'בצע',
    'reports.Executing': 'מומש',
    'reports.executionfee': 'עמלת ביצוע',
    'reports.executionprice': 'מחיר ביצוע',
    'reports.expiredate': 'תאריך פקיעה',
    'reports.expiresat': 'פקיעה',
    'reports.external_order_id': 'מזהה הוראה חיצוני',
    'reports.externalid': 'מזהה חיצוני',
    'reports.externalorderid': 'מזהה הוראה חיצוני',
    'reports.extfield': 'שדה חיצוני',
    'reports.EXTFIELDS_RULES': 'נראות שדות מורחבת',
    'reports.extprice': 'מחיר קיים',
    'reports.False': 'False',
    'reports.fee': 'עמלה',
    'reports.Fee: [addliquidityrebate]': 'עמלה: [addliquidityrebate]',
    'reports.Fee: [Brokerage]': 'עמלה: [Brokerage]',
    'reports.Fee: [Exchange]': 'עמלה: [Exchange]',
    'reports.Fee: [InvestorProtectionLevy]': 'עמלה: [InvestorProtectionLevy]',
    'reports.Fee: [removeliquidityrebate]': 'עמלה: [removeliquidityrebate]',
    'reports.Fee: [SecuritiesTransferTax]': 'עמלה: [SecuritiesTransferTax]',
    'reports.Fee: [SettlementFee]': 'עמלה: [SettlementFee]',
    'reports.Fee: [ValueAddedTax]': 'עמלה: [ValueAddedTax]',
    'reports.Fee: [CareOrder]': 'עמלה: [CareOrder]',
    'reports.Feed Data': 'נתוני פיד',
    'reports.Fees Report': 'דוח עמלות',
    'reports.FFastFillFIXFeed': 'FFastFillFIXFeed',
    'reports.fiahr_action': 'פעולה',
    'reports.fiahr_amount': 'כמות',
    'reports.fiahr_capital': 'הון',
    'reports.fiahr_count': 'מספר מניות',
    'reports.fiahr_date': 'תאריך',
    'reports.fiahr_fee': 'תגמול',
    'reports.fiahr_grosspl': 'רווח/הפסד ברוטו',
    'reports.fiahr_investor_id': 'מזהה משקיע',
    'reports.fiahr_investor_name': 'משקיע',
    'reports.fiahr_netpl': 'רווח/הפסד נטו',
    'reports.fiahr_pamm_id': 'מזהה קרן',
    'reports.fiahr_pamm_name': 'קרן',
    'reports.fiahr_price': 'מחיר',
    'reports.fiahr_requestid': 'מזהה בקשה',
    'reports.Fidessa': 'Fidessa',
    'reports.FileIncludeMilliseconds': 'הקובץ כולל אלפיות שנייה',
    'reports.FileIncludeTimeStampForMessages': 'הקובץ כולל חותמת זמן להודעות',
    'reports.FileLogHeartbeats': 'הקובץ רושם heartbeats',
    'reports.Filled': 'מומש',
    'reports.Filled close Limit order': 'הוראת לימיט לסגירה הוזנה',
    'reports.Filled close Limit order (Mutual)': 'הוראת לימיט לסגירה הוזנה (הדדי)',
    'reports.Filled close Market order': 'הוראת מרקט לסגירה הוזנה',
    'reports.Filled close Market order (Mutual)': 'הוראת מרקט לסגירה הוזנה (הדדי)',
    'reports.Filled close OCO order': 'הוראת סגירת OCO הוזנה',
    'reports.Filled close OCO order (Mutual)': 'הוראת סגירת OCO הוזנה (הדדי)',
    'reports.Filled close SL order': 'הוראת סטופ-לוס לסגירה הוזנה',
    'reports.Filled close SL order (Mutual)': 'הוראת סטופ-לוס לסגירה הוזנה (הדדי)',
    'reports.Filled close SL tr. stop order': 'הוראת סגירה בסטופ נגרר הוזנה',
    'reports.Filled close SL tr. stop order (Mutual)': 'הוראת סגירה בסטופ נגרר הוזנה (הדדי)',
    'reports.Filled close Stop Limit order': 'הוראת סטופ-לימיט לסגירה הוזנה',
    'reports.Filled close Stop Limit order (Mutual)': 'הוראת סטופ-לימיט לסגירה הוזנה (הדדי)',
    'reports.Filled close Stop order': 'הוראת סטופ לסיגרה הוזנה',
    'reports.Filled close Stop order (Mutual)': 'הוראת סטופ לסגירה הוזנה (הדדי)',
    'reports.Filled close TP order': 'הוראת מימוש רווח לסגירה מומשה',
    'reports.Filled close TP order (Mutual)': 'הוראת מימוש רווח לסגירה מומשה (הדדי)',
    'reports.Filled close Tr. stop loss order': 'מומשה הוראת הסגירה בסטופ נגרר',
    'reports.Filled close Tr. stop order': 'הוראת סגירה בסטופ נגרר מומשה',
    'reports.Filled close Tr. stop order (Mutual)': 'הוראת סגירה בסטופ נגרר מומשה (הדדי)',
    'reports.Filled Limit order': 'הוראת לימיט מומשה',
    'reports.Filled Limit order (Mutual)': 'הוראת לימיט מומשה (הדדי)',
    'reports.Filled Market order': 'הוראת מרקט מומשה',
    'reports.Filled Market order (Mutual)': 'הוראת מרקט מומשה (הדדי)',
    'reports.Filled OCO order': 'הוראת OCO מומשה',
    'reports.Filled OCO order (Mutual)': 'הוראת OCO מומשה (הדדי)',
    'reports.Filled SL order': 'הוראת סטופ-לוס מומשה',
    'reports.Filled SL order (Mutual)': 'הוראת סטופ-לוס מומשה (הדדי)',
    'reports.Filled SL tr. stop order': 'הוראת סטופ-לוס נגרר מומשה',
    'reports.Filled SL tr. stop order (Mutual)': 'הוראת סטופ-לוס נגרר מומשה (הדדי)',
    'reports.Filled Stop Limit order': 'הוראת סטופ-לימיט מומשה (הדדי)',
    'reports.Filled Stop Limit order (Mutual)': 'הוראת סטופ-לימיט מומשה (הדדי)',
    'reports.Filled Stop order': 'הוראת סטופ מומשה',
    'reports.Filled Stop order (Mutual)': 'הוראת סטופ מומשה (הדדי)',
    'reports.Filled TP order': 'הוראת מימוש רווח מומשה',
    'reports.Filled TP order (Mutual)': 'הוראת מימוש רווח מומשה (הדדי)',
    'reports.Filled Tr. stop order': 'הוראת סטופ נגרר מומשה',
    'reports.Filled Tr. stop order (Mutual)': 'הוראת סטופ נגרר מומשה (הדדי)',
    'reports.filledamount': 'הסכום שמומש',
    'reports.fir_exit_capital': 'הון נוכחי',
    'reports.fir_exit_price': 'מחיר מניה נוכחי',
    'reports.fir_investor_id': 'מזהה משקיע',
    'reports.fir_investor_name': 'שם המשקיע',
    'reports.fir_join_capital': 'הון התחלתי',
    'reports.fir_join_date': 'תאריך הצטרפות',
    'reports.fir_join_price': 'שער הצטרפות',
    'reports.fir_pamm_id': 'מזהה קרן',
    'reports.fir_pamm_name': 'שם הקרן',
    'reports.fir_reinvest_cycles': 'מחזורי השקעה מחדש',
    'reports.fir_share_count': 'מספק מניות',
    'reports.FirstDerivatives': 'FirstDerivatives',
    'reports.firstname': 'שם פרטי',
    'reports.FixedFee': 'עמלה קבועה',
    'reports.Custodial': 'משמורת',
    'reports.PortfolioOvernightFee': 'עמלת החזקה למשך לילה של תיק ההשקעות',
    'reports.CareOrder': 'הוראה לטיפול',
    'reports.Foreks': 'Foreks',
    'reports.Forex balances report': 'דוח יתרות מט"ח',
    'reports.Formal Dialog Report': 'דוח דו-שיח רשמי',
    'reports.FORTEX': 'FORTEX',
    'reports.fpghr_count': 'מניות',
    'reports.fpghr_exit_amount': 'סכום יציאה',
    'reports.fpghr_exit_price': 'שער יציאה',
    'reports.fpghr_fee': 'עמלה',
    'reports.fpghr_first_join_date': 'תאריך הצטרפות',
    'reports.fpghr_grosspl': 'רווח/הפסד ברוטו',
    'reports.fpghr_investor_id': 'מזהה משקיע',
    'reports.fpghr_investor_name': 'שם המשקיע',
    'reports.fpghr_join_amount': 'סכום הצטרפות',
    'reports.fpghr_join_price': 'שער הצטרפות',
    'reports.fpghr_last_exit_date': 'תאריך יציאה',
    'reports.fpghr_netpl': 'רווח/הפסד נטו',
    'reports.fpghr_pamm_id': 'מזהה קרן',
    'reports.fpghr_pamm_name': 'שם הקרן',
    'reports.fpghr_period': 'תקופה',
    'reports.fpghr_period_end_date': 'תאריך סיום',
    'reports.fpghr_period_start_date': 'תאריך התחלה',
    'reports.fprhr_date': 'עדכון אחרון',
    'reports.fprhr_details': 'פרטים',
    'reports.fprhr_entryid': 'מזהה כניסה',
    'reports.fprhr_event': 'אירוע',
    'reports.fprhr_investor_id': 'מזהה משקיע',
    'reports.fprhr_investor_name': 'משקיע',
    'reports.fprhr_pamm_id': 'מזהה קרן',
    'reports.fprhr_pamm_name': 'קרן',
    'reports.fprhr_requestid': 'מזהה בקשה',
    'reports.from': 'מ:',
    'reports.From.SERVER': 'שרת',
    'reports.fromDate': 'מ:',
    'reports.fromDateConnAttempt': 'מ:',
    'reports.fromDatePwdChange': 'מ(סיסמה)',
    'reports.FUNCTION_ACCOUNT_GROUP': 'קבוצת חשבונות',
    'reports.FUNCTION_ACCOUNT_OPERATIONS': 'נראות פעולות מימון',
    'reports.FUNCTION_ACCOUNTS': 'חשבונות',
    'reports.FUNCTION_ALERTS': 'התראות',
    'reports.FUNCTION_ARBITRAGER': "ארביטראז'ר",
    'reports.FUNCTION_AUTOBROKET_LIST': 'רשימת Autobroker',
    'reports.FUNCTION_BACK_TESTER': 'Backtester',
    'reports.FUNCTION_BARS_FROM': 'יצירת עמודות מ-',
    'reports.FUNCTION_BASE_CURRENCY': 'מטבע הבסיס של המערכת (ייתכן שיהיה צורך לשנות הצלבות מכשירים)',
    'reports.FUNCTION_BASKET': 'סל',
    'reports.FUNCTION_BETTING': 'הימורים',
    'reports.FUNCTION_BINDEDORDERS': 'אפשר הוראות OCO',
    'reports.FUNCTION_BLOCKED_SUMM_FOR_ORDERS': 'כספים חסומים לצורך הוראות',
    'reports.FUNCTION_BRANDING': 'מיתוגים',
    'reports.FUNCTION_BRANDINGADMIN': 'מנהל מיתוג',
    'reports.FUNCTION_BUILDER': 'כלי בניה',
    'reports.FUNCTION_CACHEADMIN': 'מנהל זיכרון מטמון',
    'reports.FUNCTION_CHART': 'גרף',
    'reports.FUNCTION_CHAT': "צ'אט",
    'reports.FUNCTION_CLOSE_POSITIONS_DISABLE': 'לא לאפשר סגירת פוזיציות',
    'reports.FUNCTION_COMMUNITY': 'קהילה',
    'reports.FUNCTION_CONFIGADMIN': 'תצורה ומיתוג',
    'reports.FUNCTION_CONNECTIONSSADMIN': 'מנהל התחברויות',
    'reports.FUNCTION_CROSS_PAIR': 'מחיר הצלבה',
    'reports.FUNCTION_CUR_EXP': 'חשיפת מט"ח',
    'reports.FUNCTION_DISABLE_BUY': 'השבתת הוראות קנייה',
    'reports.FUNCTION_DISABLE_OPTION_TRADING': 'השבתת הוראות אופציה',
    'reports.FUNCTION_DISABLE_SELL': 'השבתת הוראות מכירה',
    'reports.FUNCTION_DO_NOT_MARGIN': 'לא להשתמש בבטוחות',
    'reports.FUNCTION_EVENT_LOG': 'יומן אירועים',
    'reports.FUNCTION_FUNDING': 'מנהל פעולות',
    'reports.FUNCTION_GENERATE_OPTIONS': 'יצירת אופציות מרמה 1',
    'reports.FUNCTION_HEDGE_RULE_TYPE': 'רשימת כללי גידור:',
    'reports.FUNCTION_INSTRUMENT_LOOKUP': 'חיפוש סימול',
    'reports.FUNCTION_INSTRUMENT_PORTFOLIO': 'תיק השקעות',
    'reports.FUNCTION_INSTRUMENTSADMIN': 'מנהל סימולים',
    'reports.FUNCTION_INTERSERVER': 'Interserver',
    'reports.FUNCTION_LEVEL2': 'נתונים והוראות - רמה 2',
    'reports.FUNCTION_LEVEL3': 'זמן & מכירות',
    'reports.FUNCTION_LOCKED_BY_BROKER': 'ננעל על ידי הברוקר',
    'reports.FUNCTION_MANUAL': 'אפשר הוראות ידניות',
    'reports.FUNCTION_MARGIN_MODE': 'מצב בטוחות',
    'reports.FUNCTION_MASTER': 'ניהול חשבון ראשי',
    'reports.FUNCTION_MATRIX': 'מטריצה',
    'reports.FUNCTION_MULTI_CONNECTION': 'אפשר ריבוי חיבורים',
    'reports.FUNCTION_MUTUAL_CLOSE': 'אפשר סגירה הדדית',
    'reports.FUNCTION_NEWS': 'חדשות',
    'reports.FUNCTION_NEWSADMIN': 'מנהל חדשות',
    'reports.FUNCTION_NOT_ALLOW_OPEN_POSITION': 'לא לאפשר פוזיציות פתוחות',
    'reports.FUNCTION_NOT_ALLOW_SHORT_STOCK': 'לא לאפשר מניות שורט',
    'reports.FUNCTION_ONE_COUNTERACCOUNT': 'חשבון נגדי אחד',
    'reports.FUNCTION_ONE_POSITION': 'פיזציה אחת לכל סמל (גידור)',
    'reports.FUNCTION_ONE_QUOTECACHECOUNT': 'גודל זיכרון מטמון אחד לכולם',
    'reports.FUNCTION_OPTIONS': 'אופציות',
    'reports.FUNCTION_ORDER_BOOK': 'היסטוריית הוראות',
    'reports.FUNCTION_PARTIAL_CLOSE': 'לאפשר סגירה חלקית',
    'reports.FUNCTION_POSITION_BALANCE': 'יתרת פוזיציה',
    'reports.FUNCTION_POSITIONSADMIN': 'מנהל פוזיציות',
    'reports.FUNCTION_QUOTE_HISTORY': 'היסטוריית ציטוטים',
    'reports.FUNCTION_QUOTES': 'ציטוטים',
    'reports.FUNCTION_REPORT': 'דוח',
    'reports.FUNCTION_REPORTADMIN': 'מנהל דוחות',
    'reports.FUNCTION_RESERVER_WITHDRAWAL': 'משיכה',
    'reports.FUNCTION_PRODUCTS': 'מוצרים',
    'reports.FUNCTION_PRODUCTS_FAILURE': 'ההרשמה למוצר נכשלה',
    'reports.FUNCTION_RFQ': 'פאנל RFQ',
    'reports.FUNCTION_ROLESADMIN': 'מנהל קבוצות משתמשים',
    'reports.FUNCTION_ROUTESADMIN': 'מנהל ניתוב',
    'reports.FUNCTION_SCHEDULERADMIN': 'מנהל תיזמון',
    'reports.FUNCTION_SCRIPT_BUILDER': 'בונה סקריפטים',
    'reports.FUNCTION_SERVICESADMIN': 'מנהל שירותים',
    'reports.FUNCTION_SETTINGSADMIN': 'מנהל הגדרות',
    'reports.FUNCTION_SHOW_ORDERS': 'הוראות',
    'reports.FUNCTION_SHOW_POSITIONS': 'פוזיציות',
    'reports.FUNCTION_SLAVE': 'Slave',
    'reports.FUNCTION_SLTP': 'אפשר הוראות סטופ-לוס / מימוש-רווח',
    'reports.FUNCTION_SMS_SERVICE_DEST': 'יעד שירות SMS',
    'reports.FUNCTION_SN': 'מספר רישיון',
    'reports.FUNCTION_STRATEGIESADMIN': 'מנהל אסטרטגיות',
    'reports.FUNCTION_SUPPORT_EMAIL': 'דוא"ל של צוות התמיכה',
    'reports.FUNCTION_TABLESADMIN': 'מנהל טבלאות',
    'reports.FUNCTION_THREADEDSAVER': 'שומר השרשור מופעל',
    'reports.FUNCTION_TRADES': 'הוראות שמולאו',
    'reports.FUNCTION_TRADING': 'מסחר',
    'reports.FUNCTION_TRADING_MODE': 'מצב מסחר',
    'reports.FUNCTION_TRAILING_STOP': 'אפשר סטופ נגרר',
    'reports.FUNCTION_USER_CONNECTION_POLICY': 'מדיניות ריבוי חיבורים של משתמש',
    'reports.FUNCTION_USERSADMIN': 'מנהל משתמשים',
    'reports.FUNCTION_VALIDATE_SSL_CERTIFICATE': 'נדרש אימות SSL',
    'reports.FUNCTION_VENDOR_NAME': 'שם הספק',
    'reports.FUNCTION_WATCHLIST': 'רשימת מעקב',
    'reports.FUNCTION_ALERT': 'התראה',
    'reports.FUNCTION_ASSETS': 'נכסים',
    'reports.Fund Gain History Report': 'דוח היסטוריית רווחי קרן',
    'reports.Fund Investments Report': 'דוח השקעות של הקרן',
    'reports.Fund Investor Action History Report': 'דוח היסטוריית פעולות משקיע בקרן',
    'reports.Fund Investor History Report': 'דוח היסטוריית משקיע בקרן',
    'reports.Fund Request History Report': 'דוח היסטוריית בקשות קרן',
    'reports.Fund Transfer': 'העברת קרן',
    'reports.fund_type.closed': 'סגורה',
    'reports.fund_type.open': 'פתוחה',
    'reports.fundID': 'מזהה קרן',
    'reports.Funding': 'מימון',
    'reports.FUNDING_RULES': 'נראות פעולות מימון',
    'reports.fxintegrate.cert.host.verify': 'fx integrate cert host verify',
    'reports.fxintegrate.cert.root.ca.file': 'fx integrate cert root ca file',
    'reports.fxintegrate.host': 'fx integrate host',
    'reports.fxintegrate.logging.file': 'fx integrate logging file',
    'reports.fxintegrate.logging.maxfilecount': 'fx integrate logging maximum file count',
    'reports.fxintegrate.logging.maxfilesize': 'fx integrate logging maximum file size',
    'reports.fxintegrate.logging.output': 'fx integrate logging output',
    'reports.fxintegrate.logging.priority': 'fx integrate logging priority',
    'reports.fxintegrate.port': 'fx integrate port',
    'reports.fxintegrate.protocol': 'fxintegrate protocol',
    'reports.fxintegrate.usessl': 'fx integrate use ssl',
    'reports.GENERAL_COMMON_RULES': 'כללים משותפים כלליים',
    'reports.GENERAL_USER_RULES': 'כללים כלליים',
    'reports.GFT': 'GFT',
    'reports.gi.available_margin': 'בטוחות זמינות',
    'reports.gi.avaliable_funds': 'בטחונות זמינים',
    'reports.gi.balance': 'יתרה',
    'reports.gi.balance_blocked_by_orders': 'חסום על ידי הוראות',
    'reports.gi.cur_balance': 'יתרה חזויה',
    'reports.gi.cur_margin': 'בטוחות נוכחיות, %',
    'reports.gi.fund_capital': 'הון קרן',
    'reports.gi.fund_used': 'כספים בשימוש',
    'reports.gi.maintain_margin': 'בטוחות מתעדכנות',
    'reports.gi.margin_orders': 'בטוחות להוראות',
    'reports.gi.margin_positions': 'בטוחות לפוזיציות',
    'reports.gi.margin_stopout': 'סטופ-אאוט',
    'reports.gi.margin_stoptrade': 'הפסק את המסחר',
    'reports.gi.margin_used': 'בטוחות נוצלו',
    'reports.gi.margin_warning': 'אזהרת בטוחות',
    'reports.gi.min_margin': 'בטוחות מינימליות',
    'reports.gi.pos_maintenance_req': 'דרישת בטוחות מתעדכנות לפוזיציה',
    'reports.gi.risk_lvl': 'רמת סיכון',
    'reports.gi.stock_value': 'מניה',
    'reports.gi.today_released_pnl': 'רווח/הפסד ממומש',
    'reports.gi.withdrawal_available': 'משיכה זמינה',
    'reports.Goldman Sachs': 'Goldman Sachs',
    'reports.grosspl': 'רווח/הפסד ברוטו',
    'reports.groupid': 'מזהה קבוצה',
    'reports.groupname': 'קבוצה',
    'reports.GTL': 'GTL',
    'reports.HeartBtInt': 'מרווח דופק',
    'reports.hedged': 'STP (עיבוד ישיר)',
    'reports.helpIndex': 'http://protrader.org/en/knowledge-base/pt3/desktop/account/reports',
    'reports.host': 'מארח',
    'reports.HOT_BUTTON': 'Desktop:Hot Button',
    'reports.HotSpot': 'HotSpot',
    'reports.hours': 'שעות',
    'reports.HTTP.SERVER.HOST': 'HTTP SERVER HOST',
    'reports.HTTP.SERVER.PORT': 'HTTP SERVER PORT',
    'reports.HTTP.SERVER.PROTOCOL': 'HTTP SERVER PROTOCOL',
    'reports.HTTP.URL.HEARTBEAT': 'HTTP URL HEARTBEAT',
    'reports.HTTP.URL.LOGIN': 'HTTP URL LOGIN',
    'reports.HTTP.URL.LOGOUT': 'HTTP URL LOGOUT',
    'reports.HTTP.URL.PASSWORD.VALIDATION': 'HTTP URL PASSWORD VALIDATION',
    'reports.HTTP.URL.PRELOGIN': 'HTTP URL PRELOGIN',
    'reports.HTTP.URL.QUERY': 'HTTP URL QUERY',
    'reports.HTTP.URL.WORKFLOW': 'HTTP URL WORKFLOW',
    'reports.IB Trades Report': 'דוח עסקאות IB',
    'reports.IGIndex': 'IGIndex',
    'reports.IndexingQuoteFrequency(sec)': 'תדירות ציטוט לאינדקס (שניות)',
    'reports.Information': 'מידע',
    'reports.Informational message': 'הודעת מידע',
    'reports.Init margin req.': 'דרישת בטוחות התחלתית',
    'reports.Init. margin req.': 'דרישת בטוחות התחלתית',
    'reports.INSTALLER_SERVICE_URL': 'כתובת URL של מתקין השירות',
    'reports.InstrRouteMap': 'מפת ניתוב',
    'reports.instrtype': 'קבוצת סמלים',
    'reports.INSTRTYPES_RULES': 'נראות קבוצות סמלים',
    'reports.instrument': 'סמל',
    'reports.Instrument': 'סמל',
    'reports.instrument group': 'קבוצת סמלים',
    'reports.Instrument Specification': 'פרטי הסמל',
    'reports.Instrument Statistic Report': 'דוח נתונים סטטיסטיים של מכשיר',
    'reports.Instrument Usage By Signal Report': 'שימוש בסמלים לפי דוח איתות',
    'reports.Instrument Visibility Report': 'דוח נראות של הסימול',
    'reports.INSTRUMENT_DERIVATIVES': 'נגזרים',
    'reports.INSTRUMENT_GENERAL': 'כללי',
    'reports.INSTRUMENT_MARGIN': 'בטוחות',
    'reports.INSTRUMENT_TRADING': 'מסחר',
    'reports.INSTRUMENT_TYPE_DERIVATIVES': 'נגזרים',
    'reports.instrument.group': 'קבוצת סמלים',
    'reports.instrument.name': 'שם הסימול',
    'reports.instrumentgroup': 'קבוצת סמלים',
    'reports.InstrumentId': 'סמל',
    'reports.instrumentname': 'סמל',
    'reports.instruments': 'מכשירים',
    'reports.instrumenttype': 'סוג הסימול',
    'reports.instrumenttype.duplicatename': 'כבר קיימת קבוצת סמלים בשם הזה',
    'reports.instrumenttype.inheritanceerror': 'שגיאה בהורשת סוגים',
    'reports.instrumentType.name': 'שם קבוצת סמלים',
    'reports.instrumentType.superId': 'שם סוג-על של סמלים',
    'reports.instrumentVisibilityReport': 'דוח נראות של הסימול',
    'reports.Integral': 'אינגרלי',
    'reports.IntegralFIX': 'IntegralFIX',
    'reports.InteractiveData': 'InteractiveData',
    'reports.IntererstOnAvailableFundsAndUnsettledCash': 'ריבית על כספים זמינים + מזומן שלא סולק',
    'reports.interest': 'ריבית',
    'reports.InterestOnAvailableFunds': 'ריבית על כספים זמינים',
    'reports.InterestOnCash': 'ריבית על מזומן',
    'reports.InterestOnMarginAvailable': 'ריבית על בטוחות זמינות',
    'reports.InterestOnMarginAvailableAndUnsettledCash': 'ריבית על בטוחות זמינות ומזומן שלא סולק',
    'reports.Invalid installer hash.': 'ה-Hash של המתקין לא תקין.',
    'reports.Invalid installer size.': 'הגודל של המתקין לא תקין.',
    'reports.Invalid installer URL.': 'כתובת URL של המתקין לא תקינה.',
    'reports.AccruedDividends': 'דיבידנדים צבורים',
    'reports.DividendsTax': 'מס דיבידנדים',
    'reports.BalanceDebit': 'יתרת חיוב',
    'reports.BalanceCredit': 'יתרת אשראי',
    'reports.Invalid password:New password should have at least 1 upper case character, 1 lower case character, 1 number, 1 special character (e.g. @#$%) and contain 8 characters at least. Please try again.': 'הסיסמה החדשה צריכה לכלול לפחות אות גדולה אחת, אות קטנה אחת, ספרה אחת ותו מיוחד אחד (כמו @#$%), ולכלול לפחות 8 תווים. אפשר לנסות שוב.',
    'reports.Invalid price for the order.': 'מחיר לא תקין עבור ההוראה.',
    'reports.Investor Action History Report': 'דוח היסטוריית פעולות של משקיע',
    'reports.investorID': 'מזהה משקיע',
    'reports.InvestorProtectionLevy': 'היטל הגנה על המשקיע',
    'reports.ip': 'IP',
    'reports.IP': 'IP',
    'reports.IQFeed': 'IQFeed',
    'reports.irdnumber': 'מספר IR',
    'reports.is out of range': 'נמצא מחוץ לטווח',
    'reports.IsOnlyLastPeriod': 'התקופה האחרונה',
    'reports.isPriceStream': 'זרם מחירים',
    'reports.isShowLots': 'הצג כמות בלוטים',
    'reports.IsShowLots': 'הצג כמות בלוטים',
    'reports.IsShowPamm': 'הצג קרן',
    'reports.issingle': 'יחיד',
    'reports.JdbcDriver': 'דרייבר Jdbc',
    'reports.JdbcPassword': 'סיסמת Jdbc',
    'reports.JdbcSessionIdDefaultPropertyValue': 'ערך מאפיין ברירת המחדל של מזהה סשן JDBC',
    'reports.JdbcURL': 'JdbcURL',
    'reports.JdbcUser': 'משתמש Jdbc',
    'reports.JMS.INIT.QUEUE': 'JMS INITIAL QUEUE',
    'reports.JMS.SERVER.HOST': 'JMS SERVER HOST',
    'reports.JMS.SERVER.PASSWORD': 'JMS SERVER PASSWORD',
    'reports.JMS.SERVER.PORT': 'JMS SERVER PORT',
    'reports.JMS.SERVER.PROTOCOL': 'JMS SERVER PROTOCOL',
    'reports.JMS.SERVER.USER': 'JMS SERVER USER',
    'reports.JPMorganTrade': 'JPMorganTrade',
    'reports.keystoreAlias': 'כינוי Key store',
    'reports.keystoreFile': 'קובץ Key store',
    'reports.KyteFIX': 'KyteFIX',
    'reports.L1port': 'L1port',
    'reports.L2port': 'L2port',
    'reports.LADDER_VIEW': 'Desktop:Super DOM',
    'reports.LADDER_VIEW_OE': 'Desktop:Super DOM OE',
    'reports.Last fill price': 'שער ביצוע אחרון',
    'reports.lastname': 'שם משפחה',
    'reports.Level1Charging': 'Level1Charging',
    'reports.Level1DataCharging': 'חיוב על נתוני מסחר ברמה 1',
    'reports.Level2Charging': 'Level2Charging',
    'reports.Level2DataCharging': 'חיוב על נתוני מסחר ברמה 2',
    'reports.Level3Charging': 'Level3Charging',
    'reports.Level3DataCharging': 'חיוב על נתוני מסחר ברמה 3',
    'reports.Limit accepted by broker': 'הוראת לימיט התקבלה על ידי ברוקר',
    'reports.Limit accepted by STP': 'הוראת לימיט התקבלה על ידי STP',
    'reports.Limit order accepted': 'הוראת לימיט התקבלה',
    'reports.Limit order activated': 'הוראת לימיט הופעלה',
    'reports.Limit order cancel request': 'בקשה לביטול הוראת לימיט',
    'reports.Limit order canceled': 'הוראת לימיט בוטלה',
    'reports.Limit order created': 'הוראת לימיט נוצרה',
    'reports.Limit Order Created': 'הוראת לימיט נוצרה',
    'reports.Limit order created is off market': 'הוראת לימיט מחוץ לשוק',
    'reports.Limit order created is unplaced': 'הוראת לימיט לא הונחה בבורסה',
    'reports.Limit order is awaiting market': 'הוראת לימיט ממתינה לשוק',
    'reports.Limit Order Modified': 'הוראת לימיט נערכה',
    'reports.Limit order partially reject': 'הוראת לימיט בוטלה חלקית',
    'reports.Limit order placing request': 'בקשה להצבת הוראת לימיט',
    'reports.Limit order received by broker': 'הוראת לימיט התקבלה אצל הברוקר',
    'reports.Limit order rejected': 'הוראת לימיט נדחתה',
    'reports.Limit Order Removed': 'הוראת לימיט הוסרה',
    'reports.Limit order replace request': 'בקשה להחלפת הוראת לימיט',
    'reports.Limit order replaced': 'הוראת לימיט נערכה',
    'reports.Limit order restated': 'הוראת לימיט נקבעה מחדש',
    'reports.Care order replace request': 'בקשה להחלפת הוראה לטיפול',
    'reports.Linked Users': 'משתמשים מקושרים',
    'reports.LMAX': 'LMAX',
    'reports.LMAX FIX': 'LMAX FIX',
    'reports.Local': 'מקומי',
    'reports.locked': 'נעול',
    'reports.LogFileMaxSize': 'גודל מרבי של קובץ יומן',
    'reports.login': 'חשבונות',
    'reports.Login': 'התחברות',
    'reports.LOGIN.USER.NAMESPACE': 'LOGIN USER NAMESPACE',
    'reports.Login/password combination is not valid': 'שילוב שם משתמש/סיסמה אינו תקף.',
    'reports.LogonTimeout': 'פקיעת זמן להתחברות',
    'reports.Logout': 'התנתק',
    'reports.Lots to open': 'לוטים לפתיחה',
    'reports.lotsize': 'גודל חוזה(לוט)',
    'reports.Mail Settings': 'הגדרות דואר',
    'reports.mail.mailsettings': 'הגדרות דואר',
    'reports.mailPattern.ChatDuplicating': "שכפול צ'אט",
    'reports.mailPattern.DemoUserNotify': 'הודעת תאריך פקיעה של משתמש דמו',
    'reports.mailPattern.DemoUserRegistration': 'אישור הרשמה של משתמש דמו',
    'reports.mailPattern.DemoUserRemove': 'אישור הסרה של משתמש דמו',
    'reports.mailPattern.DepositWithdrawalNotification': 'הודעת דוא"ל על הפקדה/משיכה',
    'reports.mailPattern.MarginCall': 'הודעה על קריאת בטוחות',
    'reports.mailPattern.NewsCreated': 'נוצרו חדשות',
    'reports.mailPattern.OrderPlaced': 'הוצבה הוראת סטופ/לימיט',
    'reports.mailPattern.OrderRemoved': 'הוראת סטופ/לימיט הוסרה',
    'reports.mailPattern.PositionClosed': 'האישור על סגירת פוזיציה',
    'reports.mailPattern.PositionOpened': 'האישור על הצבת פוזיציה',
    'reports.mailPattern.SignalDuplicating': 'שכפול אות',
    'reports.mailPattern.TransactionStatementNotifyBroker': 'דוח יומי לברוקר',
    'reports.mailPattern.TransactionStatementNotifyUser': 'דוח יומי למשתמש',
    'reports.mailPattern.UserEmailConfirmation': 'דוא"ל אישור',
    'reports.mailPattern.UserPasswordRecovery': 'שחזור סיסמת משתמש',
    'reports.mailPattern.UserPasswordReset': 'איפוס סיסמת משתמש',
    'reports.mailPattern.UserRegistration': 'אישור הרשמה של משתמש',
    'reports.mailPattern.UserUnlocking': 'שחרור המשתמש לאחר מתקפה גסה',
    'reports.Main': 'ראשי',
    'reports.MAM trades report': 'דוח עסקאות MAM',
    'reports.MAM_OE': 'Desktop:Mam OE',
    'reports.MamManagementFee': 'עמלת ניהול MAM',
    'reports.MamPerfomanceFee': 'MamPerfomanceFee',
    'reports.MamPerformanceFee': 'עמלת ביצועים MAM',
    'reports.Manual order cancel request': 'בקשה ידנית לביטול הוראה',
    'reports.Manual order placing request': 'בקשה ידנית להכנסת הוראה',
    'reports.Manual order replace request': 'בקשה ידנית להחלפת הוראה',
    'reports.ManufacturedDividends': 'דיבידנדים מיוצרים',
    'reports.margin': 'בטוחות',
    'reports.Margin Call': 'קריאת בטוחות',
    'reports.Margin Call Reached': 'קריאת בטוחות הגיעה',
    'reports.Margin Call Warning.': 'אזהרת קריאת בטוחות',
    'reports.Margin used': 'בטוחות נוצלו',
    'reports.MARGIN_RULES_ACC': 'כללי בטוחות (חשבון)',
    'reports.MARGIN_RUSLES': 'כללי בטוחות',
    'reports.Margincall': 'קריאת בטוחות',
    'reports.MarginCallMessage.header.MarginCallReached': 'קריאת בטוחות הגיעה',
    'reports.MarginCallMessage.header.MarginWarning': 'אזהרת בטוחות',
    'reports.MarginCallMessage.Message': 'אנא הפקד לחשבונך',
    'reports.Market accepted by broker': 'הוראת מרקט התקבלה אצל הברוקר',
    'reports.Market accepted by STP': 'הוראת לימיט התקבלה על ידי STP',
    'reports.Market Close Order Removed': 'הוראת מרקט סגירה הוסרה',
    'reports.Market data charging report': 'דוח חיוב נתוני שוק',
    'reports.Market order accepted': 'הוראת מרקט התקבלה',
    'reports.Market order activated': 'הוראת מרקט הופעלה',
    'reports.Market order cancel request': 'בקשה לביטול הוראת מרקט',
    'reports.Market order canceled': 'הוראת מרקט בוטלה',
    'reports.Market order created': 'הוראת מרקט נוצרה',
    'reports.Market Order Created': 'הוראת מרקט נוצרה',
    'reports.Market order created is off market': 'הוראת מרקט מחוץ לשוק',
    'reports.Market order created is unplaced': 'הוראת מרקט לא הונחה בבורסה',
    'reports.Market Order Modified': 'הוראת מרקט שונתה',
    'reports.Market order partially reject': 'הוראת מרקט בוטלה חלקית',
    'reports.Market order placing request': 'בקשה להצבת הוראת מרקט',
    'reports.Market order received by broker': 'הוראת מרקט התקבלה אצל הברוקר',
    'reports.Market order rejected': 'הוראת מרקט נדחתה',
    'reports.Market Order Removed': 'הוראת מרקט הוסרה',
    'reports.Market order replace request': 'בקשה להחלפת הוראת מרקט',
    'reports.Market order replaced': 'הוראת מרקט שונתה',
    'reports.Market order restated': 'הוראת מרקט נקבעה מחדש',
    'reports.Market price': 'מחיר שוק',
    'reports.MARKETDEPTH': 'Desktop:Market Depth',
    'reports.MarketFactory Feed': 'פיד MarketFactory',
    'reports.Markup': 'מארק-אפ',
    'reports.MATRIX': 'Desktop:Matrix',
    'reports.MATRIX_OE': 'Desktop:Matrix OE',
    'reports.MaxLogsBackups': 'מקסימום גיבויי יומנים',
    'reports.MBT': 'MBT',
    'reports.message': 'הודעה',
    'reports.Message': 'הודעה',
    'reports.messageid': 'מזהה הודעה',
    'reports.MFGlobal': 'MFGlobal',
    'reports.MillisecondsinTimeStamp': 'אלפיות שניה בחותמת הזמן',
    'reports.MillisecondsInTimeStamp': 'אלפיות שניה בחותמת הזמן',
    'reports.minchange': 'מינימום שינוי',
    'reports.MinFeeAdjEquity': 'הון בהתאמת עמלה מינימלית',
    'reports.Minimum Open Margin': 'בטוחות פתוחות מינימליות',
    'reports.minutes': 'דקות',
    'reports.MLFIX': 'MLFIX',
    'reports.MOB_CANCEL_ALL_ORDERS': 'MOB:Cancel all orders',
    'reports.MOB_CHART_OE': 'MOB:Chart OE',
    'reports.MOB_CLOSE_ALL_POSITIONS': 'MOB:Close all positions',
    'reports.MOB_MARKETDEPTH': 'MOB:Market Depth',
    'reports.MOB_ORDERS_HOT_BTN': 'MOB:Orders Hot BTN',
    'reports.MOB_OTHER': 'MOB:Other',
    'reports.MOB_POSITIONS_HOT_BTN': 'MOB:Positions Hot BTN',
    'reports.MOB_TAB_CHART_VISUAL_HOT_BTN': 'MOB:Tab Chart Visual Hot BTN',
    'reports.MOB_WL_OE': 'MOB:WL OE',
    'reports.MOB_CHART_VISUAL_TRADING': 'MOB:Chart Visual Trading',
    'reports.MOB_TRADING_IDEAS': 'MOB:Trading Ideas',
    'reports.MOB_INVESTING_CHART_OE': 'MOB:Inv.‎ Chart OE',
    'reports.MOB_INVESTING_WATCHLIST_OPTION_OE': 'MOB:Inv.‎ רשימת מעקב Option OE',
    'reports.MOB_INVESTING_ASSETS_SELL_ASSET': 'MOB:Inv.‎ מכור נכסים',
    'reports.MOB_INVESTING_POSITIONS_INCREASE': 'MOB:Inv.‎ הגדל פוזיציות',
    'reports.MOB_INVESTING_CANCEL_ORDERS': 'MOB:Inv.‎ בטל הוראה',
    'reports.MOB_INVESTING_CLOSE_POSITIONS': 'MOB:Inv.‎ סגור פוזיציה',
    'reports.MOB_INVESTING_TRADING_IDEAS': 'MOB:Inv.‎ רעיונות למסחר',
    'reports.MOB_INVESTING_OTHER': 'MOB:Inv.‎ אחר',
    'reports.Modified': 'נערך',
    'reports.Modifing': 'נערך',
    'reports.Modifyied by': 'נערך על ידי',
    'reports.Modifying': 'נערך',
    'reports.months': 'חודשים',
    'reports.Morgan Stanley': 'Morgan Stanley',
    'reports.MorganStanleyCFD': 'MorganStanleyCFD',
    'reports.Mutual close request': 'בקשת סגירה הדדית',
    'reports.name': 'שם',
    'reports.NAMESPACE': 'מקום לשם',
    'reports.NEED_EMAIL_CONFIRM_ON_REGISTRATION': 'אישור רישום חשבון בדוא"ל',
    'reports.NeoNet': 'NeoNet',
    'reports.Net Open Positions': 'פוזיציות פתוחות נטו',
    'reports.netpl': 'רווח/הפסד נטו',
    'reports.New Back Office Changes Report': 'דוח שינויי בק-אופיס חדשים',
    'reports.New password must differ from several previous passwords.': 'הסיסמה החדשה חייבת להיות שונה ממספר סיסמאות קודמות',
    'reports.New Users Report': 'דוח משתמשים חדשים',
    'reports.news.feed.type': 'סוג פיד חדשות',
    'reports.news.reciving': 'קבלת חדשות',
    'reports.news.save': 'שמירת חדשות',
    'reports.news.sendEmail': 'שליחת חדשות בדוא"ל',
    'reports.NewsCharging': 'חיוב חדשות',
    'reports.NewsFeed': 'NewsFeed',
    'reports.newvalue': 'שווי חדש',
    'reports.no such position, no such order.': 'אין פוזיציה כזו, אין הוראה כזו.',
    'reports.Nomura': 'Nomura',
    'reports.Nomura-Lehman': 'Nomura-Lehman',
    'reports.None': 'ללא',
    'reports.Not enoght margin to create Order': 'אין מספיק בטוחות ליצירת הוראה',
    'reports.Not enough margin to open order': 'אין מספיק בטוחות ליצירת הוראה',
    'reports.Not enough Margin to open position': 'אין מספיק בטוחות לפתיחת פוזיציה',
    'reports.Not enough offer': 'אין מספיק הצעה',
    'reports.Not Filled Orders Report': 'דוח הוראות שלא מומשו',
    'reports.Not Successful': 'לא בוצע בהצלחה',
    'reports.notShowMam': 'לא להראות MAM',
    'reports.NotSuccessful': 'לא בוצע בהצלחה',
    'reports.number': 'מספר',
    'reports.objectid': 'מזהה אובייקט',
    'reports.ObjectId': 'מזהה הוראה',
    'reports.ObjectID': 'מזהה אובייקט',
    'reports.OCO accepted by broker': 'הוראת OCO התקבלה על ידי ברוקר',
    'reports.OCO accepted by STP': 'הוראת OCO התקבלה על ידי STP',
    'reports.OCO order activated': 'הוראת OCO הופעלה',
    'reports.OCO order cancel request': 'בקשה לביטול הוראת OCO',
    'reports.OCO order canceled': 'הוראת OCO בוטלה',
    'reports.OCO order created': 'הוראת OCO נוצרה',
    'reports.OCO Order Created': 'הוראת OCO נוצרה',
    'reports.OCO order created is off market': 'הוראת OCO רחוקה מדי ממחיר השוק',
    'reports.OCO order created is unplaced': 'הוראת OCO לא הוצבה בבורסה',
    'reports.OCO order partially reject': 'הוראת OCO בוטלה חלקית',
    'reports.OCO order placing request': 'בקשה להצבת הוראת OCO',
    'reports.OCO order received by broker': 'הוראת OCO התקבלה אצל הברוקר',
    'reports.OCO order rejected': 'הוראת OCO נדחתה',
    'reports.OCO order replace request': 'בקשה להחלפת הוראת OCO',
    'reports.OCO order replaced': 'הוראת OCO הוחלפה',
    'reports.OCO order restated': 'הוראת OCO נקבעה מחדש',
    'reports.OE': 'Desktop:OE',
    'reports.Off market': 'מחוץ לשוק',
    'reports.ONE_MARGIN_FOR_USER_ACC': 'בטוחות יחידות לחשבון משתמשים',
    'reports.Open': 'פתח',
    'reports.Open Buy': 'פתיחת קנייה',
    'reports.Open date': 'תאריך פתיחה',
    'reports.Open lots': 'לוטים פתוחים',
    'reports.Open order is forbidden by trade session': 'הוראת פתיחה אסורה על ידי סשן המסחר',
    'reports.Open order type': 'סוג הוראה פתוחה',
    'reports.Open Positions By Signal Report': 'פוזיציות פתוחות לפי דוח איתות',
    'reports.Open Positions Report': 'דוח פוזיציות פתוחות',
    'reports.Open price': 'מחיר פתיחה',
    'reports.Open Sell': 'פתיחת מכירה',
    'reports.OPEN_SPOT_ON_OPTION_EXP': 'פתח פוזיציית ספוט עם פקיעת האופציה',
    'reports.openclosebuysell': 'סוג פעולה',
    'reports.opengrosspnl': 'רווח/הפסד גולמי פתוח',
    'reports.OpenOptionPremium': 'פרמייה על אופציה פתוחה',
    'reports.openorderid': 'מזהה הוראה הוראה',
    'reports.openprice': 'מחיר פתיחה',
    'reports.opentime': 'זמן פתיחה',
    'reports.operation': 'פעולה',
    'reports.Operation': 'פעולה',
    'reports.Operation Id': 'מזהה פעולה',
    'reports.Operation type': 'סוג פעולה',
    'reports.Operation Type': 'סוג פעולה',
    'reports.operation.not_enough_margin': 'אין מספיק בטוחות',
    'reports.operation.wrong_length': 'כמות גדולה מדי',
    'reports.operation.wrong_length;': 'כמות גדולה מדי',
    'reports.operation.wrong_sum': 'סכום שגוי',
    'reports.OperationID': 'מזהה פעולה',
    'reports.OperationInDisconnectedMode': 'הפעולה הזו אינה זמינה במצב מנותק!',
    'reports.operationtype': 'סוג פעולה',
    'reports.OPTION_MASTER': 'Desktop:Option Master',
    'reports.option_value': 'ערך אופציה',
    'reports.OrcFIX': 'OrcFIX',
    'reports.order': 'הוראה',
    'reports.Order': 'הוראה',
    'reports.Order Book History': 'היסטוריית ספר הוראות',
    'reports.Order Book Report': 'דוח ספר הוראות',
    'reports.Order cancel is forbidden by trade session': 'ביטול הוראה אסור על ידי מושב המסחר',
    'reports.Order cancel request': 'בקשה לביטול הוראה',
    'reports.Order canceled successfully': 'ההוראה בוטלה בהצלחה',
    'reports.Order cannot be created since order amount is forbidden.': 'לא ניתן ליצור את ההוראה בגלל שסכום ההוראה אסור.',
    'reports.Order cannot be created since route is not active.': 'לא ניתן ליצור את ההוראה בגלל שהניתוב לא פעיל.',
    'reports.Order cannot be created, because position is in executing': 'לא ניתן ליצור את ההוראה בגלל שהפוזיציה בשלבי מימוש',
    'reports.Order cannot be created, because route is not active': 'לא ניתן ליצור את ההוראה בגלל שהניתוב לא פעיל.',
    "reports.Order cannot be created, because short positions are forbidden. You don't have enough rights.": 'לא ניתן ליצור את ההוראה מאחר שפוזיציות שורט אסורות. אין לך מספיק זכויות.',
    'reports.Order cannot be created, because short positions are forbidden. You donґt have enough rights.': 'לא ניתן ליצור את ההוראה מאחר שפוזיציות שורט אסורות. אין לך מספיק זכויות.',
    'reports.Order cannot be created, because short positions are forbidden.Or yor already have Limit/Stop orders for cover all your positions.': 'לא ניתן ליצור את ההוראה בגלל שפוזיציות שורט אסורות, או שכבר יש לך הוראות לימיט/סטופ לכיסוי כל הפוזיציות.',
    'reports.Order cannot be placed in non-trading day. Please, check the trading calendar.': 'לא ניתן לבצע הוראה ביום שאינו יום מסחר. בדוק את לוח השנה של המסחר.',
    'reports.Order groupID': 'מזהה הקבוצה של ההוראה',
    'reports.Order History Report': 'דוח היסטוריית הוראות',
    'reports.Order modification is forbidden by trade session': 'שינוי ההוראה אסור על ידי סשן המסחר',
    'reports.Order number': 'מזהה הוראה',
    'reports.Order placing request': 'בקשה להצבת הוראה',
    'reports.Order price': 'שער ההוראה',
    'reports.Order Price': 'שער ההוראה',
    'reports.Order received by STP': 'ההוראה התקבלה אצל STP',
    'reports.Order replace request': 'בקשה להחלפת הוראה',
    'reports.Order replacing confirmed': 'אושרה החלפת הוראה',
    'reports.Order TIF is forbidden by trade session': 'תוקף ההוראה אסור על ידי סשן המסחר',
    'reports.Order type': 'סוג הוראה',
    'reports.Order type is forbidden by trade session': 'סוג ההוראה אסור על ידי סשן המסחר',
    'reports.Order was rejected due to invalid price!': 'ההוראה נדחתה עקב שער לא תקין!',
    'reports.order_book_account': 'חשבון',
    'reports.order_book_datetime': 'תאריך',
    'reports.order_book_event': 'אירוע',
    'reports.order_book_login': 'התחברות',
    'reports.order_book_modified_by': 'נערך על ידי המשתמש',
    'reports.order_book_orderid': 'מזהה הוראה',
    'reports.order_book_price': 'מחיר',
    'reports.order_book_quantity': 'כמות',
    'reports.order_book_route': 'ניתוב',
    'reports.order_book_side': 'צד',
    'reports.order_book_stop_price': 'מחיר סטופ',
    'reports.order_book_symbol': 'סמל',
    'reports.order_book_symbol_type': 'סוג הסימול',
    'reports.order_book_tif': 'תוקף',
    'reports.order_book_type': 'סוג',
    'reports.orderCreate': 'יצירת הוראה',
    'reports.orderExecute': 'ביצוע הוראה',
    'reports.OrderExternalConfirm': 'אישור חיצוני של ההוראה',
    'reports.orderid': 'מזהה הוראה',
    'reports.orderId': 'מזהה הוראה',
    'reports.OrderId': 'מזהה הוראה',
    'reports.orderModify': 'שינוי הוראה',
    'reports.orderMutural': 'הוראה הדדית',
    'reports.orderRemoved': 'ההוראה הוסרה',
    'reports.ORDERS_PANEL_HOT_BTN': 'שולחן עבודה: פאנל הוראות HOT BTN',
    'reports.ordertype': 'סוג הוראה',
    'reports.Oreder Number': 'מזהה הוראה',
    'reports.originalvalue': 'שווי מקורי',
    'reports.OTHER': 'DESKTOP:אחר',
    'reports.other_account_operations': 'פעולות בחשבון אחרות',
    'reports.Out of session trading is forbidden': 'מסחר מחוץ לסשן אסור',
    'reports.Overnight trading is forbidden for account': 'מסחר לילה אסור לחשבון',
    'reports.PAMM account can not be removed during investment period.': 'לא ניתן להסיר את הקרן במהלך תקופת ההשקעה',
    'reports.PAMM join': 'הצטרפות לקרן',
    'reports.pamm.OrderByPnL.max_loss': 'ההפסד הגדול ביותר',
    'reports.pamm.OrderByPnL.max_profit': 'הרווח הגדול ביותר',
    'reports.pamm.OrderByPnL.min_loss': 'ההפסד הקטן ביותר',
    'reports.pamm.OrderByPnL.min_profit': 'הרווח הקטן ביותר',
    'reports.pamm.OrderByPnL.none': 'ללא',
    'reports.pamm.OrderBySize.max': 'הפוזיציה הגדולה ביותר',
    'reports.pamm.OrderBySize.min': 'הפוזיציה הקטנה ביותר',
    'reports.pamm.OrderByTime.first': 'פתיחה ראשונה',
    'reports.pamm.OrderByTime.last': 'פתיחה אחרונה',
    'reports.pammState.0': 'חדש',
    'reports.pammState.1': 'השקעה',
    'reports.pammState.2': 'סיום ההשקעה',
    'reports.pammState.3': 'סילוק',
    'reports.pammState.4': 'המתן למשקיעים',
    'reports.pammState.6': 'תחילת ההשקעה',
    'reports.pammState.clearing': 'סילוק',
    'reports.pammState.confirmed': 'אושר',
    'reports.pammState.end_of_investment': 'סיום ההשקעה',
    'reports.pammState.investment': 'השקעה',
    'reports.pammState.Investment': 'השקעה',
    'reports.pammState.new': 'חדש',
    'reports.pammState.pending': 'בהמתנה',
    'reports.pammState.start_of_investment': 'תחילת ההשקעה',
    'reports.pammState.wait_for_investors': 'המתן למשקיעים',
    'reports.PAMMTransfer': 'העברת קרן',
    'reports.Partially filled': 'הוזן חלקית',
    'reports.Partially filled close Limit order': 'הוראת לימיט לסגירה מומשה חלקית',
    'reports.Partially filled Close Limit Order': 'הוראת לימיט לסגירה מומשה חלקית',
    'reports.Partially filled close Limit order (Mutual)': 'הוראת לימיט לסגירה מומשה חלקית (הדדי)',
    'reports.Partially filled close Market order': 'הוראת מרקט לסגירה מומשה חלקית',
    'reports.Partially filled Close Market Order': 'הוראת מרקט לסגירה מומשה חלקית',
    'reports.Partially filled close Market order (Mutual)': 'הוראת מרקט לסגירה מומשה חלקית (הדדי)',
    'reports.Partially filled close OCO order': 'הוראת OCO לסגירה מומשה חלקית',
    'reports.Partially filled close OCO order (Mutual)': 'הוראת OCO לסגירה מומשה חלקית (הדדי)',
    'reports.Partially filled close SL order': 'הוראת סטופ-לוס לסגירה מומשה חלקית',
    'reports.Partially filled close SL order (Mutual)': 'הוראת סטופ-לוס לסגירה מומשה חלקית (הדדי)',
    'reports.Partially filled close SL tr. stop order': 'הוראת סגירה בסטופ נגרר מומשה חלקית',
    'reports.Partially filled close SL tr. stop order (Mutual)': 'הוראת סגירה בסטופ נגרר מומשה חלקית (הדדי)',
    'reports.Partially filled close Stop Limit order': 'הוראת סטופ-לימיט לסגירה מומשה חלקית',
    'reports.Partially filled close Stop Limit order (Mutual)': 'הוראת סטופ-לימיט לסגירה מומשה חלקית (הדדי)',
    'reports.Partially filled close Stop order': 'הוראת סטופ לסגירה מומשה חלקית',
    'reports.Partially filled Close Stop Order': 'הוראת סטופ לסגירה מומשה חלקית',
    'reports.Partially filled close Stop order (Mutual)': 'הוראת סטופ לסגירה מומשה חלקית (הדדי)',
    'reports.Partially filled close TP order': 'הוראת מימוש רווח לסגירה מומשה חלקית',
    'reports.Partially filled close TP order (Mutual)': 'הוראת מימוש רווח לסגירה מומשה חלקית (הדדי)',
    'reports.Partially filled close Tr. stop order': 'הוראת סגירה בסטופ נגרר מומשה חלקית',
    'reports.Partially filled close Tr. stop order (Mutual)': 'הוראת סגירה בסטופ נגרר מומשה חלקית (הדדי)',
    'reports.Partially filled Limit order': 'הוראת לימיט מומשה חלקית',
    'reports.Partially filled Limit order (Mutual)': 'הוראת לימיט מומשה חלקית (הדדי)',
    'reports.Partially filled Market order': 'הוראת מרקט מומשה חלקית',
    'reports.Partially filled Market Order': 'הוראת מרקט מומשה חלקית',
    'reports.Partially filled Market order (Mutual)': 'הוראת מרקט מומשה חלקית (הדדי)',
    'reports.Partially filled OCO order': 'הוראת OCO מומשה חלקית',
    'reports.Partially filled OCO order (Mutual)': 'הוראת OCO מומשה חלקית (הדדי)',
    'reports.Partially filled SL order': 'הוראת סטופ-לוס מומשה חלקית',
    'reports.Partially filled SL order (Mutual)': 'הוראת סטופ-לוס מומשה חלקית (הדדי)',
    'reports.Partially filled SL tr. stop order': 'הוראת סטופ-לוס נגרר מומשה חלקית',
    'reports.Partially filled SL tr. stop order (Mutual)': 'הוראת סטופ-לוס נגרר מומשה חלקית (הדדי)',
    'reports.Partially filled Stop Limit order': 'הוראת סטופ-לימיט מומשה חלקית',
    'reports.Partially filled Stop Limit order (Mutual)': 'הוראת סטופ-לימיט מומשה חלקית (הדדי)',
    'reports.Partially filled Stop order': 'הוראת סטופ מומשה חלקית',
    'reports.Partially filled Stop order (Mutual)': 'הוראת סטופ מומשה חלקית (הדדי)',
    'reports.Partially filled TP order': 'הוראת מימוש רווח מומשה חלקית',
    'reports.Partially filled TP order (Mutual)': 'הוראת מימוש רווח מומשה חלקית (הדדי)',
    'reports.Partially filled Tr. stop order': 'הוראת סטופ נגררת מומשה חלקית',
    'reports.Partially filled Tr. stop order (Mutual)': 'הוראת סטופ נגררת מומשה חלקית (הדדי)',
    'reports.Partially filled Traling Stop Order': 'הוראת סטופ נגררת מומשה חלקית',
    'reports.Password required with level - 1': 'סיסמה לא תקינה: הסיסמה החדשה צריכה לכלול לפחות אות גדולה אחת, אות קטנה אחת וספרה אחת. נסה שוב',
    'reports.Password required with level - 2': 'סיסמה לא תקינה: הסיסמה החדשה צריכה לכלול לפחות אות גדולה אחת, אות קטנה אחת וספרה אחת, והיא צריכה להיות באורך של לפחות 8 תווים. נסה שוב',
    'reports.Password required with level - 3': 'סיסמה לא תקינה: הסיסמה החדשה צריכה לכלול לפחות אות גדולה אחת, אות קטנה אחת, ספרה אחת ותו מיוחד אחד, והיא צריכה להיות באורך של לפחות 8 תווים. נסה שוב',
    'reports.PatsystemsFIXFeed': 'PatsystemsFIXFeed',
    'reports.Pending': 'בהמתנה',
    'reports.pendingorderscount': 'מספר הוראות בהמתנה',
    'reports.PeresysFIX': 'PeresysFIX',
    'reports.Perfomance By Signal Report': 'דוח ביצועים לפי איתות',
    'reports.Perform': 'ביצועים',
    'reports.Performance history report': 'דוח היסטוריית ביצועים',
    'reports.PFixFeed': 'PFixFeed',
    'reports.phone': 'טלפון',
    'reports.phonepassword': 'סיסמת טלפון',
    'reports.pin': 'קוד PIN',
    'reports.pl_unrealized': 'רווח/הפסד לא ממומש',
    'reports.Placed': 'הוצב',
    'reports.Please deposit on your account.': 'אנא הפקד לחשבונך',
    'reports.pnl': 'רווח/הפסד',
    'reports.port': 'Port',
    'reports.posId': 'מזהה פוזיציה',
    'reports.Position': 'פוזיציה',
    'reports.PositionReverseRequest': 'בקשת היפוך של פוזיציה',
    'reports.Position close request': 'בקשת סגירת פוזיציה',
    'reports.Position Closed': 'פוזיציה נסגרה',
    'reports.Position Closed (Mutual)': 'הפוזיציה נסגרה (הדדי)',
    'reports.Position Closed (SL)': 'הפוזיציה נסגרה (סטופ-לוס)',
    'reports.Position Closed (TP)': 'הפוזיציה נסגרה (מימוש רווח)',
    'reports.Position closed successfully': 'הפוזיציה נסגרה בהצלחה',
    'reports.POSITION MODIFIED': 'הפוזיציה נערכה',
    'reports.Position modify request': 'בקשה לשינוי פוזיציה',
    'reports.Position number': 'מזהה פוזיציה',
    'reports.positionOpened': 'פוזיציה נפתחה',
    'reports.Position Opened (Limit Order)': 'נפתחה פוזיציה (הוראת לימיט)',
    'reports.Position Types Ratio By Instrument': 'יחס סוגי פוזיציות לפי סמל',
    'reports.Position: {1} closed successfully': 'פוזיציה: {1} נסגרה בהצלחה',
    'reports.positionamount': 'סכום הפוזיציה',
    'reports.positionid': 'מזהה פוזיציה',
    'reports.positionId': 'מזהה פוזיציה',
    'reports.PositionId': 'מזהה פוזיציה',
    'reports.Positions History Report': 'דוח היסטוריית פוזיציות',
    'reports.Positions On Chosen Moment Report': 'דוח פוזיציות ברגע נבחר',
    'reports.POSITIONS_PANEL_HOT_BTN': 'DESKTOP: פאנל פוזיציות HOT BTN',
    'reports.positionstatus': 'סטטוס הפוזיציה',
    'reports.price': 'מחיר',
    'reports.Price': 'מחיר',
    'reports.Price is too close to current Ask price': 'המחיר קרוב מידי למחיר ה-ASK הנוכחי.',
    'reports.Price is too close to current Bid price': 'המחיר קרוב מידי למחיר ה-BID הנוכחי.',
    'reports.priceExchange': 'מחיר - בורסה',
    'reports.priceExternal': 'מחיר חיצוני',
    'reports.product type': 'סוג מוצר',
    'reports.productType': 'סוג מוצר',
    'reports.PROFILE_LANGUAGE': 'שפת הפרופיל',
    'reports.profit': 'רווח',
    'reports.Projected balance': 'יתרה חזויה',
    'reports.protocol': 'פרוטוקול',
    'reports.ProTrader': 'Protrader',
    'reports.ProTraderFIX': 'ProTraderFIX',
    'reports.Purchase And Sales Report': 'דוח קניות ומכירות',
    'reports.purchaseprice': 'חשיפה',
    'reports.quantity': 'כמות',
    'reports.QueueMaxSize': 'גודל מרבי של תור',
    'reports.quicktable.noData': 'אין נתונים להצגה. בחר את הקריטריונים הדרושים לדוח כדי לקבל את המידע הרצוי.',
    'reports.Quote is too old': 'הציטוט ישן מדי',
    'reports.QuoteDelay(sec)': 'עיכוב הציטוט (שניות)',
    'reports.quoteticker': 'טיקר ציטוט',
    'reports.raor_administrator': 'ברוקר',
    'reports.raor_approvetime': 'זמן אישור',
    'reports.raor_balance': 'מיתרת החשבון',
    'reports.raor_basis': 'הערות',
    'reports.raor_commission_percent': 'העמלה באחוזים',
    'reports.raor_counterbalance': 'ליתרת החשבון',
    'reports.raor_countersum': 'אל סכום החשבון',
    'reports.raor_crossprice': 'מחיר הצלבה',
    'reports.raor_fromaccount': 'מחשבון',
    'reports.raor_operationtime': 'זמן הפעולה',
    'reports.raor_operationtype': 'סוג פעולה',
    'reports.raor_requestid': 'מזהה פעולה',
    'reports.raor_state': 'סטטוס אישור',
    'reports.raor_sum': 'מסכום החשבון',
    'reports.raor_sum_without_commission': 'סכום ללא עמלה',
    'reports.raor_toaccount': 'אל חשבון',
    'reports.rate': 'שער',
    'reports.Rates Report': 'דוח שערים',
    'reports.Realised profit/loss': 'רווח/הפסד ממומש',
    'reports.Reason for rejection: Trading disabled by risk rules. .': 'סיבת הדחייה: המסחר הושבת על ידי כללי הסיכון. .',
    'reports.receiveBestBidOfferOnly': 'קבל את הצעת הביקוש הטובה ביותר בלבד',
    'reports.recipient': 'מקבל',
    'reports.ReconnectInterval': 'מרווח זמן להתחברות מחדש',
    'reports.refreshInterval': 'מרווח רענון',
    'reports.RefreshonLogon': 'רענן בהתחברות',
    'reports.RefreshOnLogon': 'רענן בהתחברות',
    'reports.Refused': 'סורב',
    'reports.Refused Amount': 'כמות שבוטלה',
    'reports.Rejected': 'נדחה',
    'reports.remoteid': 'מזהה מרוחק',
    'reports.Remove SL for': 'הסר סטופ-לוס עבור',
    'reports.Removed Orders Report': 'דוח הוראות שהוסרו',
    'reports.removedtime': 'זמן הסרה',
    'reports.removeliquidityrebate': 'הסר החזר נזילות',
    'reports.Replace request received by STP': 'בקשת ההחלפה התקבלה על ידי STP',
    'reports.REPORT_RULES': 'נראות הדוח',
    'reports.report.currency': 'מטבע',
    'reports.report.route': 'נתיב',
    'reports.reportAccountSummaryReport': 'דוח חשבון',
    'reports.reportAllActiveOrdersReport': 'דוח הוראות פעילות',
    'reports.reportAllNotActiveOrdersReport': 'דוח הוראות שמומשו',
    'reports.reportAllRemovedOrdersReport': 'דוח הוראות שהוסרו',
    'reports.reportBalanceByInstrument': 'דוח יתרה לפי סוג סמל',
    'reports.reportBalanceReport': 'דוח יתרות',
    'reports.reportFormalDialogReport': 'דוח דו-שיח רשמי',
    'reports.reportInformalDialogReport': "דוח היסטוריית צ'אט",
    'reports.reportNewUsersReport': 'דוח משתמשים חדשים',
    'reports.reportOpenedPositionReport': 'דוח פוזיציות פתוחות',
    'reports.reportPerfomanceReport': 'דוח ביצועים',
    'reports.reportPurchaseAndSalesReport': 'דוח קניות ומכירות',
    'reports.reportSummaryNewReport': 'דוח סיכום',
    'reports.reportSummaryReport': 'דוח סיכום יתרה',
    'reports.reportTradeOperationReport': 'דוח פעולות מסחר',
    'reports.reportTradesReport': 'דוח עסקאות',
    'reports.reportUsersReport': 'דוח משתמשים',
    'reports.Request Account Operation Report': 'בקשת דוח פעולות בחשבון',
    'reports.Request is not allowed for this account': 'הבקשה אינה מותרת בחשבון זה',
    'reports.Request not supported': 'הבקשה לא נתמכת',
    'reports.RequestAccountOperationReport': 'בקשת דוח פעולות בחשבון',
    'reports.Required Balance': 'יתרה נדרשת',
    'reports.REQUIRED_STRONG_PASSWORDS': 'נדרשת סיסמה חזקה',
    'reports.ResetOnDisconnect': 'לאפס בעת ההתנתקות',
    'reports.ResetOnLogon': 'לאפס בעת ההתחברות',
    'reports.ResetOnLogout': 'לאפס בעת ההתנתקות',
    'reports.Restated': 'הוצג מחדש',
    'reports.Reuters': 'Reuters',
    'reports.Revenue plan': 'תוכנית הכנסות',
    'reports.REVENUE_PLAN_GENERAL': 'כללי',
    'reports.revenue.name': 'שם תוכנית ההכנסות',
    'reports.revenue.speccrossinstrument': 'סמל צלב מיוחד',
    'reports.revenue.speccurrency': 'מטבע מיוחד',
    'reports.Reverse': 'היפוך',
    'reports.reward_type.capital_percent': 'הון, %',
    'reports.reward_type.fixed': 'קבוע',
    'reports.reward_type.fixed_and_percent': 'קבוע + צמיחה בתקופת ההשקעה, %',
    'reports.reward_type.no': 'לא',
    'reports.reward_type.percent': 'צמיחה בתקופת ההשקעה, %',
    'reports.role': 'תפקיד',
    'reports.Rollback': 'שחזר',
    'reports.Rollback position': 'גלגל אחורה את הפוזיציה',
    'reports.Rollback position request': 'בקשת גלגול אחורה של פוזיציה',
    'reports.route': 'נתיב',
    'reports.Route': 'נתיב',
    'reports.Route Trading Statistics Report': 'דוח נתונים סטטיסטיים של ניתוב עסקה',
    'reports.Route Visibility': 'דוח נראות של הניתוב',
    'reports.Route Visibility Report': 'דוח נראות של הניתוב',
    'reports.RouteInstrMap': 'מפת סמלים',
    'reports.routename': 'נתיב',
    'reports.routes': 'נתיבים',
    'reports.routes.account': 'חשבון פיד מקושר',
    'reports.routes.allow_day': 'DAY',
    'reports.routes.allow_foc': 'FOK',
    'reports.routes.allow_gtc': 'GTC',
    'reports.routes.allow_ioc': 'IOC',
    'reports.routes.allow_market': 'מרקט',
    'reports.routes.allow_moc': 'לאפשר MOC',
    'reports.routes.allow_moo': 'לאפשר MOO',
    'reports.routes.allow_stop': 'סטופ',
    'reports.routes.allow_stoplimit': 'לימיט',
    'reports.routes.allow_stoptolimit': 'סטופ-לימיט',
    'reports.routes.route_comment': 'הערה',
    'reports.routes.route_external_feed': 'ספק הנזילות',
    'reports.routes.route_isactive': 'פעיל',
    'reports.routes.route_isinfo': 'מידע',
    'reports.routes.route_istrade': 'עסקה',
    'reports.routes.route_login': 'התחברות',
    'reports.routes.route_name': 'שם',
    'reports.routes.route_password': 'סיסמה',
    'reports.routes.route_saveQuotes': 'שמור היסטוריה נפרדת',
    'reports.routes.route_status': 'סטטוס',
    'reports.ROUTESVIS_RULES': 'נראות הניתוב',
    'reports.RssNews': 'RSSNews',
    'reports.RTS': 'RTS',
    'reports.rules.error.restriction.max': 'המספר צריך להיות קטן יותר',
    'reports.rules.error.restriction.min': 'המספר צריך להיות גדול יותר',
    'reports.SAVED_ORDERS': 'Desktop:Saved orders',
    'reports.saveLogs': 'שמור יומנים',
    'reports.saveNews': 'שמור חדשות',
    'reports.Saxo Bank': 'Saxo Bank',
    'reports.SCALPER': 'Desktop:Scalper',
    'reports.Scheduler Log Report': 'מתזמן דוח יומנים',
    'reports.scheduler.accountoperation_archive': 'העברת פעולות בחשבון לארכיון',
    'reports.scheduler.dailyreport': 'שלח דוח',
    'reports.scheduler.dividentsservice': 'הפעלת דיבידנדים על פוזיציות',
    'reports.scheduler.lastexcecuted': 'בוצע ב-',
    'reports.scheduler.modifyRuleTask': 'משימת עריכה',
    'reports.scheduler.movepositiontask': 'משימת העברת פוזיציה',
    'reports.scheduler.openclosetradingfor': 'פתח/סגור עסקה',
    'reports.scheduler.opentradingfor': 'פתח עסקה',
    'reports.scheduler.parameter.backup': 'רמת גיבוי',
    'reports.scheduler.parameter.calculateByClosePrice': 'השתמש במחיר הסגירה הנוכחי',
    'reports.scheduler.parameter.calculateStrategy': 'סוג החישוב',
    'reports.scheduler.parameter.coeff1': 'חלק 1',
    'reports.scheduler.parameter.coeff2': 'חלק 2',
    'reports.scheduler.parameter.comment': 'הערה על פעולה בחשבון',
    'reports.scheduler.parameter.counteraccount': 'חשבון נגדי',
    'reports.scheduler.parameter.days_before_exp': 'ימים עד לפקיעה',
    'reports.scheduler.parameter.divident': 'כמות דיבידנדים',
    'reports.scheduler.parameter.dividentmode': 'סוג דיבידנדים',
    'reports.scheduler.parameter.email': 'כתובות דוא"ל (מופרדות בפסיק)',
    'reports.scheduler.parameter.inheritUserGroups': 'כולל קבוצות משנה',
    'reports.scheduler.parameter.instrtype': 'קבוצת סמלים',
    'reports.scheduler.parameter.instrument': 'סמל',
    'reports.scheduler.parameter.isopen': 'פתח/סגור עסקה',
    'reports.scheduler.parameter.isupdateall': 'עדכן את כל המכשירים בקבוצה',
    'reports.scheduler.parameter.margincoeff': 'מקדם בטוחות (על בסיס זמן)',
    'reports.scheduler.parameter.max': 'מקסימום (%)',
    'reports.scheduler.parameter.message': 'הודעה',
    'reports.scheduler.parameter.min': 'מינימום (%)',
    'reports.scheduler.parameter.operations': 'סוג פעולה',
    'reports.scheduler.parameter.owner': 'אובייקט',
    'reports.scheduler.parameter.ownerType': 'סוג אובייקט',
    'reports.scheduler.parameter.putinaleerts': 'להכניס להתראות',
    'reports.scheduler.parameter.reconciliation.ClientId': 'מזהה לקוח להתאמה',
    'reports.scheduler.parameter.reconciliation.Direction': 'כיוון',
    'reports.scheduler.parameter.reconciliation.FromDate': 'התחל את ההתאמה מתאריך',
    'reports.scheduler.parameter.reconciliation.Route': 'נתיב',
    'reports.scheduler.parameter.reconciliation.SendItemName': 'שליחת שם קובץ',
    'reports.scheduler.parameter.reconciliation.Storage': 'סוג אחסון',
    'reports.scheduler.parameter.reconciliation.Transport': 'סוג תחבורה',
    'reports.scheduler.parameter.reconciliation.transportDestination': 'יעד',
    'reports.scheduler.parameter.reconciliation.transportLogin': 'שם משתמש לאימות',
    'reports.scheduler.parameter.reconciliation.transportPassword': 'סיסמת אימות',
    'reports.scheduler.parameter.reconciliation.Type': 'סוג התאמה',
    'reports.scheduler.parameter.reports': 'בחר דוח',
    'reports.scheduler.parameter.revenueplan': 'בחר תוכנית הכנסות',
    'reports.scheduler.parameter.routes': 'כל נתיב פעיל חייב להיות',
    'reports.scheduler.parameter.routesName': 'כולל נתיבים',
    'reports.scheduler.parameter.rule': 'כלל',
    'reports.scheduler.parameter.ruleType': 'סוג כלל',
    'reports.scheduler.parameter.ruleView': 'ערך',
    'reports.scheduler.parameter.sum': 'כמות במטבע המערכת',
    'reports.scheduler.parameter.swapCoefKey': 'מקדם סוואפ',
    'reports.scheduler.parameter.userGroup': 'קבוצת משתמשים',
    'reports.scheduler.parameter.usergroups': 'בחר קבוצת משתמשים',
    'reports.scheduler.removedo': 'הפעל שירות הסרת הוראות יומיות',
    'reports.scheduler.rolloverservice': 'הפעל רול-אובר של חוזים עתידיים',
    'reports.scheduler.runinterestservice': 'הפעל שירות ריבית על היתרה',
    'reports.scheduler.runsignalsubscribtion': 'הפעל עמלת חיוב יומית עבור איתות',
    'reports.scheduler.runswaptask': 'הפעל סוואפ',
    'reports.scheduler.splitinstrument': 'פצל סימול',
    'reports.scheduler.type.accountoperation': 'פעולה בחשבון',
    'reports.scheduler.type.backup': 'צור גיבוי',
    'reports.scheduler.type.beginbalance': 'התחל יתרה',
    'reports.scheduler.type.broadcastmessage': 'הודעת שידור אונליין',
    'reports.scheduler.type.changemargincoeff': 'מקדם בטוחות (על בסיס זמן)',
    'reports.scheduler.type.changerevenue': 'שנה תוכנית הכנסות',
    'reports.scheduler.type.closeoptions': 'הסתר סמלים שפקעו',
    'reports.scheduler.type.deletedemousers': 'מחק משתמשי דמו שפקעו',
    'reports.scheduler.type.deletequotes': 'מחק ציטוטים ישנים',
    'reports.scheduler.type.fixswapplan': 'חשב תוכנית סוואפ קבוע',
    'reports.scheduler.type.futuresrollover': 'הפעל רול-אובר של חוזים עתידיים',
    'reports.scheduler.type.insertlastquotestask': 'הכנס ציטוטים אחרונים',
    'reports.scheduler.type.lockbybroker': 'נעילה על ידי הברוקר',
    'reports.scheduler.type.message': 'הודעה',
    'reports.scheduler.type.modifyobject': 'ערוך אובייקט',
    'reports.scheduler.type.pamm': 'משימת קרן',
    'reports.scheduler.type.pendingpayment': 'תשלום בהמתנה',
    'reports.scheduler.type.reconciliation': 'משימת התאמה',
    'reports.scheduler.type.reconnect_routes': 'התחל/עצור ניתובים פעילים',
    'reports.scheduler.type.subscribe': 'קבל תשלומי מנוי',
    'reports.scheduler.type.unknown': 'סוג לא ידוע',
    'reports.scheduler.type.updatespikefilter': 'עדכן מסנן ספייק',
    'reports.scheduler.type.updateuserstradinginfo': 'עדכן את פרטי הסטטיסטייקה של מסחר המשתמשים',
    'reports.ScreenLogEvents': 'יומן מסך - אירועים',
    'reports.ScreenLogShowHeartBeats': 'יומן מסך - הצגת פעימות',
    'reports.ScreenLogShowIncoming': 'יומן מסך - הצגת כניסות',
    'reports.ScreenLogShowOutgoing': 'יומן מסך - הצגת יציאות',
    'reports.Script': 'סקריפט',
    'reports.SDK': 'Desktop:SDK',
    'reports.seconds': 'שניות',
    'reports.SecuritiesTransferTax': 'מס העברת ניירות ערך',
    'reports.Self trading is not allowed.': 'מסחר עצמי אסור.',
    'reports.Sell': 'מכירה',
    'reports.sell trade amount': 'סכום עסקת קנייה',
    'reports.sell trades': 'עסקאות קנייה',
    'reports.Send from': 'נשלח מ-',
    'reports.Send_Rej': 'דחה',
    'reports.sender': 'שולח',
    'reports.SenderCompID': 'מזהה המחשב של השולח',
    'reports.senderip': 'IP של השולח',
    'reports.SendResetSeqNumFlag': 'דגל שליחת איפוס של מספר סידורי',
    'reports.sendTag200': 'שלח Tag200',
    'reports.server': 'שרת',
    'reports.server_url': 'כתובת ה-URL של השרת',
    'reports.SERVER.AUTO.RECONNECT': 'חיבור אוטומטי לשרת',
    'reports.SERVER.POLLING.INTERVAL': 'מרווח סקירה של השרת',
    'reports.serviceName': 'שם השירות',
    'reports.sessionid': 'מזהה סשן',
    'reports.sessiontype': 'סוג הסשן',
    'reports.SETTINGS_FILTER': 'מסננים',
    'reports.SETTINGS_GENERAL': 'כללי',
    'reports.SETTINGS_LOCKING': 'נועל',
    'reports.SETTINGS_QUOTE_CACHE_SIZE': 'הגדרת גודל המטמון של ציטוט',
    'reports.SETTINGS_QUOTE_SAVE': 'הגדרות שמירת ציטוט',
    'reports.SETTINGS_QUOTES': 'ציטוטים',
    'reports.SETTINGS_REGISTRATION': 'לקבלת חשבון דמו',
    'reports.SETTINGS_TRADING': 'מסחר',
    'reports.SettleDate': 'תאריך פקיעה',
    'reports.SettleDateForward': 'תאריך ערך',
    'reports.SettlementFee': 'עמלת מימוש',
    'reports.Sharia Operations Report': 'דוח פעולות שריעה',
    'reports.signedrequest': 'בקשת חתימה',
    'reports.sizeForQuoteSubscription': 'גודל עבור מנוי לציטוטים',
    'reports.SL': 'סטופ-לוס',
    'reports.SL accepted by broker': 'הוראת סטופ-לוס התקבלה על ידי ברוקר',
    'reports.SL accepted by STP': 'הוראת סטופ-לוס התקבלה על ידי STP',
    'reports.SL order accepted': 'הוראת סטופ-לוס התקבלה',
    'reports.SL order cancel request': 'בקשה לביטול הוראת סטופ-לוס',
    'reports.SL order canceled': 'הוראת סטופ-לוס בוטלה',
    'reports.SL order created': 'הוראת סטופ-לוס נוצרה',
    'reports.SL Order Created': 'הוראת סטופ-לוס נוצרה',
    'reports.SL order created is off market': 'הוראת סטופ-לוס רחוקה מדי ממחיר השוק',
    'reports.SL order created is unplaced': 'הוראת סטופ-לוס לא הוצבה בבורסה',
    'reports.SL Order Modified': 'הוראת סטופ-לוס שונתה',
    'reports.SL order partially reject': 'הוראת סטופ-לוס בוטלה חלקית',
    'reports.SL order placing request': 'בקשה להצבת הוראת סטופ-לוס',
    'reports.SL order received by broker': 'הוראת סטופ-לוס התקבלה אצל הברוקר',
    'reports.SL order rejected': 'הוראת סטופ-לוס נדחתה',
    'reports.SL Order Removed': 'הוראת סטופ-לוס הוסרה',
    'reports.SL order replace request': 'בקשה להחלפת הוראת סטופ-לוס',
    'reports.SL order replaced': 'הוראת סטופ-לוס שונתה',
    'reports.SL price': 'שער סטופ-לוס',
    'reports.SL tr. stop': 'סטופ-לוס נגרר',
    'reports.SL tr. stop accepted by broker': 'הוראת סטופ-לוס נגרר התקבלה על ידי ברוקר',
    'reports.SL tr. stop accepted by STP': 'הוראת סטופ-לוס נגרר התקבלה על ידי STP',
    'reports.SL tr. stop order accepted': 'הוראת סטופ-לוס נגרר התקבלה',
    'reports.SL tr. stop order canceled': 'הוראת סטופ-לוס נגרר בוטלה',
    'reports.SL tr. stop order created': 'הוראת סטופ-לוס נגרר נוצרה',
    'reports.SL tr. stop order created is off market': 'הוראת סטופ-לוס נגרר מחוץ לשוק',
    'reports.SL tr. stop order created is unplaced': 'הוראת סטופ-לוס נגרר לא הוצבה בבורסה',
    'reports.SL tr. stop order partially reject': 'הוראת סטופ-לוס נגרר נדחתה חלקית',
    'reports.SL tr. stop order received by broker': 'הוראת סטופ-לוס נגרר התקבלה אצל הברוקר',
    'reports.SL tr. stop order rejected': 'הוראת סטופ-לוס נגרר נדחתה',
    'reports.SL tr. stop order replaced': 'הוראת סטופ-לוס נגרר שונתה',
    'reports.SmartRoute(aggregator)': 'אמולטור פיצול',
    'reports.Sms generation error': 'שגיאה ביצירת SMS',
    'reports.SMTP server required a secure connection, or identity of the client has not been established.': 'שרת SMTP דורש חיבור מאובטח, או שזהות הלקוח לא בוצעה',
    'reports.SOAP API methods are not available for execution for this user': 'שיטות SOAP API אינן זמינות לביצוע עבור משתמש זה',
    'reports.SocketConnectHost': 'Socket connectHost',
    'reports.SocketConnectPort': 'Socket connects port',
    'reports.SocketKeyStore': 'Socket key store',
    'reports.SocketKeyStorePassword': 'סיסמת Socket key store',
    'reports.SocketUseSSL': 'Socket use SSL',
    'reports.SplitOrders': 'פצל הוראות',
    'reports.spread': 'מרווח',
    'reports.Spread Amount Report': 'דוח סכום מרווח',
    'reports.spreadpnl': 'מרווח רווח/הפסד',
    'reports.Start receiving data from server...': 'מתחיל לקבל נתונים מהשרת...',
    'reports.StartDay': 'יום התחלה',
    'reports.StartTime': 'זמן התחלה',
    'reports.STATIONS_RULES': 'עמדות',
    'reports.Statistic Report': 'דוח סטטיסטי',
    'reports.STATUS_BLOCKED': 'חסום',
    'reports.stock_req': 'בקשת הוראות מניות',
    'reports.stock_value': 'שווי מניה',
    'reports.StockOperation': 'פעולות מנייה',
    'reports.stocks_liquidity': 'נזילות מניות',
    'reports.Stop accepted by broker': 'הוראת סטופ התקבלה על ידי ברוקר',
    'reports.Stop accepted by STP': 'הוראת סטופ התקבלה על ידי STP',
    'reports.Stop Limit accepted by broker': 'הוראת סטופ-לימיט התקבלה על ידי ברוקר',
    'reports.Stop Limit accepted by STP': 'הוראת סטופ-לימיט התקבלה על ידי STP',
    'reports.Stop Limit order accepted': 'הוראת סטופ-לימיט התקבלה',
    'reports.Stop Limit order activated': 'הוראת סטופ-לימיט הופעלה',
    'reports.Stop limit order cancel request': 'בקשה לביטול הוראת סטופ-לימיט',
    'reports.Stop limit order canceled': 'הוראת סטופ-לימיט בוטלה',
    'reports.Stop Limit order canceled': 'הוראת סטופ-לימיט בוטלה',
    'reports.Stop Limit order created': 'הוראת סטופ-לימיט נוצרה',
    'reports.Stop Limit Order Created': 'הוראת סטופ-לימיט נוצרה',
    'reports.Stop Limit order created is off market': 'הוראת סטופ-לימיט רחוקה מדי ממחיר השוק',
    'reports.Stop Limit order created is unplaced': 'הוראת סטופ-לימיט לא הוצבה בבורסה',
    'reports.Stop limit order is awaiting market': 'הוראת סטופ-לימיט ממתינה לשוק',
    'reports.Stop Limit Order Modified': 'הוראת סטופ-לימיט הוחלפה',
    'reports.Stop Limit order partially reject': 'הוראת סטופ-לימיט נדחתה חלקית',
    'reports.Stop limit order placing request': 'בקשה להצבת הוראת סטופ-לימיט',
    'reports.Stop Limit order received by broker': 'הוראת סטופ-לימיט התקבלה אצל הברוקר',
    'reports.Stop Limit order rejected': 'הוראת סטופ-לימיט נדחתה',
    'reports.Stop Limit Order Removed': 'הוראת סטופ-לימיט הוסרה',
    'reports.Stop limit order replace request': 'בקשה להחלפת הוראת סטופ-לימיט',
    'reports.Stop limit order replaced': 'הוראת סטופ-לימיט הוחלפה',
    'reports.Stop Limit order replaced': 'הוראת סטופ-לימיט הוחלפה',
    'reports.Stop Limit order restated': 'הוראת סטופ-לימיט נקבעה מחדש',
    'reports.Stop loss order canceled': 'הוראת סטופ-לוס בוטלה',
    'reports.Stop Loss price is too big': 'הוראת סטופ התקבלה',
    'reports.Stop order accepted': 'הוראת סטופ התקבלה',
    'reports.Stop order activated': 'הוראת סטטופ הופעלה',
    'reports.Stop order cancel request': 'בקשה לביטול הוראת סטופ',
    'reports.Stop order canceled': 'הוראת סטופ בוטלה',
    'reports.Stop order created': 'הוראת סטופ נוצרה',
    'reports.Stop Order Created': 'הוראת סטופ נוצרה',
    'reports.Stop order created is off market': 'הוראת הסטופ שנוצרה מחוץ לשוק',
    'reports.Stop order created is unplaced': 'הוראת סטופ לא הוצבה בבורסה',
    'reports.Stop order is awaiting market': 'הוראת סטופ ממתינה לשוק',
    'reports.Stop Order Modified': 'הוראת סטופ נגרר הוחלפה',
    'reports.Stop order partially reject': 'הוראת סטופ נדחתה חלקית',
    'reports.Stop order placing request': 'בקשה להצבת הוראת סטופ',
    'reports.Stop order received by broker': 'הוראת סטופ התקבלה אצל הברוקר',
    'reports.Stop order rejected': 'הוראת סטופ נדחתה חלקית',
    'reports.Stop Order Removed': 'הוראת סטופ הוסרה',
    'reports.Stop order replace request': 'בקשה להחלפת הוראת סטופ',
    'reports.Stop order replaced': 'הוראת סטופ נגרר הוחלפה',
    'reports.Stop order restated': 'הוראת סטופ נקבעה מחדש',
    'reports.Stop price': 'מחיר סטופ',
    'reports.stoploss': 'סטופ-לוס',
    'reports.StopOutType': 'סוג סטופ-אאוט',
    'reports.stopprice': 'מחיר סטופ',
    'reports.STP_Route_Change': 'קבע את שם המסלול המקורי בהוראה',
    'reports.Strike Price': 'מחיר סטרייק',
    'reports.submitted': 'נשלח',
    'reports.Subscribe': 'לעשות מנוי',
    'reports.SUBSCRIBE_RULES': 'תוכניות מנוי',
    'reports.success': 'הצלחה',
    'reports.Successful': 'הצליח',
    'reports.sum': 'סכום',
    'reports.Sum': 'סכום',
    'reports.Summary Report': 'דוח סיכום',
    'reports.SunGard': 'SunGard',
    'reports.SUSPEND_MARGINCALL_ON_CLOSE_MARKET': 'השהה עוזר קריאת בטוחות בשווקים סגורים',
    'reports.swap': 'סוואפ',
    'reports.swapbuy': 'SWAP לונג',
    'reports.swapplan': 'תוכנית סוואפ',
    'reports.swaps': 'Swaps',
    'reports.swaps_in': 'סוואפ נכנס',
    'reports.swaps_out': 'סוואפ יוצא',
    'reports.swapsell': 'SWAP שורט',
    'reports.symbol': 'סמל',
    'reports.Symbol': 'סמל',
    'reports.symbol_type': 'סוג הסימול',
    'reports.System': 'מערכת',
    'reports.system_currency': 'מטבע המערכת',
    'reports.systemMonitor.instruments': 'סמלים',
    'reports.systemMonitor.onlineConnections': 'חיבורים אונליין',
    'reports.systemMonitor.positions': 'פוזיציות פתוחות',
    'reports.systemMonitor.regusers': 'משתמשים רשומים',
    'reports.systemMonitor.runningRoutes': 'הניתוב התחיל מנתיבים פעילים',
    'reports.systemMonitor.totalQueueSize': 'תורים בשירותים',
    'reports.TABLE_ALERT': 'Desktop:Table Alert',
    'reports.tablename': 'שם הטבלה',
    'reports.TableName': 'שם הטבלה',
    'reports.Take profit order canceled': 'הוראת מימוש רווח בוטלה',
    'reports.Take Profit price is too big': 'שער מימוש רווח גדול מדי',
    'reports.takeprofit': 'מימוש רווח',
    'reports.TargetCompID': 'מזהה מחשב יעד',
    'reports.task.comment': 'הערה',
    'reports.task.day': 'יום',
    'reports.task.hour': 'שעה',
    'reports.task.minute': 'דקה',
    'reports.task.month': 'חודש',
    'reports.task.timezone': 'הפרש אזור זמן',
    'reports.task.usedst': 'השתמש ב-DST',
    'reports.task.year': 'שנה',
    'reports.TempFilePath': 'נתיב קובץ זמני',
    'reports.Tenfore': 'Tenfore',
    'reports.terminal': 'טרמינל',
    'reports.Terminal': 'טרמינל',
    'reports.TERMINAL_API': 'API',
    'reports.TERMINAL_COMMUNITY': 'קהילה',
    'reports.TERMINAL_FIX': 'חיבור FIX',
    'reports.TERMINAL_HTML': 'HTML',
    'reports.TERMINAL_JAVA': 'Java',
    'reports.TERMINAL_MOBILE': 'נייד',
    'reports.TERMINAL_NET': '.Net',
    'reports.TERMINAL_POCKETPC': 'Pocket PC',
    'reports.TERMINAL_WEB': 'WebStation',
    'reports.terminaltype': 'סוג הטרמינל',
    'reports.TFDS Quote Receiver': 'מקבל ציטוטי TFDS',
    'reports.tif': 'תוקף',
    'reports.TIF': 'תוקף',
    'reports.time': 'זמן',
    'reports.Time': 'תאריך/שעה',
    'reports.to': 'אל',
    'reports.toDate': 'אל',
    'reports.toDateConnAttempt': 'אל',
    'reports.toDatePwdChange': 'אל(סיסמה)',
    'reports.tooLargeData': 'נתוני הדוח גדולים מדי! הצג {1} מתוך {2} שורות',
    'reports.total': 'סך הכל',
    'reports.total traded amount': 'סה"כ הסכום במסחר',
    'reports.totalfee': 'סה"כ עמלה',
    'reports.TP': 'מימוש רווח',
    'reports.TP accepted by broker': 'הוראת מימוש רווח התקבלה על ידי ברוקר',
    'reports.TP accepted by STP': 'הוראת מימוש רווח התקבלה על ידי STP',
    'reports.TP order accepted': 'הוראת מימוש רווח התקבלה',
    'reports.TP order cancel request': 'בקשה לביטול הוראת מימוש רווח',
    'reports.TP order canceled': 'הוראת מימוש רווח בוטלה',
    'reports.TP order created': 'הוראת מימוש רווח הוצרה',
    'reports.TP Order Created': 'הוראת מימוש רווח הוצרה',
    'reports.TP order created is off market': 'הוראת מימוש רווח שנוצרה מחוץ לשוק',
    'reports.TP order created is unplaced': 'הוראת מימוש רווח שנוצרה לא הוצבה בבורסה',
    'reports.TP Order Modified': 'הוראת מימוש רווח הוחלפה',
    'reports.TP order partially reject': 'הוראת מימוש רווח נדחתה חלקית',
    'reports.TP order placing request': 'בקשה להצבת הוראת מימוש רווח',
    'reports.TP order received by broker': 'הוראת מימוש רווח התקבלה אצל הברוקר',
    'reports.TP order rejected': 'הוראת מימוש רווח נדחתה',
    'reports.TP Order Removed': 'הוראת מימוש רווח הוסרה',
    'reports.TP order replace request': 'בקשה להחלפת הוראת מימוש רווח',
    'reports.TP order replaced': 'הוראת מימוש רווח הוחלפה',
    'reports.Tr stop loss order cancel request': 'בקשה לביטול הוראת סטופ-לוס נגרר',
    'reports.Tr stop loss order placing request': 'בקשה להצבת הוראת סטופ-לוס נגרר',
    'reports.Tr stop loss order replace request': 'בקשה להחלפת הוראת סטופ-לוס נגרר',
    'reports.tr. stop': 'סטופ נגרר',
    'reports.Tr. stop accepted by broker': 'הוראת סטופ נגרר התקבלה על ידי ברוקר',
    'reports.Tr. stop accepted by STP': 'הוראת סטופ נגרר התקבלה על ידי STP',
    'reports.Tr. stop is too big': 'מחיר סטופ נגרר לא תקין להוראה',
    'reports.Tr. stop loss order accepted': 'הוראת סטופ-לוס נגרר התקבלה',
    'reports.Tr. stop loss order canceled': 'הוראת סטופ-לוס נגרר בוטלה',
    'reports.Tr. stop loss order created': 'הוראת סטופ-לוס נגרר נוצרה',
    'reports.Tr. stop loss order created is off market': 'הוראת סטופ-לוס נגרר שנוצרה מחוץ לשוק',
    'reports.Tr. stop loss order created is unplaced': 'הוראת סטופ-לוס נגרר שנוצרה לא הוצבה בבורסה',
    'reports.Tr. stop loss order replaced': 'הוראת סטופ-לוס נגרר הוחלפה',
    'reports.Tr. stop order accepted': 'הוראת סטופ נגרר התקבלה',
    'reports.Tr. stop order activated': 'הוראת סטופ נגרר הופעלה',
    'reports.Tr. stop order canceled': 'הוראת סטופ נגרר בוטלה',
    'reports.Tr. stop order created': 'הוראת סטופ נגרר נוצרה',
    'reports.Tr. stop order created is off market': 'הוראת סטופ נגרר שנוצרה מחוץ לשוק',
    'reports.Tr. stop order created is unplaced': 'הוראת סטופ נגרר לא הוצבה בבורסה',
    'reports.Tr. stop order is awaiting market': 'הוראת סטופ נגרר ממתינה לשוק',
    'reports.Tr. stop order partially reject': 'הוראת סטופ נגרר נדחתה חלקית',
    'reports.Tr. stop order received by broker': 'הוראת סטופ נגרר התקבלה אצל הברוקר',
    'reports.Tr. stop order placing request': 'בקשה להצבת הוראת סטופ נגרר',
    'reports.Tr. stop order cancel request': 'בקשה לביטול הוראת סטופ נגרר',
    'reports.Tr. stop order replace request': 'בקשה להחלפת הוראת סטופ נגרר',
    'reports.Tr. stop order rejected': 'הוראת סטופ נגרר נדחתה',
    'reports.Tr. stop order replaced': 'הוראת סטופ נגרר הוחלפה',
    'reports.Tr. stop order restated': 'הוראת סטופ נגרר נקבעה מחדש',
    'reports.Tr.SL Order Removed': 'הוראת סטופ נגרר הוסרה',
    'reports.Trade executed': 'העסקה בוצעה',
    'reports.Trade executed (Mutual)': 'העסקה בוצעה (הדדי)',
    'reports.Trade executed (SL)': 'העסקה בוצעה (סטופ-לוס)',
    'reports.Trade Operations Report': 'דוח פעולות מסחר',
    'reports.Trade Periods By Signal Report': 'דוח תקופות מסחר לפי איתות',
    'reports.trade.BeginString': 'מחרוזת התחלת עסקה',
    'reports.trade.CheckCompID': 'בדיקת מסחר- מזהה מחשב',
    'reports.trade.CheckLatency': 'בדיקת מסחר- מהירות חיבור',
    'reports.trade.ClosedResendInterval': 'עסקה נסגרה- מרווח שליחה חוזרת',
    'reports.trade.ConnectionType': 'סוג חיבור מסחר',
    'reports.trade.ContinueInitializationOnError': 'עסקה - המשך אתחול בשגיאה',
    'reports.trade.DataDictionary': 'מילון נתוני מסחר',
    'reports.trade.EndDay': 'תאריך סיום עסקה',
    'reports.trade.EndTime': 'זמן סיום עסקה',
    'reports.trade.entityId': 'מזהה ישות עסקה',
    'reports.trade.FileIncludeMilliseconds': 'קובץ המסחר כולל אלפיות שנייה',
    'reports.trade.FileIncludeTimeStampForMessages': 'קובץ המסחר כולל חותמת זמן להודעות',
    'reports.trade.FileLogHeartbeats': 'פעימות יומן קובץ מסחר',
    'reports.trade.fxintegrate.cert.host.verify': 'אימות מארח Trade fx integrate cert',
    'reports.trade.fxintegrate.cert.root.ca.file': 'קובץ Trade fx integrate cert root ca',
    'reports.trade.fxintegrate.host': 'מארח Trade fxintegrate',
    'reports.trade.fxintegrate.logging.file': 'קובץ יומן Trade fx integrate',
    'reports.trade.fxintegrate.logging.maxfilecount': 'מספר מרבי של קבצי יומן Trade fx integrate',
    'reports.trade.fxintegrate.logging.output': 'פלט יומן Trade fx integrate',
    'reports.trade.fxintegrate.logging.priority': 'עדיפות יומן Trade fxintegrate',
    'reports.trade.fxintegrate.port': 'יציאת Trade fx integrate',
    'reports.trade.fxintegrate.protocol': 'פרוטוקול Trade fx integrate',
    'reports.trade.fxintegrate.usessl': 'Fx integrate use ssl',
    'reports.trade.HeartBtInt': 'Trade heartbeat Int',
    'reports.trade.JdbcDriver': 'דרייבר Trade Jdbc',
    'reports.trade.JdbcPassword': 'סיסמת Trade Jdbc',
    'reports.trade.JdbcURL': 'כתובת URL ‏של Trade Jdbc',
    'reports.trade.JdbcUser': 'משתמש Trade Jdbc',
    'reports.trade.keystoreAlias': 'כינוי Trade key store',
    'reports.trade.keystoreFile': 'קובץ Trade key store',
    'reports.trade.LogFileMaxSize': 'גודל מרבי של קובץ יומן מסחר',
    'reports.trade.login': 'התחברות מסחר',
    'reports.trade.MaxLogsBackups': 'מקסימום גיבויים של יומני מסחר',
    'reports.trade.MillisecondsinTimeStamp': 'אלפיות שניה בחותמת הזמן',
    'reports.trade.MillisecondsInTimeStamp': 'אלפיות שניה בחותמת זמן המסחר',
    'reports.trade.password': 'סיסמת מסחר',
    'reports.trade.ReconnectInterval': 'מרווח זמן להתחברות מחדש למסחר',
    'reports.trade.RefreshonLogon': 'רענן בהתחברות',
    'reports.trade.RefreshOnLogon': 'רענן מסחר בעת ההתחברות',
    'reports.trade.ResetOnDisconnect': 'אפס מסחר בעת ההתנתקות',
    'reports.trade.ResetOnLogon': 'אפס מסחר בעת ההתחברות',
    'reports.trade.ResetOnLogout': 'אפס מסחר בעת יציאה',
    'reports.trade.saveLogs': 'מסחר - שמור יומנים',
    'reports.trade.ScreenLogEvents': 'מסחר - יומן מסך - אירועים',
    'reports.trade.ScreenLogShowHeartBeats': 'מסחר - יומן מסך - הצגת פעימות',
    'reports.trade.ScreenLogShowIncoming': 'מסחר - יומן מסך - מציג כניסות',
    'reports.trade.ScreenLogShowOutgoing': 'מסחר - יומן מסך - הצגת יציאות',
    'reports.trade.SenderCompID': 'מסחר - מזהה מחשב של השולח',
    'reports.trade.SendResetSeqNumFlag': 'מסחר- דגל שליחת איפוס של מספר סידורי',
    'reports.trade.SocketConnectHost': 'Trade socket - חיבור מארח',
    'reports.trade.SocketConnectPort': 'Trade socket - חיבור יציאה',
    'reports.trade.SocketKeyStore': 'Trade socket key store',
    'reports.trade.SocketKeyStorePassword': 'סיסמת Trade socket key store',
    'reports.trade.SocketUseSSL': 'Trade socket use SSL',
    'reports.trade.StartDay': 'יום תחילת מסחר',
    'reports.trade.StartTime': 'זמן תחילת מסחר',
    'reports.trade.TargetCompID': 'עסקה- מזהה מחשב יעד',
    'reports.trade.UseDataDictionary': 'עסקה- שימוש במילון נתונים',
    'reports.trade.ValidateFieldsHaveValues': 'עסקה- אימות שיש ערכים בשדות',
    'reports.trade.ValidateFieldsOutOfOrder': 'השדות לאימות העסקה לא תקינים',
    'reports.trade.ValidateUserDefinedFields': 'עסקה- אימות שדות שהוגדרו על ידי המשתמש',
    'reports.tradeamount': 'סכום עסקה',
    'reports.tradeid': 'מזהה עסקה',
    'reports.tradePassword': 'סיסמת מסחר',
    'reports.trader': 'סוחר',
    'reports.Trades by Signal': 'עסקאות לפי איתות',
    'reports.Trades Report': 'דוח עסקאות',
    'reports.Trades report by instrument': 'דוח עסקאות לפי מכשיר',
    'reports.trades_bought': 'עסקאות שנקנו',
    'reports.trades_sold': 'עסקאות שנמכרו',
    'reports.tradevolume': 'נפח העסקה',
    'reports.trading': 'מסחר',
    'reports.Trading': 'מסחר',
    'reports.Trading disabled by risk rules': 'מסחר הושבת על ידי כללי סיכון',
    'reports.TRADING_IDEA_CARD': 'Desktop:Trading Idea card',
    'reports.trading_in': 'מסחר נכנס',
    'reports.trading_out': 'מסחר יוצא',
    'reports.TRADING_RULES_ACC': 'כללי מסחר (חשבון)',
    'reports.TRADING_RUSLES': 'כללי מסחר',
    'reports.TRADINGSYSTEMLIST': 'Desktop:Trading system list',
    'reports.Traiding out of Main session is forbidden for this account': 'מסחר מחוץ לזמני פעילות ראשיים אסור עבור המשתמש הזה',
    'reports.Trailing stop order cancel request': 'בקשה לביטול הוראת סטופ נגרר',
    'reports.Trailing Stop Order Created': 'הוראת סטופ נגרר נוצרה',
    'reports.Trailing Stop Order Modified': 'הוראת סטופ נגרר שונתה',
    'reports.Trailing stop order placing request': 'בקשה להצבת הוראת סטופ נגרר',
    'reports.Trailing Stop Order Removed': 'הוראת סטופ נגרר הוסרה',
    'reports.Trailing stop order replace request': 'בקשה להחלפת הוראת סטופ נגרר',
    'reports.TrailingStop': 'סטופ נגרר',
    'reports.Transfer': 'העברה',
    'reports.TransferFee': 'עמלת העברה',
    'reports.True': 'True',
    'reports.type': 'סוג',
    'reports.Type': 'סוג',
    'reports.Types': 'סוגים',
    'reports.UBSFIXFeed': 'UBSFIXFeed',
    'reports.Unable to cancel the order since route is not active.': 'לא ניתן לבטל את ההוראה מכיוון שהניתוב אינו פעיל.',
    'reports.Unblocking': 'ביטול חסימה',
    'reports.Unplaced': 'לא הוצב',
    'reports.unrealized p/l': 'רווח/הפסד שלא מומשו',
    'reports.unrealizedpnl': 'רווח/הפסד שלא מומשו',
    'reports.unsettled_cash': 'מזומן לא מסולק',
    'reports.updatedtime': 'זמן עדכון',
    'reports.Updater': 'מעדכן',
    'reports.URL': 'כתובת URL',
    'reports.usage': 'שימוש',
    'reports.USE_OPEN_PRICE_IN_MARGIN': 'שימוש במחיר פתיחה',
    'reports.UseDataDictionary': 'שימוש במילון נתונים',
    'reports.usePrevQuotedOrders': 'שימוש בהוראות עם ציטוט קודם',
    'reports.UsePriority': 'עדיפות שימוש',
    'reports.user': 'משתמש',
    'reports.User': 'משתמש',
    'reports.User Authorization Error': 'שגיאת הרשאת משתמש',
    'reports.user group': 'קבוצת משתמשים',
    'reports.User Previledges Report': 'דוח הרשאות משתמש',
    'reports.user.acc_4_signals': 'חשבון לאיתותים',
    'reports.user.address': 'כתובת',
    'reports.user.amount': 'כמות',
    'reports.user.amountType': 'סוג כמות',
    'reports.user.birthday': 'תאריך לידה',
    'reports.user.certificate': 'אישור המשתמש',
    'reports.user.chatOnEmail': 'שלח צ\'אט בדוא"ל',
    'reports.user.city': 'עיר',
    'reports.user.comment': 'הערה',
    'reports.user.commission_type': 'עמלה על ידי',
    'reports.user.email': 'דוא"ל',
    'reports.user.extaccount': 'חשבון חיצוני',
    'reports.user.firstname': 'שם פרטי',
    'reports.user.gender': 'מין',
    'reports.user.group': 'קבוצה',
    'reports.user.how_handle': 'איך לטפל באיתותים',
    'reports.user.introducebroker': 'חשבון ברוקר מפנה',
    'reports.user.language': 'שפה',
    'reports.user.lastname': 'שם משפחה',
    'reports.user.linkedUsers': 'משתמשים מקושרים',
    'reports.user.login': 'התחברות',
    'reports.user.middlename': 'שם אמצעי',
    'reports.user.password': 'סיסמה חדשה',
    'reports.user.phonenumber': 'מספר טלפון',
    'reports.user.phonepassword': 'סיסמת טלפון',
    'reports.user.photo': 'תמונה',
    'reports.user.pin': 'קוד PIN',
    'reports.user.showInSearch': 'הצג בחיפוש',
    'reports.user.showMyContacts': 'הצג את אנשי הקשר שלי',
    'reports.user.signalsOnEmail': 'איתותים בדוא"ל',
    'reports.user.state': 'מדינה',
    'reports.user.status': 'סטטוס',
    'reports.user.subscribeplan': 'תוכנית מנוי',
    'reports.user.website': 'אתר אינטרנט',
    'reports.user.zipcode': 'מיקוד',
    'reports.usergroup.group': 'קבוצת-על',
    'reports.usergroup.name': 'קבוצת משתמשים',
    'reports.USERGROUPSVIS_RULES': 'נראות של קבוצות משתמשים',
    'reports.userlogin': 'שם משתמש',
    'reports.UserLogin': 'שם משתמש',
    'reports.username': 'משתמש',
    'reports.Users Report': 'דוח משתמשים',
    'reports.Users Report(copy)': 'דוח משתמשים (עותק)',
    'reports.users_num': 'מספר משתמשים',
    'reports.useSSL': 'השתמש ב-SSL',
    'reports.ValidateFieldsHaveValues': 'אימות שיש ערכים בשדות',
    'reports.ValidateFieldsOutOfOrder': 'אימות שדות לא תקינים',
    'reports.ValidateUserDefinedFields': 'אימות שדות שהוגדרו על ידי המשתמש',
    'reports.value': 'ערך',
    'reports.VALUE_ADDRESS': 'כתובת',
    'reports.VALUE_BASE_CURRENCY': 'חלק בסיס של הסימול',
    'reports.VALUE_BRUTEFORCE_LOCK_MINUTS': 'ערך של נעילת מתקפה גסה, בדקות',
    'reports.VALUE_CITY': 'עיר',
    'reports.VALUE_COMMISSION_ACCOUNT': 'עמלה חשבון נגדי',
    'reports.VALUE_COMMISSION_FOR_TRANSFER': 'עמלה להעברה',
    'reports.VALUE_COMMISSION_ID': 'תוכנית הכנסות',
    'reports.VALUE_COUNTER_CURRENCY': 'חלק נגדי של הסימול',
    'reports.VALUE_COUNTRY': 'ארץ',
    'reports.VALUE_DAY_BEGIN': 'תאריך התחלה',
    'reports.VALUE_DAY_END': 'תאריך סיום',
    'reports.VALUE_DAYS_TILL_EXP': 'ימים עד פקיעה',
    'reports.VALUE_DEFAULT_BROKER': 'ברוקר ברירת מחדל',
    'reports.VALUE_DEFAULT_LANG': 'שפת ברירת מחדל',
    'reports.VALUE_DERIVATIVE_TYPE': 'סוג נגזר',
    'reports.VALUE_HEDGE_COEFFICIENT': 'מקדם גידור',
    'reports.VALUE_L2QUOTEGROUP_DEPTH': 'עומק קבוצה רמה 2',
    'reports.VALUE_L2QUOTEGROUP_INTERVAL': 'מרווח קבוצה רמה 2',
    'reports.VALUE_LEVERAGE': 'מינוף',
    'reports.VALUE_LOT_SIZE': 'גודל חוזה(לוט)',
    'reports.VALUE_LOTSTEP': 'צעד לוט',
    'reports.VALUE_MARGIN_COEFFICIENT': 'מקדם בטוחות (על בסיס זמן)',
    'reports.VALUE_MARGINCALL': 'קריאת בטוחות ,%',
    'reports.VALUE_MARGINTRADING': 'רמת הפסקת מסחר, %',
    'reports.VALUE_MARKET_RANGE': 'טווח שוק, טיקים',
    'reports.VALUE_MAX_DELTA_QUOTES': 'הפרש המחיר המרבי המותר בין שני ציטוטים עוקבים (טיקים)',
    'reports.VALUE_MAX_DELTA_TRADES': 'הפרש המחיר המרבי המותר בין שתי עסקאות עוקבות',
    'reports.VALUE_MAXIMUM_CACHE_SIZE': 'גודל מטמון מרבי',
    'reports.VALUE_MAXIMUM_FILTER': 'ערך ספייק מרבי',
    'reports.VALUE_MAXIMUMLOT': 'לוט מקסימלי',
    'reports.VALUE_MIN_OPTION_INTERVAL': 'הפרש זמן מינימלי מותר בין שני ציטוטים של אופציות',
    'reports.VALUE_MIN_PRICE_DIFF_FOR_MARGIN': 'הפרש מחיר מינימלי לבטוחות',
    'reports.VALUE_MINIMALLOT': 'לוט מינימלי',
    'reports.VALUE_MINIMUM_FILTER': 'ערך ספייק מינימלי',
    'reports.value_nav': 'ערך/NAV',
    'reports.VALUE_NO_QUOTES_MAXTIME': 'זמן מרבי ללא ציטוטים',
    'reports.VALUE_NUMBER_OF_SHARES': 'מספר מניות',
    'reports.VALUE_ONE_COUNTER_ACCOUNT': 'חשבון נגדי',
    'reports.VALUE_PIP_SIZE': 'גודל טיק (שינוי מינימלי)',
    'reports.VALUE_PnL_ACCOUNT': 'רווח/הפסד חשבון נגדי',
    'reports.VALUE_POST_SESSION_END': 'לאחר סיום הסשן',
    'reports.VALUE_PRE_SESSION_BEGIN': 'לפני תחילת הסשן',
    'reports.VALUE_PRICE_GENERATION_MODEL': 'מודל יצירת מחיר',
    'reports.VALUE_PWD_VERIFICATION_LEN': 'אורך סיסמת האימות',
    'reports.VALUE_QUOTE_CACHE_15MIN_SIZE': 'גודל מטמון ציטוט- 15 דקות',
    'reports.VALUE_QUOTE_CACHE_1MIN_SIZE': 'גודל מטמון ציטוט- דקה',
    'reports.VALUE_QUOTE_CACHE_30MIN_SIZE': 'גודל מטמון ציטוט- 30 דקות',
    'reports.VALUE_QUOTE_CACHE_4HOUR_SIZE': 'גודל מטמון ציטוט- 4 שעות',
    'reports.VALUE_QUOTE_CACHE_5MIN_SIZE': 'גודל מטמון ציטוט- 5 דקות',
    'reports.VALUE_QUOTE_CACHE_DAY_SIZE': 'גודל מטמון ציטוט- יום',
    'reports.VALUE_QUOTE_CACHE_HOUR_SIZE': 'גודל מטמון ציטוט- שעה',
    'reports.VALUE_QUOTE_CACHE_MONTH_SIZE': 'גודל מטמון ציטוט- חודש',
    'reports.VALUE_QUOTE_CACHE_SIZE': 'גודל מטמון ציטוט',
    'reports.VALUE_QUOTE_CACHE_TIC_SIZE': 'גודל מטמון ציטוט- טיק',
    'reports.VALUE_QUOTE_CACHE_WEEK_SIZE': 'גודל מטמון ציטוט- שבוע',
    'reports.VALUE_QUOTE_CACHE_YEAR_SIZE': 'גודל מטמון ציטוט- שנה',
    'reports.VALUE_QUOTE_PATH': 'נתיב מטמון הציטוטים',
    'reports.VALUE_QUOTES_FILE_SIZE': 'גודל קובץ ציטוטים',
    'reports.VALUE_SLIPPAGE': "זליגה (סליפג')",
    'reports.VALUE_SMS_PATTERN': 'תבנית SMS',
    'reports.VALUE_SPOT_INSTRUMENT': 'סימול ספוט',
    'reports.VALUE_SPREAD_ACCOUNT': 'מרווח חשבון נגדי',
    'reports.VALUE_STATE': 'מדינה',
    'reports.VALUE_STOPOUT': 'רמת סטופ-אאוט, %',
    'reports.VALUE_SWAP_ACCOUNT': 'חשבון נגדי סוואפ',
    'reports.VALUE_TEMPLATE_NUMERIC': 'תבניות דוא"ל',
    'reports.VALUE_TICK_COAST': 'טיק- coast',
    'reports.VALUE_TIMEZONE_OFFSET': 'הפרש אזור זמן',
    'reports.VALUE_UNREPEAT_PASSWORD': 'מספר סיסמאות ללא חזרה',
    'reports.VALUE_WL_ACCOUNT': 'חשבון נגדי הפקדה/משיכה',
    'reports.VALUE_WRONG_PASSWORDS_BEFORE_LOCK': 'מספר הסיסמאות השגויות המותר',
    'reports.VALUE_ZIP': 'מיקוד',
    'reports.ValueAddedTax': 'מע"מ',
    'reports.valuedate': 'תאריך שווי',
    'reports.Visibility': 'נראות',
    'reports.VISIBILITY_BRANDING': 'נראות המיתוג',
    'reports.VISIBILITY_COMMISSIONSPLAN': 'נראות תוכניות הכנסה',
    'reports.VISIBILITY_EXTFIELDS': 'נראות שדות מורחבת',
    'reports.VISIBILITY_INSTRUMENT_TYPE': 'נראות סוג הסימול',
    'reports.VISIBILITY_ROUTE': 'נראות הניתוב',
    'reports.VISIBILITY_SUBSCRIBE_PLAN': 'תוכניות מנוי',
    'reports.VISIBILITY_USERGROUP': 'נראות של קבוצות משתמשים',
    'reports.Wait confirm for cancel': 'המתן לאישור ביטול',
    'reports.Wait confirm for execution': 'המתן לאישור ביצוע',
    'reports.Wait confirm for modify': 'המתן לאישור שינוי',
    'reports.Waiting market': 'בהתמנה לשוק',
    'reports.WEB_CHART_OE': 'WEB:Chart OE',
    'reports.WEB_CHART_VISUAL': 'WEB:Chart Visual',
    'reports.WEB_MARKETDEPTH': 'WEB:Market Depth',
    'reports.WEB_OE': 'WEB:OE',
    'reports.WEB_OPTION_MASTER': 'WEB:Option Master',
    'reports.WEB_ORDERS_PANEL_HOT_BTN': 'WEB:Orders Panel Hot Buttons',
    'reports.WEB_OTHER': 'WEB:Other',
    'reports.WEB_POSITIONS_PANEL_HOT_BTN': 'WEB:Positions Panel Hot Buttons',
    'reports.WEB_ALERT': 'WEB:Alert',
    'reports.WEB_SAVED_ORDERS': 'WEB:Saved Orders',
    'reports.SERVER': 'Server:Server',
    'reports.weeks': 'שבועות',
    'reports.Widgets Instrument Statistics Report': "דוח סטטיסטקת מכשירים וודג'ט",
    'reports.widgets_isr_buytrades': 'קנייה עסקאות',
    'reports.widgets_isr_commission': 'עמלה',
    'reports.widgets_isr_instrumentname': 'סמל',
    'reports.widgets_isr_netpl': 'רווח/הפסד נטו',
    'reports.widgets_isr_plticks': 'רווח/הפסד טיקים',
    'reports.widgets_isr_selltrades': 'עסקאות קנייה',
    'reports.widgets_isr_swap': 'סוואפ',
    'reports.widgets_isr_totaltrades': 'סה"כ עסקאות',
    'reports.widgets_isr_trades': 'עסקאות',
    'reports.widgets_isr_tradevolume': 'נפח',
    'reports.widgets_isr_winningtrades': 'עסקאות זוכות',
    'reports.widthdraw': 'משיכה',
    'reports.Withdraw': 'משיכה',
    'reports.Withdrawal': 'משיכה',
    'reports.withdrawalfee': 'עמלת משיכה',
    'reports.Wrong account operation summ.': 'סכום פעולה בחשבון שגוי',
    'reports.Wrong recovery key': 'מפתח שחזור שגוי',
    'reports.years': 'שנים',
    'reports.yes': 'כן',
    'reports.64': 'Web:Positions CM',
    "reports.You can't trade with this account.": 'אתה לא יכול לסחור עם החשבון הזה.',
    Reserve: 'שמירת הזמנה',
    'RiskRuleType.NegativeProjectedBalance': 'משתמש: {0}, חשבון: {1}. הופעל סטופ-אאוט בשל יתרה חזויה שלילית.',
    'RiskRuleType.AvailableCash': 'אזהרה! אתה מתחיל להשתמש בכספי האשראי של הברוקר (מינוף)',
    'ribbon.closeAccount': 'סגור חשבון',
    'screen.closeAccount.header': 'אשר סגירת חשבון',
    'screen.closeAccount.okBtnText': 'שלח בקשה',
    'screen.closeAccount.closeBtnText': 'סגירה',
    'screen.closeAccount.confirmText': 'בטוח שברצונך לסגור את חשבון המשתמש?',
    'screen.closeAccount.cancelText': 'בטל בקשה',
    'screen.closeAccount.approveText': 'הבקשה שלך התקבלה. אנו נשלים את הפעולות הנדרשות בקרוב והחשבון ייסגר.',
    'screen.closeAccount.submitText': 'הבקשה שלך נשלחה בהצלחה. הברוקר ייצור איתך קשר בהקדם האפשרי.\n\nשים לב שהפעולה לא תעובד באופן מיידי, ועדיין תהיה לך אפשרות להשתמש בחשבון. עם זאת, לאחר סגירת החשבון שלך הוא לא יהיה זמין יותר.',
    'closeAccount.dealticket.0': 'הבקשה שלך נשלחה בהצלחה. הברוקר ייצור איתך קשר בהקדם האפשרי.',
    'closeAccount.dealticket.1': 'הבקשה שלך התקבלה. אנו נשלים את הפעולות הנדרשות בקרוב והחשבון ייסגר.',
    'closeAccount.dealticket.2': 'הבקשה שלך נדחתה. לפרטים נוספים פנה לברוקר.',
    'closeAccount.dealticket.3': 'הבקשה שלך בוטלה.',
    'ribbon.enviroment': 'סביבה',
    'ribbon.enviroment.help': 'עזרה',
    'ribbon.enviroment.logout': 'התנתק',
    'ribbon.enviroment.logging': 'הורד יומן',
    'ribbon.enviroment.New': 'סביבת עבודה חדשה',
    'ribbon.enviroment.NotificationWindow.lockTrading': 'המסחר נעול',
    'ribbon.enviroment.NotificationWindow.UnlockTrading': 'המסחר שוחרר מנעילה',
    'ribbon.enviroment.Save': 'שמור מרחב עבודה',
    'ribbon.enviroment.settings': 'הגדרות',
    'ribbon.enviroment.settings.disabled.tt': 'לא ניתן לשנות את ההגדרות במצב מנותק!',
    'ribbon.help.about': 'אודות',
    'ribbon.help.onboarding': 'סיור הכרת מערכת',
    'ribbon.help.help': 'עוד',
    'ribbon.help.home': 'עמוד הבית',
    'ribbon.help.downloadLogFile': 'הורד יומן',
    'ribbon.linking.linkBlue': 'כחול',
    'ribbon.linking.linkEmpty': 'ללא',
    'ribbon.linking.linkGreen': 'ירוק',
    'ribbon.linking.linkOrange': 'כתום',
    'ribbon.linking.linkPurple': 'סגול',
    'ribbon.linking.linkRed': 'אדום',
    'ribbon.linking.linkYellow': 'צהוב',
    'ribbon.more.tradingTools': 'כלי מסחר',
    'ribbon.more.brokerInfo': 'מידע על הברוקר',
    'screen.brokerInfo.header': 'מידע על הברוקר',
    'ribbon.tools': 'כלים',
    'ribbon.tools.full_logs': 'רישום מלא ביומן הודעות שרת',
    'ribbon.tools.grid': 'חלון גרפים',
    'ribbon.tools.withdrawal': 'משיכה',
    'ribbon.tools.reports': 'דוחות',
    'ribbon.tools.products': 'מנויים',
    'ribbon.tools.portfolio': 'תיק ההשקעות שלי',
    'ribbon.tradingTerminal': 'טרמינל',
    'ribbon.tradingTerminal.statement': '',
    'ribbon.tradingTerminal.riskCalculator': '#hidden#',
    'RiskManagement.Messages.DailyLimit': 'הגעת למגבלת ההפסד היומי',
    'RiskManagement.Messages.MaxDailyProfit': 'הושג רווח יומי',
    'RiskManagement.Messages.MaxTrailingLimit': 'הגעת לירידה הנגררת המקסימלית',
    'RiskManagement.Messages.MaxUnrealizedLossLimit': 'הושגה מגבלת הפסד לא ממומש',
    'RiskManagement.Messages.WeeklyLimit': 'הושגה מגבלת הפסד שבועית',
    'RiskManagement.Messages.MaxOrdersCountPerDay': 'המסחר הושבת על ידי כללי הסיכון. הגעת למספר המרבי של הוראות ליום.',
    'RiskManagement.Messages.MaxRelativeDrawDownLevel': 'הגעת לרמת הירידה היחסית המקסימלית.',
    'RiskManagement.Messages.EODTrailingDrawDownLevel': 'הגעת לרמת הירידה הנגררת המקסימלית בסוף היום.',
    'RiskManagement.Messages.RelativeDailyLossLimit': 'הגעת למגבלת הפסד יחסי',
    'screen.about.copyright': '© 2017-2026 TraderEvolution Global LTD.',
    'screen.about.dateBuild': 'תאריך בנייה:',
    'screen.about.title': 'אודות',
    'screen.about.titleWeb': 'אודות TraderEvolution',
    'screen.about.versionWeb': 'גרסת Build',
    'screen.additionalVerification.comment': 'החיבור ({1}) דורש אימות נוסף:',
    'screen.additionalVerification.Need activation': 'נדרשת הפעלה',
    'screen.additionalVerification.Need activation.comment': 'אנא הזן קוד הפעלה (נשלח לדוא"ל שלך)',
    'screen.additionalVerification.Need activation.watermark': 'אנא הזן את ה-OTP שלך כאן',
    'screen.additionalVerification.title': 'נדרש אימות נוסף',
    'screen.additionalVerification.title.Email': 'נדרש אימות נוסף (סיסמה חד-פעמית בדוא"ל)',
    'screen.additionalVerification.title.Fixed': 'נדרש אימות נוסף (סיסמה קבועה)',
    'screen.additionalVerification.title.Sms': 'נדרש אימות נוסף (סיסמה חד-פעמית ב-SMS)',
    'screen.additionalVerification.title.SmsPlusEmailOneTimePass': 'נדרש אימות נוסף (סיסמה חד פעמית ב-SMS + דוא"ל)',
    'screen.additionalVerification.title.DailySmsPlusEmailOneTimePass': 'אימות נוסף (SMS יומי + סיסמה חד פעמית בדוא"ל)',
    'screen.additionalVerification.watermark': 'אנא הזן את ה-OTP שלך כאן',
    'screen.changepass.cancel': 'בטל מנוי',
    'screen.changepass.changed': 'הסיסמה שונתה בהצלחה',
    'screen.changepass.changed.login': 'הסיסמה שונתה בהצלחה. אפשר להתחבר',
    'screen.changepass.confirm': 'אשר סיסמה חדשה',
    'screen.changepass.new': 'סיסמה חדשה',
    'screen.changepass.ok': 'אישור',
    'screen.changepass.old': 'סיסמה נוכחית',
    'screen.changepass.title': 'שינוי סיסמה',
    'screen.changeTradingPass.title': 'שנה סיסמת מסחר',
    'screen.changepass.watermark_confirm': '<אשר סיסמה>',
    'screen.changepass.watermark_new': '<סיסמה חדשה>',
    'screen.changepass.watermark_old': '<הסיסמה הנוכחית>',
    'screen.changepass.alert_not_match': 'הסיסמה והאישור אינם תואמים',
    'screen.changepass.wrongVerification': 'אימות שגוי',
    'screen.changepass.tooeasy': 'הסיסמה שלך נפוצה מדי וקלה לניחוש',
    'screen.closePosition.cancel': 'בטל מנוי',
    'screen.closePosition.ok': 'סגירה',
    'screen.closePosition.title': 'סגירה',
    'screen.closePosition.maxLotWarning': 'הכמות גדולה מהלוט המקסימלי ייווצרו הוראות לסגירת הפוזיציה.',
    'screen.closePosition.additionalInfoLabel': 'עמלה (משוער)',
    'screen.closePosition.EstimatedClosingFee': 'עמלת סגירה משוערת',
    'screen.PositionExerciseRequestScreen.title': 'בקשת מימוש פוזיציה',
    'screen.PositionExerciseRequestScreen.exercise': 'מימוש',
    'screen.PositionExerciseRequestScreen.exerciseError': 'רק אופציות בתוך הכסף יכולות להיות מופעלות',
    'screen.PositionExerciseCancelConfirm.text': 'לבטל את ביצוע הבקשה לפוזיציה מס. {1}?',
    'screen.PositionExerciseComplete.header': 'התקבל סטטוס "ממתין למימוש" עבור הפוזיציה',
    'screen.PositionExerciseComplete.text': 'הפוזיציה {1} לחשבון {2} חסומה לביצוע פעילות. כדי לבטל את החסימה על הפוזיציה יש לבטל את הבקשה לביצוע הפעולה.',
    'screen.PositionExerciseDealticket.header': 'בקשת מימוש פוזיציה',
    'screen.PositionExerciseCancelDealticket.header': 'בקשת ביטול מימוש פוזיציה',
    'screen.editPosition.header': 'שנה פוזיציה',
    'screen.error.title': 'שגיאה',
    'screen.export.header': 'ייצא',
    'screen.export.contextMenu': 'ייצא',
    'screen.export.Export': 'ייצא',
    'screen.export.Cancel': 'בטל מנוי',
    'screen.export.CSV': 'CSV',
    'screen.export.Excel': 'אקסל',
    'screen.export.selectFormat.tt': 'בחר סוג קובץ',
    'screen.export.checkAllText': 'סמן הכל',
    'screen.licensing.emptyFieldErrors.password': 'שדה הסיסמה ריק',
    'screen.licensing.statusMessages.connecting': 'מתחבר...',
    'screen.login.change_pass': 'הסיסמה אופסה או פגה ויש לשנות אותה',
    'screen.login.bad_branding_key': 'היישום אינו מורשה למשתמש',
    'screen.lookup.scripts.noitems': 'אין פריטים תואמים',
    'screen.lookup.scripts.showing': 'מציג {1} פריטים',
    'screen.lookup.scripts.watermark': '<חיפוש>',
    'screen.modifyOrder.amount': 'כמות:',
    'screen.modifyOrder.bind_to': 'מקושר ל:',
    'screen.modifyOrder.Change order': 'עריכת הוראה',
    'screen.modifyOrder.created': 'תאריך/שעה:',
    'screen.modifyOrder.instrument': 'סימול:',
    'screen.modifyOrder.leverage': 'מינוף:',
    'screen.modifyOrder.market_price': 'מחיר נוכחי:',
    'screen.modifyOrder.modify': 'ערוך',
    'screen.modifyOrder.modifyPosition': 'שנה פוזיציה',
    'screen.modifyOrder.number': 'מזהה פוזיציה:',
    'screen.modifyOrder.operation': 'כיוון הפוזיציה',
    'screen.modifyOrder.orderNumber': 'מזהה ההוראה',
    'screen.modifyOrder.ordertype': 'סוג ההוראה',
    'screen.modifyOrder.price': 'מחיר פתיחה',
    'screen.modifyOrder.productType': 'סוג מוצר:',
    'screen.modifyOrder.route': 'ניתוב:',
    'screen.properties.cancel': 'סגירה',
    'screen.properties.cancel.ToolTip': 'סגירה',
    'screen.properties.common': 'מאפיינים',
    'screen.properties.ok': 'אישור',
    'screen.properties.ok.ToolTip': 'אוקיי',
    'screen.properties.title': 'הגדרות כלליות',
    'screen.properties.unsavedChanges': 'אין לך שינויים שלא נשמרו. לצאת ולאבד את השינויים?',
    'screen.LoginScreen.Connecting': 'מתחבר...',
    'screen.LoginScreen.Error.loginIdIsEmpty': 'שדה מזהה הכניסה ריק',
    'screen.LoginScreen.Error.passwordIdIsEmpty': 'שדה הסיסמה ריק',
    'screen.LoginScreen.Error.noWorkingServers': 'לא נמצאו שרתים עובדים',
    'screen.LoginScreen.ExploreLinkLabel': 'גלה את האפליקציה',
    'screen.LoginScreen.ExploreLinkLabel.ToolTip': 'היכנס לאפליקציה במצב דמו. לא תהיה לך הרשאה לסחור או לשנות את הגדרות האפליקציה',
    'screen.LoginScreen.ForgotLinkLabel': 'שכחתי סיסמה',
    'screen.LoginScreen.ForgotLinkLabel.ToolTip': 'שחזור סיסמה',
    'screen.LoginScreen.LoadingUserData': 'טוען את נתוני המשתמש...',
    'screen.LoginScreen.LoginButtonText': 'התחבר',
    'screen.LoginScreen.LoginButtonTooltip': 'היכנס לפלטפורמה',
    'screen.LoginScreen.LoginIDLabel': 'התחברות',
    'screen.LoginScreen.LoginIDTextBox.ToolTip': 'שם משתמש',
    'screen.LoginScreen.PasswordLabel': 'סיסמה',
    'screen.LoginScreen.PasswordTextBox.ToolTip': 'סיסמת משתמש',
    'screen.LoginScreen.RegistrationLinkLabel': 'לקבלת חשבון דמו',
    'screen.LoginScreen.RegistrationLinkLabel.ToolTip': 'הרשמה לחשבון דמו',
    'screen.LoginScreen.SavePassCheckBox': 'שמור סיסמה',
    'screen.LoginScreen.SavePassCheckBox.ToolTip': 'זכור פרטי התחברות',
    'screen.LoginScreen.ShowPassEye.ToolTip': 'לחץ על מנת להראות סיסמה',
    'screen.LoginScreen.ShowPassCrossed.ToolTip': 'לחץ על מנת להסתיר סיסמה',
    'screen.LoginScreen.Settings.LanguageLabel': 'שפה',
    'screen.LoginScreen.CustomerNo': 'מספר לקוח',
    'screen.LoginScreen.Error.CustomerNoIsEmpty': 'שדה מספר הלקוח ריק',
    'screen.LoginScreen.ChatLink.visible': '#hidden#',
    'screen.LoginScreen.ChatLink.url': 'https://chat.movidesk.com/ChatWidget/Landing/7A6E5709B4C1431997F4F6B3CB10619E',
    'screen.LoginScreen.ChatLink.label': "צ'אט חי",
    'screen.LoginScreen.LoginError': 'שגיאת התחברות',
    'screen.recconection.attemptLabelLabel': 'ניסיונות:',
    'screen.recconection.reconnecting': 'מתחבר מחדש...',
    'screen.recconection.seconds': 'שניות...',
    'screen.recconection.statusLabelLabel': 'סטטוס:',
    'screen.recconection.stop': 'סטופ',
    'screen.recconection.title': 'מנהל התחברות מחדש',
    'screen.recconection.tryNow': 'נסה עכשיו',
    'screen.recconection.waiting': 'ממתין',
    'screen.RecoveryPassForm.Cancel': 'בטל מנוי',
    'screen.RecoveryPassForm.Confirm': 'אשר את הסיסמה',
    'screen.RecoveryPassForm.Email': 'דוא"ל:',
    'screen.RecoveryPassForm.HaveCode': 'כבר יש לי מפתח',
    'screen.RecoveryPassForm.Key': 'מפתח',
    'screen.RecoveryPassForm.Login': 'שם משתמש:',
    'screen.RecoveryPassForm.New password': 'סיסמה חדשה',
    'screen.RecoveryPassForm.New password contains prohibited symbols': 'הסיסמה החדשה מכילה תווים אסורים',
    'screen.RecoveryPassForm.Send': 'שחזר',
    'screen.RecoveryPassForm.Title': 'שחזור סיסמה',
    'screen.RecoveryPassForm.invalid_login': 'שם משתמש לא חוקי לשחזור הסיסמה שלך',
    'screen.RecoveryPassForm.invalid_login_or_email': 'שם משתמש או דוא"ל לא חוקיים לשחזור הסיסמה שלך',
    'screen.RecoveryPassForm.invalid_email': 'הדוא"ל לא תקין למשתמש הזה',
    'screen.RecoveryPassForm.Your request for password recovering has sent successfully. Please check your email!': 'בקשתך לשחזור סיסמה נשלחה בהצלחה. בדוק את הדוא"ל שלך!',
    'screen.registrationWizard.confirmPassword': '*אשר סיסמה:',
    'screen.registrationWizard.confirmPassword.watermark': '<אשר את הסיסמה שלך>',
    'screen.registrationWizard.email': '*דוא"ל:',
    'screen.registrationWizard.email.watermark': '<דוא"ל>',
    'screen.registrationWizard.Country': 'מדינה:',
    'screen.registrationWizard.Password': '*סיסמה:',
    'screen.registrationWizard.Balance': 'יתרה:',
    'screen.registrationWizard.firstName': '*שם פרטי:',
    'screen.registrationWizard.firstName.watermark': '<מינימום 2 תווים>',
    'screen.registrationWizard.lastName': '*שם משפחה:',
    'screen.registrationWizard.lastName.watermark': '<מינימום 2 תווים>',
    'screen.registrationWizard.login': 'שם משתמש:',
    'screen.registrationWizard.login.watermark': '<השאר ריק לצורך יצירה אוטומטית>',
    'screen.registrationWizard.password.watermark': '<הזן את הסיסמה שלך>',
    'screen.registrationWizard.phone': 'מספר טלפון:',
    'screen.registrationWizard.phoneNumber.watermark': '<(קידומת מדינה) מספר טלפון>',
    'screen.registrationWizard.registrationStatus': 'סטטוס הרשמה',
    'screen.registrationWizard.successMessage': 'ההרשמה הצליחה!\nשם משתמש: {1}\nסיסמה: {2}',
    'screen.registrationWizard.Header': 'צור חשבון דמו',
    'screen.registrationWizard.Register': 'הרשם',
    'screen.registrationWizard.Cancel': 'בטל מנוי',
    'screen.renameScreen.cancel': 'בטל מנוי',
    'screen.renameScreen.illegalName': 'שם לא חוקי!',
    'screen.renameScreen.ok': 'אוקיי',
    'screen.renameScreen.newList.header': 'שם הרשימה',
    'screen.renameScreen.newList.placeholder': 'רשימה חדשה',
    'screen.renameScreen.newTemplate.header': 'שם התבנית',
    'screen.renameScreen.newTemplate.placeholder': 'תבנית חדשה',
    'screen.renameScreen.rename.header': 'שינוי שם',
    'screen.rename.alreadyExist.firstPart': 'שם',
    'screen.rename.alreadyExist.secondPart': ' כבר קיים.',
    'screen.remove.lastlist': 'צריכה להיות רשימה אחת לפחות',
    'screen.remove.title': 'הסר',
    'screen.remove.confirmText.firstPart': 'הסר',
    'screen.remove.confirmText.secondPart': ' רשימה?',
    'screen.remove.confirmText.secondPart.templates': ' תבנית?',
    'screen.ReportMessageTooltip.CreatedAt': 'נוצר ב',
    'screen.ReportMessageTooltip.FilledAt': 'מומש ב',
    'screen.ReportMessageTooltip.MarginCall': 'קריאת בטוחות',
    'screen.ReportMessageTooltip.Market': 'מרקט',
    'screen.ReportMessageTooltip.ModifiedAt': 'שונה ב',
    'screen.ReportMessageTooltip.RemovedAt': 'הוסר ב',
    'screen.reports.actions_print': 'הדפס',
    'screen.reports.address': 'כתובת',
    'screen.reports.beginDatePicker.ButtonDropDown.ToolTip': 'לחץ כדי לפתוח לוח שנה',
    'screen.reports.beginDatePicker.ToolTip': 'בחר תאריך/שעה',
    'screen.reports.brokerzip': 'מיקוד',
    'screen.reports.button_printer_setup': 'הגדרה',
    'screen.reports.byGroup': 'לפי קבוצה',
    'screen.reports.byInstrumentGroup': 'לפי קבוצה',
    'screen.reports.byInstruments': 'לפי מכשירים',
    'screen.reports.byUser': 'לפי חשבון',
    'screen.reports.byUserGroup': 'לפי קבוצה',
    'screen.reports.cell_data': '',
    'screen.reports.column.inner_text': '',
    'screen.reports.columns_maneger': 'מנהל עמודות...',
    'screen.reports.country': 'ארץ',
    'screen.reports.csv': 'ייצא ל-CSV...',
    'screen.reports.customerzip': 'עיר, מיקוד',
    'screen.reports.dataCoverage': 'כיסוי נתונים',
    'screen.reports.errSaving': 'אירעה שגיאה במהלך שמירת הקובץ.',
    'screen.reports.excel': 'ייצא לאקסל...',
    'screen.reports.exportToButton': 'ייצא ל...',
    'screen.reports.filter': 'מנהל מסננים...',
    'screen.reports.historyFor': 'היסטוריה עבור',
    'screen.reports.html': 'ייצא ל-HTML...',
    'screen.reports.info': 'מידע',
    'screen.reports.error': 'שגיאה',
    'screen.reports.Reports': 'דוחות',
    'screen.reports.InstrumentAndGroupLookup.byGroupCombobox.ToolTip': 'בחר קבוצת סמלים',
    'screen.reports.InstrumentAndGroupLookup.instrunentLookup.ToolTip': 'בחר סמל',
    'screen.reports.license': 'מספר רישיון',
    'screen.reports.listViewEx.itemAll': 'All',
    'screen.reports.manager': 'מנהל',
    'screen.reports.minimizeButton.Hide reports parameters': 'הסתר את הפרמטרים של הדוח',
    'screen.reports.minimizeButton.Show reports parameters': 'הצג את הפרמטרים של הדוח',
    'screen.reports.name': 'שם',
    'screen.reports.news.daily': 'יומי',
    'screen.reports.news.from': 'מ:',
    'screen.reports.news.hideACriterias': 'הסתר קריטריונים מתקדמים',
    'screen.reports.news.invalidDateTime': "אנא בחר תאריך/שעה 'מ-' ו'עד' חוקיים",
    'screen.reports.news.monthToDate': 'החודש עד היום',
    'screen.reports.news.range': 'טווח',
    'screen.reports.news.showACriterias': 'הצג קריטריונים מתקדמים',
    'screen.reports.news.sinceInception': 'מאז ההקמה',
    'screen.reports.news.till': 'עד',
    'screen.reports.news.yearToDate': 'השנה עד היום',
    'screen.reports.noData': 'אין נתונים זמינים',
    'screen.reports.order': 'הוראה',
    'screen.reports.param.Name': 'שם',
    'screen.reports.paramOfReport': 'הפרמטרים של הדוח',
    'screen.reports.pdf': 'ייצא ל-PDF...',
    'screen.reports.phone': 'מספר טלפון',
    'screen.reports.pos': 'פוזיציה',
    'screen.reports.president': 'שם הנשיא',
    'screen.reports.print': 'הדפס...',
    'screen.reports.processingRequset': 'בטל מנוי',
    'screen.reports.rangeError': 'תאריך "מ-" לא יכול להיות מאוחר מתאריך "עד"!',
    'screen.reports.report.button_printer_setup': 'הגדרה',
    'screen.reports.reportHeader.accnumber': 'מספר חשבון',
    'screen.reports.reportHeader.from': 'מ:',
    'screen.reports.reportHeader.Text': 'מידע על הלקוח והברוקר',
    'screen.reports.reportHeaders.account': 'חשבון:',
    'screen.reports.reportHeaders.currancy': 'מטבע:',
    'screen.reports.reportHeaders.date': 'תאריך:',
    'screen.reports.reportHeaders.from': 'מאת:',
    'screen.reports.reportHeaders.owner': 'בעלים:',
    'screen.reports.reportHeaders.to': 'אל:',
    'screen.reports.reportHeaderText': 'מידע על הלקוח והברוקר',
    'screen.reports.reportParameters': 'פרמטרים של דוח',
    'screen.reports.reports.Canceled': 'הפעולה בוטלה',
    'screen.reports.reports.ExpingToCSV': 'מייצא נתונים למסמך CSV...',
    'screen.reports.reports.ExpingToExcel': 'מייצא נתונים למסמך Excel...',
    'screen.reports.reports.ExpingToHTML': 'מייצא נתונים למסמך HTML...',
    'screen.reports.reports.ExpingToPDF': 'מייצא נתונים למסמך PDF...',
    'screen.reports.reports.ExportingPrint': 'מייצא נתונים להדפסה...',
    'screen.reports.reports.ExpPrint': 'הנתונים יוצאו להדפסה בהצלחה.',
    'screen.reports.reports.ExpPrintErr': 'אירעה שגיאה במהלך ייצוא להדפסה!',
    'screen.reports.reports.ExpToCSV': 'הנתונים יוצאו ל-CSV בהצלחה.',
    'screen.reports.reports.ExpToCSVErr': 'אירעה שגיאה במהלך ייצוא ל-CSV!',
    'screen.reports.reports.ExpToExcel': 'הנתונים יוצאו לאקסל בהצלחה.',
    'screen.reports.reports.ExpToExcelErr': 'אירעה שגיאה במהלך ייצוא לאקסל!',
    'screen.reports.reports.ExpToHTML': 'הנתונים יוצאו למסמך HTML בהצלחה.',
    'screen.reports.reports.ExpToHTMLErr': 'אירעה שגיאה במהלך ייצוא למסמך HTML!',
    'screen.reports.reports.ExpToPDF': 'הנתונים יוצאו למסמך PDF בהצלחה.',
    'screen.reports.reports.ExpToPDFErr': 'אירעה שגיאה במהלך ייצוא למסמך PDF!',
    'screen.reports.reports.getReport': 'קבל דוח',
    'screen.reports.reports.in_separate_window': 'הדוח נפתח בחלון נפרד',
    'screen.reports.reports.inCurrentWindow': 'בחלון הנוכחי',
    'screen.reports.reports.info': 'השתמש במנהל הדוחות כדי להציג ולהדפיס דוחות של פעילות בחשבון',
    'screen.reports.reports.inSeparateWindow': 'בחלון נפרד',
    'screen.reports.reports.loading': 'טוען נתונים לדוח...',
    'screen.reports.reports.noData': 'מצטערים, אין נתונים זמינים לבקשה זו. נסה להשתמש בפרמטרים אחרים לדוח.',
    'screen.reports.reports.noItemAvailable': 'אין פריטים זמינים',
    'screen.reports.reportType': 'סוג דוח',
    'screen.reports.reportTypeCombobox.ToolTip': 'בחר סוג דוח',
    'screen.reports.save': 'שמור',
    'screen.reports.showSummary': 'הצג סיכום',
    'screen.reports.sinceInception': 'מאז ההקמה',
    'screen.reports.summary': 'סיכום',
    'screen.reports.table': 'טבלה',
    'screen.reports.title': 'מנהל דוחות',
    'screen.reports.to': 'אל',
    'screen.reports.trades': 'עסקאות',
    'screen.reports.UserAndGroupLookup.byGroupCombobox.ToolTip': 'בחר קבוצת חשבונות',
    'screen.reports.UserAndGroupLookup.usersLookup.ToolTip': 'בחר חשבון',
    'screen.snapshot.header': 'תמונת מצב',
    'screen.snapshot.lastLabel': 'סגירה קודמת',
    'screen.snapshot.bidLabel': 'ביקוש',
    'screen.snapshot.askLabel': 'היצע',
    'screen.snapshot.priceLabel': 'מחיר:',
    'screen.snapshot.sizeLabel': 'גודל:',
    'screen.snapshot.changeLabel': 'שינוי:',
    'screen.snapshot.highLabel': 'הכי גבוה היום:',
    'screen.snapshot.lowLabel': 'הכי נמוך היום:',
    'screen.snapshot.changePercentLabel': 'שינוי, %:',
    'screen.snapshot.volumeLabel': 'נפח היום:',
    'screen.snapshot.getSnapshotBtnText': 'קבל תמונת מצב',
    'screen.snapshot.getSnapshotBtnText.minusOne.tt': 'רענן צילום מצב',
    'screen.snapshot.getSnapshotBtnText.Zero.tt': 'הגעת למגבלת הבקשות לתמונת מצב',
    'screen.snapshot.getSnapshotBtnText.moreZero.tt': 'קבל צילום מצב נתונים בזמן אמת',
    'screen.snapshot.closeBtnText': 'סגירה',
    'screen.PanelSettingsScreen.applyButton': 'החל',
    'screen.TimeZoneSelector.title': 'בחר אזורי זמן',
    'screen.tradingTools.header': 'כלי מסחר',
    'screen.UnlockTradingScreen.lockedLabel': 'המסחר נעול',
    'screen.UnlockTradingScreen.unlockButton': 'בטל נעילה',
    'screen.withdrawal.account': 'מחשבון',
    'screen.withdrawal.Asset': 'נכס',
    'screen.withdrawal.Availible funds': 'זמין:',
    'screen.withdrawal.avaliableNumeric.ToolTip': 'הגדר הון שנותר',
    'screen.withdrawal.Cancel': 'בטל מנוי',
    'screen.withdrawal.error.not_allowed': 'פעולת משיכה אינה אפשרית עבור המשתמש שלך, אנא צור קשר עם הברוקר שלך',
    'screen.withdrawal.error.not_enough_balance': 'אין מספיק יתרה',
    'screen.withdrawal.error.not_enough_blocked': 'סכום לא חוקי (לא ניתן לבטל חסימה של יותר ממה שחסום)',
    'screen.withdrawal.error.not_enough_margin': 'אין מספיק בטוחות',
    'screen.withdrawal.error.UnableToBlock': 'שגיאה! לא ניתן לבטל את החסימה.',
    'screen.withdrawal.error.WrongSum': 'שגיאה: סכום שגוי.',
    'screen.withdrawal.errorLabel': 'אין מספיק כסף למשיכה',
    'screen.withdrawal.Fee': 'עמלת משיכה:',
    'screen.withdrawal.from': 'מ:',
    'screen.withdrawal.Remains': 'יתרה',
    'screen.withdrawal.RequiredAmount': 'סכום נדרש:',
    'screen.withdrawal.ReservedWithdrawal': 'משיכה',
    'screen.withdrawal.usersLookup.ToolTip': 'בחר חשבון',
    'screen.withdrawal.Withdraw': 'משיכה',
    'screen.withdrawal.Withdrawal': 'משיכה',
    'screen.withdrawal.withdrawalNumeric.ToolTip': 'הגדר סכום למשיכה',
    'screen.withdrawal.Amount': 'כמות',
    'Simple Moving Average': 'ממוצע נע פשוט',
    SixMonth: '6 חודשים',
    'Smoothed Moving Average': 'ממוצע נע מוחלק',
    'Standard Deviation': 'סטיית תקן',
    'statusBar.passwordpanel.DetalTicket.Text': 'גישה מותרת לפעילות מסחר',
    'statusBar.passwordPanel.passwordBox.invalidPass': 'סיסמת המסחר אינה תקינה.',
    Stochastic: 'סטוכסטי',
    'Stochastic Slow': 'סטוכסטי איטי',
    Stop: 'סטופ',
    'Stop Limit': 'סטופ-לימיט',
    'Stop-loss': 'סטופ-לוס',
    Suomi: '#hidden#',
    'Swing Index': 'אינדקס סווינג',
    'Take-profit': 'מימוש רווח',
    'TerceraAccountLookup.AccountNotExist': 'חשבון לא קיים',
    'TerceraAccountLookup.IncorrectAccount': 'חשבון שגוי',
    'TerceraAccountLookup.Linked accounts': 'חשבונות מקושרים',
    'TerceraAccountLookup.Multy select': 'בחירה מרובה',
    'TerceraAccountLookup.Select': 'בחר הכל',
    'TerceraAccountLookup.Select All': 'בחר הכל',
    'TerceraInstrumentLookup.InstrTypeImg.tt': 'לחץ לפתיחת חלונית פרטי הסמל',
    'TerceraInstrumentLookup.DelayedIco.tt': 'מעוכב למשך {0} דקות',
    'TerceraInstrumentLookup.DelayedIco.NotPluralDelay.tt': 'מעוכב למשך {0} דקות',
    'textBoxWithValidating.ErrorText.NameContainsInvalidChar': 'השם מכיל תווים לא תקינים',
    'textBoxWithValidating.ErrorText.NameExist': 'השם הזה כבר קיים',
    ThreeMonth: '3 חודשים',
    'Tr. stop': 'סטופ נגרר',
    'tr. stop': 'סטופ-לוס נגרר',
    'TradeDefaultManager.Set defaults': 'הגדר ברירות מחדל',
    'TradeDefaultManager.Types manager': 'מנהל סוגים',
    'TradeTool.Amount of order': 'כמות ההוראה',
    'TradeTool.Cancel order': 'בטל הוראה',
    'TradeTool.ChangeToMarket': 'שנה את סוג ההוראה למרקט',
    'TradeTool.Cancel SL': 'ביטול סטופ-לוס',
    'TradeTool.Cancel TP': 'ביטול מימוש רווח',
    'TradeTool.Close position': 'סגור פוזיציה',
    'TradeTool.Drag to set SL order': 'גרור כדי להגדיר הוראת סטופ-לוס',
    'TradeTool.Drag to set TP order': 'גרור כדי להגדיר הוראת מימוש רווח',
    'TradeTool.Leverage': 'מינוף',
    'TradeTool.Order': 'הוראה',
    'TradeTool.Position': 'פוזיציה',
    'TradeTool.Position P/L': 'רווח/הפסד ברוטו',
    'TradeTool.Tick and P/L': 'טיקים ורווח/הפסד',
    'TradeTool.Trailing Stop': 'סטופ נגרר',
    'TradeTool.View more actions': 'הצג פעולות נוספות',
    'Trade order limit reached': 'הגעת למספר ההוראות המרבי ליום.',
    TTO: 'TTO',
    'TypesManagerScreen.DefaultLotsSetup': 'הגדרת לוטים ברירת מחדל',
    'TypesManagerScreen.NumericLabel.Price increment (arrow), ticks': 'תוספת מחיר (חץ), טיקים',
    'TypesManagerScreen.NumericLabel.SL default offset, ticks': 'ברירת מחדל להזחת סטופ-לוס, טיקים',
    'TypesManagerScreen.NumericLabel.TP default offset, ticks': 'ברירת מחדל להזחת מימוש רווח, טיקים',
    'TypesManagerScreen.NumericLabel.SL default offset, percent': 'ברירת מחדל להזחת סטופ-לוס, %',
    'TypesManagerScreen.NumericLabel.TP default offset, percent': 'ברירת מחדל להזחת מימוש רווח, %',
    'TypesManagerScreen.NumericLabel.User quantity coefficient': 'מקדם כמות של המשתמש',
    'TypesManagerScreen.QuickTable.Column.Default lots': 'לוטים ברירת מחדל',
    'TypesManagerScreen.QuickTable.Column.Enable': 'אפשר',
    'TypesManagerScreen.Types Manager': 'קביעת ברירות מחדל',
    'UserControl.TerceraNumeric.ValueGreaterMax': 'הערך גדול מהמקסימום',
    'UserControl.TerceraNumeric.ValueIsEmpty': 'הערך ריק',
    'UserControl.TerceraNumeric.ValueLessMin': 'הערך נמוך מהמינימום',
    'UserControl.TerceraNumeric.ValueNotMultiple': 'הערך אינו כפולה של השינוי המינימלי',
    'UserControl.TerceraNumeric.ValueNotNumber': 'הערך אינו מספר',
    'UserControl.TerceraDQNumeric.ValueLessMin': 'הערך לא יכולה להיות פחות מ-',
    'UserControl.TerceraDQNumeric.ValueGreaterMax': 'הערך לא יכולה להיות גדול מ-',
    'UserControl.TerceraSLTPNumeric.ValueIsEmpty': 'ערך סטופ-לוס/מימוש רווח שגוי',
    'UserControl.TerceraSLTPNumeric.ChartOffsetWarning': 'שים לב שהערך נמצא כהפרש ממחיר ההוראה',
    Volume: 'נפח',
    'Volume Weighted Average Price': 'מחיר ממוצע משוקלל לפי נפח',
    VWAP: 'VWAP',
    'VWAP.DaysNumber': 'מספר ימים במחזור',
    'VWAP.StartEndDayTime': 'זמן התחלה/סיום יום',
    allowCreatePanelsFromPanel: '',
    allowLinkSystem: '',
    allowWorkspaceContextMenu: '',
    allowWorkspaceEdit: '',
    'orders.confirm.all.question1': 'לבטל את כל (',
    'orders.confirm.all.question2': ') ההוראות?',
    'orders.confirm.all.title': 'בטל את כל ההוראות',
    'orders.confirm.cancel.question1': 'לבטל את כל ההוראות בסימול שנבחר?',
    'positions.confirm.mutual.question1': 'האם אתה רוצה לסגור הדדית (',
    'positions.confirm.mutual.question2': ') פוזיציות?',
    'Rows.firstPart': 'מגבלת הסמלים/שורות ב-',
    'Rows.secondPart': 'הושגה. פנה לצוות התמיכה שלך למידע מפורט.',
    'general.messageBox.cancel.ToolTip': 'בטל שינויים וסגור',
    'property.Confirmations.ToolTip': 'הגדרות אישור',
    'general.messageBox.ok.ToolTip': 'החל שינויים וסגור',
    'property.Defaults.ToolTip': 'הגדרות ברירת המחדל למסחר',
    'property.Description': 'תיאור',
    'property.View.ToolTip': 'הצג את ההגדרות',
    'property.Warnings.ToolTip': 'הגדרות אזהרה',
    'Throtling.Count.firstPart': 'מגבלת הזמינות של',
    'Throtling.Count.secondPart': 'חלוניות הושגה. פנה לצוות התמיכה שלך למידע מפורט.',
    'workspace.At first you should unlock workspace to rename it': 'כדי לשנות את שם סביבת העבודה תחילה יש לבטל את הנעילה שלה.',
    'workspace.Clear': 'נקה',
    'workspace.clear_ask': 'לנקות את מרחב העבודה?',
    'workspace.clear_wsp': 'ניקוי מרחב העבודה',
    'workspace.Close': 'סגירה',
    'workspace.close_wsp': 'סגירת מרחב העבודה',
    'workspace.DefaultNameSpace': 'Wrk#',
    'workspace.errorSavingFile': 'אירעה שגיאה במהלך שמירת הקובץ.',
    'workspace.information': 'מידע',
    'workspace.saved.Message': 'סביבת העבודה נשמרה',
    'workspace.Lock': 'נעל',
    'workspace.Lock.Message': 'סביבת העבודה נעולה',
    'workspace.menu.Clone': 'שכפל',
    'workspace.menu.Close': 'סגירה',
    'workspace.menu.CloseAllButThis': 'סגור את כל השאר',
    'workspace.menu.Lock': 'נעל',
    'workspace.menu.Reset': '#hidden#',
    'workspace.menu.Reset.tt': 'שנה את סביבת העבודה להגדרות ברירת המחדל',
    'workspace.newWorkspaceName': 'הזן שם חדש לסביבת העבודה',
    'workspace.numberOfWorkspace': 'מספר סביבות העבודה הפתוחות חורג מהמקסימום המותר',
    'workspace.Rename': 'שינוי שם',
    'workspace.Unlock': 'בטל נעילה',
    'workspace.Unlock.Message': 'סביבת העבודה שוחררה מנעילה',
    'InstrumentDetailsPanel.ISIN': 'מספר ISIN',
    'InstrumentDetailsPanel.Industry': 'תעשייה',
    'InstrumentDetailsPanel.Industry.descr': 'תעשייה',
    'InstrumentDetailsPanel.Sector': 'מגזר',
    'InstrumentDetailsPanel.Sector.descr': 'מגזר',
    'InstrumentDetailsPanel.AccruedInterest.descr': 'ריבית צבורה נוכחית מחושבת ללוט 1',
    'InstrumentDetailsPanel.AddLiqudityRebatePerLot.descr': 'אומר שעבור כל לוט בעסקה שבוצעה, ערך ההחזר הקבוע ייגבה/יוחזר (במטבע התוכנית)',
    'InstrumentDetailsPanel.AddLiqudityRebateOrderPerLot.descr': 'אומר שעבור כל לוט בעסקה שבוצעה, ערך ההחזר הקבוע ייגבה/יוחזר (במטבע התוכנית)',
    'InstrumentDetailsPanel.AddLiqudityRebatePerVolume.descr': 'אומר שהסכום שייגבה/יוחזר יחושב כאחוז מנפח המסחר',
    'InstrumentDetailsPanel.AllowedOperations.descr': 'מציג פעולות מותרות לסמל נתון',
    'InstrumentDetailsPanel.AllowedOrderTypes.descr': 'מציג סוגי הוראות מותרות לסמל נתון',
    'InstrumentDetailsPanel.AllowShortPositions.Intraday': 'תוך יומי מאפשרים פוזיציות שורט',
    'InstrumentDetailsPanel.AllowShortPositions.Delivery': 'משלוח מאפשר פוזיציות שורט',
    'InstrumentDetailsPanel.AllowShortPositions.descr': 'מציג אם מותר או לא לפתוח פוזיציות קצרות לפי הסמל הנתון',
    'InstrumentDetailsPanel.AllowShortPositions.Intraday.descr': 'מציג אם מותר או לא לפתוח פוזיציות קצרות לפי הסמל הנתון',
    'InstrumentDetailsPanel.AllowShortPositions.Delivery.descr': 'מציג אם מותר או לא לפתוח פוזיציות קצרות לפי הסמל הנתון',
    'InstrumentDetailsPanel.AssetClass.descr': 'סוג הסמל הנסחר בשוק',
    'InstrumentDetailsPanel.BondDaysPerMonth': 'ימים בחודש',
    'InstrumentDetailsPanel.BondDaysPerMonth.descr': 'מספר הימים בחודש המשמש לחישובי ריבית',
    'InstrumentDetailsPanel.BondDaysPerYear': 'ימים בשנה',
    'InstrumentDetailsPanel.BondDaysPerYear.descr': 'מספר הימים בשנה המשמש לחישובי ריבית',
    'InstrumentDetailsPanel.CloseOutDeadline.descr': 'תאריך שבו הפוזיציות ייסגרו לפי כל חוזה ספציפי',
    'InstrumentDetailsPanel.ContactMonth.descr': 'תאריך פקיעת החוזה. זמין עבור אופציות וחוזים עתידיים.',
    'InstrumentDetailsPanel.ContractSize.descr': 'כמות הנכס הבסיסי לחוזה(לוט) אחד',
    'InstrumentDetailsPanel.CurrentSession.descr': 'מידע על סשן המסחר הנוכחי',
    'InstrumentDetailsPanel.DeliveryMethod.descr': 'אופן משלוח הנכס',
    'InstrumentDetailsPanel.DeliveryStatus.descr': 'סטטוס משלוח הנכס',
    'InstrumentDetailsPanel.Description.descr': 'מידע מפורט על הסמל',
    'InstrumentDetailsPanel.ExerciseStyle': 'סגנון מימוש',
    'InstrumentDetailsPanel.ExerciseStyle.descr': 'סגנון מימוש אופציה',
    'InstrumentDetailsPanel.FirstTradeDate.descr': 'התאריך הראשון שבו ניתן לסחור בחוזה. זמין עבור אופציות וחוזים עתידיים.',
    'InstrumentDetailsPanel.HiLimit.descr': 'הגבול העליון של טווח המחיר המותר שמעליו הוראות מושהות אינן מתקבלות',
    'InstrumentDetailsPanel.ISIN.descr': 'מספר זיהוי ניירות ערך בינלאומי',
    'InstrumentDetailsPanel.KEYNextHoliday.descr': 'מציג את תאריך החג הבא שבו המסחר אינו מותר',
    'InstrumentDetailsPanel.LastTradeDate.descr': 'התאריך האחרון שבו ניתן לסחור בחוזה. זמין עבור אופציות, חוזים עתידיים וחוזי פורוורד.',
    'InstrumentDetailsPanel.Leverage': 'מינוף',
    'InstrumentDetailsPanel.Leverage.Intraday': 'מינוף תוך יומי',
    'InstrumentDetailsPanel.Leverage.Delivery': 'מינוף משלוח',
    'InstrumentDetailsPanel.LotSize.descr': 'כמות הנכס הבסיסי לחוזה(לוט)',
    'InstrumentDetailsPanel.LotStep.descr': 'שינוי צעד לוט',
    'InstrumentDetailsPanel.LowLimit.descr': 'הגבול התחתון של טווח המחיר המותר שמעליו הוראות מושהות אינן מתקבלות',
    'InstrumentDetailsPanel.MAIN.descr': 'מידע על הגדרות לסשן ראשי',
    'InstrumentDetailsPanel.Margin.descr': 'מציג דרישת בטוחות התלויות בסוג חישוב הבטוחות',
    'InstrumentDetailsPanel.Margin_ByAccount.descr': 'מציג דרישות בטוחות על פי מקדמי החשבון',
    'InstrumentDetailsPanel.MarginBuy.descr': 'מציג דרישות בטוחות עבור פוזיציות לונג המשתמשות בסכומי בטוחות שונים ללונג/שורט ללא תלות בבטוחות להחזקה למשך הלילה',
    'InstrumentDetailsPanel.MarginDay.descr': 'מציג דרישת בטוחות יומית שאינה תלויה בלונג/שורט',
    'InstrumentDetailsPanel.MarginDayBuy.descr': 'מציג מקדמים יומיים של דרישת בטוחות התחלתית ומתעדכנת עבור פוזיציית לונג',
    'InstrumentDetailsPanel.MarginDaySell.descr': 'מציג מקדמים למשך היום של דרישת בטוחות התחלתית ומתעדכנת עבור פוזיציית שורט',
    'InstrumentDetailsPanel.MarginOvernight.descr': 'מציג דרישת בטוחות למשך הלילה שלא תלויה בלונג/שורט',
    'InstrumentDetailsPanel.MarginOvernightBuy.descr': 'מציג את המקדמים של דרישת בטוחות התחלתית ומתעדכנת עבור העברת פוזיציית לונג למשך הלילה',
    'InstrumentDetailsPanel.MarginOvernightSell.descr': 'מציג את המקדמים של דרישת בטוחות התחלתית ומתעדכנת עבור העברת פוזיציית שורט למשך הלילה',
    'InstrumentDetailsPanel.MarginSell.descr': 'מציג דרישות בטוחות עבור פוזיציות שורט המשתמשות בסכומי בטוחות שונים ללונג/שורט ללא תלות בבטוחות להחזקה למשך הלילה',
    'InstrumentDetailsPanel.Margin.Intraday.descr': 'מציג דרישת בטוחות התלויות בסוג חישוב הבטוחות',
    'InstrumentDetailsPanel.Margin.Delivery': 'דרישת בטוחות למשלוח',
    'InstrumentDetailsPanel.Margin.Intraday': 'דרישת בטוחות יומית',
    'InstrumentDetailsPanel.MarginBuy.Intraday.descr': 'מציג דרישות בטוחות עבור פוזיציות לונג המשתמשות בסכומי בטוחות שונים ללונג/שורט ללא תלות בבטוחות להחזקה למשך הלילה',
    'InstrumentDetailsPanel.MarginDay.Intraday.descr': 'מציג דרישות בטוחות למשך היום שאינן תלויות בבטוחות לונג/שורט',
    'InstrumentDetailsPanel.MarginDayBuy.Intraday.descr': 'מציג מקדמים למשך היום של דרישת בטוחות התחלתית ומתעדכנת עבור פוזיציית לונג',
    'InstrumentDetailsPanel.MarginDaySell.Intraday.descr': 'מציג מקדמים למשך היום של דרישת בטוחות התחלתית ומתעדכנת עבור פוזיציית שורט',
    'InstrumentDetailsPanel.MarginOvernight.Intraday.descr': 'מציג דרישת בטוחות למשך הלילה שלא תלויה בלונג/שורט',
    'InstrumentDetailsPanel.MarginOvernightBuy.Intraday.descr': 'מציג את המקדמים של דרישת בטוחות התחלתית ומתעדכנת עבור העברת פוזיציית לונג למשך הלילה',
    'InstrumentDetailsPanel.MarginOvernightSell.Intraday.descr': 'מציג את המקדמים של דרישת בטוחות התחלתית ומתעדכנת עבור העברת פוזיציית שורט למשך הלילה',
    'InstrumentDetailsPanel.MarginSell.Intraday.descr': 'מציג דרישות בטוחות עבור פוזיציות שורט המשתמשות בסכומי בטוחות שונים ללונג/שורט ללא תלות בבטוחות להחזקה למשך הלילה',
    'InstrumentDetailsPanel.Margin.Delivery.descr': 'מציג דרישת בטוחות התלויות בסוג חישוב הבטוחות',
    'InstrumentDetailsPanel.MarginBuy.Delivery.descr': 'מציג דרישות בטוחות עבור פוזיציות לונג המשתמשות בסכומי בטוחות שונים ללונג/שורט ללא תלות בבטוחות להחזקה למשך הלילה',
    'InstrumentDetailsPanel.MarginDay.Delivery.descr': 'מציג דרישות בטוחות למשך היום שאינן תלויות בבטוחות לונג/שורט',
    'InstrumentDetailsPanel.MarginDayBuy.Delivery.descr': 'מציג מקדמים למשך היום של דרישת בטוחות התחלתית ומתעדכנת עבור פוזיציית לונג',
    'InstrumentDetailsPanel.MarginDaySell.Delivery.descr': 'מציג מקדמים למשך היום של דרישת בטוחות התחלתית ומתעדכנת עבור פוזיציית שורט',
    'InstrumentDetailsPanel.MarginOvernight.Delivery.descr': 'מציג דרישת בטוחות למשך הלילה שלא תלויה בלונג/שורט',
    'InstrumentDetailsPanel.MarginOvernightBuy.Delivery.descr': 'מציג את המקדמים של דרישת בטוחות התחלתית ומתעדכנת עבור העברת פוזיציית לונג למשך הלילה',
    'InstrumentDetailsPanel.MarginOvernightSell.Delivery.descr': 'מציג את המקדמים של דרישת בטוחות התחלתית ומתעדכנת עבור העברת פוזיציית שורט למשך הלילה',
    'InstrumentDetailsPanel.MarginSell.Delivery.descr': 'מציג דרישות בטוחות עבור פוזיציות שורט המשתמשות בסכומי בטוחות שונים ללונג/שורט ללא תלות בבטוחות להחזקה למשך הלילה',
    'InstrumentDetailsPanel.MaturityDate.descr': 'תאריך פקיעת החוזה',
    'InstrumentDetailsPanel.MaximumLot.descr': 'העסקה המותרת הגדולה ביותר בלוטים',
    'InstrumentDetailsPanel.MaximumLot.Intraday': 'לוט מקסימלי תוך יומי',
    'InstrumentDetailsPanel.MaximumLot.Intraday.descr': 'העסקה המותרת הגדולה ביותר בלוטים',
    'InstrumentDetailsPanel.MaximumLot.Delivery': 'לוט מקסימלי למשלוח',
    'InstrumentDetailsPanel.MaximumLot.Delivery.descr': 'העסקה המותרת הגדולה ביותר בלוטים',
    'InstrumentDetailsPanel.MaxPositionQtyPerSymbol.descr': 'סכום מקסימלי של כל הפוזיציות במכשיר בלוטים',
    'InstrumentDetailsPanel.MaxPositionQtyPerSymbol.Intraday.descr': 'סכום מקסימלי של כל הפוזיציות במכשיר בלוטים',
    'InstrumentDetailsPanel.MaxPositionQtyPerSymbol.Delivery.descr': 'סכום מקסימלי של כל הפוזיציות במכשיר בלוטים',
    'InstrumentDetailsPanel.MinimalLot.descr': 'החלק הקטן ביותר של חוזה(לוטים) שבו המסחר זמין',
    'InstrumentDetailsPanel.MinimalLot.Intraday': 'חוזה(לוט) מינימלי במהלך היום',
    'InstrumentDetailsPanel.MinimalLot.Intraday.descr': 'החלק הקטן ביותר של חוזה(לוטים) שבו המסחר זמין',
    'InstrumentDetailsPanel.MinimalLot.Delivery': 'חוזה(לוט) מינימלי למשלוח',
    'InstrumentDetailsPanel.MinimalLot.Delivery.descr': 'החלק הקטן ביותר של חוזה(לוטים) שבו המסחר זמין',
    'InstrumentDetailsPanel.NextPaymentDate.descr': 'תאריך תשלום התשואה הבא',
    'InstrumentDetailsPanel.NormalMarketSize.descr': 'גודל שוק רגיל',
    'InstrumentDetailsPanel.NoticeDate.descr': 'התאריך שבו תישלח ההודעה על תאריך הפקיעה המוקדם ביותר. זמין עבור חוזים עתידיים.',
    'InstrumentDetailsPanel.OrderPerLot.descr': 'עמלה ששולמה עבור כל חוזה(לוט) שנסחר',
    'InstrumentDetailsPanel.PerPhoneTransaction.descr': 'העמלה ששולמה עבור כל טרנזקציה שנעשתה על ידי דילר בטלפון',
    'InstrumentDetailsPanel.PerTransaction.descr': 'עמלה עבור כל טרנזקציה. טרנזקציות: הצבת הוראה, ביטול הוראה ושינוי הוראה',
    'InstrumentDetailsPanel.PerVolume.descr': 'עמלה המחושבת על בסיס הנפח של כל עסקה, %',
    'InstrumentDetailsPanel.POSTCLOSE.descr': 'מידע על הגדרות במסחר אפטר',
    'InstrumentDetailsPanel.PREOPEN.descr': 'מידע על הגדרות סשן טרום פתיחת השוק',
    'InstrumentDetailsPanel.PreviousPaymentDate.descr': 'תאריך תשלום תשואה קודם',
    'InstrumentDetailsPanel.QuotiongCurrency.descr': 'מידע על מטבע שבו מחושב הציטוט',
    'InstrumentDetailsPanel.RemoveLiqudityRebatePerLot.descr': 'אומר שעבור כל לוט בעסקה שבוצעה, ערך ההחזר הקבוע ייגבה/יוחזר (במטבע התוכנית)',
    'InstrumentDetailsPanel.RemoveLiqudityRebateOrderPerLot.descr': 'אומר שעבור כל לוט בעסקה שבוצעה, ערך ההחזר הקבוע ייגבה/יוחזר (במטבע התוכנית)',
    'InstrumentDetailsPanel.RemoveLiqudityRebatePerVolume.descr': 'אומר שהסכום שייגבה/יוחזר יחושב כאחוז מנפח המסחר',
    'InstrumentDetailsPanel.SessionStatus.descr': 'סטטוס הסשן, ערכים זמינים: פתוח, סגור',
    'InstrumentDetailsPanel.SettlementDate.descr': 'תאריך שבו חייב להתבצע משלוח',
    'InstrumentDetailsPanel.StrikePrice.descr': 'רמת מחיר של נכס הבסיס שלפיה יבוצע חוזה האופציה',
    'InstrumentDetailsPanel.SwapBuy.descr': 'מציג את ערך Swap שהוחל על פוזיציות לונג למשך הלילה של הסמל',
    'InstrumentDetailsPanel.SwapSell.descr': 'מציג את ערך SWAP שחל על פוזיציות שורט לילה של הסמל',
    'InstrumentDetailsPanel.Symbol.descr': 'שם הסמל שנבחר בחיפוש',
    'InstrumentDetailsPanel.TickCoast.descr': 'כמות הנכס הבסיסי לטיק אחד',
    'InstrumentDetailsPanel.TickSize.descr': 'שינוי מינימלי של המחיר',
    'InstrumentDetailsPanel.TradingBalance.descr': 'מחזור סליקה T + x',
    'InstrumentDetailsPanel.TradindBlockedOnSession.descr': 'מציג אם המסחר חסום לסשן הנוכחי',
    'InstrumentDetailsPanel.TradingStatus.descr': 'סטטוס המסחר, ערכים זמינים: פתוח, סגור, השהיית מסחר',
    'InstrumentDetailsPanel.Underlier.descr': 'שם הנכס שיימסר. זמין עבור אופציות וחוזים עתידיים.',
    'InstrumentDetailsPanel.VAT.descr': 'מע"מ ששולם מכל עמלת פעולה',
    'InstrumentDetailsPanel.Volume.descr': 'העמלה מחושבת על בסיס נפח כל עסקה',
    'InstrumentDetailsPanel.Yield.descr': 'ערך התשואה הנוכחי',
    'InstrumentDetailsPanel.ExchangeTrading': 'בורסת מסחר',
    'InstrumentDetailsPanel.ExchangeMarketData': 'בורסת נתוני שוק',
    'InstrumentDetailsPanel.CustodialFee': 'משמורת',
    'InstrumentDetailsPanel.CustodialFee.descr': 'עמלות משמורת',
    'panel.accounts.AccountValue.descr': 'ערך כולל של החשבון',
    'panel.accounts.Asset.descr': 'שם נכס',
    'panel.accounts.AvailableMargin.descr': 'כספים זמינים עבור חשבון זה',
    'panel.accounts.Balance.descr': 'יתרת חשבון',
    'panel.accounts.BalancePlusAllRisks.descr': 'יתרת ​​כל הסיכונים',
    'panel.accounts.BeginBalance.descr': 'רווח/הפסד נקי להיום',
    'panel.accounts.BlockedByOrders.descr': 'בטוחות דרושות חסומות להוראות',
    'panel.accounts.BlockedByPamm.descr': 'הון התחלתי שהושקע עבור קרנות',
    'panel.accounts.CashBalance.descr': 'יתרת מזומנים',
    'panel.accounts.CopyTrading': 'העתק את המסחר',
    'panel.accounts.ClientType.descr': 'בעל החשבון התחבר לאחרונה מ- (.Net, Java, Mobile, Html)',
    'panel.accounts.CreditValue.descr': 'כספי אשראי זמינים למסחר',
    'panel.accounts.CurBalance.descr': 'הון עצמי נוכחי (יתרה + רווח/הפסד לא ממומש)',
    'panel.accounts.CurMargin.descr': 'דרישת בטוחות התחלתית ביחס ליתרה + כל הסיכונים',
    'panel.accounts.CurrentFundCapital.descr': 'הון קרן נוכחי שהושקע עבור קרנות',
    'panel.accounts.Email.descr': 'כתובת דוא"ל',
    'panel.accounts.EODTrailingDrawdownLevel.descr': 'מציין את שווי היתרה החזויה המינימלית המותרת (מחושב בסוף כל יום) שיכולה להיות בחשבון',
    'panel.accounts.RelativeDailyLossLimit.descr': 'מציין את ההפסדים המרביים המותרים',
    'panel.accounts.Estimate value.descr': 'ערך מחושב מנכסים אחרים',
    'panel.accounts.FundCapitalGain.descr': 'הפרש בין הון קרן נוכחי להתחלתי',
    'panel.accounts.FundsUsedPercent.descr': 'כספים בשימוש ביחס ליתרה וכל הסיכונים',
    'panel.accounts.InterestRate.descr': 'שיעור ריבית שנתי על הפקדה',
    'panel.accounts.Leverage.descr': 'מינוף בטוחות התחלתי של חשבון',
    'panel.accounts.LockedBalance.descr': 'יתרה נעולה למשיכה נוספת',
    'panel.accounts.LockedBy.descr': 'נעול על ידי ברוקר (בקשה להצעת מחיר עבור סוחרים)',
    'panel.accounts.Login.descr': 'שם חשבון',
    'panel.accounts.MaintMargin.descr': 'דרישת בטוחות מתעדכנות ביחס ליתרת כל הסיכונים',
    'panel.accounts.MarginAvailableReal.descr': 'בטוחות זמינות לחשבון',
    'panel.accounts.MarginRequirement.descr': 'דרישת בטוחות מתעדכנות לכל הפוזיציות הפתוחות',
    'panel.accounts.MarginStopOut.descr': 'בטוחות מתעדכנות שחסומות עבור פוזיציות ופקודות',
    'panel.accounts.MarginStopTrade.descr': 'חשבון שנמנע מסחר אם היתרה נמוכה מרמה זו',
    'panel.accounts.MarginUsedNew.descr': 'בטוחות התחלתיות לפויזציות והוראות',
    'panel.accounts.MarginWarning.descr': 'הודעת בטוחות מתקבלת כאשר המאזן פחות מהרמה הזו',
    'panel.accounts.marginWarnPercent.descr': 'רמת אזהרת בטוחות,%',
    'panel.accounts.MaxDailyLossLimit.descr': 'ערך מקסימלי של הפסד נטו יומי לחשבון',
    'panel.accounts.MaxDailyProfit.descr': 'ערך מקסימלי של רווח נטו יומי לחשבון',
    'panel.accounts.MaxDrawdownLevel.descr': 'מציין את שווי היתרה החזויה המינימלית המותרת שיכולה להיות בחשבון',
    'panel.accounts.MaximumLot.descr': 'כמות מרבית בהוראה אחת',
    'InstrumentDetailsPanel.Account.descr': 'שם החשבון',
    'panel.accounts.MaxOrderAmount.descr': 'סכום מרבי בהוראה',
    'panel.accounts.MaxOrderCapital.descr': 'הון מירבי בהוראה',
    'panel.accounts.MaxOrdersPerDay.descr': 'מספר ההוראות שהמשתמש יכול להציב במהלך יום',
    'panel.accounts.MaxPendingOrders.descr': 'מספר מרבי של הוראות בהמתנה',
    'panel.accounts.MaxPendingOrdersValue.descr': 'השווי המרבי המצטבר של ההוראות בהמתנה הזמין למשתמש',
    'panel.accounts.MaxPositionQtyPerSymbol.descr': 'כמות מרבית בפוזיציה יחידה בסימול',
    'panel.accounts.MaxPositions.descr': 'מספר מרבי של פוזיציות',
    'panel.accounts.MaxWeekLostLimit.descr': 'השווי המרבי של ההפסד השבועי נטו בחשבון',
    'panel.accounts.MinMargin.descr': 'בטוחות חסומות לפוזיציות',
    'panel.accounts.GrossPNL.descr': 'רווח/הפסד ברוטו להיום',
    'panel.accounts.OptionPremiumReq.descr': 'פרמיית אופציות להוראות קנייה',
    'panel.accounts.OptionValue.descr': 'ערך אופציה נוכחי בתיק',
    'panel.accounts.Orders.descr': 'מספר הוראות',
    'panel.accounts.Owner.descr': 'בעלים של החשבון',
    'panel.accounts.Positions.descr': 'מספר פוזיציות',
    'panel.accounts.Profit.descr': 'רווח/הפסד בכל הפוזיציות הפתוחות',
    'panel.accounts.ProfitNet.descr': 'רווח/הפסד נטו בכל הפוזיציות הפתוחות',
    'panel.accounts.Role.descr': 'סוג קרן',
    'panel.accounts.Status.descr': 'סטטוס משתמש של בעל החשבון (מקוון, לא מקוון)',
    'panel.accounts.Collateral.descr': 'שווי בטוחות נוכחי לפוזיציות שורט',
    'panel.accounts.StocksOrdersReq.descr': 'דרישת הוראות למניות',
    'panel.accounts.StocksValue.descr': 'שווי נוכחי של המניות בתיק ההשקעות',
    'panel.accounts.stopOutPercent.descr': '% דרישת בטוחות מתעדכנות בסטופ-אאוט',
    'panel.accounts.stopTradingPercent.descr': 'רמת הפסקת מסחר, %',
    'panel.accounts.TodayFees.descr': 'סכום העמלות ששולמו על ידי החשבון',
    'panel.accounts.TodayRebates.descr': 'סכום כל הכספים שהתקבלו/שולמו על ידי הברוקר ליצירת/הסרת נזילות ביום הנוכחי',
    'panel.accounts.TodayTrades.descr': 'ספירת העסקאות של היום',
    'panel.accounts.TodayTurnover.descr': 'מחזור הכספים ליום עבור החשבון הנוכחי',
    'panel.accounts.TodayVolume.descr': 'נפח מסחר של היום',
    'panel.accounts.TotalMaxPositionsQty.descr': 'כמות מקסימלית של סכום כל העמדות ביחידות',
    'panel.accounts.TrailingDrawdownLevel.descr': 'רמה מרבית של ירידה בחשבון',
    'panel.accounts.UnsettledCash.descr': 'רווח/הפסד, אשר יזוכה בחשבון בהתאם למחזור הערך T+n',
    'panel.accounts.UserGroup.descr': 'קבוצת משתמשים',
    'panel.accounts.UserID.descr': 'מזהה של משתמש',
    'panel.accounts.UserLogin.descr': 'כניסה של משתמש',
    'panel.accounts.WithdrawalAvailable.descr': 'יתרה מקסימלית זמינה למשיכה',
    'panel.accounts.CurrentDailyLoss.descr': 'ערך נוכחי של הגבלת הפסד נטו יומית בחשבון',
    'panel.accounts.CurrentWeeklyLoss.descr': 'ערך מגבלת הפסד שבועי נקי נוכחי עבור חשבון',
    'panel.accounts.UnrealizedLoss.descr': 'שווי נוכחי של הפסד לא ממומש בחשבון',
    'panel.accounts.UnrealizedLossLimit.descr': 'ערך מקסימלי של הפסד לא ממומש לחשבון',
    'panel.accounts.VolumeLimit.All.descr': 'סה"כ הנפח המרבי של כל הפוזיציות וההוראות בחשבון. הערך נקבע בלוטים/חוזים, בסכום (מספר לוטים*גודל לוט או מספר לוטים*עלות טיק/גודל טיק), או בחשיפה לכסף',
    'panel.accounts.VolumeLimit.descr': 'סה"כ הנפח המרבי של כל הפוזיציות וההוראות לפי סוג מכשיר בחשבון. הערך נקבע בלוטים/חוזים, בסכום (מספר לוטים*גודל לוט או מספר לוטים*עלות טיק/גודל טיק), או בחשיפה לכסף',
    'panel.accounts.LossLimitPerTrade': 'מגבלת הפסד לעסקה',
    'panel.accounts.LossLimitPerTrade.descr': 'מציין רמת ההפסד המקסימלית לעסקה בודדת',
    'panel.accountDetails.ATIVA.ativa_intraday_total': 'סה"כ Saldo',
    'panel.accountDetails.ATIVA.ativa_intraday_disponivel': 'Saldo disponivel',
    'panel.accountDetails.ATIVA.ativa_intraday_d0': 'D+0',
    'panel.accountDetails.ATIVA.ativa_intraday_d1': 'D+1',
    'panel.accountDetails.ATIVA.ativa_intraday_d2': 'D+2',
    'panel.accountDetails.Kyrrex risks.AvailableBalance.descr': 'יתרת מאזן זמינה',
    'panel.accountDetails.Kyrrex risks.BlockedBalance.descr': 'יתרה חסומה',
    'panel.accountDetails.Groups.Cedro risks': 'פרטי חשבון',
    'panel.accountDetails.Cedro risks.AVBA': 'היתרה הזמינה',
    'panel.accountDetails.Cedro risks.DAY_1_CREDITS': 'D1',
    'panel.accountDetails.Cedro risks.DAY_2_CREDITS': 'D2',
    'panel.accountDetails.Cedro risks.PRBA': 'יתרה חזויה',
    'panel.accountDetails.Cedro risks.TOTL': 'סך הכל',
    'panel.accountDetails.Cedro risks.LMAL': 'מגבלה כוללת (מסחר יומי)',
    'panel.accountDetails.Cedro risks.LMDI': 'יתרה כוללת (מסחר יומי)',
    'panel.accountDetails.Cedro risks.SLDTL': 'יתרה כוללת (עמדה)',
    'panel.accountDetails.Cedro risks.UNQL': 'מגבלת כוללת (עמדה)',
    'Order.OrderStatus.STATUS_UNKNOWN': 'לא ידוע',
    'Order.OrderStatus.STATUS_PENDING_NEW': 'חדש בהמתנה',
    'Order.OrderStatus.STATUS_NEW': 'נוצר',
    'Order.OrderStatus.STATUS_ACCEPTED': 'התקבל',
    'Order.OrderStatus.STATUS_PENDING_EXECUTION': 'ביצוע בהמתנה',
    'Order.OrderStatus.STATUS_REPLACED': 'נערך',
    'Order.OrderStatus.STATUS_PENDING_CANCEL': 'ביטול בהמתנה',
    'Order.OrderStatus.STATUS_PART_FILLED': 'הוזן חלקית',
    'Order.OrderStatus.STATUS_FILLED': 'מומש',
    'Order.OrderStatus.STATUS_PENDING_REPLACE': 'שינוי בהמתנה',
    'Order.OrderStatus.STATUS_WAITING_MARKET': 'ממתין לשוק',
    'Order.OrderStatus.STATUS_WAITING_CANCELLATION': 'בהמתנה לביטול',
    'Order.OrderStatus.STATUS_OFF_MARKET': 'מחוץ לשוק',
    'Order.OrderStatus.STATUS_UNPLACED': 'לא הוצב',
    'pageNavigation.nextButton': 'קדימה',
    'pageNavigation.backButton': 'חזרה',
    'pageNavigation.doneButton': 'סיים',
    'onBoarding.workspaceControlArea.header': 'אזור בקרת מרחב עבודה',
    'onBoarding.workspaceControlArea.description': 'מרחב העבודה מורכב מחלונות ומחלוניות, התצורות שלהם ומיקומם על המסך. כל שינוי במרחב עבודה נשמר באופן אוטומטי.',
    'onBoarding.workspaceLock.header': 'נעילת מרחב עבודה',
    'onBoarding.addWorkspace.header': 'הוספת מרחב עבודה',
    'onBoarding.workspaceLock.description': 'ניתן לנעול את מרחב העבודה ולבטל את הנעילה שלך על ידי לחיצה על סימן המנעול. אם מרחב העבודה נעול, אי אפשר לסגור חלונות קיימים או להוסיף חלונות חדשים.',
    'onBoarding.addWorkspace.description': 'ניתן ליצור מרחב עבודה חדש על ידי לחיצה על "+".',
    'onBoarding.linkWindowsByColor.header': 'קישור חלונות באמצעות צבע',
    'onBoarding.linkWindowsByColor.description': 'ניתן להחליף את הסימולים באופן אוטומטי בכל החלונות על ידי החלפתם במקום אחד בלבד. כדי לעשות זאת יש ללחוץ על סמל הקישור ולבחור צבע תואם בכל החלונות הרלוונטיים.',
    'onBoarding.mouseTrading.header': 'מסחר עכבר',
    'onBoarding.mouseTrading.description3': "אפשר לבצע הוראות מסחר ישירות על הגרף. ניתן להפעיל 'מסחר עכבר' בפינה השמאלית העליונה של התרשים.",
    'onBoarding.mouseTrading.description1': "אפשר להגדיר גם את הכמות וגם את תוקף ההוראה דרך הווידג'ט שקופץ לאחר הפעלת התכונה.",
    'onBoarding.mouseTrading.description2': 'משתמשים בגרירה ושחרור כדי לשנות הוראות ופוזיציות, להוסיף סטופ-לוס או מימוש רווח, או לשנות את הכמות.',
    'onBoarding.marginRisk.header': 'סיכון בטוחות',
    'onBoarding.marginRisk.description1': "לפני הצבת ההוראה, כדאי לעיין במידע נוסף על הסיכונים על ידי הרחבת חלונית 'הזנת הוראה'.",
    'onBoarding.marginRisk.description2': 'כפתורים להצגה/הסתרה של הפאנל.',
    'onBoarding.windowsDocking.header': 'עגינת חלונות',
    'onBoarding.windowsDocking.description': 'ניתן להזיז כל חלון במרחב העבודה ולעגון אותו עם חלונות אחרים. פשוט גוררים את החלון למקום שבו רוצים לעגון אותו, עד שמופיעים לחצנים כחולים עם חיצים.',
    'onBoarding.instrumentInfo.header': 'מידע על הנכס',
    'onBoarding.instrumentInfo.description': 'ניתן למצוא מידע נוסף על כל מכשיר על ידי לחיצה על סמל סוג המכשיר',
    'onBoarding.accountDetailsWidget.header': 'שורת נתוני חשבון',
    'onBoarding.accountDetailsWidget.description': "גרור ושחרר כל שדה מהרשימה כדי להתאים אישית את המידע המוצג בווידג'ט.",
    'onBoarding.help.header': 'עזרה',
    'onBoarding.generalSettings.header': 'הגדרות כלליות',
    'onBoarding.help.description': 'למדריך המשתמש המלא, לחץ על כפתור העזרה.',
    'onBoarding.generalSettings.description': 'כאן אפשר לערוך הגדרות כלליות, מקשים חמים, ברירות מחדל למסחר ועוד.',
    'IndicatorGroup.Moving Average': 'ממוצע נע',
    MD: 'MD',
    REGRESSION: 'רגרסיה',
    Regression: 'רגרסיה',
    SMMA: 'SMMA',
    PPMA: 'PPMA',
    SMA: 'SMA',
    EMA: 'EMA',
    'IndicatorGroup.Oscillators': 'אוסילטורים',
    MACD: 'MACD',
    BB: 'BB',
    BBF: 'BBF',
    'IndicatorGroup.Volume': 'נפח',
    RSI: 'RSI',
    PO: 'PO',
    CCI: 'CCI',
    Aroon: 'אינדיקטור - ארון',
    KRI: 'KRI',
    'Kairi Relative Index': 'מדד יחסי של קאירי',
    PPO: 'PPO',
    'Percentage Price Oscillator': 'מתנד אחוז מחיר',
    RLW: 'RLW',
    '%R Larry Williams': '‎%R לארי וויליאמס',
    ROC: 'ROC',
    'Rate of Change': 'שיעור השינוי',
    QStick: 'QStick',
    TSI: 'TSI',
    'True Strength Index': 'מדד עוצמה אמיתית',
    SI: 'SI',
    ALLIGATOR: 'אליגטור',
    MMA: 'MMA',
    'IndicatorGroup.Trend': 'מגמה',
    STOCHASTIC: 'סטוכסטי',
    OBV: 'OBV',
    'IndicatorGroup.Volatility': 'תנודתיות',
    ATR: 'ATR',
    CMO: 'CMO',
    SD: 'SD',
    SAR: 'SAR',
    ADX: 'ADX',
    'IndicatorGroup.Channels': 'ערוצים',
    KELTNER: 'KELTNER',
    CHANNEL: 'CHANNEL',
    MAE: 'MAE',
    LWMA: 'LWMA',
    MAS3: 'MAS3',
    'IndicatorGroup.Extra': 'אקסטרה',
    Didi: '#hidden#',
    HiloEscandina: '#hidden#',
    StopATR: '#hidden#',
    Fractals3: 'Fractals3',
    Fractals5: 'Fractals5',
    'IndicatorGroup.Custom': 'מותאם אישית',
    'SUPER TREND': '#hidden#',
    'SUPER TREND.ShortName': 'SuperTrend',
    'SUPER TREND.FullName': 'מגמת על',
    'EMA CROSS': '#hidden#',
    'EMA CROSS.ShortName': 'EMACross',
    'EMA CROSS.FullName': 'חציית ממוצע נע משוקלל',
    'MULTIMOV AVG': '#hidden#',
    'MULTIMOV AVG.ShortName': 'MultiMovAvg',
    'MULTIMOV AVG.FullName': 'ממוצעים נעים במספר מסגרות זמן',
    'SUPERTREND MTV3': '#hidden#',
    'SUPERTREND MTV3.ShortName': 'SuperTrendMTv3',
    'SUPERTREND MTV3.FullName': 'מגמות על במספר מסגרות זמן',
    'Kaufman adaptive moving average': 'ממוצע נע מסתגל של קאופמן',
    'Multi EMA': 'Multi EMA',
    'Self-Adjusting Alpha with Fractals Energy': 'RSI אלפא בהסתגלות עצמית עם אנרגיית פרקטלים',
    'disconnectMessageBox.Header': 'חיבור',
    'disconnectMessageBox.Text': 'החיבור יופסק בעוד {0} שניות עקב חוסר פעילות. לחץ על "התנתקות" כדי להפסיק את החיבור עכשיו, או על "ביטול" כדי להישאר מחובר.',
    'disconnectMessageBox.logoutButton': 'התנתק',
    'disconnectMessageBox.cancelButton': 'בטל מנוי',
    'disconnectMessageBox.logoutButton.descr': 'אם תלחץ, החיבור ינותק עכשיו עקב חוסר פעילות.',
    'disconnectMessageBox.cancelButton.descr': 'אם תלחץ, החיבור לא ינותק עקב חוסר פעילות.',
    'Max. concurrent connections': 'מקסימום חיבורים במקביל',
    'Max. concurrent connections reason': 'הגעת למגבלה המקסימלית של חיבורים במקביל',
    ChangeValidityToTIF: '#hidden#',
    'Resources.Property.Opening market orders are forbidden': 'הוראת מרקט לפתיחה אסורה',
    'Session has expired. Please login.': 'הסשן שלך פקע. התחבר מחדש.',
    'The total limit of alerts has been reached.': 'הגעת למגבלת סך ההתראות.',
    'Alert cannot be created due to wrong node.': 'לא ניתן לקבל את ההתראה. אנא צור קשר עם צוות התמיכה.',
    'potrfolio.management.headerLabel.MyPortfolio': 'תיק ההשקעות שלי',
    'potrfolio.metrics.textMetrics': 'מדדים',
    'potrfolio.metrics.textMetricsTitle': 'צמיחת תיק השקעות',
    'potrfolio.metrics.addpanel.header': 'הוסף מדדים',
    'potrfolio.metrics.addpanel.buttonText': 'הוסף',
    'alert.event.header.created': 'נוצר',
    'alert.event.text.created': 'התראה {0} {1} נוצרה',
    'alert.event.header.modified': 'נערך',
    'alert.event.text.modified': 'התראה {0} {1} שונתה',
    'alert.event.header.stopped': 'הופעל סטופ',
    'alert.event.text.stopped': 'התראה {0} {1} הופסקה',
    'alert.event.header.executed': 'בוצע',
    'alert.event.text.executed': 'התראה {0} {1} בוצעה',
    'alert.event.header.expired': 'פג תוקף',
    'alert.event.text.expired': 'התראה {0} {1} פקעה',
    'alert.event.header.deleted': 'נמחק',
    'alert.event.text.deleted': 'התראה {0} {1} נמחקה',
    'alert.event.header.restarted': 'הופעל מחדש',
    'alert.event.text.restarted': 'התראה {0} {1} הופעלה מחדש',
    'alert.specifyOrder.Error': 'יש לציין פרמטרים של הוראה כדי ליצור התראה עם פעולה = הצבת הוראה',
    'alert.specifyAlertType.Error': 'עבור מכשירים מסוג מט"ח, לא ייתכן "סוג התראה = נפח". יש לציין פרמטר אחר.',
    'alert.specifyExpirationTime.Error': 'תאריך פקיעה קודם לזמן הנוכחי',
    'alert.specifyAlertPanelBtn.Error': 'הגעת למספר ההתראות המרבי למשתמש.',
    'screen.products.Products': 'מנויים',
    'screen.products.Categories': 'מנויים',
    'screen.products.Categories.NoData': 'אין מנויים',
    'screen.products.toolbar.filterCB.All': 'All',
    'screen.products.toolbar.filterCB.Subscribed': 'מנוי',
    'screen.products.toolbar.filterCB.AvailableForSubscription': 'זמין למנוי',
    'screen.products.toolbar.filterCB.Processing': 'מעבד',
    'screen.products.SubscribeRequestConfirmScreen.header': 'מנוי',
    'screen.products.SubscribeRequestConfirmScreen.text': "אתה מגיש בקשה למנוי.\nאם נדרש אימות מסמכים, עיבוד הבקשה עשוי לקחת זמן מה.\nניתן לבדוק את המצב הנוכחי של הבקשה דרך הכרטיסייה 'בקשות'.\nאם הבקשה תעובד בהצלחה, הלחצן בכרטיס ישתנה ל'מנוי'.",
    'screen.products.SubscribeRequestConfirmScreen.OkBtnText': 'אישור',
    'screen.products.Request': 'בקשה',
    'screen.products.Request.ToolTip': 'מכיל תוצאות בקשות הרשמה וביטול',
    'screen.products.ButtonSubscribe': 'לעשות מנוי',
    'screen.products.ButtonSubscribed': 'נרשמת',
    'screen.products.CancelSubscribeRequestButton.text': 'בטל בקשה',
    'screen.products.CancelSubscribeRequestButton.tt': 'הבקשה <date/time> <requestType> <productName> בשלבי עיבוד.\nלחץ על הלחצן כדי לבטל את הבקשה.',
    'screen.products.ButtonUnsubscribe': 'ביטול המנוי',
    'screen.documets.Header': 'חתום על מסמכים',
    'screen.documets.Button.ToolTip': 'חסרים שדות נדרשים',
    'screen.products.ButtonUnsubscribe.Click': 'לאחר שהבקשה תטופל המנוי יבוטל באופן מיידי, ללא המתנה לתום התקופה בגינה נגבה תשלום.',
    'panel.product.ProductName': 'מנוי',
    'panel.product.ProductType': 'סוג בקשה',
    'panel.product.ProductStatus': 'סטטוס בקשה',
    'panel.product.ProductStatus.Value.None': 'ללא',
    'panel.product.ProductStatus.Value.Processing': 'מעבד',
    'panel.product.ProductStatus.Value.Approved': 'אושר',
    'panel.product.ProductStatus.Value.Rejected': 'נדחה',
    'panel.product.ProductStatus.Value.Canceled': 'בוטל',
    'panel.product.Comment': 'הערה',
    'panel.product.DateTime': 'תאריך/שעה',
    'panel.product.Cancel': 'בטל מנוי',
    'panel.Products.Request.CancelRequest': 'בטל בקשה',
    'panel.Products.Request.CancelRequest.Message': 'האם אתה רוצה לבטל את הבקשה:\n<date/time> <requestType> <productName>?',
    'Product is no longer relevant for use': 'המוצר לא רלוונטי יותר לשימוש',
    'panel.Products.Unsubscribe.PopupMessage': "אתה מגיש בקשה לבטל את המנוי.\nעיבוד הבקשה עשוי לקחת זמן מה. בזמן העיבוד, המנוי נשאר בתוקף ותוכל ליהנות מהיתרונות שלו.\nניתן לבדוק את המצב הנוכחי של הבקשה דרך הכרטיסייה 'בקשות'.\nהאם אתה רוצה להמשיך?",
    'AdditionalProperty.Unsubscribe': 'ביטול המנוי',
    'Bid/Ask prices are not available for the instrument.': 'מחירי קנייה/מכירה אינם זמינים עבור המכשיר.',
    'RangeControl.StartDaySlide.Tooltip': 'שעת תחילת יום',
    'RangeControl.EndDaySlide.Tooltip': 'שעת סיום יום',
    'AccountDetailesPanel.quickTable.Name': 'שם',
    'AccountDetailesPanel.quickTable.Value': 'ערך',
    'corporateActionType.BonusIssue': 'מניות בונוס',
    'corporateActionType.StockDividends': 'דיבידנדים בגין מניה',
    'corporateActionType.CashDividends': 'דיבידנדים במזומן',
    'corporateActionType.RightsIssue': 'הנפקת זכויות',
    'corporateActionType.SpinOff': 'ספין אוף',
    'InstrumentDetailsPanel.OrderPerLot': 'הוראה ללוט (חוזה)',
    'InstrumentDetailsPanel.OrderPerLotBUY.descr': 'עמלה ששולמה עבור כל חוזה(לוט) שנסחר (קנייה)',
    'InstrumentDetailsPanel.OrderPerLotBUY': 'הוראה לחוזה (לוט) (סגירה)',
    'InstrumentDetailsPanel.OrderPerLotCLOSE.descr': 'העמלה מחושבת על בסיס נפח כל עסקה (סגירה)',
    'InstrumentDetailsPanel.OrderPerLotCLOSE': 'הוראה לחוזה (לוט) (סגירה)',
    'InstrumentDetailsPanel.OrderPerLotCLOSEBUY.descr': 'עמלה ששולמה עבור כל חוזה(לוט) שנסחר (סגירת קנייה)',
    'InstrumentDetailsPanel.OrderPerLotCLOSEBUY': 'הוראה לחוזה (לוט) (סגירת קנייה)',
    'InstrumentDetailsPanel.OrderPerLotCLOSESELL.descr': 'עמלה ששולמה עבור כל חוזה(לוט) שנסחר (סגירת מכירה)',
    'InstrumentDetailsPanel.OrderPerLotCLOSESELL': 'הוראה לחוזה (לוט) (סגירת מכירה)',
    'InstrumentDetailsPanel.OrderPerLotOPEN.descr': 'העמלה מחושבת על בסיס נפח כל עסקה (פתיחה)',
    'InstrumentDetailsPanel.OrderPerLotOPEN': 'הוראה לחוזה (לוט) (פתיחה)',
    'InstrumentDetailsPanel.OrderPerLotOPENBUY.descr': 'עמלה ששולמה עבור כל חוזה(לוט) שנסחר (פתיחת קנייה)',
    'InstrumentDetailsPanel.OrderPerLotOPENBUY': 'הוראה לחוזה (לוט) פתיחת קנייה',
    'InstrumentDetailsPanel.OrderPerLotOPENSELL.descr': 'עמלה ששולמה עבור כל חוזה (לוט) שנסחר (פתיחת מכירה)',
    'InstrumentDetailsPanel.OrderPerLotOPENSELL': 'הוראה לחוזה (לוט) (פתיחת מכירה)',
    'InstrumentDetailsPanel.OrderPerLotOPENSHORT.descr': 'עמלה ששולמה עבור כל חוזה(לוט) שנסחר (פתיחה קצרה)',
    'InstrumentDetailsPanel.OrderPerLotOPENSHORT': 'הוראה לחוזה (לוט) (פתיחה קצרה)',
    'InstrumentDetailsPanel.OrderPerLotSELL.descr': 'עמלה ששולמה עבור כל חוזה (לוט) שנסחר (מכירה)',
    'InstrumentDetailsPanel.OrderPerLotSELL': 'הוראה לחוזה (לוט) (לונג)',
    'InstrumentDetailsPanel.OrderPerLotSHORT': 'הוראה לחוזה (לוט) (שורט)',
    'InstrumentDetailsPanel.OrderVolume.descr': 'עמלה ששולמה עבור כל חלק מנפח ההוראה שמומש',
    'InstrumentDetailsPanel.OrderVolume': 'נפח הוראה',
    'InstrumentDetailsPanel.OptionExercise.descr': 'תיגבה במקרה של מימוש אופציה עבור כל לוט של פוזיציה',
    'InstrumentDetailsPanel.OptionExerciseSELL': 'עמלת מימוש אופציה (שורט)',
    'InstrumentDetailsPanel.OptionExerciseSELL.descr': 'תיגבה במקרה של מימוש אופציה עבור כל לוט של פוזיצית שורט',
    'InstrumentDetailsPanel.OptionExerciseBUY': 'עמלת מימוש אופציה (לונג)',
    'InstrumentDetailsPanel.OptionExerciseBUY.descr': 'תיגבה במקרה של מימוש אופציה עבור כל חוזה(לוט) של פוזיציה ארוכה',
    'InstrumentDetailsPanel.PerFill.descr': 'עמלה ששולמה עבור כל מימוש של הוראה',
    'InstrumentDetailsPanel.PerFill': 'לכל מילוי',
    'InstrumentDetailsPanel.PerLot.descr': 'עמלה ששולמה עבור כל חוזה(לוט) שנסחר',
    'InstrumentDetailsPanel.PerLot': 'מילוי חוזה(לוט)',
    'InstrumentDetailsPanel.PerLotBUY.descr': 'עמלה ששולמה עבור כל חוזה(לוט) שנסחר (קנייה)',
    'InstrumentDetailsPanel.PerLotBUY': 'מילוי ללוט (קניה)',
    'InstrumentDetailsPanel.PerLotCLOSE.descr': 'העמלה מחושבת על בסיס נפח כל עסקה (סגירה)',
    'InstrumentDetailsPanel.PerLotCLOSE': 'מילוי לכל חוזה(לוט) (סגירה)',
    'InstrumentDetailsPanel.PerLotCLOSEBUY.descr': 'עמלה ששולמה עבור כל חוזה(לוט) שנסחר (סגירת קנייה)',
    'InstrumentDetailsPanel.PerLotCLOSEBUY': 'מילוי לכל חוזה(לוט) (סגירת לונג)',
    'InstrumentDetailsPanel.PerLotCLOSESELL.descr': 'עמלה ששולמה עבור כל חוזה(לוט) שנסחר (סגירת מכירה)',
    'InstrumentDetailsPanel.PerLotCLOSESELL': 'מילוי לכל חוזה(לוט) (סגירת מכירה)',
    'InstrumentDetailsPanel.PerLotOPEN.descr': 'העמלה מחושבת על בסיס נפח כל עסקה (פתיחה)',
    'InstrumentDetailsPanel.PerLotOPEN': 'מילוי לחוזה(לוט) (פתיחה)',
    'InstrumentDetailsPanel.PerLotOPENBUY.descr': 'עמלה ששולמה עבור כל חוזה(לוט) שנסחר (פתיחת קנייה)',
    'InstrumentDetailsPanel.PerLotOPENBUY': 'מילוי לחוזה(לוט) (פתיחת קנייה)',
    'InstrumentDetailsPanel.PerLotOPENSELL.descr': 'עמלה ששולמה עבור כל חוזה (לוט) שנסחר (פתיחת מכירה)',
    'InstrumentDetailsPanel.PerLotOPENSELL': 'מילוי לכל חוזה (פתיחת לונג)',
    'InstrumentDetailsPanel.PerLotOPENSHORT.descr': 'עמלה ששולמה עבור כל חוזה(לוט) שנסחר (פתיחה קצרה)',
    'InstrumentDetailsPanel.PerLotOPENSHORT': 'מילוי לכל חוזה (פתיחת שורט)',
    'InstrumentDetailsPanel.PerLotSELL.descr': 'עמלה ששולמה עבור כל חוזה (לוט) שנסחר (מכירה)',
    'InstrumentDetailsPanel.PerLotSELL': 'מילוי לחוזה (לוט) (מכירה)',
    'InstrumentDetailsPanel.PerLotSHORT.descr': 'עמלה ששולמה עבור כל חוזה(לוט) שנסחר (שורט)',
    'InstrumentDetailsPanel.PerLotSHORT': 'מילוי לכל חוזה(לוט) (שורט)',
    'InstrumentDetailsPanel.PerOrderVolume.descr': 'עמלה ששולמה עבור כל חלק מנפח ההוראה שמומש',
    'InstrumentDetailsPanel.PerOrderVolumeBUY.descr': 'העמלה ששולמה עבור כל חלק מנפח ההוראה שמומש (קנייה), %',
    'InstrumentDetailsPanel.PerOrderVolumeBUY': 'נפח ההוראה',
    'InstrumentDetailsPanel.PerOrderVolumeCLOSE.descr': 'העמלה ששולמה עבור כל חלק מנפח ההוראה שמומש (סגירה), %',
    'InstrumentDetailsPanel.PerOrderVolumeCLOSE': 'נפח ההוראה',
    'InstrumentDetailsPanel.PerOrderVolumeCLOSEBUY.descr': 'העמלה ששולמה עבור כל חלק מנפח ההוראה שמומש (קנייה סגורה), %',
    'InstrumentDetailsPanel.PerOrderVolumeCLOSEBUY': 'נפח ההוראה (סגירת קנייה), %',
    'InstrumentDetailsPanel.PerOrderVolumeCLOSESELL.descr': 'העמלה ששולמה לכל חלק מנפח ההוראה שמומש (סגירת מכירה), %',
    'InstrumentDetailsPanel.PerOrderVolumeCLOSESELL': 'נפח ההוראה (סגירת מכירה), %',
    'InstrumentDetailsPanel.PerOrderVolumeOPEN.descr': 'העמלה ששולמה לכל חלק מנפח ההוראה שמומש (פתיחה), %',
    'InstrumentDetailsPanel.PerOrderVolumeOPEN': 'נפח ההוראה',
    'InstrumentDetailsPanel.PerOrderVolumeOPENBUY.descr': 'העמלה ששולמה לכל חלק מנפח ההוראה שמומש (פתיחת קנייה), %',
    'InstrumentDetailsPanel.PerOrderVolumeOPENBUY': 'נפח ההוראה (פתיחת קנייה), %',
    'InstrumentDetailsPanel.PerOrderVolumeOPENSELL.descr': 'העמלה ששולמה לכל חלק מנפח ההוראה שמומש (פתיחת מכירה), %',
    'InstrumentDetailsPanel.PerOrderVolumeOPENSELL': 'נפח ההוראה (פתיחת מכירה), %',
    'InstrumentDetailsPanel.PerOrderVolumeOPENSHORT.descr': 'העמלה ששולמה לכל חלק מנפח ההוראה שמומש (פתיחת שורט), %',
    'InstrumentDetailsPanel.PerOrderVolumeOPENSHORT': 'נפח ההוראה (פתיחת שורט), %',
    'InstrumentDetailsPanel.PerOrderVolumeSELL.descr': 'העמלה ששולמה לכל חלק מנפח ההוראה שמומש (מכירה), %',
    'InstrumentDetailsPanel.PerOrderVolumeSELL': 'נפח ההוראה',
    'InstrumentDetailsPanel.PerOrderVolumeSHORT.descr': 'העמלה ששולמה לכל חלק מנפח ההוראה שמומש (שורט), %',
    'InstrumentDetailsPanel.PerOrderVolumeSHORT': 'נפח ההוראה',
    'InstrumentDetailsPanel.PerVolumeBUY.descr': 'עמלה המחושבת על בסיס הנפח של כל עסקה (קנייה), %',
    'InstrumentDetailsPanel.PerVolumeBUY': 'נפח מילוי (קנייה), %',
    'InstrumentDetailsPanel.PerVolumeCLOSE.descr': 'עמלה המחושבת על בסיס הנפח של כל עסקה (סגירה), %',
    'InstrumentDetailsPanel.PerVolumeCLOSE': 'נפח מילוי (סגירה), %',
    'InstrumentDetailsPanel.PerVolumeCLOSEBUY.descr': 'עמלה המחושבת על בסיס הנפח של כל עסקה (סגירת קנייה), %',
    'InstrumentDetailsPanel.PerVolumeCLOSEBUY': 'נפח מילוי (סגירת קנייה), %',
    'InstrumentDetailsPanel.PerVolumeCLOSESELL.descr': 'עמלה המחושבת על בסיס הנפח של כל עסקה (סגירת מכירה), %',
    'InstrumentDetailsPanel.PerVolumeCLOSESELL': 'נפח מילוי (סגירת מכירה), %',
    'InstrumentDetailsPanel.PerVolumeOPEN.descr': 'העמלה המחושבת על בסיס הנפח של כל עסקה (פתיחה), %',
    'InstrumentDetailsPanel.PerVolumeOPEN': 'נפח מילוי (פתיחה), %',
    'InstrumentDetailsPanel.PerVolumeOPENBUY.descr': 'עמלה המחושבת על בסיס הנפח של כל עסקה (פתיחת קנייה), %',
    'InstrumentDetailsPanel.PerVolumeOPENBUY': 'נפח מילוי (פתיחת קנייה), %',
    'InstrumentDetailsPanel.PerVolumeOPENSELL.descr': 'עמלה המחושבת על בסיס הנפח של כל עסקה (פתיחת מכירה), %',
    'InstrumentDetailsPanel.PerVolumeOPENSELL': 'נפח מילוי (פתיחת מכירה), %',
    'InstrumentDetailsPanel.PerVolumeOPENSHORT.descr': 'עמלה המחושבת על בסיס הנפח של כל עסקה (פתיחת שורט), %',
    'InstrumentDetailsPanel.PerVolumeOPENSHORT': 'נפח מילוי (פתיחת שורט), %',
    'InstrumentDetailsPanel.PerVolumeSELL.descr': 'עמלה המחושבת על בסיס הנפח של כל עסקה (מכירה), %',
    'InstrumentDetailsPanel.PerVolumeSELL': 'נפח מילוי (מכירה), %',
    'InstrumentDetailsPanel.PerVolumeSHORT.descr': 'עמלה המחושבת על בסיס הנפח של כל עסקה (שורט), %',
    'InstrumentDetailsPanel.PerVolumeSHORT': 'נפח הפקודה',
    'system.ChangePassLow': 'הסיסמה החדשה צריכה לכלול לפחות {0} תווים, ולא לכלול את התו (&). נסה שוב',
    'system.ChangePassBase': 'הסיסמה החדשה צריכה לכלול לפחות {0} תווים, אות גדולה אחת, אות קטנה אחת וספרה אחת, ולא לכלול את התו (&). אפשר לנסות שוב.',
    'system.ChangePassHigh': 'הסיסמה החדשה צריכה לכלול לפחות {0} תווים, אות גדולה אחת, אות קטנה אחת, ספרה אחת ותו מיוחד אחד (כמו @#S%), ולא לכלול את התו (&). אפשר לנסות שוב.',
    'system.TooLongPass': 'הסיסמה יכולה להיות באורך של עד {0} תווים.',
    'screen.modifyOrder.modifyPosition.ModifyQuantity': 'שנה כמות',
    'screen.modifyOrder.modifyPosition.TargetProductType': 'סוג מוצר מטרה',
    'screen.MonthCalendarPopupForm.Apply': 'החל',
    'screen.modifyOrder.modifyPosition.ModifyQuantity.SlTpInfo': 'שים לב: הוראות סטופ-לוס/מימוש רווח יבוטלו לאחר שינוי סוג המוצר',
    'general.trading.qtyMoreTodayTradedValue': 'הערך לא יכול להיות גדול מכמות המסחר היומית',
    'general.trading.noPriceForMarketOrder': 'אין מחיר להוראת מרקט',
    'general.trading.noQuantityAvailable': 'אין כמות זמינה לשינוי.',
    'reports.Product type modified': 'סוג מוצר נערך',
    'screen.changepass.wrongKey': 'מפתח שחזור שגוי',
    'screen.changepass.lockedAfterBrut': 'המשתמש ננעל לאחר מתקפה גסה!',
    'screen.changepass.wrongOldOrNewPassword': 'סיסמה נוכחית שגויה',
    'screen.changepass.pwdMustBeDifferent': 'סיסמה חדשה שגויה: אינך יכול להשתמש באותה סיסמה',
    'screen.changepass.errorEmail': 'דוא"ל לא חוקי לזכירת הסיסמה שלך.',
    'screen.changepass.wrongLogin': 'שם משתמש שגוי!',
    'reports.Product type modification rejected': 'שינוי סוג מוצר נדחה',
    'InstrumentDetailsPanel.ETB': 'ETB',
    'InstrumentDetailsPanel.ETB.descr': "'קל להלוות' (ETB) פירושו שיש היצע של המניה ובדרך כלל היא תהיה זמינה לפוזיציית שורט",
    'portfolio.metrics.TapeRolling': 'גלילת קלטת',
    'portfolio.metrics.contextMenu.Customize': 'התאם אישית',
    'portfolio.metrics.CustomizeBarPanel.header': 'התאמה אישית של סרגל המדדים',
    'portfolio.metrics.CustomizeBarPanel.okBtn': 'אוקיי',
    'portfolio.metrics.CustomizeBarPanel.closeBtn': 'סגירה',
    'panel.accounts.MaxRelativeDrawDownLevel': 'רמת משיכה יחסית מקסימלית',
    'panel.accounts.MaxRelativeDrawDownLevel.descr': 'מציין את ערך היתרה המשוערת המינימלית המותרת (מחושב יחסית ליתרה הנוכחית) שהחשבון יכול להיות בו',
    'panel.accounts.accountDetails.RiskManagement.TradingStatus.Max relative drawdown level was reached': 'הגעת לרמת הירידה היחסית המקסימלית.',
    'panel.accounts.accountDetails.RiskManagement.TradingStatus.EOD trailing drawdown level was reached': 'הגעת לרמת הירידה הנגררת המקסימלית בסוף היום.',
    'panel.accounts.accountDetails.RiskManagement.TradingStatus.Relative daily loss limit was reached': 'הגעת למגבלת הפסד יחסי',
    'Not selected order type': 'סוג הוראה לא נבחר',
    'panel.AlgorithmMarketConsensusPanel': 'קונצנזוס שוק',
    'panel.AlgorithmMarketConsensusPanel.TopLong': 'לונגים מובילים',
    'panel.AlgorithmMarketConsensusPanel.TopShort': 'שורט מובילים',
    'panel.AlgorithmMarketConsensusPanel.menu.MoreOneSymbolInfoDisabled.tt': 'נבחר יותר מסימול אחד',
    'panel.AlgorithmMarketConsensusPanel.menu.NoSymbolInfoDisabled.tt': 'לא נבחרו סמלים',
    'panel.AlgorithmMarketConsensusPanel.Settings.ContextMenu': 'הגדרות...',
    'panel.AlgorithmMarketConsensusPanel.Settings.Screen': 'הגדרות קונצנזוס שוק',
    'panel.AlgorithmMarketConsensusPanel.noData': 'ממתין לנתונים...',
    'panel.GainersLosersPanel': 'סורק עולות/ יורדות',
    'panel.GainersLosersPanel.Item.Change': 'שינוי %',
    'panel.GainersLosersPanel.Item.Volume': 'נפח',
    'panel.GainersLosersPanel.Item.Last': 'סגירה קודמת',
    'panel.GainersLosersPanel.Item.Last.descr': 'מחיר מסחר אחרון',
    'panel.GainersLosersPanel.Item.ChangeGainers.descr': 'מציג את האחוז שבו התרחשה העלייה',
    'panel.GainersLosersPanel.Item.ChangeLosers.descr': 'מציג את האחוז שבו התרחשה הירידה',
    'panel.GainersLosersPanel.Item.GainersSymbols.descr': 'סמלים שמראים עלייה במחיר',
    'panel.GainersLosersPanel.Item.GainersSymbols': 'עולים',
    'panel.GainersLosersPanel.Item.LosersSymbols.descr': 'סמלים שמראים ירידה במחיר',
    'panel.GainersLosersPanel.Item.LosersSymbols': 'יורדים',
    'panel.GainersLosersPanel.Item.Symbol': 'סמל',
    'panel.GainersLosersPanel.Property.GainersColor': 'צבע סמל עולים',
    'panel.GainersLosersPanel.Property.LosersColor': 'צבע סמל יורדים',
    'panel.HeatmapPanel': 'מפת חום',
    'panel.HeatmapPanel.Settings.Header': 'מפת חום - הגדרות',
    'panel.HeatmapPanel.Settings.GradationScale': 'סולם הדרגתיות',
    'panel.HeatmapPanel.Settings.IndustryLevel': 'רמת תעשייה',
    'panel.HeatmapPanel.Settings.SectorLevel': 'רמת סקטור',
    'panel.HeatmapPanel.Settings.SymbolLevel': 'רמת סמל',
    'panel.HighLowPanel.noData': 'ממתין לנתונים...',
    'panel.HighLowPanel': 'סורק גבוה/נמוך יומי',
    'panel.HighLowPanel.menu.ClearTable': 'נקה טבלה',
    'panel.HighLowPanel.Item.Symbol': 'סמל',
    'panel.HighLowPanel.Item.Symbol.descr': 'שם הסימול',
    'panel.HighLowPanel.Item.Change': 'שינוי',
    'panel.HighLowPanel.Item.Change.descr': 'הערך מראה כמה השתנה המחיר במונחים מוחלטים',
    'panel.HighLowPanel.Item.ChangePr': 'שינוי %',
    'panel.HighLowPanel.Item.ChangePr.descr': 'הערך מציג את אחוז השינוי במחיר',
    'panel.HighLowPanel.Item.Price': 'מחיר',
    'panel.HighLowPanel.Item.Price.descr': 'המחיר שבו הייתה פריצה או נגיעה',
    'panel.HighLowPanel.Item.Time': 'זמן',
    'panel.HighLowPanel.Item.Time.descr': 'ציטוט אחרון',
    'panel.HighLowPanel.Item.Volume': 'נפח',
    'panel.HighLowPanel.Item.Volume.descr': 'נפח מסחר יומי',
    'panel.HighLowPanel.Item.Exchange': 'בורסה',
    'panel.HighLowPanel.Item.Exchange.descr': 'בורסה',
    'reports.POSITIONS_PANEL_DB_CLICK': 'DESKTOP: פאנל פוזיציות DC',
    'reports.ORDERS_PANEL_DB_CLICK': 'DESKTOP:ORDERS PANEL DC',
    'reports.CHART_VISUAL_DB_CLICK': 'Desktop:Chart Visual DC',
    'reports.PORTFOLIO_MANAGER': 'Desktop: Portfolio Manager',
    'reports.POSITIONS_PANEL_CONTEXT_MENU': 'Desktop:Positions CM',
    'reports.ORDERS_PANEL_CONTEXT_MENU': 'Desktop:Working orders CM',
    'reports.CHART_VISUAL_CONTEXT_MENU': 'Desktop:Chart Visual CM',
    'reports.WEB_CHART_VISUAL_DB_CLICK': 'WEB:Chart Visual Trading DC',
    'reports.WEB_ORDERS_PANEL_DB_CLICK': 'WEB:Orders Panel DC',
    'reports.WEB_POSITIONS_PANEL_DB_CLICK': 'WEB:Positions Panel DC',
    'reports.WEB_PORTFOLIO_MANAGER': 'WEB:Portfolio Manager',
    'reports.WEB_CHART_VISUAL_CONTEXT_MENU': 'WEB:Chart Visual Trading CM',
    'reports.WEB_ORDERS_PANEL_CONTEXT_MENU': 'WEB:Orders Panel CM',
    'reports.WEB_POSITIONS_PANEL_CONTEXT_MENU': 'WEB:Positions Panel CM',
    'reports.MOB_PORTFOLIO_MANAGER': 'MOB:Portfolio Manager',
    'reports.SERVER_OTHER': 'SERVER:Other',
    'reports.MOB_OPTIONS_PANEL': 'MOB:Options Panel',
    'property.TopLongColors': 'צבע לונגים מובילים',
    'property.TopShortColors': 'צבע שורטים מובילים',
    'chart.infoWindow.Items.Countdown': 'ספירה לאחור:',
    'chart.infoWindow.Items.Funding': 'מימון:',
    'chart.infoWindow.Items.Countdown.VisibilityByDefault': '#hidden#',
    'chart.infoWindow.Items.Funding.VisibilityByDefault': '#hidden#',
    'chart.infoWindow.Items.Bars.VisibilityByDefault': '#hidden#',
    'chart.infoWindow.Items.Date.VisibilityByDefault': '#hidden#',
    'chart.infoWindow.Items.Time.VisibilityByDefault': '#hidden#',
    'chart.infoWindow.Items.Change.VisibilityByDefault': '#hidden#',
    'chart.infoWindow.Items.HighLow.VisibilityByDefault': '#hidden#',
    'panel.watchlist.CurrentFundingRate.descr': 'אם שיעור המימון חיובי, פוזיציות לונג משלמות לפוזיציות שורט. אם שלילי, פוזיציות שורט משלמות לפוזיציות לונג.',
    'panel.watchlist.CurrentFundingRate': 'שיעור מימון נוכחי',
    'panel.watchlist.NextFundingSettlement': 'הסדר המימון הבא',
    'property.IsCountdownVisible': 'ספירה לאחור',
    'property.IsFundingVisible': 'מימון',
    'panel.detail.Countdown': '#hidden#',
    'panel.detail.Funding': '#hidden#',
    'FlagSM.Message': 'נייר הערך נמצא תחת אמצעי מעקב - {0}, וודא שברצונך להמשיך.',
    'FlagSM.Short term ASM Flag.11': 'מכשיר ASM לטווח קצר שלב 1',
    'FlagSM.Short term ASM Flag.12': 'מכשיר ASM לטווח קצר שלב 2',
    'FlagSM.Long term ASM Flag.11': 'מכשיר ASM לטווח ארוך שלב 1',
    'FlagSM.Long term ASM Flag.12': 'מכשיר ASM לטווח ארוך שלב 2',
    'FlagSM.Long term ASM Flag.13': 'מכשיר ASM לטווח ארוך שלב 3',
    'FlagSM.Long term ASM Flag.14': 'מכשיר ASM לטווח ארוך שלב 4',
    'FlagSM.ESM Flag.11': 'מכשיר ESM שלב 1',
    'FlagSM.ESM Flag.12': 'מכשיר ESM שלב 2',
    'FlagSM.GSM Flag.10': 'מכשירים ב-GSM',
    'FlagSM.GSM Flag.11': 'מכשיר GSM שלב 1',
    'FlagSM.GSM Flag.12': 'מכשיר GSM שלב 2',
    'FlagSM.GSM Flag.13': 'מכשיר GSM שלב 3',
    'FlagSM.GSM Flag.14': 'מכשיר GSM שלב 4',
    'FlagSM.GSM Flag.16': "מכשיר GSM שלב 1 לפי הודעה מס' 20170807-31",
    'FlagSM.GSM Flag.299': 'ברשימה תחת GSM',
    'FlagSM.GSM Flag.21': 'GSM שלב 1',
    'FlagSM.GSM Flag.22': 'GSM שלב 2',
    'FlagSM.GSM Flag.23': 'GSM שלב 3',
    'FlagSM.GSM Flag.24': 'GSM שלב 4',
    'FlagSM.GSM Flag.25': 'GSM שלב 5',
    'FlagSM.GSM Flag.26': 'GSM שלב 6',
    'FlagSM.GSM Flag.211': 'STASM שלב 1',
    'FlagSM.GSM Flag.212': 'STASM שלב 2',
    'FlagSM.GSM Flag.213': 'LTASM שלב 1',
    'FlagSM.GSM Flag.214': 'LTASM שלב 2',
    'FlagSM.GSM Flag.215': 'LTASM שלב 3',
    'FlagSM.GSM Flag.216': 'LTASM שלב 4',
    'FlagSM.GSM Flag.220': 'קבלת IBC',
    'FlagSM.GSM Flag.221': 'ASM IBC שלב 1',
    'FlagSM.GSM Flag.222': 'ASM IBC שלב 2',
    'FlagSM.GSM Flag.223': 'ASM ICA שלב 1',
    'FlagSM.GSM Flag.224': 'ASM ICA שלב 2',
    'FlagSM.GSM Flag.225': 'עומס גבוה על מקדם',
    'FlagSM.GSM Flag.226': 'שעבוד מקדם גבוה',
    'FlagSM.GSM Flag.230': 'רשימה חסויה SMS',
    'FlagSM.GSM Flag.231': 'רשימת מעקב SMS',
    'FlagSM.GSM Flag.232': 'סרטון לא רצוי',
    'FlagSM.GSM Flag.233': 'וידאו לא רצוי ו-LTASM שלב 4',
    'FlagSM.GSM Flag.234': 'ESM שלב 1',
    'FlagSM.GSM Flag.235': 'ESM שלב 2',
    'FlagSM.GSM Flag.236': 'ESM 1 ו-GSM 0',
    'FlagSM.GSM Flag.237': 'ESM 2 ו-GSM 0',
    'FlagSM.GSM Flag.250': 'LTASM 1 ו-GSM 0',
    'FlagSM.GSM Flag.251': 'LTASM 2 ו-GSM 0',
    'FlagSM.GSM Flag.252': 'LTASM 3 ו-GSM 0',
    'FlagSM.GSM Flag.253': 'LTASM 4 ו-GSM 0',
    'FlagSM.GSM Flag.254': 'STASM 1 ו-GSM 0',
    'FlagSM.GSM Flag.255': 'STASM 2 ו-GSM 0',
    'FlagSM.GSM Flag.256': 'ומס גבוה/לא של מקדם ו-GSM 0',
    'FlagSM.GSM Flag.257': 'עומס גבוה על מקדם ו-GSM 0',
    'FlagSM.GSM Flag.258': 'IBC 1 ו-GSM 0',
    'FlagSM.GSM Flag.259': 'IBC 2 ו-GSM 0',
    'FlagSM.GSM Flag.260': 'ICA 1 ו-GSM 0',
    'FlagSM.GSM Flag.261': 'ICA 2 ו-GSM 0',
    'FlagSM.GSM Flag.262': 'קבלת IBC ו-GSM 0',
    'FlagSM.GSM Flag.263': 'GSM 1 וקבלת IBC',
    'FlagSM.GSM Flag.264': 'GSM 2 וקבלת IBC',
    'FlagSM.GSM Flag.265': 'GSM 3 וקבלת IBC',
    'FlagSM.GSM Flag.266': 'GSM 4 וקבלת IBC',
    'panel.ClosePositionsMutually': 'סגור פוזיציות בהדדיות',
    'panel.ClosePositionsMutually.Symbol': 'סימול:',
    'panel.ClosePositionsMutually.PositionID': 'פוזיציה',
    'panel.ClosePositionsMutually.Side': 'צד',
    'panel.ClosePositionsMutually.Quantity': 'כמות',
    'panel.ClosePositionsMutually.Total': 'סה"כ:',
    'panel.ClosePositionsMutually.CloseBtn': 'סגירה',
    'panel.ClosePositionsMutually.CancelBtn': 'בטל מנוי',
    'panel.General.FullscreenModeBtn.Tooltip': 'מצב מסך מלא',
    'panel.General.ExploreTheApp.Text': 'התחבר כדי להתחיל לסחור.',
    'panel.General.ExploreTheApp.LinkPartText': 'התחבר',
    'TvTradingPlatform.AccountSummary.Title': 'סיכום החשבון',
    'TvTradingPlatform.Quantity': 'כמות',
    'TvTradingPlatform.Positions.AvgFillPrice': 'שער ביצוע ממוצע',
    'TvTradingPlatform.TimeFrame.1D.title': 'יום',
    'TvTradingPlatform.TimeFrame.1D.desciption': 'יום אחד במרווחים של 1 דקות',
    'TvTradingPlatform.TimeFrame.5D.title': '5D',
    'TvTradingPlatform.TimeFrame.5D.desciption': '5 ימים במרווחים של 5 דקות',
    'TvTradingPlatform.TimeFrame.1M.title': '1M',
    'TvTradingPlatform.TimeFrame.1M.desciption': 'חודש אחד במרווחים של 30 דקות',
    'TvTradingPlatform.TimeFrame.3M.title': '3M',
    'TvTradingPlatform.TimeFrame.3M.desciption': '3 חודשים במרווחים של שעה',
    'TvTradingPlatform.TimeFrame.6M.title': '6M',
    'TvTradingPlatform.TimeFrame.6M.desciption': '6 חודשים במרווחים של 4 שעות',
    'TvTradingPlatform.TimeFrame.1Y.title': '1Y',
    'TvTradingPlatform.TimeFrame.1Y.desciption': 'שנה אחת במרווחים של שבוע',
    'TvTradingPlatform.TimeFrame.5Y.title': '5Y',
    'TvTradingPlatform.TimeFrame.5Y.desciption': '5 שנים במרווחים של שבוע',
    'TvTradingPlatform.OrderConfirmation.Exchange': 'בורסה',
    'TvTradingPlatform.OrderConfirmation.TimeInForce': 'זמן התוקף',
    'TvTradingPlatform.OrderType.StopLimit': 'סטופ-לימיט',
    'property.ImpliedVolatility': 'סטיות התקן הגלומות',
    'property.ImpliedVolatilityPercent': 'תנודתיות גלומה, %',
    'property.OP_IV_tt': 'סוג חישוב',
    'property.Clear_tt': 'נקה',
    'property.OptionPrice': 'מחיר אופציה',
    'property.DaysTillExpiration': 'ימים עד פקיעה',
    'property.Put': 'Put',
    'property.Puts': 'Puts',
    'property.Call': 'Call',
    'property.Calls': 'Calls',
    'property.CallsAndPuts': 'Calls&Puts',
    'property.Delta': 'דלתא',
    'property.Gamma': 'גאמא',
    'property.Theta': 'תטא',
    'property.Vega': 'וגא',
    'property.Rho': 'Rho',
    'property.TheoreticalOptionPrice': 'מחיר אופציה תיאורטי',
    'property.TheoreticalPrice': 'מחיר תיאורטי',
    'property.Calculate': 'חשב',
    'screen.OptionCalculator': 'מחשבון אופציות',
    'Web.mobile.active.WorkingOrders': 'בעבודה',
    'Web.mobile.active.WorkingOrders.EmptyPlaceholder': 'אין הוראות',
    'Web.mobile.active.FilledOrders': 'מומש',
    'Web.mobile.active.HistoryOrders': 'היסטוריה',
    'Web.mobile.active.Positions': 'פוזיציות',
    'Web.mobile.active.Positions.EmptyPlaceholder': 'אין פוזיציות',
    'Web.mobile.active.Assets': 'נכסים',
    'Web.mobile.active.Orders': 'הוראות',
    'Web.mobile.active.More': 'עוד',
    'Web.mobile.active.MamSummary': 'סיכום MAM',
    'Web.mobile.active.OptionChain': 'שרשרת אופציות',
    'Web.mobile.active.Alerts.NoAlerts': 'אין התראות',
    'Web.mobile.active.EventLog.NoEvents': 'אין אירועים',
    'Web.mobile.active.EventLog.DateTime': 'תאריך וזמן',
    'Web.mobile.active.MamSummary.Column.OperationType': 'סוג פעולה',
    'Web.mobile.active.MamSummary.Column.Amount': 'כמות',
    'Web.mobile.active.More.Header': 'עוד',
    'Web.mobile.active.Settings.Defaults': 'ברירות מחדל',
    'Web.mobile.active.Settings.QuantityInLots': 'כמות בלוט',
    'Web.mobile.active.Settings.SetSlTpInOffset': 'הגדרת סטופ-לוס/מימוש רווח כהפרש',
    'Web.mobile.active.Settings.OrderSending': 'שליחת הוראה',
    'Web.mobile.active.Settings.OrderModifying': 'שינוי הוראה',
    'Web.mobile.active.Settings.OrderExecuting': 'ביצוע הוראה',
    'Web.mobile.active.Settings.OrderCancelling': 'ביטול הוראה',
    'Web.mobile.active.Settings.PositionModifying': 'שינוי פוזיציה',
    'Web.mobile.active.Settings.PositionClosing': 'סגירת פוזיציה',
    'Web.mobile.active.Table.Total.Profit': 'סה"כ רווח',
    'Web.mobile.active.NewTrades.PnL': 'רווח/הפסד',
    'Web.mobile.active.OrderBook.ExecutionType': 'סוג ביצוע',
    'Web.mobile.active.Assets.EmptyPlaceholder': 'אין נכסים',
    'Web.mobile.active.Assets.DefSymbol': 'סימול ברירת מחדל',
    'Web.mobile.active.Assets.SODQuantity': 'כמות בתחילת היום',
    'Web.mobile.active.Assets.CurrentValueForSale': 'ערך נוכחי למכירה',
    'Web.mobile.active.Positions.Profit': 'רווח/הפסד',
    'Web.mobile.active.AccountDetails.LinkingTooltip': 'פונקציה זו מסננת את הפוזיציות וההוראות לפי חשבון. החשבון מתחלף באופן סינכרוני בכל החלוניות',
    'Web.mobile.active.Watchlist.EmptyPlaceholder': 'אין סימולים',
    'Web.mobile.active.Watchlist.ListNamePlaceholder': 'הקלד את השם כאן',
    'Web.mobile.active.Watchlist.Added': 'נוסף לרשימת מעקב',
    'Web.mobile.active.Watchlist.Removed': 'הוסר מרשימת המעקב',
    'Web.mobile.active.Watchlist.MaxReached': 'הגעת למספר המרבי',
    'Web.mobile.active.ExchangesFilter.Filter': 'מסנן',
    'Web.mobile.active.OrderEntry.Send': 'שלח הוראה',
    'Web.mobile.active.OrderEntry.Price': 'מחיר',
    'Web.mobile.active.OrderEntry.TrStop': 'סטופ נגרר',
    'Web.mobile.active.OrderEntry.SlPrice': 'מחיר סטופ-לוס',
    'Web.mobile.active.OrderEntry.SlOffset': 'הפרש סטופ-לוס',
    'Web.mobile.active.OrderEntry.TrSlOffset': 'הפרש סטופ-לוס נגרר',
    'Web.mobile.active.OrderEntry.SllPrice': 'מחיר לימיט בסטופ-לוס',
    'Web.mobile.active.OrderEntry.SllOffset': 'הפרש לימיט בסטופ-לוס',
    'Web.mobile.active.OrderEntry.TpPrice': 'מחיר מימוש רווח',
    'Web.mobile.active.OrderEntry.TpOffset': 'הפרש מימוש רווח',
    'Web.mobile.active.Login.ExploreTheApp': 'גלה את האפליקציה',
    'Web.mobile.active.InstrumentInfo.Price': 'מחיר',
    'Web.mobile.active.InstrumentInfo.BreakEven': 'נקודת איזון',
    'Web.mobile.active.Asset.SellExchange': 'בורסה',
    'Web.mobile.active.Asset.StartDayQtyMargin': 'כמות בתחילת היום ל-MA',
    'Web.mobile.active.Asset.LiquidityRate': 'שיעור נזילות, %',
    'Web.mobile.active.Asset.TodayTradedQty': 'כמות תוך-יומית',
    'Web.mobile.active.Asset.AvailableQtySell': 'כמות זמינה',
    'Web.mobile.active.FilledOrder.TradeVolume': 'נפח העסקה',
    'Web.mobile.active.FilledOrder.Date': 'תאריך',
    'Web.mobile.active.FilledOrder.GrossPnL': 'רווח/הפסד ברוטו',
    'Web.mobile.active.HistoryOrder.Date': 'תאריך',
    'Web.mobile.active.MamSummary.EmptyPlaceholder': 'אין לך פעולות.',
    'Web.mobile.active.MamSummary.Account': 'חשבון',
    'Web.mobile.active.MamSummary.OperationId': 'מזהה פעולה',
    'Web.mobile.active.MamSummary.InstrumentName': 'סמל',
    'Web.mobile.active.MamSummary.OpenPrice': 'מחיר פתיחה',
    'Web.mobile.active.MamSummary.ClosePrice': 'מחיר סגירה',
    'Web.mobile.active.MamSummary.Side': 'צד',
    'Web.mobile.active.MamSummary.Quantity': 'כמות',
    'Web.mobile.active.MamSummary.Buy': 'קנייה',
    'Web.mobile.active.MamSummary.Sell': 'מכירה',
    'Web.mobile.active.MarketConsensus.ExpertChoice.Tooltip': 'בחירת מומחה',
    'Web.mobile.active.Position.StopLoss': 'סטופ-לוס',
    'Web.mobile.active.Position.TakeProfit': 'מימוש רווח',
    'Web.mobile.active.Position.Date': 'תאריך',
    'Web.mobile.active.Order.StopLoss': 'סטופ-לוס',
    'Web.mobile.active.Order.TrStopOffset': 'הפרש סטופ-לוס נגרר',
    'Web.mobile.active.Order.TrStopLoss': 'סטופ נגרר',
    'Web.mobile.active.Order.TakeProfit': 'מימוש רווח',
    'Web.mobile.active.Order.QuantityFilled': 'הכמות שהתממשה',
    'Web.mobile.active.Search': 'חפש',
    'Web.mobile.active.CalendarPeriod.Today': 'היום',
    'Web.mobile.active.CalendarPeriod.LastWeek': 'שבוע שעבר',
    'Web.mobile.active.CalendarPeriod.Last1M': 'החודש האחרון',
    'Web.mobile.active.CalendarPeriod.Last3M': '3 חודשים אחרונים',
    'Web.mobile.active.CalendarPeriod.Last6M': '6 חודשים אחרונים',
    'Web.mobile.active.InstrumentDetails.6.SessionInfo': 'לוח זמנים',
    'Web.mobile.active.OrderModify.Confirmation.Title.Modify': 'משנה את ההוראה',
    'Web.mobile.active.OrderModify.Confirmation.Title.Cancel': 'מבטל את ההוראה',
    'Web.mobile.active.OrderModify.Confirmation.Title.ExecuteAtMarket': 'לבצע הוראה במחיר מרקט?',
    'Web.mobile.active.OrderModify.Error.SLSmallerMin': 'סטופ-לוס קטן מהערך המינימלי המותר',
    'Web.mobile.active.OrderModify.Error.SLGreaterMax': 'סטופ-לוס גדול מהערך המרבי המותר',
    'Web.mobile.active.OrderModify.Error.TPSmallerMin': 'מימוש רווח קטן מהערך המינימלי המותר',
    'Web.mobile.active.OrderModify.Error.TPGreaterMax': 'מימוש רווח גדול מהערך המרבי המותר',
    'Web.mobile.active.PositionModify.Confirmation.Title': 'משנה את הפוזיציה',
    'Web.mobile.active.PositionClose.Confirmation.Lots': 'לוטים',
    'Web.mobile.active.Lists': 'רשימות',
    'Web.mobile.active.Lists.description': 'בחר רשימות כדי להוסיף להם את הפריט, או בטל את הסימון כדי להסיר',
    'Web.mobile.active.AccountDetails.Groups.1.AccountSummary': 'סיכום החשבון',
    'Web.mobile.active.AccountDetails.Groups.4.TodayResult': 'התוצאה היום',
    'Web.mobile.active.AccountDetails.MarginUsedPercent': 'דרישת בטוחות התחלתית %',
    'Web.mobile.active.AccountDetails.OptionPremiumReq': 'דרישת פרמיית אופציות',
    'Web.mobile.active.AccountDetails.OpenGrossPL': 'רווח/הפסד גולמי פתוח',
    'Web.mobile.active.AccountDetails.OpenPostionsNumber': 'פוזיציות פתוחות',
    'Web.mobile.active.AccountDetails.OpenOrdersNumber': 'הוראות פעילות',
    'Web.mobile.active.AccountDetails.TodaysNetProfit': 'רווח נטו היום',
    'Web.mobile.active.Chart.IndicatorsMenu.AddedIndicators': 'אינדיקטורים שנוספו',
    'Web.mobile.active.Chart.Menu.ChartSyle': 'סגנון הגרף',
    'Web.mobile.active.Chart.Menu.Settings': 'הגדרות',
    'Web.mobile.active.Chart.NoDataAvailable': 'אין נתונים זמינים עבור {0}',
    'Web.mobile.active.TrailingStopLoss': 'נגרר',
    'Web.mobile.active.Position.GrossPnL': 'רווח/הפסד ברוטו',
    'Web.mobile.active.Position.PositionValue': 'שווי פוזיציה',
    'Web.mobile.active.AccountDetails.PieChart.In': 'ב-',
    'Web.mobile.active.signIn.error.emptyLogin': 'שדה ההתחברות ריק',
    'Web.mobile.active.signIn.error.emptyPassword': 'שדה הסיסמה ריק',
    'Web.Mobile.active.Withdrawal.Error': 'ערך שגוי למשיכה',
    'Web.Mobile.advancedOE.OEButtonDisabled.more': 'הכמות גדולה מהמקסימום המותר:',
    'Web.mobile.active.Table.Total.GrossPnL': 'סה"כ רווח/הפסד ברוטו',
    'Web.mobile.hidden.AccountDetails.MarginWarning': '#hidden#',
    'IsAllowedResponceReason.OpenNotAllowedInTrSession': 'חשבון: {0}; הפעולה "שליחת הוראה" אסורה עקב הכללים של סשן המסחר.',
    'Web.Mobile.Webpage.notAvailable': 'דף האינטרנט לא זמין',
    'Web.mobile.chart.maxFavoriteReached': 'הגעת לאורך המרבי.',
    'Accounts.AccountDetails.Mode.Demo': 'דמו',
    'Accounts.AccountDetails.Mode.Live': 'חי',
    'Accounts.AccountDetails.Mode.Contest': 'תחרות',
    'Accounts.AccountDetails.Mode.Funded': 'ממומן',
    'Accounts.AccountDetails.Mode.Challenge': 'אתגר',
    'screen.confirmation.CancelOrder': 'בטל הוראה',
    'screen.confirmation.CancelOrder.Message': 'האם אתה בטוח שאתה רוצה לבטל את ההוראה?',
    'screen.Confirmation.CommissionInfo': '#hidden#',
    'screen.confirmation.ModifyOrder': 'אשר שינוי הוראה',
    'screen.confirmation.ModifyOrder.Message': 'האם אתה בטוח שברצונך לשנות את ההוראה?',
    'screen.confirmation.ModifyPosition': 'אשר שינוי פוזיציה',
    'screen.confirmation.ModifyPosition.Message': 'האם אתה בטוח שברצונך לשנות את הפוזיציה?',
    'screen.confirmation.PlaceOrder': 'אשר מיקום הוראה',
    'screen.confirmation.PlaceOrder.Message': 'האם אתה בטוח שברצונך לבצע את ההוראה?',
    'screen.confirmation.ReversePosition': 'אשר היפוך פוזיציה',
    'screen.confirmation.EstimatedFee': 'עמלות מוערכות',
    'screen.confirmation.AfterTradeCash': 'מזומן לאחר המסחר',
    'screen.confirmation.positionID': 'מזהה פוזיציה',
    'screen.confirmation.orderID': 'מזהה הוראה',
    'screen.confirmation.SLprice': 'מחיר סטופ-לוס',
    'screen.confirmation.TPprice': 'מחיר מימוש רווח',
    'limitPrice.shortCaption': 'LMT:',
    'stopPrice.shortCaption': 'STP:',
    'trailingStop.shortCaption': 'הפרש:',
    'panel.accounts.LiveLeverage': 'מינוף בזמן אמת',
    'property.ClickToModify': 'לחץ כדי לשנות',
    'panel.accounts.AvailableCash': 'מזומן זמין',
    'panel.accounts.TotalPositionsValue': 'סה"כ שווי הפוזיציות',
    'panel.accounts.FreeCommission': 'ללא עמלה',
    'ServerMargin.AvailableCashRiskWarningMessage': 'לאחר הצבת ההוראה, תתחיל להשתמש בכספי האשראי של הברוקר (מינוף).',
    'timeSelector.Hours': 'שעות',
    'timeSelector.Minutes': 'דקות',
    'GoToSelector.Btn.tt': 'מאפשר לנווט אל ההיסטוריה הנדרשת בגרף',
    'GoToSelector.Btn.Forbidden.tt': 'לא רלוונטי להיסטוריית טיקים',
    'property.Hotkeys': 'מקשים חמים',
    'property.Hotkeys.ToolTip': 'הגדרות מקשים חמים',
    'property.Hotkeys.DisplayInFullScreenMode': 'תצוגה במצב מסך מלא',
    'property.Hotkeys.ChangeChartStyle': 'שינוי סגנון גרף',
    'property.Hotkeys.ZoomIn': 'הגדל',
    'property.Hotkeys.ZoomOut': 'הקטן',
    'property.Hotkeys.AutoManualScaling': 'סולם אוטומטי/ידני',
    'property.Hotkeys.MouseTrading': 'מסחר עכבר',
    'property.Hotkeys.ShowHideInfoWindow': 'הצג/הסתר חלון מידע',
    'property.Hotkeys.AddIndicator': 'הוסף אינדיקטור',
    'property.Hotkeys.RemoveDrawings': 'הסרת שרטוטים',
    'property.Hotkeys.ShowFilledOrders': 'הצג הוראות שהתממשו',
    'property.Hotkeys.SetPeriod_Tick': 'קביעת תקופה (טיק)',
    'property.Hotkeys.SetPeriod_1m': 'קביעת תקופה (דקה)',
    'property.Hotkeys.SetPeriod_5m': 'קביעת תקופה (5 דקות)',
    'property.Hotkeys.SetPeriod_15m': 'קביעת תקופה (15 דקות)',
    'property.Hotkeys.SetPeriod_30m': 'קביעת תקופה (30 דקות)',
    'property.Hotkeys.SetPeriod_1H': 'קביעת תקופה (שעה)',
    'property.Hotkeys.SetPeriod_4H': 'קביעת תקופה (4 שעות)',
    'property.Hotkeys.SetPeriod_1D': 'קביעת תקופה (יום)',
    'property.Hotkeys.SetPeriod_1W': 'קביעת תקופה (שבוע)',
    'property.Hotkeys.SetPeriod_1M': 'קביעת תקופה (חודש)',
    'property.Hotkeys.SetPeriod_1Y': 'קביעת תקופה (שנה)',
    'property.Hotkeys.ObjectManagerIndicators': 'מנהל אובייקטים - אינדיקטורים',
    'property.Hotkeys.ObjectManagerDrawings': 'מנהל אובייקטים - שרטוטים',
    'property.Hotkeys.ObjectManagerOverlays': 'מנהל אובייקטים - שכבות-על',
    'property.Hotkeys.DrawLine': 'שרטט קו',
    'property.Hotkeys.DrawVerticalLine': 'שרטט קו אנכי',
    'property.Hotkeys.DrawHorizontalLine': 'שרטט קו אופקי',
    'property.Hotkeys.DrawArrow': 'שרטט חץ',
    'property.Hotkeys.DrawComments': 'שרטט הערות',
    'property.Hotkeys.DrawFibonacciRetracement': "שרטט נסיגת פיבונאצ'י",
    'property.Hotkeys.DrawFibonacciExpansion': "שרטט התרחבות פיבונאצ'י",
    'property.Hotkeys.DrawFibonacciArc': "שרטט קשת פיבונאצ'י",
    'property.Hotkeys.DrawFibonacciTimeGoalAnalysis': "שרטט ניתוח יעד זמן פיבונאצ'י",
    'property.Hotkeys.DrawFibonacciFans': "שרטט מניפות פיבונאצ'י",
    'property.Hotkeys.DrawFibonacciSpiral': "שרטט ספירלת פיבונאצ'י",
    'property.Hotkeys.DrawFibonacciTimeZone': "שרטט אזור זמן פיבונאצ'י",
    'property.Hotkeys.DrawFibonacciPhiChannel': "שרטט ערוץ פי פיבונאצ'י",
    'property.Hotkeys.DrawTriangle': 'שרטט משולש',
    'property.Hotkeys.DrawPolygon': 'שרטט מצולע',
    'property.Hotkeys.DrawRectangle': 'שרטט מלבן',
    'property.Hotkeys.ShowHideGrid': 'הצג/הסתר חלון גרפים',
    'property.Hotkeys.ShowOpenPositions': 'הצג פוזיציות פתוחות',
    'property.Hotkeys.ShowVolume': 'הצג נפח',
    'property.Hotkeys.ShowWorkingOrders': 'הצג הוראות פעילות',
    'property.Hotkeys.Chart.CancelLastOrderOnSelectedInstrument': 'בטל את ההוראה האחרונה במכשיר שנבחר',
    'property.Hotkeys.Chart.CancelAllActiveOrdersOnSelectedInstrument': 'בטל את כל ההוראות הפעילות במכשיר שנבחר',
    'property.Hotkeys.Chart.CancelBuyOrderClosestToTheLastPrice': 'בטל את הוראה/ות הקנייה הקרובות ביותר למחיר האחרון',
    'property.Hotkeys.Chart.CancelSellOrderClosestToTheLastPrice': 'בטל את הוראות המכירה הקרובות ביותר למחיר האחרון',
    'property.Hotkeys.MarketDepth.CancelLastOrderOnSelectedInstrument': 'בטל את ההוראה האחרונה במכשיר שנבחר',
    'property.Hotkeys.MarketDepth.CancelAllActiveOrdersOnSelectedInstrument': 'בטל את כל ההוראות הפעילות במכשיר שנבחר',
    'property.Hotkeys.MarketDepth.CancelBuyOrderClosestToTheLastPrice': 'בטל את הוראה/ות הקנייה הקרובות ביותר למחיר האחרון',
    'property.Hotkeys.MarketDepth.CancelSellOrderClosestToTheLastPrice': 'בטל את הוראות המכירה הקרובות ביותר למחיר האחרון',
    'property.Hotkeys.PlaceBuyOrder': 'הזן הוראת קנייה',
    'property.Hotkeys.PlaceSellOrder': 'הצבת הוראת מכירה',
    'property.Hotkeys.SellAsk': 'מכירה לפי מחיר היצע',
    'property.Hotkeys.BuyBid': 'קנייה לפי מחיר ביקוש',
    'property.Hotkeys.OpenBuyOE': 'הזנת פקודה: פתיחת קנייה',
    'property.Hotkeys.OpenSellOE': 'הזנת פקודה: פתיחת מכירה',
    'property.Hotkeys.PlaceOrder': 'הצבת הוראה',
    'property.Hotkeys.CloseAllPositionsImmediately': 'סגור את כל הפוזיציות באופן מיידי',
    'property.Hotkeys.CancelAllOrdersImmediately': 'בטל את כל ההוראות באופן מיידי',
    'property.Hotkeys.CancelAllOrdersAndCloseAllPositionsImmediately': 'בטל את כל ההוראות וסגור את כל הפוזיציות באופן מיידי',
    'property.Hotkeys.OpenReports': 'פתח דוחות',
    'property.Hotkeys.ModifyOrder': 'עריכת הוראה',
    'property.Hotkeys.CancelOrder': 'בטל הוראה',
    'property.Hotkeys.ChangeToMarket': "שנה ל'מרקט'",
    'hotkeysMessageBox.ErrorText': "השילוב הזה כבר בשימוש עבור הפעולה '{0} ({1})'!",
    'hotkeysPopupMessage.ErrorText.MustCombination': 'חייב להיות שילוב של Ctrl, Shift או Alt עם אות או ספרה',
    'hotkeysPopupMessage.ErrorText.NeedAddLetterOrNumber': 'יש להוסיף אות או ספרה',
    'ChartObjectManager.Text': 'מנהל אובייקטים',
    'button.cancel': 'בטל מנוי',
    'ObjectManagerItem.Name': 'שם',
    'ObjectManagerItem.Remove': 'הסר',
    'ObjectManagerItem.Settings': 'הגדרות',
    'ObjectManagerItem.Show on chart': 'הצג על גרף',
    'ObjectManagerItem.Visible': 'גלוי',
    'ObjectManagerItem.Window': 'חלון',
    'general.connection.safeDisconect': 'שילוב שם משתמש/סיסמה אינו תקף.',
    cashValueNotMultipleToMinChange: 'ערך מזומן אינו כפולה של השינוי המינימלי = {0}',
    cashBelowMinimumAllowedValue: 'סכום המזומן נמוך מהערך המינימלי המותר = {0}',
    cashAboveMaximumAllowedValue: 'סכום המזומן מעל הערך המרבי המותר = {0}',
    'ChartObjectManager.mainWindow': 'חלון ראשי',
    'ChartObjectManager.subWindow': 'חלון משנה',
    'chart.menu.ObjectManager.RemoveAll': 'הסר הכל',
    'chart.menu.ObjectManager.RemoveSelected': 'הסר נבחרים',
    partialSelection: 'נבחרו {0} פריטים',
    noSelection: 'בחר עוקבים',
    'reports.AUTO_INVEST_MOB_ANDROID': '‎MOB:Auto-invest “Android”‎',
    'reports.AUTO_INVEST_MOB_IOS': 'MOB:Auto-invest “IOS”‎',
    'reports.AUTO_INVEST_MOB_WEB': 'MOB:Auto-invest “WEB”‎',
    'reports.AUTO_INVEST_DESKTOP': 'Desktop:Auto-invest',
    'reports.AUTO_INVEST_WEB': 'WEB:Auto-invest',
    'reports.AUTO_INVEST_MOB_INV_ANDROID': 'MOB:Inv.‎ Auto-invest “Android”‎',
    'reports.AUTO_INVEST_MOB_INV_IOS': 'MOB:Inv.‎ Auto-invest “IOS”‎',
    'propery.MainPriceRenderer.Text': 'טקסט',
    'propery.MainPriceRenderer.Back': 'חזרה',
    'TerceraAccountLookup.AccountItems': 'פריטים'
};
